[
  {
    "key": "txt_Theupload_815",
    "text": "The upload failed and no respondents were saved. Please try again.",
    "translations": [
      {
        "language": "AR",
        "text": "تعذّر إكمال عملية الرفع ولم يتم حفظ أي من المشاركين. يرجى المحاولة مرة أخرى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Thiscandi_961",
    "text": "This candidate no longer exists. Refresh the page and try again.",
    "translations": [
      {
        "language": "AR",
        "text": "لم يعد هذا المرشح موجودًا. يرجى تحديث الصفحة والمحاولة مرة أخرى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Anotherup_303",
    "text": "Another upload is already running for this survey. Please wait for it to finish.",
    "translations": [
      {
        "language": "AR",
        "text": "هناك عملية رفع أخرى قيد التنفيذ لهذا الاستبيان. يرجى الانتظار حتى تكتمل."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_UserType",
    "text": "Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع المستخدم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": "Typ"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": "Tipo"
      },
      {
        "language": "PT",
        "text": "Tipo"
      },
      {
        "language": "IT",
        "text": "Tipo"
      },
      {
        "language": "CS",
        "text": "Typ"
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUsingTemplateFromLibrary",
    "text": "Using template from library",
    "translations": [
      {
        "language": "AR",
        "text": "استخدام قالب من المكتبة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "pulse_schedule_threshold_error",
    "text": "Enter a response rate between 1 and 100.",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zadejte míru odezvy v rozmezí 1 až 100."
      },
      {
        "language": "EN",
        "text": "Enter a response rate between 1 and 100."
      }
    ]
  },
  {
    "key": "pulse_schedule_recurring_window_error",
    "text": "End date must be at least one full cycle after the start date.",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Datum ukončení musí být nejméně o jeden celý cyklus později než datum zahájení."
      },
      {
        "language": "EN",
        "text": "End date must be at least one full cycle after the start date."
      }
    ]
  },
  {
    "key": "txt_DirectMan_634",
    "text": "Direct Manager(s)",
    "translations": [
      {
        "language": "AR",
        "text": "المدير/المديرون المباشرون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přímý nadřízený (nadřízení)"
      },
      {
        "language": "EN",
        "text": "Direct Manager(s)"
      }
    ]
  },
  {
    "key": "txt_Refinethe_478",
    "text": "Refine the dashboard to a specific entity.",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص لوحة المعلومات لجهة محددة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zúžte přehled na konkrétní subjekt."
      },
      {
        "language": "EN",
        "text": "Refine the dashboard to a specific entity."
      }
    ]
  },
  {
    "key": "txt_NoCommentThemes",
    "text": "No Comment Themes",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد محاور للتعليقات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Žádná témata komentářů"
      },
      {
        "language": "EN",
        "text": "No Comment Themes"
      }
    ]
  },
  {
    "key": "txt_Configure_655",
    "text": "Configure Threshold",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد الحدّ الأدنى"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nastavit prahovou hodnotu"
      },
      {
        "language": "EN",
        "text": "Configure Threshold"
      }
    ]
  },
  {
    "key": "txtApply",
    "text": "Apply",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Použít"
      },
      {
        "language": "EN",
        "text": "Apply"
      }
    ]
  },
  {
    "key": "txt_Candidate_153",
    "text": "Candidates with evaluators avg below this value are flagged at risk.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم تصنيف المرشحين الذين يقل متوسط تقييم المقيمين لديهم عن هذه القيمة كمرشحين محل اهتمام."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kandidáti, u nichž je průměrné hodnocení hodnotitelů nižší než tato hodnota, jsou označeni jako rizikoví."
      },
      {
        "language": "EN",
        "text": "Candidates with evaluators avg below this value are flagged at risk."
      }
    ]
  },
  {
    "key": "txt_SelfHigherThanEvaluators",
    "text": "Self Higher Than Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "التقييم الذاتي أعلى من تقييم المقيمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vlastní hodnocení vyšší než hodnocení hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Self Higher Than Evaluators"
      }
    ]
  },
  {
    "key": "txt_SelfMatchesEvaluators",
    "text": "Self Matches Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "التقييم الذاتي مطابق لتقييم المقيمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vlastní hodnocení odpovídá hodnocení hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Self Matches Evaluators"
      }
    ]
  },
  {
    "key": "txt_SelfLowerThanEvaluators",
    "text": "Self Lower Than Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "التقييم الذاتي أقل من تقييم المقيمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vlastní hodnocení nižší než hodnocení hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Self Lower Than Evaluators"
      }
    ]
  },
  {
    "key": "txt_Aligned",
    "text": "Aligned",
    "translations": [
      {
        "language": "AR",
        "text": "متوافق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "V souladu"
      },
      {
        "language": "EN",
        "text": "Aligned"
      }
    ]
  },
  {
    "key": "txt_SelfAwarenessDistribution",
    "text": "Self-awareness distribution",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع الوعي الذاتي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Rozložení sebehodnocení"
      },
      {
        "language": "EN",
        "text": "Self-awareness distribution"
      }
    ]
  },
  {
    "key": "txt_PreparingCommentAnalysis",
    "text": "Preparing Comments Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "جارٍ إعداد تحليل التعليقات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Příprava analýzy komentářů"
      },
      {
        "language": "EN",
        "text": "Preparing Comments Analysis"
      }
    ]
  },
  {
    "key": "txt_Fullscree_109",
    "text": "Fullscreen",
    "translations": [
      {
        "language": "AR",
        "text": "شاشة كاملة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Fullscreen"
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Celá obrazovka"
      }
    ]
  },
  {
    "key": "txt_OrgChart_262",
    "text": "Org Chart",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Organizační schéma"
      },
      {
        "language": "EN",
        "text": "Org Chart"
      }
    ]
  },
  {
    "key": "txt_Evaluator_325",
    "text": "Evaluator Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة المقيمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Skóre hodnotitele"
      },
      {
        "language": "EN",
        "text": "Evaluator Score"
      }
    ]
  },
  {
    "key": "txt_of_respondent",
    "text": "{{0}} of {{1}} Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "{{0}} من {{1}} مستجيب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "{{0}} z {{1}} respondenta"
      },
      {
        "language": "EN",
        "text": "{{0}} of {{1}} Respondent"
      }
    ]
  },
  {
    "key": "txt_FocusArea_309",
    "text": "Focus Area",
    "translations": [
      {
        "language": "AR",
        "text": "مجال التركيز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Oblast zaměření"
      },
      {
        "language": "EN",
        "text": "Focus Area"
      }
    ]
  },
  {
    "key": "txt_Strongest_642",
    "text": "Strongest Competency",
    "translations": [
      {
        "language": "AR",
        "text": "أبرز جدارة ومهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nejsilnější kompetence"
      },
      {
        "language": "EN",
        "text": "Strongest Competency"
      }
    ]
  },
  {
    "key": "txt_Competenc_761",
    "text": "Competency Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة على الجدارات والمهارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přehled kompetencí"
      },
      {
        "language": "EN",
        "text": "Competency Overview"
      }
    ]
  },
  {
    "key": "txt_Summaryof_190",
    "text": "Summary of the review",
    "translations": [
      {
        "language": "AR",
        "text": "ملخص المراجعة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Shrnutí hodnocení"
      },
      {
        "language": "EN",
        "text": "Summary of the review"
      }
    ]
  },
  {
    "key": "txt_OverallSc_785",
    "text": "Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Celkové skóre"
      },
      {
        "language": "EN",
        "text": "Overall Score"
      }
    ]
  },
  {
    "key": "txt_Evaluator_882",
    "text": "Evaluators Avg.",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Průměr hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Evaluators Avg."
      }
    ]
  },
  {
    "key": "txt_Pivot_472",
    "text": "Pivot",
    "translations": [
      {
        "language": "AR",
        "text": "جدول محوري"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Pivot"
      },
      {
        "language": "EN",
        "text": "Pivot"
      }
    ]
  },
  {
    "key": "txt_survey",
    "text": "Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment"
      }
    ]
  },
  {
    "key": "txt_ShowRespo_984",
    "text": "Show Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "عرض المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zobrazit respondenty"
      },
      {
        "language": "EN",
        "text": "Show Respondents"
      }
    ]
  },
  {
    "key": "txt_Combinedc_610",
    "text": "Combined competency score represent performance across all assessments.",
    "translations": [
      {
        "language": "AR",
        "text": "تُمثل الدرجة المجمعة للجدارات والمهارات الأداء العام عبر جميع التقييمات."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kombinované skóre kompetencí představuje výkon napříč všemi hodnoceními."
      },
      {
        "language": "EN",
        "text": "Combined competency score represent performance across all assessments."
      }
    ]
  },
  {
    "key": "txt_Competenc_808",
    "text": "Competencies Score Overview  ",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة على درجة الجدارات والمهارات:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přehled skóre kompetencí  "
      },
      {
        "language": "EN",
        "text": "Competencies Score Overview  "
      }
    ]
  },
  {
    "key": "txtOverall",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Celkově"
      },
      {
        "language": "EN",
        "text": "Overall"
      }
    ]
  },
  {
    "key": "txt_ViewProfi_678",
    "text": "View Profile",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الملف الشخصي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zobrazit profil"
      },
      {
        "language": "EN",
        "text": "View Profile"
      }
    ]
  },
  {
    "key": "txt_ListofRes_377",
    "text": "List of Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Seznam respondentů"
      },
      {
        "language": "EN",
        "text": "List of Respondents"
      }
    ]
  },
  {
    "key": "txt_to_659",
    "text": "to",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "k"
      },
      {
        "language": "EN",
        "text": "to"
      }
    ]
  },
  {
    "key": "txtCandidates",
    "text": "Candidates",
    "translations": [
      {
        "language": "AR",
        "text": "المرشحين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Respondenti"
      },
      {
        "language": "EN",
        "text": "Candidates"
      }
    ]
  },
  {
    "key": "txt_Searchcom_675",
    "text": "Search competencies...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث عن جدارات ومهارات..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyhledat kompetence..."
      },
      {
        "language": "EN",
        "text": "Search competencies..."
      }
    ]
  },
  {
    "key": "txt_Nocompete_780",
    "text": "No competencies found.",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم العثور على أي جدارات ومهارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nebyly nalezeny žádné kompetence."
      },
      {
        "language": "EN",
        "text": "No competencies found."
      }
    ]
  },
  {
    "key": "txt_Submissio_835",
    "text": "Submissions",
    "translations": [
      {
        "language": "AR",
        "text": "التقديمات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Odeslané"
      },
      {
        "language": "EN",
        "text": "Submissions"
      }
    ]
  },
  {
    "key": "txtScore",
    "text": "Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Skóre"
      },
      {
        "language": "EN",
        "text": "Score"
      }
    ]
  },
  {
    "key": "txt_SortbySco_681",
    "text": "Sort by Score",
    "translations": [
      {
        "language": "AR",
        "text": "الترتيب حسب الدرجة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Seřadit podle skóre"
      },
      {
        "language": "EN",
        "text": "Sort by Score"
      }
    ]
  },
  {
    "key": "txt_Competenc_717",
    "text": "Competency Scores",
    "translations": [
      {
        "language": "AR",
        "text": "درجات الجدارات والمهارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Skóre kompetencí"
      },
      {
        "language": "EN",
        "text": "Competency Scores"
      }
    ]
  },
  {
    "key": "txt_TotalComp_637",
    "text": "Total Competencies",
    "translations": [
      {
        "language": "AR",
        "text": "إجمالي الجدارات والمهارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Celkový počet kompetencí"
      },
      {
        "language": "EN",
        "text": "Total Competencies"
      }
    ]
  },
  {
    "key": "txt_TotalCand_750",
    "text": "Total Candidates",
    "translations": [
      {
        "language": "AR",
        "text": "إجمالي المرشحين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Celkový počet kandidátů"
      },
      {
        "language": "EN",
        "text": "Total Candidates"
      }
    ]
  },
  {
    "key": "txtCompetenciesAnalysis",
    "text": "Competencies Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات الجدارات والمهارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Analýza kompetencí"
      },
      {
        "language": "EN",
        "text": "Competencies Analysis"
      }
    ]
  },
  {
    "key": "txt_Anillustr_926",
    "text": "An illustration of <span class=\"font-medium\">{{0}}’s</span> self-evaluated score compared with the overall evaluators’ score. This figure displays a spider chart, where a range of 3 – 10 competencies must be selected to show data",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح الشكل درجة <span class=\"font-medium\">{{0}}</span> في التقييم الذاتي مقارنةً بالدرجة الإجمالية للمقيّمين.<br/>يعرض هذا الشكل مخططًا عنكبوتيًا، ويتطلب اختيار ما بين 3 إلى 10 جدارة لعرض البيانات."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Ilustrace <span class=\"font-medium\">{{0}}</span> vlastního hodnocení ve srovnání s celkovým hodnocením hodnotitelů. Tento obrázek zobrazuje pavoukový graf, kde je pro zobrazení dat nutné vybrat rozsah 3–10 kompetencí"
      },
      {
        "language": "EN",
        "text": "An illustration of <span class=\"font-medium\">{{0}}’s</span> self-evaluated score compared with the overall evaluators’ score. This figure displays a spider chart, where a range of 3 – 10 competencies must be selected to show data"
      }
    ]
  },
  {
    "key": "txt_Translati_931",
    "text": "Translations loading...",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة قيد الإنجاز..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Načítání překladů..."
      },
      {
        "language": "EN",
        "text": "Translations loading..."
      }
    ]
  },
  {
    "key": "txt_Selectwhi_406",
    "text": "Select which AI translated Language to show:",
    "translations": [
      {
        "language": "AR",
        "text": "اختر اللغة المترجمة بالذكاء الاصطناعي التي ترغب في عرضها:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyberte jazyk, do kterého má být překlad AI zobrazen:"
      },
      {
        "language": "EN",
        "text": "Select which AI translated Language to show:"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Komentáře"
      },
      {
        "language": "EN",
        "text": "Comments"
      }
    ]
  },
  {
    "key": "txt_ScoreCard_116",
    "text": "Score Card",
    "translations": [
      {
        "language": "AR",
        "text": "بطاقة التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Hodnotící karta"
      },
      {
        "language": "EN",
        "text": "Score Card"
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "التقرير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zpráva"
      },
      {
        "language": "EN",
        "text": "Report"
      }
    ]
  },
  {
    "key": "txt_DetailedR_924",
    "text": "Detailed Report",
    "translations": [
      {
        "language": "AR",
        "text": "التقرير التفصيلي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Podrobná zpráva"
      },
      {
        "language": "EN",
        "text": "Detailed Report"
      }
    ]
  },
  {
    "key": "txt_Summarize_690",
    "text": "Summarized Report",
    "translations": [
      {
        "language": "AR",
        "text": "التقرير المختصر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Souhrnná zpráva"
      },
      {
        "language": "EN",
        "text": "Summarized Report"
      }
    ]
  },
  {
    "key": "txt_DownloadC_342",
    "text": "Download Candidate Report",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل تقرير المرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Stáhnout zprávu o uchazeči"
      },
      {
        "language": "EN",
        "text": "Download Candidate Report"
      }
    ]
  },
  {
    "key": "txt_DownloadM_971",
    "text": "Download Management Report",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل تقرير الإدارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Stáhnout zprávu pro vedení"
      },
      {
        "language": "EN",
        "text": "Download Management Report"
      }
    ]
  },
  {
    "key": "Evaluator",
    "text": "Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Hodnotitel"
      },
      {
        "language": "EN",
        "text": "Evaluator"
      }
    ]
  },
  {
    "key": "txt_Competenc_429",
    "text": "Competencies (Previous Score)",
    "translations": [
      {
        "language": "AR",
        "text": "الجدارات (الدرجة السابقة)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kompetence (předchozí skóre)"
      },
      {
        "language": "EN",
        "text": "Competencies (Previous Score)"
      }
    ]
  },
  {
    "key": "txt_Thetableb_722",
    "text": "The table below shows the gap between <span class=\"font-medium\">{{0}}’s</span> current and previous evaluator scores across competencies:",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح الجدول أدناه الفجوة بين درجات <span class=\"font-medium\">{{0}}</span> الحالية والسابقة من المقيّمين عبر الجدارات:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Níže uvedená tabulka ukazuje rozdíl mezi <span class=\"font-medium\">{{0}}</span> aktuálním a předchozím skóre od hodnotitelů v jednotlivých kompetencích:"
      },
      {
        "language": "EN",
        "text": "The table below shows the gap between <span class=\"font-medium\">{{0}}’s</span> current and previous evaluator scores across competencies:"
      }
    ]
  },
  {
    "key": "txt_Anillustr_435",
    "text": "An illustration of <span class=\"\"font-medium\">{{0}}’s</span> self-evaluated score compared with the overall evaluators’ score.<br/>This figure displays a spider chart, where a range of 3 – 10 competencies must be selected to show data",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح الشكل درجة <span class=\"font-medium\">{{0}}</span> في التقييم الذاتي مقارنةً بالدرجة الإجمالية للمقيّمين.<br/>يعرض هذا الشكل مخططًا عنكبوتيًا، ويتطلب اختيار ما بين 3 إلى 10 جدارة لعرض البيانات."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Ilustrace <span class=\"\"font-medium\">{{0}}</span> vlastního hodnocení ve srovnání s celkovým skóre hodnotitelů. <br/>Tento graf zobrazuje pavoukový graf, kde je třeba vybrat rozsah 3–14 kompetencí, aby se data zobrazila"
      },
      {
        "language": "EN",
        "text": "An illustration of <span class=\"\"font-medium\">{{0}}’s</span> self-evaluated score compared with the overall evaluators’ score.<br/>This figure displays a spider chart, where a range of 3 – 14 competencies must be selected to show data"
      }
    ]
  },
  {
    "key": "txt_Thefollow_567",
    "text": "The following comments are segmented by evaluator group and are presented exactly as the respondent entered them, highlighting <span class=\"font-medium\">{{0}}’s</span> areas of strength and the suggested areas to develop.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تقسيم التعليقات التالية حسب مجموعة المقيّمين، وتُعرض كما أدخلها المستجيب تمامًا، مع إبراز جوانب القوة لدى <span class=\"font-medium\">{{0}}</span> والمجالات المقترحة للتطوير."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Následující komentáře jsou rozčleněny podle skupin hodnotitelů a jsou prezentovány přesně tak, jak je respondent zadal, s vyznačením <span class=\"font-medium\">{{0}}ových</span> silných stránek a oblastí doporučených k rozvoji."
      },
      {
        "language": "EN",
        "text": "The following comments are segmented by evaluator group and are presented exactly as the respondent entered them, highlighting <span class=\"font-medium\">{{0}}’s</span> areas of strength and the suggested areas to develop."
      }
    ]
  },
  {
    "key": "txt_Noblindsp_187",
    "text": "No blind spots!",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد نقاط ضعف غير مدركة!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Žádná slepá místa!"
      },
      {
        "language": "EN",
        "text": "No blind spots!"
      }
    ]
  },
  {
    "key": "txt_Nohiddens_455",
    "text": "No hidden strengths!",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد نقاط القوة المجهولة!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Žádné skryté silné stránky!"
      },
      {
        "language": "EN",
        "text": "No hidden strengths!"
      }
    ]
  },
  {
    "key": "txtGap",
    "text": "Gap",
    "translations": [
      {
        "language": "AR",
        "text": "الفجوة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Rozdíl"
      },
      {
        "language": "EN",
        "text": "Gap"
      }
    ]
  },
  {
    "key": "txtEvaluators",
    "text": "Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "المقيّمون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Hodnotitelé"
      },
      {
        "language": "EN",
        "text": "Evaluators"
      }
    ]
  },
  {
    "key": "Self",
    "text": "Self",
    "translations": [
      {
        "language": "AR",
        "text": "الذاتي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vlastní"
      },
      {
        "language": "EN",
        "text": "Self"
      }
    ]
  },
  {
    "key": "txtCompetency",
    "text": "Competency",
    "translations": [
      {
        "language": "AR",
        "text": "الجدارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kompetence"
      },
      {
        "language": "EN",
        "text": "Competency"
      }
    ]
  },
  {
    "key": "scoreCardPara",
    "text": "The following section provides an overview of <span class=\"font-medium\">{{0}}’s</span> overall performance scores:",
    "translations": [
      {
        "language": "AR",
        "text": "يوفر القسم التالي نظرة عامة على درجات الأداء الإجمالية لـ <span class=\"font-medium\">{{0}}</span>:"
      },
      {
        "language": "EN",
        "text": "The following section provides an overview of <span class=\"font-medium\">{{0}}’s</span> overall performance scores:"
      },
      {
        "language": "CS",
        "text": "Následující část poskytuje přehled <span class=\"font-medium\">{{0}}</span> celkových skóre výkonnosti:"
      }
    ]
  },
  {
    "key": "CompetenciesList",
    "text": "Competencies List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الجدارات"
      },
      {
        "language": "EN",
        "text": "Competencies List"
      },
      {
        "language": "CS",
        "text": "Seznam kompetencí"
      }
    ]
  },
  {
    "key": "calculationProcessPara",
    "text": "<ul class=\"bullets\"><li><i class=\"fas fa-circle\"></i><p>Each statement score is given an average rating based on the received feedback.</p></li><li><i class=\"fas fa-circle\"></i><p>Each competency score is calculated as the overall rating score of the selected statements</p></li><li><i class=\"fas fa-circle\"></i><p>The overall performance is calculated as the average rating of the weighted competencies.</p></li><li><i class=\"fas fa-circle\"></i><p>Not Applicable (N/A) responses are excluded from calculations.</p></li></ul>",
    "translations": [
      {
        "language": "AR",
        "text": "<ul class=\"bullets\"><li><i class=\"fas fa-circle\"></i><p>يتم احتساب نتيجة كل عبارة من خلال أخذ متوسط نتائج اختيارات المقييمين.</p></li><li><i class=\"fas fa-circle\"></i><p> يتم احتساب نتيجة كل جدارة ومهارة من خلال أخذ متوسط نتائج العبارات المختارة.</p></li><li><i class=\"fas fa-circle\"></i><p>يتم احتساب معدل تقييم الأداء الكلي بحسب الأوزان المعطاة لكل جدارة ومهارة.</p></li><li><i class=\"fas fa-circle\"></i><p>يتم استثناء خيار \"لا ينطبق\" من حساب معدل التقييم.</p></li></ul>"
      },
      {
        "language": "EN",
        "text": "<ul class=\"bullets\"><li><i class=\"fas fa-circle\"></i><p>Each statement score is given an average rating based on the received feedback.</p></li><li><i class=\"fas fa-circle\"></i><p>Each competency score is calculated as the overall rating score of the selected statements</p></li><li><i class=\"fas fa-circle\"></i><p>The overall performance is calculated as the average rating of the weighted competencies.</p></li><li><i class=\"fas fa-circle\"></i><p>Not Applicable (N/A) responses are excluded from calculations.</p></li></ul>"
      },
      {
        "language": "CS",
        "text": "<ul class=\"bullets\"><li><i class=\"fas fa-circle\"></i><p>Každému tvrzení je na základě obdržené zpětné vazby přiřazeno průměrné hodnocení.</ p></li><li><i class=\"fas fa-circle\"></i><p>Skóre každé kompetence se vypočítává jako celkové hodnocení vybraných tvrzení</p></li><li><i class=\"fas fa-circle\"></i><p>Celkový výkon se vypočítává jako průměrné hodnocení vážených kompetencí. </p></li><li><i class=\"fas fa-circle\"></i><p>Odpovědi typu „Nevztahuje se“ (N/A) jsou z výpočtů vyloučeny.</p></li></ul>"
      }
    ]
  },
  {
    "key": "CalculationProcess",
    "text": "Calculation Process",
    "translations": [
      {
        "language": "AR",
        "text": "عملية الحساب"
      },
      {
        "language": "EN",
        "text": "Calculation Process"
      },
      {
        "language": "CS",
        "text": "Proces výpočtu"
      }
    ]
  },
  {
    "key": "howToUseThisReportPara",
    "text": "<p>This report provides a clear overview of [CandidateName]’s feedback results, including the following insights:</p><ul class=\"bullets\"><li><i class=\"fas fa-circle\"></i><p>Comparison of [CandidateName]’s self-scores and evaluator scores.</p></li><li><i class=\"fas fa-circle\"></i><p>Comparison of [CandidateName]’s evaluator scores against the overall evaluator average.</p></li><li><i class=\"fas fa-circle\"></i><p>Highlight [CandidateName]’s top hidden strengths and blind spots to support targeted development and encouragement.</p></li></ul>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>يوفّر هذا التقرير نظرة واضحة على نتائج التغذية الراجعة الخاصة بـ [CandidateName]، بما يشمل المؤشرات التالية:</p><ul class=\"bullets\"><li><i class=\"fas fa-circle\"></i><p>مقارنة بين درجات التقييم الذاتي ودرجات المقيّمين الخاصة بـ [CandidateName].</p></li><li><i class=\"fas fa-circle\"></i><p>مقارنة درجات المقيّمين الخاصة بـ [CandidateName] مع المتوسط العام لدرجات المقيّمين.</p></li><li><i class=\"fas fa-circle\"></i><p>إبراز أبرز نقاط القوة المجهولة ونقاط الضعف الغير مدركة لدى [CandidateName]، بما يدعم التطوير المستهدف والتشجيع المناسب.</p></li></ul>"
      },
      {
        "language": "EN",
        "text": "<p>This report provides a clear overview of [CandidateName]’s feedback results, including the following insights:</p><ul class=\"bullets\"><li><i class=\"fas fa-circle\"></i><p>Comparison of [CandidateName]’s self-scores and evaluator scores.</p></li><li><i class=\"fas fa-circle\"></i><p>Comparison of [CandidateName]’s evaluator scores against the overall evaluator average.</p></li><li><i class=\"fas fa-circle\"></i><p>Highlight [CandidateName]’s top hidden strengths and blind spots to support targeted development and encouragement.</p></li></ul>"
      },
      {
        "language": "CS",
        "text": "<p>Tato zpráva poskytuje jasný přehled výsledků zpětné vazby [CandidateName], včetně následujících informací:</p><ul class=\"bullets\"><li><i class=\"fas fa-circle\"></i><p>Porovnání vlastního hodnocení [CandidateName] a hodnocení hodnotitelů.</ p></li><li><i class=\"fas fa-circle\"></i><p>Porovnání hodnocení [CandidateName] od hodnotitelů s celkovým průměrem hodnotitelů.</p></li><li><i class=\"fas fa-circle\"></i><p>Zvýraznění nejvýznamnějších skrytých silných stránek a slabých míst [CandidateName] s cílem podpořit cílený rozvoj a motivaci.</p></li></ul>"
      }
    ]
  },
  {
    "key": "180txtIntroductionpara1",
    "text": "180-degree performance appraisal is one of the most important modern methods of evaluating a manager’s behavior in the working environment to show different views on his professional performance, unlike the traditional performance appraisal, which mainly focuses on management / superior feedback. <br/> This report is designed to derive feedback from the candidate’s team members to provide different garnered views. It is meant to serve as a starting baseline for workplace development",
    "translations": [
      {
        "language": "AR",
        "text": "يعد تقييم °180 من أهم الأساليب الحديثة لتقييم سلوك المدير في بيئة العمل لإظهار وجهات نظر مختلفة حول أدائه المهني على عكس تقييم الأداء التقليدي الذي يركز بشكل أساسي على التغذية الراجعة المتفوقة للإدارة.<br/>  تم تصميم هذا التقرير لاستخلاص الملاحظات من أعضاء فريق المرشح لتقديم وجهات نظر مختلفة. من المفترض أن يكون بمثابة خط أساس لتطوير بيئة العمل"
      },
      {
        "language": "EN",
        "text": "180-degree performance appraisal is one of the most important modern methods of evaluating a manager’s behavior in the working environment to show different views on his professional performance, unlike the traditional performance appraisal, which mainly focuses on management / superior feedback"
      },
      {
        "language": "CS",
        "text": "180stupňové hodnocení výkonu je jednou z nejdůležitějších moderních metod hodnocení chování manažera v pracovním prostředí, která odráží různé pohledy na jeho profesionální výkon, na rozdíl od tradičního hodnocení výkonu, které se zaměřuje hlavně na zpětnou vazbu od vedení / nadřízených"
      }
    ]
  },
  {
    "key": "txtIntroductionpara1",
    "text": "360-degree performance appraisal is one of the most important modern methods of evaluating an employee's behavior in the working environment to show different views on his professional performance, unlike the traditional performance appraisal, which mainly focuses on management / superior feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "يعد تقييم °360 من أهم الأساليب الحديثة لتقييم سلوك الموظف في بيئة العمل بهدف إظهار وجهات النظر المختلفة حول أدائه المهني على عكس تقييم الأداء التقليدي الذي يعتمد بشكل رئيسي على آراء وملاحظات المدير المباشر/ الإدارة."
      },
      {
        "language": "FR",
        "text": "L’évaluation à 360 degrés est l’une des méthodes modernes les plus importantes pour évaluer le comportement d’un employé dans l’environnement de travail pour montrer des points de vue différents sur sa performance professionnelle, contrairement à l’évaluation traditionnelle du rendement, qui s’appuie principalement sur les points de vue et les commentaires du gestionnaire/administrateur direct."
      },
      {
        "language": "EN",
        "text": "360-degree performance appraisal is one of the most important modern methods of evaluating an employee's behavior in the working environment to show different views on his professional performance, unlike the traditional performance appraisal, which mainly focuses on management / superior feedback."
      },
      {
        "language": "CS",
        "text": "360stupňové hodnocení výkonu je jednou z nejdůležitějších moderních metod posuzování chování zaměstnance v pracovním prostředí, která umožňuje získat různé pohledy na jeho pracovní výkon, na rozdíl od tradičního hodnocení výkonu, které se zaměřuje především na zpětnou vazbu ze strany vedení či nadřízených."
      }
    ]
  },
  {
    "key": "txt_Thetableb_872",
    "text": "The table below shows the gap between <span class=\"font-medium\">{{0}}</span>’s current and previous evaluator scores across competencies:",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح الجدول أدناه الفجوة بين درجات المقيّمين الحالية والسابقة لـ <span class=\"font-medium\">{{0}}</span> عبر الجدارات:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Níže uvedená tabulka ukazuje rozdíly mezi <span class=\"font-medium\">{{0}}</span> a jeho předchozími hodnoceními hodnotitelů v jednotlivých kompetencích:"
      },
      {
        "language": "EN",
        "text": "The table below shows the gap between <span class=\"font-medium\">{{0}}</span>’s current and previous evaluator scores across competencies:"
      }
    ]
  },
  {
    "key": "txt_PreviousG_537",
    "text": "Previous Gap Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الجدارات حسب الدرجات السابقة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Analýza rozdílů z předchozího hodnocení"
      },
      {
        "language": "EN",
        "text": "Previous Gap Analysis"
      }
    ]
  },
  {
    "key": "txt_Evaluator_210",
    "text": "Evaluators’ Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Hodnocení hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Evaluators’ Score"
      }
    ]
  },
  {
    "key": "txt_Competenc_174",
    "text": "Competencies (Avg. Score)",
    "translations": [
      {
        "language": "AR",
        "text": "الجدارات (متوسط الدرجة)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kompetence (průměrné skóre)"
      },
      {
        "language": "EN",
        "text": "Competencies (Avg. Score)"
      }
    ]
  },
  {
    "key": "txt_Thetableb_492",
    "text": "The table below shows the gap between <span class=\"font-medium\">{{0}}’s</span> evaluator scores and the overall evaluator average across competencies:",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح الجدول أدناه الفجوة بين درجات المقيّمين لـ <span class=\"font-medium\">{{0}}</span> والمتوسط العام لدرجات المقيّمين عبر الجدارات:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Níže uvedená tabulka ukazuje rozdíl mezi skóre hodnotitelů <span class=\"font-medium\">{{0}}</span> a celkovým průměrem hodnotitelů napříč kompetencemi:"
      },
      {
        "language": "EN",
        "text": "The table below shows the gap between <span class=\"font-medium\">{{0}}’s</span> evaluator scores and the overall evaluator average across competencies:"
      }
    ]
  },
  {
    "key": "txt_AverageGa_133",
    "text": "Average Gap Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الجدارات حسب المتوسط العام "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Analýza průměrných rozdílů"
      },
      {
        "language": "EN",
        "text": "Average Gap Analysis"
      }
    ]
  },
  {
    "key": "txt_Cannotadd_133",
    "text": "Cannot add more than 3 emails!",
    "translations": [
      {
        "language": "AR",
        "text": "لا يمكن إضافة أكثر من 3 عناوين بريد إلكتروني!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nelze přidat více než 3 e-maily!"
      },
      {
        "language": "EN",
        "text": "Cannot add more than 3 emails!"
      }
    ]
  },
  {
    "key": "txt_ViewAll_199",
    "text": "View All",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الكل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zobrazit vše"
      },
      {
        "language": "EN",
        "text": "View All"
      }
    ]
  },
  {
    "key": "txt_Thereport_566",
    "text": "The report has been sent successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال التقرير بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zpráva byla úspěšně odeslána!"
      },
      {
        "language": "EN",
        "text": "The report has been sent successfully!"
      }
    ]
  },
  {
    "key": "txt_generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الجيل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Generace"
      },
      {
        "language": "EN",
        "text": "Generation"
      }
    ]
  },
  {
    "key": "txt_leaver_gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Pohlaví"
      },
      {
        "language": "EN",
        "text": "Gender"
      }
    ]
  },
  {
    "key": "txt_DateofBir_175",
    "text": "Date of Birth",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الميلاد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Datum narození"
      },
      {
        "language": "EN",
        "text": "Date of Birth"
      }
    ]
  },
  {
    "key": "txt_BandLevel_107",
    "text": "Band Level",
    "translations": [
      {
        "language": "AR",
        "text": "المستوى الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Úroveň pásma"
      },
      {
        "language": "EN",
        "text": "Band Level"
      }
    ]
  },
  {
    "key": "txt_AgeGroup_456",
    "text": "Age Group",
    "translations": [
      {
        "language": "AR",
        "text": "الفئة العمرية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Věková skupina"
      },
      {
        "language": "EN",
        "text": "Age Group"
      }
    ]
  },
  {
    "key": "txt_SearchLan_535",
    "text": "Search Language",
    "translations": [
      {
        "language": "AR",
        "text": "بحث عن لغة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyhledávání podle jazyka"
      },
      {
        "language": "EN",
        "text": "Search Language"
      }
    ]
  },
  {
    "key": "txtBlindSpot",
    "text": "Blind Spot",
    "translations": [
      {
        "language": "AR",
        "text": " نقاط ضعف غير مدركة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Slepé místo"
      },
      {
        "language": "EN",
        "text": "Blind Spot"
      }
    ]
  },
  {
    "key": "txt_HiddenStr_308",
    "text": "Hidden Strength",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط القوة المجهولة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Skrytá silná stránka"
      },
      {
        "language": "EN",
        "text": "Hidden Strength"
      }
    ]
  },
  {
    "key": "txt_Candidate_820",
    "text": "Candidate's evaluator score relative to the assessment average",
    "translations": [
      {
        "language": "AR",
        "text": "درجة تقييم المرشح مقارنةً بالمتوسط العام للتقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Hodnocení kandidáta hodnotiteli v porovnání s průměrem hodnocení"
      },
      {
        "language": "EN",
        "text": "Candidate's evaluator score relative to the assessment average"
      }
    ]
  },
  {
    "key": "txt_status",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Stav"
      },
      {
        "language": "EN",
        "text": "Status"
      }
    ]
  },
  {
    "key": "txt_RelationT_230",
    "text": "Relation Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع العلاقة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Typ vztahu"
      },
      {
        "language": "EN",
        "text": "Relation Type"
      }
    ]
  },
  {
    "key": "txt_user_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "E-mail"
      },
      {
        "language": "EN",
        "text": "Email"
      }
    ]
  },
  {
    "key": "txt_Evaluator_416",
    "text": "Evaluator’s Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المقيَم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Jméno hodnotitele"
      },
      {
        "language": "EN",
        "text": "Evaluator’s Name"
      }
    ]
  },
  {
    "key": "txt_id",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "هوية الموظف"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "ID"
      },
      {
        "language": "EN",
        "text": "ID"
      }
    ]
  },
  {
    "key": "txt_Searchfor_156",
    "text": "Search for evaluators...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث عن مقيًمين..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyhledat hodnotitele..."
      },
      {
        "language": "EN",
        "text": "Search for evaluators..."
      }
    ]
  },
  {
    "key": "customers",
    "text": "Customers",
    "translations": [
      {
        "language": "AR",
        "text": "العملاء"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zákazníci"
      },
      {
        "language": "EN",
        "text": "Customers"
      }
    ]
  },
  {
    "key": "team",
    "text": "Team",
    "translations": [
      {
        "language": "AR",
        "text": "أعضاء الفريق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Tým"
      },
      {
        "language": "EN",
        "text": "Team"
      }
    ]
  },
  {
    "key": "peers",
    "text": "Peers",
    "translations": [
      {
        "language": "AR",
        "text": "الزملاء"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kolegové"
      },
      {
        "language": "EN",
        "text": "Peers"
      }
    ]
  },
  {
    "key": "managers",
    "text": "Managers",
    "translations": [
      {
        "language": "AR",
        "text": "المدراء"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Manažeři"
      },
      {
        "language": "EN",
        "text": "Managers"
      }
    ]
  },
  {
    "key": "txtInvalidEmail",
    "text": "Please Enter a valid email!",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إدخال بريد إلكتروني صالح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zadejte prosím platnou e-mailovou adresu!"
      },
      {
        "language": "EN",
        "text": "Please Enter a valid email!"
      }
    ]
  },
  {
    "key": "txt_share_success",
    "text": "Email Shared Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم مشاركة البريد الإلكتروني بنجاح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "E-mail byl úspěšně sdílen!"
      },
      {
        "language": "EN",
        "text": "Email Shared Successfully!"
      }
    ]
  },
  {
    "key": "txt_SaveChang_949",
    "text": "Save Changes",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ التغييرات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Uložit změny"
      },
      {
        "language": "EN",
        "text": "Save Changes"
      }
    ]
  },
  {
    "key": "txt_Manager’s_302",
    "text": "Manager’s Email <span class=\"font-medium\">(Up to 3 emails per candidate)</span>",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني للمدير <span class=\"font-medium\">(حتى 3 عناوين بريد إلكتروني لكل مرشح)</span>"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "E-mail manažera <span class=\"font-medium\">(Maximálně 3 e-maily na kandidáta)</span>"
      },
      {
        "language": "EN",
        "text": "Manager’s Email <span class=\"font-medium\">(Up to 3 emails per candidate)</span>"
      }
    ]
  },
  {
    "key": "txt_AddManage_175",
    "text": "Add Managers",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مدير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přidat nadřízené"
      },
      {
        "language": "EN",
        "text": "Add Managers"
      }
    ]
  },
  {
    "key": "number_candidate_selected",
    "text": "{{0}} Candidates Selected",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد {{0}} مرشحًا"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "{{0}} vybraných uchazečů"
      },
      {
        "language": "EN",
        "text": "{{0}} Candidates Selected"
      }
    ]
  },
  {
    "key": "txt_{{0}}Cand_528",
    "text": "{{0}} Candidates Selected",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد {{0}} مرشحًا"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "{{0}} vybraných uchazečů"
      },
      {
        "language": "EN",
        "text": "{{0}} Candidates Selected"
      }
    ]
  },
  {
    "key": "txt_Typeanema_945",
    "text": "Type an email...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب عنوان البريد الإلكتروني..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zadejte e-mail..."
      },
      {
        "language": "EN",
        "text": "Type an email..."
      }
    ]
  },
  {
    "key": "txt_SendtoMan_390",
    "text": "Manager Emails",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني للمدراء"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "E-maily nadřízených"
      },
      {
        "language": "EN",
        "text": "Manager Emails"
      }
    ]
  },
  {
    "key": "OTHERS_option",
    "text": "Other Stakeholders",
    "translations": [
      {
        "language": "AR",
        "text": "أصحاب المعنيين الآخرين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Ostatní zúčastněné strany"
      },
      {
        "language": "EN",
        "text": "Other Stakeholders"
      }
    ]
  },
  {
    "key": "MANAGERS_option",
    "text": "Candidates’ Managers",
    "translations": [
      {
        "language": "AR",
        "text": "مدراء المرشحين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nadřízení uchazečů"
      },
      {
        "language": "EN",
        "text": "Candidates’ Managers"
      }
    ]
  },
  {
    "key": "CANDIDATES_option",
    "text": "Candidates Only",
    "translations": [
      {
        "language": "AR",
        "text": "المرشحون فقط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Pouze uchazeči"
      },
      {
        "language": "EN",
        "text": "Candidates Only"
      }
    ]
  },
  {
    "key": "txt_SharingDe_698",
    "text": "Sharing Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل المشاركة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Podrobnosti o sdílení"
      },
      {
        "language": "EN",
        "text": "Sharing Details"
      }
    ]
  },
  {
    "key": "txt_Candidate_553",
    "text": "Candidate",
    "translations": [
      {
        "language": "AR",
        "text": "المرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Uchazeč"
      },
      {
        "language": "EN",
        "text": "Candidate"
      }
    ]
  },
  {
    "key": "txt_Searchfor_637",
    "text": "Search for candidates...",
    "translations": [
      {
        "language": "AR",
        "text": "البحث عن مرشحين..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyhledat uchazeče..."
      },
      {
        "language": "EN",
        "text": "Search for candidates..."
      }
    ]
  },
  {
    "key": "txt_Descendin_169",
    "text": "Descending",
    "translations": [
      {
        "language": "AR",
        "text": "تنازلي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Sestupně"
      },
      {
        "language": "EN",
        "text": "Descending"
      }
    ]
  },
  {
    "key": "txt_Ascending_863",
    "text": "Ascending",
    "translations": [
      {
        "language": "AR",
        "text": "تصاعدي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vzestupně"
      },
      {
        "language": "EN",
        "text": "Ascending"
      }
    ]
  },
  {
    "key": "txt_ShowTranslations_104",
    "text": "Show Translations",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الترجمة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zobrazit překlady"
      },
      {
        "language": "EN",
        "text": "Show Translations"
      }
    ]
  },
  {
    "key": "txt_ClearTranslations_103",
    "text": "Hide Translations",
    "translations": [
      {
        "language": "AR",
        "text": "إخفاء الترجمة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Skrýt překlady"
      },
      {
        "language": "EN",
        "text": "Hide Translations"
      }
    ]
  },
  {
    "key": "txt_TranslationStarted_105",
    "text": "Comments Translation using AI Started",
    "translations": [
      {
        "language": "AR",
        "text": "جارٍ بدء ترجمة التعليقات باستخدام الذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Překlad komentářů pomocí AI byl zahájen"
      },
      {
        "language": "EN",
        "text": "Comments Translation using AI Started"
      }
    ]
  },
  {
    "key": "txt_TranslationFailed_107",
    "text": "Comment Translation Failed",
    "translations": [
      {
        "language": "AR",
        "text": "تعذر إكمال ترجمة التعليقات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Překlad komentáře se nezdařil"
      },
      {
        "language": "EN",
        "text": "Comment Translation Failed"
      }
    ]
  },
  {
    "key": "txt_TranslationSuccess_106",
    "text": "Comments Translated using AI",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات مترجمة باستخدام الذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Komentáře přeložené pomocí AI"
      },
      {
        "language": "EN",
        "text": "Comments Translated using AI"
      }
    ]
  },
  {
    "key": "txt_JoiningDa_751",
    "text": "Joining Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانضمام"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Datum nástupu"
      },
      {
        "language": "EN",
        "text": "Joining Date"
      }
    ]
  },
  {
    "key": "txt_Expired_218",
    "text": "Expired",
    "translations": [
      {
        "language": "AR",
        "text": "منتهي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vypršela platnost"
      },
      {
        "language": "EN",
        "text": "Expired"
      }
    ]
  },
  {
    "key": "txt_RELATIONS_203",
    "text": "RELATIONSHIP",
    "translations": [
      {
        "language": "AR",
        "text": "العلاقة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "VZTAH"
      },
      {
        "language": "EN",
        "text": "RELATIONSHIP"
      }
    ]
  },
  {
    "key": "txt_Current_703",
    "text": " ",
    "translations": [
      {
        "language": "AR",
        "text": "الحالي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Aktuální"
      },
      {
        "language": "EN",
        "text": "Current"
      }
    ]
  },
  {
    "key": "txt_Competenc_481",
    "text": "Competency Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان الجدارة والمهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Název kompetence"
      },
      {
        "language": "EN",
        "text": "Competency Title"
      }
    ]
  },
  {
    "key": "txt_TotalEval_522",
    "text": "Total Evaluators:",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المقيمون:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Celkový počet hodnotitelů:"
      },
      {
        "language": "EN",
        "text": "Total Evaluators:"
      }
    ]
  },
  {
    "key": "txt_Change(%)_323",
    "text": "Change (%)",
    "translations": [
      {
        "language": "AR",
        "text": "التغيير %"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Změna (%)"
      },
      {
        "language": "EN",
        "text": "Change (%)"
      }
    ]
  },
  {
    "key": "txt_BasicInfo_657",
    "text": "Basic Information",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات العامة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Základní informace"
      },
      {
        "language": "EN",
        "text": "Basic Information"
      }
    ]
  },
  {
    "key": "txt_copied_success",
    "text": "Email Copied Succesfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم نسخ الإيميل بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "E-mail úspěšně zkopírován!"
      },
      {
        "language": "EN",
        "text": "Email Copied Succesfully!"
      }
    ]
  },
  {
    "key": "txt_Candidate_106",
    "text": "Candidate Profile",
    "translations": [
      {
        "language": "AR",
        "text": "ملف المُرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Profil kandidáta"
      },
      {
        "language": "EN",
        "text": "Candidate Profile"
      }
    ]
  },
  {
    "key": "txt_ShowAITra_411",
    "text": "Show AI Translated",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الترجمة باستخدام AI"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zobrazit překlad AI"
      },
      {
        "language": "EN",
        "text": "Show AI Translated"
      }
    ]
  },
  {
    "key": "txt_ShowOrigi_520",
    "text": "Show Original Language",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الترجمة الأساسية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zobrazit původní jazyk"
      },
      {
        "language": "EN",
        "text": "Show Original Language"
      }
    ]
  },
  {
    "key": "txt_AITransla_706",
    "text": "AI Translated to Arabic",
    "translations": [
      {
        "language": "AR",
        "text": "مترجم للغة العربية باستخدام الذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přeloženo AI do arabštiny"
      },
      {
        "language": "EN",
        "text": "AI Translated to Arabic"
      }
    ]
  },
  {
    "key": "txt_SelectLan_536",
    "text": "Select Language",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار اللغة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyberte jazyk"
      },
      {
        "language": "EN",
        "text": "Select Language"
      }
    ]
  },
  {
    "key": "txt_Commentsw_787",
    "text": "Comments will be Auto translated from its original language to the selected language below:",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم ترجمة التعليقات تلقائيًا من لغتها الأصلية إلى اللغة المختارة أدناه."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Komentáře budou automaticky přeloženy z původního jazyka do níže vybraného jazyka:"
      },
      {
        "language": "EN",
        "text": "Comments will be Auto translated from its original language to the selected language below:"
      }
    ]
  },
  {
    "key": "txt_Nolanguag_955",
    "text": "No languages found",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم العثور على لغات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Nebyly nalezeny žádné jazyky"
      },
      {
        "language": "EN",
        "text": "No languages found"
      }
    ]
  },
  {
    "key": "txt_Peer-to-p_402",
    "text": "Peer-to-peer comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة زميل لـ زميل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Srovnání mezi kolegy"
      },
      {
        "language": "EN",
        "text": "Peer-to-peer comparison"
      }
    ]
  },
  {
    "key": "txt_ONAVERAGE_813",
    "text": "ON AVERAGE",
    "translations": [
      {
        "language": "AR",
        "text": "ضمن المتوسط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "PRŮMĚRNÉ"
      },
      {
        "language": "EN",
        "text": "ON AVERAGE"
      }
    ]
  },
  {
    "key": "txt_BELOWAVER_822",
    "text": "BELOW AVERAGE",
    "translations": [
      {
        "language": "AR",
        "text": "أقل من المتوسط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "POD PRŮMĚREM"
      },
      {
        "language": "EN",
        "text": "BELOW AVERAGE"
      }
    ]
  },
  {
    "key": "txt_ABOVEAVER_417",
    "text": "ABOVE AVERAGE",
    "translations": [
      {
        "language": "AR",
        "text": "أعلى من المتوسط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "NAD PRŮMĚREM"
      },
      {
        "language": "EN",
        "text": "ABOVE AVERAGE"
      }
    ]
  },
  {
    "key": "txt_Avg.Score_154",
    "text": "Avg. Score:",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط الدرجة:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Průměrné skóre:"
      },
      {
        "language": "EN",
        "text": "Avg. Score:"
      }
    ]
  },
  {
    "key": "txt_OverallEv_401",
    "text": "Overall Evaluators' Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الإجمالية للمقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Celkové skóre hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Overall Evaluators' Score"
      }
    ]
  },
  {
    "key": "txt_OverallSe_480",
    "text": "Overall Self Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الإجمالية للتقييم الذاتي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Celkové vlastní skóre"
      },
      {
        "language": "EN",
        "text": "Overall Self Score"
      }
    ]
  },
  {
    "key": "txt_MultiComp_220",
    "text": "Multi Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة المتعددة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Více srovnání"
      },
      {
        "language": "EN",
        "text": "Multi Comparison"
      }
    ]
  },
  {
    "key": "txt_Competenc_574",
    "text": "Competency {{0}} -",
    "translations": [
      {
        "language": "AR",
        "text": "الجدارة  والمهارة {{0}} -"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kompetence –"
      },
      {
        "language": "EN",
        "text": "Competency -"
      }
    ]
  },
  {
    "key": "txt_ResponseR_909",
    "text": "Response Rate:",
    "translations": [
      {
        "language": "AR",
        "text": "نسبة الاستجابة:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Míra odezvy:"
      },
      {
        "language": "EN",
        "text": "Response Rate:"
      }
    ]
  },
  {
    "key": "txt_Display_136",
    "text": "Display",
    "translations": [
      {
        "language": "AR",
        "text": "عرض"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zobrazit"
      },
      {
        "language": "EN",
        "text": "Display"
      }
    ]
  },
  {
    "key": "txt_Export_965",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Exportovat"
      },
      {
        "language": "EN",
        "text": "Export"
      }
    ]
  },
  {
    "key": "txt_Avg._473",
    "text": "Avg.",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Průměr"
      },
      {
        "language": "EN",
        "text": "Avg."
      }
    ]
  },
  {
    "key": "txt_Poweredby_158",
    "text": "Powered by",
    "translations": [
      {
        "language": "AR",
        "text": "بدعم من"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Poskytuje"
      },
      {
        "language": "EN",
        "text": "Powered by"
      }
    ]
  },
  {
    "key": "txt_Commentsw_699",
    "text": "Comments will automatically translate to <span class=\"text-exp font-medium\">[{{0}}]</span> while you browse candidates",
    "translations": [
      {
        "language": "AR",
        "text": "ستُترجم التعليقات تلقائيًا إلى <span class=\"text-exp font-medium\">[{{0}}]</span> أثناء تصفح المرشحين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Komentáře se automaticky přeloží do <span class=\"text-exp font-medium\">[{{0}}]</span> při procházení kandidátů"
      },
      {
        "language": "EN",
        "text": "Comments will automatically translate to <span class=\"text-exp font-medium\">[{{0}}]</span> while you browse candidates"
      }
    ]
  },
  {
    "key": "txt_AutoTrans_183",
    "text": "Auto Translation Activated",
    "translations": [
      {
        "language": "AR",
        "text": "تم تفعيل الترجمة التلقائية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Automatický překlad aktivován"
      },
      {
        "language": "EN",
        "text": "Auto Translation Activated"
      }
    ]
  },
  {
    "key": "txt_AutoTrans_102",
    "text": "Translate",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Přeložit"
      },
      {
        "language": "EN",
        "text": "Translate"
      }
    ]
  },
  {
    "key": "txtGapAnalysis",
    "text": "Gap Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الفجوات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Analýza mezer"
      },
      {
        "language": "EN",
        "text": "Gap Analysis"
      }
    ]
  },
  {
    "key": "txtRelations",
    "text": "Relations",
    "translations": [
      {
        "language": "AR",
        "text": "العلاقات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vztahy"
      },
      {
        "language": "EN",
        "text": "Relations"
      }
    ]
  },
  {
    "key": "txtPreviousChange",
    "text": "Previous/Change",
    "translations": [
      {
        "language": "AR",
        "text": "السابق / التغيير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Předchozí/Změnit"
      },
      {
        "language": "EN",
        "text": "Previous/Change"
      }
    ]
  },
  {
    "key": "txt_BS_639",
    "text": "BS",
    "translations": [
      {
        "language": "AR",
        "text": "ن.ض"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "BS"
      },
      {
        "language": "EN",
        "text": "BS"
      }
    ]
  },
  {
    "key": "txt_HS_343",
    "text": "HS",
    "translations": [
      {
        "language": "AR",
        "text": "ن.ق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "HS"
      },
      {
        "language": "EN",
        "text": "HS"
      }
    ]
  },
  {
    "key": "txt_Evaluator_821",
    "text": "Evaluator",
    "translations": [
      {
        "language": "AR",
        "text": "المقيّم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Hodnotitel"
      },
      {
        "language": "EN",
        "text": "Evaluator"
      }
    ]
  },
  {
    "key": "txt_AllCompet_165",
    "text": "All Competencies",
    "translations": [
      {
        "language": "AR",
        "text": "جميع الجدارات والمهارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Všechny kompetence"
      },
      {
        "language": "EN",
        "text": "All Competencies"
      }
    ]
  },
  {
    "key": "txt_Filters_872",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "التصفيات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Filtry"
      },
      {
        "language": "EN",
        "text": "Filters"
      }
    ]
  },
  {
    "key": "txt_Evaluator_603",
    "text": "Evaluators' Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Hodnocení hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Evaluators' Score"
      }
    ]
  },
  {
    "key": "txt_Candidate_918",
    "text": "Candidate Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Jméno kandidáta"
      },
      {
        "language": "EN",
        "text": "Candidate Name"
      }
    ]
  },
  {
    "key": "txt_MultiComp_896",
    "text": "Multi Compare",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة متعددة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Více srovnání"
      },
      {
        "language": "EN",
        "text": "Multi Compare"
      }
    ]
  },
  {
    "key": "txt_PeertoPee_262",
    "text": "Peer to Peer Compare",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة زميل لـ زميل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Srovnání mezi kolegy"
      },
      {
        "language": "EN",
        "text": "Peer to Peer Compare"
      }
    ]
  },
  {
    "key": "txt_onavg._505",
    "text": "on avg.",
    "translations": [
      {
        "language": "AR",
        "text": "ضمن المتوسط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "v průměru"
      },
      {
        "language": "EN",
        "text": "on avg."
      }
    ]
  },
  {
    "key": "txt_belowavg._684",
    "text": "below avg.",
    "translations": [
      {
        "language": "AR",
        "text": "أقل من المتوسط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "pod průměrem"
      },
      {
        "language": "EN",
        "text": "below avg."
      }
    ]
  },
  {
    "key": "txt_aboveavg._891",
    "text": "above avg.",
    "translations": [
      {
        "language": "AR",
        "text": "أعلى من المتوسط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "nad průměrem"
      },
      {
        "language": "EN",
        "text": "above avg."
      }
    ]
  },
  {
    "key": "txt_Change_346",
    "text": "Change",
    "translations": [
      {
        "language": "AR",
        "text": "التغيير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Změnit"
      },
      {
        "language": "EN",
        "text": "Change"
      }
    ]
  },
  {
    "key": "txt_Avg.Evalu_737",
    "text": "Avg. Evaluators' Score",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط درجة المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Průměrné hodnocení hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Avg. Evaluators' Score"
      }
    ]
  },
  {
    "key": "txtStatements",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Prohlášení"
      },
      {
        "language": "EN",
        "text": "Statements"
      }
    ]
  },
  {
    "key": "txtCompetencies",
    "text": "Competencies",
    "translations": [
      {
        "language": "AR",
        "text": "الجدارات والمهارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Kompetence"
      },
      {
        "language": "EN",
        "text": "Competencies"
      }
    ]
  },
  {
    "key": "360180_Feedback",
    "text": "360°/180° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم أداء  180°/360°"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "360°/180° zpětná vazba"
      },
      {
        "language": "EN",
        "text": "360°/180° Feedback"
      }
    ]
  },
  {
    "key": "txtSelectEntity",
    "text": "Select Entity",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vyberte subjekt"
      },
      {
        "language": "EN",
        "text": "Select Entity"
      }
    ]
  },
  {
    "key": "txt_Generatin_754",
    "text": "Generating Statements...",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ إنشاء عبارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Výsledky se generují. . . "
      },
      {
        "language": "EN",
        "text": "Generating Statements..."
      }
    ]
  },
  {
    "key": "txt_GenerateS_819",
    "text": "Generate Statements",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Vygenerovat výsledky"
      },
      {
        "language": "EN",
        "text": "Generate Statements"
      }
    ]
  },
  {
    "key": "txt180ManagementReport",
    "text": "180° Management Report\t",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير °180 الإداري"
      },
      {
        "language": "FR",
        "text": "Rapport de Gestion 180°"
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "180° Zpráva pro manažera"
      },
      {
        "language": "EN",
        "text": "180° Management Report\t"
      }
    ]
  },
  {
    "key": "txt180CandidateReport",
    "text": "180° Candidate Report\t",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير °180 للمرشح"
      },
      {
        "language": "FR",
        "text": "Rapport du Candidat 180°"
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "180° Zpráva pro respondenta"
      },
      {
        "language": "EN",
        "text": "180° Candidate Report\t"
      }
    ]
  },
  {
    "key": "txt_Standard_417",
    "text": "Locked",
    "translations": [
      {
        "language": "AR",
        "text": "مقفل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Zamčeno"
      },
      {
        "language": "EN",
        "text": "Locked"
      }
    ]
  },
  {
    "key": "txt_delete_template",
    "text": "Are you sure you want to delete this template?\t",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا النموذج؟"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": "Jste si jisti, že chcete vymazat tuto předlohu?"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this template?\t"
      }
    ]
  },
  {
    "key": "txt_candidates_reminders_1",
    "text": "Are you sure you want to send the reminder only to the selected candidates without notifying their evaluators  ",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من أنك تريد إرسال التذكير فقط إلى المرشحين المحددين دون إخطار المقيمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Möchten Sie die Erinnerung wirklich nur an die ausgewählten Kandidaten senden, ohne deren Gutachter zu benachrichtigen?"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Sei sicuro di voler inviare il promemoria solo ai candidati selezionati senza avvisare i loro valutatori?"
      },
      {
        "language": "CS",
        "text": "Opravdu chcete poslat připomenutí pouze vybraným respondentům  bez upozornění jejich hodnotitelů?"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to send the reminder only to the selected candidates without notifying their evaluators  "
      }
    ]
  },
  {
    "key": "txt_exclude_evaluators_reminder",
    "text": "Exclude Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "استثناء المقيمين من القائمة "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Evaluatoren ausschließen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Escludi i valutatori"
      },
      {
        "language": "CS",
        "text": "Mimo hodnotitele"
      },
      {
        "language": "EN",
        "text": "Exclude Evaluators"
      }
    ]
  },
  {
    "key": "txt180FeedbackAssessmentReport",
    "text": "180° Feedback Assessment Report\t",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير تقييم أداء°180"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "180° Feedback-Bericht"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "Relatório de avaliação de feedback 180°"
      },
      {
        "language": "IT",
        "text": "Report Assessment 180°"
      },
      {
        "language": "CS",
        "text": "Zpráva Hodnocení Zpětná vazba 180°"
      },
      {
        "language": "EN",
        "text": "180° Feedback Assessment Report\t"
      }
    ]
  },
  {
    "key": "txt180FeedbackAssessment",
    "text": "180° Feedback Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم أداء °180"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "180° Feedback-Assessment"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "Avaliação de Feedback 180°"
      },
      {
        "language": "IT",
        "text": "Feedback Assessment 180°"
      },
      {
        "language": "CS",
        "text": "Hodnocení Zpětná vazba 180°"
      },
      {
        "language": "EN",
        "text": "180° Feedback Assessment"
      }
    ]
  },
  {
    "key": "txt_select_placeholder",
    "text": "-Select-",
    "translations": [
      {
        "language": "AR",
        "text": "-اختر-"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Auswählen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "- Seleziona -"
      },
      {
        "language": "CS",
        "text": "Vybrat"
      },
      {
        "language": "EN",
        "text": "-Select-"
      }
    ]
  },
  {
    "key": "txt_remove_respondents_live_message",
    "text": "All selected respondents will be deleted, excluding those marked as completed.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم حذف جميع المستجيبين المحددين، باستثناء الذين استكملوا التقييم."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Alle ausgewählten Befragten werden gelöscht, mit Ausnahme derjenigen, die als abgeschlossen markiert sind."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Tutti i rispondenti selezionati verranno eliminati, ad eccezione di quelli contrassegnati come completati."
      },
      {
        "language": "CS",
        "text": "Všichni vybraní respondenti budou smazáni, s výjimkou těch, kteří jsou označeni jako vyplnění."
      },
      {
        "language": "EN",
        "text": "All selected respondents will be deleted, excluding those marked as completed."
      }
    ]
  },
  {
    "key": "txt_remove_candidates_live_message",
    "text": "All selected candidates and their evaluators will be deleted except those marked as completed.  ",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم حذف جميع المرشحين المحددين مع المقيمين الخاصين بهم، باستثناء الذين تم استكمال تقييمهم."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Alle ausgewählten Kandidaten und ihre Gutachter werden gelöscht, mit Ausnahme derjenigen, die als abgeschlossen markiert sind."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Tutti i candidati selezionati e i loro valutatori verranno eliminati, ad eccezione di quelli contrassegnati come completati."
      },
      {
        "language": "CS",
        "text": "Všichni vybraní respondenti a jejich hodnotitelé budou smazáni, s výjimkou těch, kteří jsou označeni jako dokončení."
      },
      {
        "language": "EN",
        "text": "All selected candidates and their evaluators will be deleted except those marked as completed.  "
      }
    ]
  },
  {
    "key": "txt_respondents",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Befragte"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "Respondentes"
      },
      {
        "language": "IT",
        "text": "Rispondenti"
      },
      {
        "language": "CS",
        "text": "Respondenti"
      },
      {
        "language": "EN",
        "text": "Respondents"
      }
    ]
  },
  {
    "key": "Stars",
    "text": "Stars",
    "translations": [
      {
        "language": "AR",
        "text": "النجوم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sterne"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Stelle"
      },
      {
        "language": "CS",
        "text": "Hvězdičky"
      },
      {
        "language": "EN",
        "text": "Stars"
      }
    ]
  },
  {
    "key": "Check",
    "text": "Check",
    "translations": [
      {
        "language": "AR",
        "text": "زر الاختيار"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Überprüfen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Verifica"
      },
      {
        "language": "CS",
        "text": "Kontrola"
      },
      {
        "language": "EN",
        "text": "Check"
      }
    ]
  },
  {
    "key": "Emoji",
    "text": "Emoji",
    "translations": [
      {
        "language": "AR",
        "text": "الرموز التعبيرية  "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Emoji"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Emoji"
      },
      {
        "language": "CS",
        "text": "Emoji"
      },
      {
        "language": "EN",
        "text": "Emoji"
      }
    ]
  },
  {
    "key": "text_here",
    "text": "text here…",
    "translations": [
      {
        "language": "AR",
        "text": "نص هنا..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Text hier…"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "testo qui…"
      },
      {
        "language": "CS",
        "text": "text . . . "
      },
      {
        "language": "EN",
        "text": "text here…"
      }
    ]
  },
  {
    "key": "Respondents",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Befragte"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Rispondenti"
      },
      {
        "language": "CS",
        "text": "Respondenti"
      },
      {
        "language": "EN",
        "text": "Respondents"
      }
    ]
  },
  {
    "key": "txt_totalbalance",
    "text": "Total Balance",
    "translations": [
      {
        "language": "AR",
        "text": "الرصيد الإجمالي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Gesamtsaldo"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Saldo totale"
      },
      {
        "language": "CS",
        "text": "Celkový zůstatek"
      },
      {
        "language": "EN",
        "text": "Total Balance"
      }
    ]
  },
  {
    "key": "txt_allrespondents",
    "text": "All Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "جميع المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Alle Befragten"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Tutti i rispondenti"
      },
      {
        "language": "CS",
        "text": "Všichni respondenti"
      },
      {
        "language": "EN",
        "text": "All Respondents"
      }
    ]
  },
  {
    "key": "txt_ExportRep_183",
    "text": "Export Report",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bericht exportieren"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Esporta il report"
      },
      {
        "language": "CS",
        "text": "Exportovat zprávu"
      },
      {
        "language": "EN",
        "text": "Export Report"
      }
    ]
  },
  {
    "key": "txtAvgScore",
    "text": "Avg. Score",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط الدرجة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Durchschnittliche Punktzahl"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Punteggio medio"
      },
      {
        "language": "CS",
        "text": "Průměrné skóre"
      },
      {
        "language": "EN",
        "text": "Avg. Score"
      }
    ]
  },
  {
    "key": "txt_Atleast3c_916",
    "text": "At least 3 competencies are required. It's recommended to select 5 to 15.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار 3 جدارات ومهارات كحد أدنى، مع توصية باختيار من 5 إلى 15 جدارة ومهارة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Es sind mindestens 3 Kompetenzen erforderlich. Es wird empfohlen, 5 bis 15 auszuwählen."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Sono richieste almeno 3 competenze. Si consiglia di selezionarne da 5 a 15."
      },
      {
        "language": "CS",
        "text": "Vyžadují se alespoň 3 kompetence. Doporučuje se vybrat 5 až 15."
      },
      {
        "language": "EN",
        "text": "At least 3 competencies are required. It's recommended to select 5 to 15."
      }
    ]
  },
  {
    "key": "txt_Candidate_604",
    "text": "Candidates and evaluators response rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل استجابة المرشحين والمقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Antwortrate der Kandidaten und Gutachter"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Tasso di risposta di candidati e valutatori"
      },
      {
        "language": "CS",
        "text": "Míra odezvy respondentů a hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Candidates and evaluators response rate"
      }
    ]
  },
  {
    "key": "txt_response_rete_tooltip",
    "text": "Overall response rate of all active respondents",
    "translations": [
      {
        "language": "AR",
        "text": "نسبة الاستجابة الإجمالية لجميع المستجيبين الفعالين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Gesamtantwortrate aller aktiven Befragten"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Tasso di risposta complessivo di tutti i rispondenti attivi"
      },
      {
        "language": "CS",
        "text": "Celková míra odezvy všech aktivních respondentů"
      },
      {
        "language": "EN",
        "text": "Overall response rate of all active respondents"
      }
    ]
  },
  {
    "key": "CLOSED",
    "text": "CLOSED",
    "translations": [
      {
        "language": "AR",
        "text": " مغلق  "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "GESCHLOSSEN"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "FECHADO"
      },
      {
        "language": "IT",
        "text": "CHIUSO"
      },
      {
        "language": "CS",
        "text": "UZAVŘENO"
      },
      {
        "language": "EN",
        "text": "CLOSED"
      }
    ]
  },
  {
    "key": "LIVE",
    "text": "LIVE",
    "translations": [
      {
        "language": "AR",
        "text": "مباشر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "LIVE"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "AO VIVO"
      },
      {
        "language": "IT",
        "text": "ATTIVO"
      },
      {
        "language": "CS",
        "text": "ŽIVĚ"
      },
      {
        "language": "EN",
        "text": "LIVE"
      }
    ]
  },
  {
    "key": "DRAFT",
    "text": "DRAFT",
    "translations": [
      {
        "language": "AR",
        "text": "مسودة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "ENTWURF"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "RASCUNHO"
      },
      {
        "language": "IT",
        "text": "BOZZA"
      },
      {
        "language": "CS",
        "text": "NÁVRH"
      },
      {
        "language": "EN",
        "text": "DRAFT"
      }
    ]
  },
  {
    "key": "CustomizetheScaleSetup",
    "text": "Customize the Scale Setup that will be sent to the respondents. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص إعداد المقياس للعبارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Passen Sie die Skaleneinstellungen an, die an die Befragten gesendet werden."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "Personalize a configuração da escala que será enviada aos respondentes."
      },
      {
        "language": "IT",
        "text": "Personalizza la configurazione della scala di valutazione che verrà inviata ai rispondenti."
      },
      {
        "language": "CS",
        "text": "Přizpůsobte si nastavení stupnice, které bude zasláno respondentům."
      },
      {
        "language": "EN",
        "text": "Customize the Scale Setup that will be sent to the respondents. "
      }
    ]
  },
  {
    "key": "ScaleSetup",
    "text": "Scale Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد المقياس"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Skalen Setup"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "Configuração de escala"
      },
      {
        "language": "IT",
        "text": "Configurazione della scala di valutazione"
      },
      {
        "language": "CS",
        "text": "Nastavení stupnice"
      },
      {
        "language": "EN",
        "text": "Scale Setup"
      }
    ]
  },
  {
    "key": "txt_Customize_299",
    "text": "Customize the Welcome Message that will be sent to the respondents. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص رسالة الترحيب التي سوف تظهر للمستجيبين قبل بدء التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Passen Sie die Willkommensnachricht an, die an die Befragten gesendet wird."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "Personalize a mensagem de boas-vindas que será enviada aos respondentes."
      },
      {
        "language": "IT",
        "text": "Personalizza il messaggio di benvenuto che verrà inviato ai rispondenti."
      },
      {
        "language": "CS",
        "text": "Přizpůsobte si nastavení zprávy, které bude zasláno respondentům."
      },
      {
        "language": "EN",
        "text": "Customize the Welcome Message that will be sent to the respondents. "
      }
    ]
  },
  {
    "key": "WelcomeMessage",
    "text": "Welcome Message",
    "translations": [
      {
        "language": "AR",
        "text": "رسالة الترحيب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Willkommensnachricht"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "Mensagem de boas-vindas"
      },
      {
        "language": "IT",
        "text": "Messaggio di benvenuto"
      },
      {
        "language": "CS",
        "text": "Úvodní zpráva"
      },
      {
        "language": "EN",
        "text": "Welcome Message"
      }
    ]
  },
  {
    "key": "CustomizeYourSurvey",
    "text": "Customize your assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Passen Sie Ihre Bewertung an"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "Personalize sua pesquisa"
      },
      {
        "language": "IT",
        "text": "Personalizza il tuo Assessment"
      },
      {
        "language": "CS",
        "text": "Přizpůsobte si své hodnocení"
      },
      {
        "language": "EN",
        "text": "Customize your assessment"
      }
    ]
  },
  {
    "key": "SurveyOptions",
    "text": "Assessment Options",
    "translations": [
      {
        "language": "AR",
        "text": "خيارات التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bewertungsoptionen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": "Opções de pesquisa"
      },
      {
        "language": "IT",
        "text": "Opzioni dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Možnosti hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Options"
      }
    ]
  },
  {
    "key": "txt_NoComment_852",
    "text": "No Comments",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد تعليقات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kein Kommentar"
      },
      {
        "language": "PT",
        "text": "Sem comentários"
      },
      {
        "language": "IT",
        "text": "Nessun commento"
      },
      {
        "language": "CS",
        "text": "Žádné komentáře"
      },
      {
        "language": "EN",
        "text": "No Comments"
      }
    ]
  },
  {
    "key": "txt_datesupdated",
    "text": "Dates updated successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديث التواريخ بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Daten erfolgreich aktualisiert!"
      },
      {
        "language": "PT",
        "text": "Datas atualizadas com sucesso!"
      },
      {
        "language": "IT",
        "text": "Date aggiornate con successo!"
      },
      {
        "language": "CS",
        "text": "Data byla úspěšně aktualizována!"
      },
      {
        "language": "EN",
        "text": "Dates updated successfully!"
      }
    ]
  },
  {
    "key": "txt_errExit62",
    "text": "has already been added to this candidate.",
    "translations": [
      {
        "language": "AR",
        "text": "تمت إضافته لهذا المرشح سابقاً."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "wurde diesem Kandidaten bereits hinzugefügt."
      },
      {
        "language": "PT",
        "text": "já foi adicionado a este candidato."
      },
      {
        "language": "IT",
        "text": "è già stato aggiunto a questo candidato."
      },
      {
        "language": "CS",
        "text": "tomuto respondentovi bylo již přidáno."
      },
      {
        "language": "EN",
        "text": "has already been added to this candidate."
      }
    ]
  },
  {
    "key": "txt_errExit61",
    "text": "Evaluator with email",
    "translations": [
      {
        "language": "AR",
        "text": "المقيّم مع البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Gutachter mit E-Mail"
      },
      {
        "language": "PT",
        "text": "Avaliador com e-mail"
      },
      {
        "language": "IT",
        "text": "Valutatore con email"
      },
      {
        "language": "CS",
        "text": "Hodnotitel s e-mailem"
      },
      {
        "language": "EN",
        "text": "Evaluator with email"
      }
    ]
  },
  {
    "key": "txt_errExit52",
    "text": "belongs to the candidate and cannot be assigned as their own evaluator.",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني ينتمي للمرشح ولا يمكن تعيينه كمقيِّم خاص به."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "gehört dem Kandidaten und kann nicht als dessen eigener Gutachter eingesetzt werden."
      },
      {
        "language": "PT",
        "text": "pertence ao candidato e não pode ser designado como seu próprio avaliador."
      },
      {
        "language": "IT",
        "text": "appartiene al candidato e non può essere assegnato come proprio valutatore."
      },
      {
        "language": "CS",
        "text": "patří danému uchazeči a nelze jej určit jako jeho vlastního hodnotitele."
      },
      {
        "language": "EN",
        "text": "belongs to the candidate and cannot be assigned as their own evaluator."
      }
    ]
  },
  {
    "key": "txt_errExit42",
    "text": "has already been added.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إضافته سابقاً."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "wurde bereits hinzugefügt."
      },
      {
        "language": "PT",
        "text": "já foi adicionado."
      },
      {
        "language": "IT",
        "text": "è già stato aggiunto."
      },
      {
        "language": "CS",
        "text": "již bylo přidáno."
      },
      {
        "language": "EN",
        "text": "has already been added."
      }
    ]
  },
  {
    "key": "txt_errExit41",
    "text": "Candidate with email",
    "translations": [
      {
        "language": "AR",
        "text": "المرشح مع البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidat mit E-Mail"
      },
      {
        "language": "PT",
        "text": "Candidato com e-mail"
      },
      {
        "language": "IT",
        "text": "Candidato con email"
      },
      {
        "language": "CS",
        "text": "Uchazeč s e-mailem"
      },
      {
        "language": "EN",
        "text": "Candidate with email"
      }
    ]
  },
  {
    "key": "txt_errExit3",
    "text": "This evaluator has already been added to this candidate.",
    "translations": [
      {
        "language": "AR",
        "text": "تمت إضافة هذا المقيّم لهذا المرشح سابقاً."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Dieser Gutachter wurde diesem Kandidaten bereits hinzugefügt."
      },
      {
        "language": "PT",
        "text": "Este avaliador já foi adicionado a este candidato."
      },
      {
        "language": "IT",
        "text": "Questo valutatore è già stato aggiunto a questo candidato."
      },
      {
        "language": "CS",
        "text": "Tento hodnotitel již byl k tomuto uchazeči přiřazen."
      },
      {
        "language": "EN",
        "text": "This evaluator has already been added to this candidate."
      }
    ]
  },
  {
    "key": "txt_errExit2",
    "text": "A candidate cannot be assigned as their own evaluator.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يمكن تعيين مرشح كمقيِّم لنفسه."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ein Kandidaten kann nicht als sein eigener Gutachter hinzugefügt werden."
      },
      {
        "language": "PT",
        "text": "Um candidato não pode ser designado como seu próprio avaliador."
      },
      {
        "language": "IT",
        "text": "Un candidato non può essere assegnato come proprio valutatore."
      },
      {
        "language": "CS",
        "text": "Uchazeč nemůže být jmenován svým vlastním hodnotitelem."
      },
      {
        "language": "EN",
        "text": "A candidate cannot be assigned as their own evaluator."
      }
    ]
  },
  {
    "key": "txt_errExit1",
    "text": "This candidate has already been added to the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "تمت إضافة هذا المرشح للتقييم سابقاً."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Dieser Kandidat wurde bereits zur Bewertung hinzugefügt."
      },
      {
        "language": "PT",
        "text": "Este candidato já foi adicionado à avaliação."
      },
      {
        "language": "IT",
        "text": "Questo candidato è già stato aggiunto all'Assessment."
      },
      {
        "language": "CS",
        "text": "Tento uchazeč již byl zařazen do výběrového řízení."
      },
      {
        "language": "EN",
        "text": "This candidate has already been added to the assessment."
      }
    ]
  },
  {
    "key": "txt_add_resmorb",
    "text": "You can add respondents manually or in bulk",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إضافة المستجيبين يدوياً أو  باستخدام جدول البيانات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sie können Befragte manuell oder als Paket hinzufügen"
      },
      {
        "language": "PT",
        "text": "Você pode adicionar entrevistados manualmente ou em massa"
      },
      {
        "language": "IT",
        "text": "Puoi aggiungere rispondenti manualmente o in blocco"
      },
      {
        "language": "CS",
        "text": "Respondenty můžete přidávat ručně nebo hromadně"
      },
      {
        "language": "EN",
        "text": "You can add respondents manually or in bulk"
      }
    ]
  },
  {
    "key": "txtChangeCompetency",
    "text": "Change Competency",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير الجدارة والمهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kompetenz ändern"
      },
      {
        "language": "PT",
        "text": "Alterar competência"
      },
      {
        "language": "IT",
        "text": "Modifica la competenza"
      },
      {
        "language": "CS",
        "text": "Schopnost přizpůsobit se změnám"
      },
      {
        "language": "EN",
        "text": "Change Competency"
      }
    ]
  },
  {
    "key": "txt_go_closed_180",
    "text": "This assessment will now be closed and you will no longer be able to make any changes or add new respondents. Any candidate without self-evaluation or with less than 3 Team evaluators submitting the assessment will be excluded from the analysis.\t",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إنهاء هذا التقييم الآن ولن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين. سيتم استبعاد المرشح في حال لم يقم بتعبئة التقييم الذاتي أو في حال كان لديه أقل من ثلاثة مقيميين من الفريق."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Dieses Assessment wird nun geschlossen und Sie können keine Änderungen mehr vornehmen oder neue Befragte hinzufügen. Jeder Kandidat ohne Selbstbewertung oder mit weniger als 3 Teambewertern, die das Assessment einreichen, wird von der Analyse ausgeschlossen."
      },
      {
        "language": "PT",
        "text": "Esta avaliação será encerrada e você não poderá mais fazer alterações ou adicionar novos entrevistados. Qualquer candidato sem autoavaliação ou com menos de 3 avaliadores da Equipe submetendo a avaliação será excluído da análise."
      },
      {
        "language": "IT",
        "text": "Questo Assessment ora verrà chiuso e non sarà più possibile apportare modifiche o aggiungere nuovi rispondenti. Qualsiasi candidato privo di autovalutazione o con meno di 3 valutatori del Team che abbiano completato la valutazione sarà escluso dall’analisi."
      },
      {
        "language": "CS",
        "text": "Toto hodnocení bude nyní uzavřeno a již nebudete moci provádět žádné změny ani přidávat nové respondenty. Každý kandidát, který neprovedl sebehodnocení nebo u kterého hodnocení odevzdalo méně než 3 hodnotitelé z týmu, bude z analýzy vyloučen."
      },
      {
        "language": "EN",
        "text": "This assessment will now be closed and you will no longer be able to make any changes or add new respondents. Any candidate without self-evaluation or with less than 3 Team evaluators submitting the assessment will be excluded from the analysis.\t"
      }
    ]
  },
  {
    "key": "txt_Clickpubt_771",
    "text": "Click “<b>Publish</b>” to save and start using your template!",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"<b>نشر</b>\" للحفظ والبدء في استخدام النموذج الخاص بك."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie auf „<b>Veröffentlichen</b>“, um Ihre Vorlage zu speichern und zu verwenden!"
      },
      {
        "language": "PT",
        "text": "Clique em “<b>Publicar</b>” para salvar e começar a usar seu modelo!"
      },
      {
        "language": "IT",
        "text": "Clicca su “Pubblica” per salvare e iniziare a utilizzare il tuo template!"
      },
      {
        "language": "CS",
        "text": "Kliknutím na “<b>Publikovat</b>”   uložte šablonu a začněte ji používat!"
      },
      {
        "language": "EN",
        "text": "Click “<b>Publish</b>” to save and start using your template!"
      }
    ]
  },
  {
    "key": "txt_PublishTe_975",
    "text": "Publish Template",
    "translations": [
      {
        "language": "AR",
        "text": "نشر النموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlage veröffentlichen"
      },
      {
        "language": "PT",
        "text": "Publicar modelo"
      },
      {
        "language": "IT",
        "text": "Pubblica il template"
      },
      {
        "language": "CS",
        "text": "Publikovat šablonu"
      },
      {
        "language": "EN",
        "text": "Publish Template"
      }
    ]
  },
  {
    "key": "txt_Clickhere_327",
    "text": "Click here to select the statements under each competency and add custom statements by clicking “<b>Add Statement</b>”! <br>Hint: You can add custom statements to predefined competencies.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لاختيار العبارات تحت كل جدارة ومهارة وقم بإضافة عبارات مخصصة من خلال النقر على \"<b>إضافة عبارة</b>\". <br>تلميح: باستطاعتك إضافة عبارات مخصصة تحت الجدارات والمهارات المُعرفة مسبقاً."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Aussagen unter jeder Kompetenz auszuwählen, und fügen Sie benutzerdefinierte Aussagen hinzu, indem Sie auf „<b>Aussage hinzufügen</b>“ klicken! <br>Tipp: Sie können  zu vordefinierten Kompetenzen benutzerdefinierte Aussagen hinzufügen."
      },
      {
        "language": "PT",
        "text": "Clique aqui para selecionar as declarações em cada competência e adicionar declarações personalizadas clicando em “<b>Adicionar Declaração</b>”! <br>Dica: você pode adicionar declarações personalizadas a competências predefinidas."
      },
      {
        "language": "IT",
        "text": "Clicca qui per selezionare le affermazioni sotto ogni competenza e aggiungerne di personalizzate cliccando su “Aggiungi affermazione”! \nSuggerimento: Puoi aggiungere le affermazioni personalizzate anche alle competenze predefinite."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, abyste vybrali popisy u jednotlivých kompetencí, a přidejte vlastní popisy kliknutím na “<b>Přidat hodnocení</b>”! <br> Tip: K předdefinovaným kompetencím můžete přidávat vlastní popisy."
      },
      {
        "language": "EN",
        "text": "Click here to select the statements under each competency and add custom statements by clicking “<b>Add Statement</b>”! <br>Hint: You can add custom statements to predefined competencies."
      }
    ]
  },
  {
    "key": "txt_Tocreatea_662",
    "text": "To create a new 360/180 assessment template, click on “<b>New Assessment</b>”.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"<b>تقييم جديد</b>\" لإنشاء نموذج جديد لتقييم 360/180."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Um eine neue 360/180-Assessmentvorlage zu erstellen, klicken Sie auf „<b>Neues Assessment</b>“."
      },
      {
        "language": "PT",
        "text": "Para criar um novo modelo de avaliação 360/180, clique em “<b>Nova Avaliação</b>”."
      },
      {
        "language": "IT",
        "text": "Per creare un nuovo template dell'Assessment 360°/180°, clicca su “Nuovo Assessment”."
      },
      {
        "language": "CS",
        "text": "Chcete-li vytvořit novou šablonu hodnocení 360/180, klikněte na “<b>Nové hodnocení</b>”"
      },
      {
        "language": "EN",
        "text": "To create a new 360/180 assessment template, click on “<b>New Assessment</b>”."
      }
    ]
  },
  {
    "key": "txtComments180_desc",
    "text": "In the “<b>Comments</b>” page, written Strength Areas and Areas of Improvements from candidates (self) and evaluators during the assessment are shown under Self, and Evaluators (Team, and Peers)<br> Note: Evaluators' comments are anonymous.\t",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"<b>التعليقات</b>\"، يتم عرض تعليقات نقاط القوة ومجالات التحسين من المرشحين والمقيمين أثناء أداء التقييم وتكون التعليقات من التقييم الذاتي والتقييم من أعضاء الفريق والزملاء."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Auf der Seite „<b>Kommentare</b>“ werden schriftlich Stärken und Verbesserungsmöglichkeiten von Kandidaten und Bewertern während des Assessments unter „Eigenbewertung“ und \"Fremdbewertung\"(Team und Kollegen) angezeigt.<br> Hinweis: Bewerter 'Kommentare sind anonym."
      },
      {
        "language": "PT",
        "text": "Na página “<b>Comentários</b>”, as Áreas de Força e as Áreas de Melhorias escritas pelos candidatos (próprios) e avaliadores durante a avaliação são mostradas em Próprios e Avaliadores (Equipe e Pares)<br> Observação: os comentários dos avaliadores são anônimos."
      },
      {
        "language": "IT",
        "text": "Nella pagina “Commenti”, i punti di forza e le aree di miglioramento scritti dai candidati (autovalutazione) e dai valutatori durante la compilazione dell'Assessment sono mostrate sotto “Autovalutazione” e “Valutatori (Team e Colleghi)”. \nNota: I commenti dei valutatori sono anonimi."
      },
      {
        "language": "CS",
        "text": "Na stránce „<b>Komentáře</b>“ se v sekci „Vlastní“ zobrazují silné stránky a oblasti k zlepšení, které během hodnocení uvedli respondenti (sami o sobě) a hodnotitelé, a v sekci „Hodnotitelé (tým a kolegové)“<br> Poznámka: Komentáře hodnotitelů jsou anonymní."
      },
      {
        "language": "EN",
        "text": "In the “<b>Comments</b>” page, written Strength Areas and Areas of Improvements from candidates (self) and evaluators during the assessment are shown under Self, and Evaluators (Team, and Peers)<br> Note: Evaluators' comments are anonymous.\t"
      }
    ]
  },
  {
    "key": "txtAddEvaluators180_desc",
    "text": " Click here to define each candidate’s evaluator and their relationship type from the dropdown menu.<br>Note: Each candidate must at least 3 Team.\tIf peers are included, at least 2 Peer.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتحديد المُقَيِّم لكل مرشح ونوع العلاقة من القائمة المنسدلة. ملاحظة: يجب أن يكون لكل مرشح  3 أعضاء فريق كحد أدنى. إذا تم تضمين الزملاء، يجب أن يكون هناك 2 من الزملاء كحد أدنى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Klicken Sie hier, um den Bewerter jedes Kandidaten und seinen Beziehungstyp aus dem Dropdown-Menü zu definieren.<br>Hinweis: Jeder Kandidat muss mindestens 3 Teams umfassen. Wenn Peers enthalten sind, mindestens 2 Peers."
      },
      {
        "language": "PT",
        "text": "Clique aqui para definir o avaliador de cada candidato e seu tipo de relacionamento no menu suspenso.<br>Observação: Cada candidato deve ter pelo menos 3 equipes. Se pares forem incluídos, pelo menos 2 pares."
      },
      {
        "language": "IT",
        "text": "Clicca qui per definire ciascun valutatore per candidato e il tipo di relazione dal menu a tendina. \nNota: Ogni candidato deve avere almeno 3 valutatori del team. Se vengono inclusi i colleghi, devono essere almeno 2."
      },
      {
        "language": "CS",
        "text": " Klikněte sem a z rozevíracího seznamu vyberte hodnotitele pro každého kandidáta a typ jejich vztahu.<br>Poznámka: Každý kandidát musí mít alespoň 3 členy týmu.    Pokud jsou zahrnuti kolegové, musí být alespoň 2 kolegové."
      },
      {
        "language": "EN",
        "text": " Click here to define each candidate’s evaluator and their relationship type from the dropdown menu.<br>Note: Each candidate must at least 3 Team.\tIf peers are included, at least 2 Peer."
      }
    ]
  },
  {
    "key": "txt_Havesomeo_689",
    "text": "Have some of your candidates and evaluators completed their assessments while others are still in progress? No worries! You can view their reports by clicking “<b>Close</b>” for the chosen candidate. To view the closed candidate’s report, click on “Open”.<br> Note: To close a candidate's report, it is required a minimum of self-assessment, 3 Team assessments, and If peers are included, 2 Peer assessments to be completed.",
    "translations": [
      {
        "language": "AR",
        "text": "هل استكمل بعض المرشحين والمقيمين لديك تقييماتهم بينما لا يزال البعض الآخر قيد الإنجاز؟ لا تقلق! يمكنك عرض هذه التقارير بالنقر على \"أغلق الآن\" للمرشح المختار. وللاطلاع على تقرير المرشح المغلق انقر على “فتح”. ملحوظة: لإغلاق تقرير المرشح، يلزم استكمال التقييم الذاتي، و3 تقييمات من أعضاء الفريق.  إذا تم تضمين الزملاء،  يلزم استكمال تقييمين من الزملاء."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Haben einige Ihrer Kandidaten und Bewerter ihre Assessments abgeschlossen, während andere noch dabei sind? Kein Problem! Sie können ihre Berichte anzeigen, indem Sie für den ausgewählten Kandidaten auf „<b>Schließen</b>“ klicken. Um den Bericht des abgeschlossenen Kandidaten anzuzeigen, klicken Sie auf „Öffnen“.<br> Hinweis: Um den Bericht eines Kandidaten zu schließen, müssen mindestens eine Selbstbewertung, 3 Teambewertungen und (sofern Kollegen einbezogen werden) 2 Peer-Bewertungen abgeschlossen sein."
      },
      {
        "language": "PT",
        "text": "Alguns de seus candidatos e avaliadores concluíram suas avaliações enquanto outros ainda estão em andamento? Sem problemas! Você pode visualizar seus relatórios clicando em “<b>Fechar</b>” do candidato escolhido. Para visualizar o relatório do candidato fechado, clique em “Abrir”.<br> Nota: Para fechar o relatório de um candidato é necessário um mínimo de autoavaliação, 3 avaliações de equipe e, caso sejam incluídos pares, 2 avaliações de pares a serem realizadas."
      },
      {
        "language": "IT",
        "text": "Alcuni dei tuoi candidati e valutatori hanno completato il loro assessment mentre altri sono ancora in corso? Nessun problema! Puoi visualizzare i loro report cliccando su “Chiudi” per il candidato scelto. Per aprire il report chiuso di un candidato, clicca su “Apri”. \nNota: Per chiudere il report di un candidato è necessario almeno un'autovalutazione, 3 valutazioni del team e 2 valutazioni dei colleghi, se inclusi."
      },
      {
        "language": "CS",
        "text": "Dokončili někteří z vašich kandidátů a hodnotitelů hodnocení, zatímco u jiných ještě probíhá? Žádný problém! Zprávy si můžete prohlédnout kliknutím na „<b>Zavřít</b>“ u vybraného kandidáta. Chcete-li zobrazit zprávu uzavřeného kandidáta, klikněte na „Otevřít“.<br> Poznámka: K uzavření zprávy kandidáta je nutné vyplnit minimálně sebehodnocení, 3 hodnocení týmu a, pokud jsou zahrnuti kolegové, 2 hodnocení kolegy."
      },
      {
        "language": "EN",
        "text": "Have some of your candidates and evaluators completed their assessments while others are still in progress? No worries! You can view their reports by clicking “<b>Close</b>” for the chosen candidate. To view the closed candidate’s report, click on “Open”.<br> Note: To close a candidate's report, it is required a minimum of self-assessment, 3 Team assessments, and If peers are included, 2 Peer assessments to be completed."
      }
    ]
  },
  {
    "key": "txtPublish_desc",
    "text": "Once you set up the invitation & reminder emails, click here to send the assessment invitations and go live! ",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد أن تقوم بإعداد الدعوات لاستكمال التقييم، انقر هنا لإرسال دعوات التقييم وإطلاق التقييم مباشرةً!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Sobald Sie die Einladungs- und Erinnerungs-E-Mails eingerichtet haben, klicken Sie hier, um die Assessment- einladungen zu versenden und los zu legen!"
      },
      {
        "language": "PT",
        "text": "Depois de configurar os e-mails de convite e lembrete, clique aqui para enviar os convites de avaliação e entrar no ar!"
      },
      {
        "language": "IT",
        "text": "Dopo aver configurato le email di invito e di promemoria, clicca qui per inviare gli inviti alla compilazione dell'Assessment e avviare il processo!"
      },
      {
        "language": "CS",
        "text": "Jakmile nastavíte e-maily s pozvánkami a upomínkami, klikněte sem, abyste odeslali pozvánky k hodnocení a spustili akci!"
      },
      {
        "language": "EN",
        "text": "Once you set up the invitation & reminder emails, click here to send the assessment invitations and go live! "
      }
    ]
  },
  {
    "key": "Email_Templates_desc",
    "text": "In the <b>Email Templates</b>, you invite the respondents you input in the “<b>Candidates</b>” section through email.",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>دعوات استكمال التقييم </b>تقوم بدعوة المستجيبين المضافين في خطوة \"<b>المستجيبين</b>\" من خلال البريد الإلكتروني."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "In den <b>E-Mail-Vorlagen</b> laden Sie die Befragten, die Sie im Abschnitt „<b>Kandidaten</b>“ eingegeben haben, per E-Mail ein."
      },
      {
        "language": "PT",
        "text": "Nos <b>Modelos de e-mail</b>, você convida os entrevistados inseridos na seção “<b>Candidatos</b>” por e-mail."
      },
      {
        "language": "IT",
        "text": "Nei Template email, inviti i rispondenti inseriti nella sezione “Candidati” tramite email."
      },
      {
        "language": "CS",
        "text": "V části <b>Šablony e-mailů</b> pozvete e-mailem respondenty, které jste zadali v sekci „<b>respondenti</b>“."
      },
      {
        "language": "EN",
        "text": "In the <b>Email Templates</b>, you invite the respondents you input in the “<b>Candidates</b>” section through email."
      }
    ]
  },
  {
    "key": "txtdownload_12334",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Herunterladen"
      },
      {
        "language": "PT",
        "text": "Download"
      },
      {
        "language": "IT",
        "text": "Scarica"
      },
      {
        "language": "CS",
        "text": "Stáhnout"
      },
      {
        "language": "EN",
        "text": "Download"
      }
    ]
  },
  {
    "key": "txt_Thetabled_207",
    "text": "The table displays the list of candidates and their evaluators' response rates.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض الجدول قائمة المرشحين ومعدلات استجابة المقيمين لهم."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Die Tabelle zeigt die Liste der Kandidaten und die Rücklaufquoten ihrer Bewerter."
      },
      {
        "language": "PT",
        "text": "A tabela apresenta a lista de candidatos e as taxas de resposta de seus avaliadores."
      },
      {
        "language": "IT",
        "text": "La tabella mostra l'elenco dei candidati e i tassi di risposta dei loro valutatori."
      },
      {
        "language": "CS",
        "text": "Tabulka obsahuje seznam kandidátů a míru odezvy jejich hodnotitelů."
      },
      {
        "language": "EN",
        "text": "The table displays the list of candidates and their evaluators' response rates."
      }
    ]
  },
  {
    "key": "txt_Youcandow_731",
    "text": "You can download the candidates’ list and overall performance score across all competencies for a detailed comparison. <br>Note: Available in Excel format.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المرشحين ومعدل تقييم الأداء العام لجميع الجدارات والمهارات لإجراء مقارنة تفصيلية.<br>ملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Für einen detaillierten Vergleich können Sie die Kandidatenliste und die Gesamtleistungsbewertung aller Kompetenzen herunterladen. <br>Hinweis: Verfügbar im Excel-Format."
      },
      {
        "language": "PT",
        "text": "Você pode baixar a lista de candidatos e a pontuação geral de desempenho em todas as competências para uma comparação detalhada. <br>Nota: Disponível em formato Excel."
      },
      {
        "language": "IT",
        "text": "Puoi scaricare l'elenco dei candidati e il punteggio di performance complessivo di tutte le competenze per un confronto dettagliato.\nNota: Disponibile in formato Excel."
      },
      {
        "language": "CS",
        "text": "Pro podrobné srovnání si můžete stáhnout seznam kandidátů a celkové hodnocení výkonnosti ve všech kompetencích. <br>Poznámka: K dispozici ve formátu Excel."
      },
      {
        "language": "EN",
        "text": "You can download the candidates’ list and overall performance score across all competencies for a detailed comparison. <br>Note: Available in Excel format."
      }
    ]
  },
  {
    "key": "txt_FilterSort_desc",
    "text": "Tailor your view of candidates' performance by filtering scores based on competencies. <br> You can also decide whether to see the top 5, top 10, or all and sort candidates by their scores (ascending/descending). ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص رؤيتك لأداء المرشحين من خلال تصفية النتائج بناءً على الجدارات والمهارات.  <br>يمكنك أيضًا تحديد ما إذا كنت تريد رؤية المراكز أعلى 5 أو أعلى 10 أو الكل و يمكنك أيضاً فرز المرشحين حسب نتائجهم (تصاعدي/تنازلي)."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Passen Sie Ihre Sicht auf die Leistung der Kandidaten an, indem Sie die Ergebnisse nach Kompetenzen filtern. <br> Sie können auch entscheiden, ob Sie die Top 5, die Top 10 oder alle sehen möchten, und die Kandidaten nach ihrer Punktzahl sortieren (aufsteigend/absteigend)."
      },
      {
        "language": "PT",
        "text": "Personalize sua visão do desempenho dos candidatos filtrando pontuações com base em competências. <br> Você também pode decidir se deseja ver os 5 primeiros, os 10 primeiros ou todos e classificar os candidatos por suas pontuações (crescente/decrescente)."
      },
      {
        "language": "IT",
        "text": "Personalizza la visualizzazione della performance dei candidati filtrando i punteggi per competenza. \nPuoi anche scegliere di vedere i primi 5, 10 o tutti e ordinare i candidati per punteggio (crescente/decrescente)."
      },
      {
        "language": "CS",
        "text": "Přizpůsobte si přehled výsledků uchazečů pomocí filtrování skóre podle kompetencí. <br> Můžete si také vybrat, zda chcete zobrazit prvních 5, prvních 10 nebo všechny uchazeče, a seřadit je podle skóre (vzestupně/sestupně)."
      },
      {
        "language": "EN",
        "text": "Tailor your view of candidates' performance by filtering scores based on competencies. <br> You can also decide whether to see the top 5, top 10, or all and sort candidates by their scores (ascending/descending). "
      }
    ]
  },
  {
    "key": "txt_Clickhere_188",
    "text": "Click here to download the report and turn on the sections you want to include.<br> Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF.\"",
    "translations": [
      {
        "language": "AR",
        "text": " انقر هنا لتحميل التقرير واختر الأقسام التي ترغب في تضمينها في التقرير.<br>تلميح: قم بالوصول بسهولة إلى تقارير الوحدات التنظيمية المفصلة عن طريق اختيار نوع الوحدة التنظيمية في قائمة \"<b>تصفح عن طريق</b>\" وابدأ بالتحميل الآن! - متوفر في صيغة PDF. "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um den Bericht herunterzuladen und die Abschnitte zu aktivieren, die Sie einschließen möchten.<br> Hinweis: Greifen Sie ganz einfach auf detaillierte Berichte zu, indem Sie im Menü „Anzeigen nach“ Ihren bevorzugten Typ auswählen und mit dem Herunterladen beginnen! -Verfügbar als PDF.“"
      },
      {
        "language": "PT",
        "text": "Clique aqui para baixar o relatório e ativar as seções que deseja incluir.<br> Dica: acesse facilmente relatórios detalhados de entidades escolhendo seu tipo de entidade preferido no menu 'Visualizar por' e comece a baixar agora! - Disponível em PDF.\""
      },
      {
        "language": "IT",
        "text": "Clicca qui per scaricare il report e selezionare le sezioni da includere. \nSuggerimento: Accedi facilmente ai report dettagliati per livello organizzativo scegliendo il tipo preferito nel menu \"Visualizza per\" e inizia subito a scaricare! - Disponibile in PDF."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, abyste si zprávu stáhli, a zaškrtněte sekce, které chcete zahrnout.<br> Tip: K podrobným zprávám o entitách se snadno dostanete tak, že v nabídce „Zobrazit podle“ vyberete požadovaný typ entity a začnete stahovat hned teď! – K dispozici ve formátu PDF."
      },
      {
        "language": "EN",
        "text": "Click here to download the report and turn on the sections you want to include.<br> Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF.\""
      }
    ]
  },
  {
    "key": "txt_download_close",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Herunterladen"
      },
      {
        "language": "PT",
        "text": "Download"
      },
      {
        "language": "IT",
        "text": "Scarica"
      },
      {
        "language": "CS",
        "text": "Stáhnout"
      },
      {
        "language": "EN",
        "text": "Download"
      }
    ]
  },
  {
    "key": "txtViewBy_desc",
    "text": "Click here to filter the analysis by choosing the entity.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التحليلات عن طريق اختيار الوحدة التنظيمية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Analyse zu filtern."
      },
      {
        "language": "PT",
        "text": "Clique aqui para filtrar a análise escolhendo a entidade."
      },
      {
        "language": "IT",
        "text": "Clicca qui per filtrare l'analisi scegliendo il livello organizzativo."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a filtrujte analýzu výběrem subjektu."
      },
      {
        "language": "EN",
        "text": "Click here to filter the analysis by choosing the entity."
      }
    ]
  },
  {
    "key": "txt_overview_desc",
    "text": "The “<b>Overview</b>” page displays the total number of candidates & evaluators, their overall response rate, and overall performance score. ",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة \"<b>نظرة عامة</b>\" تعرض عدد المرشحين والمقيمين ومعدل الاستجابة العام ومعدل التقييم العام."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Auf der Seite „<b>Übersicht</b>“ werden die Gesamtzahl der Kandidaten und Bewerter, ihre Gesamtantwortrate und ihre Gesamtleistungsbewertung angezeigt."
      },
      {
        "language": "PT",
        "text": "A página “<b>Visão Geral</b>” exibe o número total de candidatos e avaliadores, sua taxa de resposta geral e pontuação geral de desempenho."
      },
      {
        "language": "IT",
        "text": "La pagina “Panoramica” mostra il numero totale di candidati e valutatori, il loro tasso di risposta complessivo e il punteggio di performance complessivo."
      },
      {
        "language": "CS",
        "text": "Na stránce „<b>Přehled</b>“ se zobrazuje celkový počet uchazečů a hodnotitelů, jejich celková míra odezvy a celkové skóre výkonu."
      },
      {
        "language": "EN",
        "text": "The “<b>Overview</b>” page displays the total number of candidates & evaluators, their overall response rate, and overall performance score. "
      }
    ]
  },
  {
    "key": "txt_Clickon_closeasm",
    "text": "Click on “<b>Close Assessment</b>” to close the assessment. Note: You cannot add or delete respondents once you close the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"<b>أغلق التقييم</b>\" لإغلاق التقييم. <br>ملحوظة: لن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie auf „<b>Bewertung schließen</b>“, um die Bewertung zu schließen. Hinweis: Sie können keine Kandidaten hinzufügen oder löschen, nachdem Sie die Bewertung geschlossen haben."
      },
      {
        "language": "PT",
        "text": "Clique em “<b>Fechar avaliação</b>” para fechar a avaliação. Observação: você não poderá adicionar ou excluir respondentes depois de fechar a avaliação."
      },
      {
        "language": "IT",
        "text": "Clicca su “Chiudi Assessment” per chiudere l'Assessment. Nota: Una volta chiuso, non potrai più aggiungere o eliminare rispondenti."
      },
      {
        "language": "CS",
        "text": "Klikněte na „<b>Zavřít hodnocení</b>“, abyste hodnocení uzavřeli. Poznámka: Po uzavření hodnocení již nelze přidávat ani mazat respondenty."
      },
      {
        "language": "EN",
        "text": "Click on “<b>Close Assessment</b>” to close the assessment. Note: You cannot add or delete respondents once you close the assessment."
      }
    ]
  },
  {
    "key": "txt_Havesomeo_478",
    "text": "Have some of your candidates and evaluators completed their assessments while others are still in progress? No worries! You can view their reports by clicking “<b>Close</b>” for the chosen candidate. To view the closed candidate’s report, click on “Open”.<br> Note: To close a candidate's report, it is required a minimum of self-assessment, one manager assessment, and two peer or team assessments to be completed.",
    "translations": [
      {
        "language": "AR",
        "text": "هل استكمل بعض المرشحين والمقيمين لديك تقييماتهم بينما لا يزال البعض الآخر قيد الإنجاز؟ لا تقلق! يمكنك عرض هذه التقارير بالنقر على \"<b>أغلق الآن</b>\" للمرشح المختار. وللاطلاع على تقرير المرشح المغلق انقر على “فتح”.<br> ملحوظة: لإغلاق تقرير المرشح، يلزم استكمال التقييم الذاتي، وتقييم مدير واحد، وتقييمين من الزملاء أو أعضاء الفريق كحد أدنى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Haben einige Ihrer Kandidaten und Gutachter ihre Bewertungen abgeschlossen, während andere noch dabei sind? Kein Problem! Sie können deren Berichte anzeigen, indem Sie beim ausgewählten Kandidaten auf „<b>Schließen</b>“ klicken. Um den Bericht des abgeschlossenen Kandidaten anzuzeigen, klicken Sie auf „Öffnen“.<br> Hinweis: Um den Bericht eines Kandidaten zu schließen, müssen mindestens eine Selbstbewertung, eine Managerbewertung und zwei Peer- oder Teambewertungen abgeschlossen sein."
      },
      {
        "language": "PT",
        "text": "Alguns de seus candidatos e avaliadores concluíram suas avaliações enquanto outros ainda estão em andamento? Sem problemas! Você pode visualizar seus relatórios clicando em “<b>Fechar</b>” do candidato escolhido. Para visualizar o relatório do candidato fechado, clique em “Abrir”.<br> Observação: Para fechar o relatório de um candidato, é necessário um mínimo de autoavaliação, uma avaliação de gerente e duas avaliações de pares ou de equipe a serem concluídas."
      },
      {
        "language": "IT",
        "text": "Alcuni dei tuoi candidati e valutatori hanno completato il loro Assessment mentre altri sono ancora in corso? Nessun problema! Puoi visualizzare i loro report cliccando su “Chiudi” per il candidato scelto. Per aprire il report chiuso di un candidato, clicca su “Apri”.\nNota: Per chiudere il report di un candidato è necessario almeno un'autovalutazione, una valutazione del manager e due valutazioni dei colleghi o del team."
      },
      {
        "language": "CS",
        "text": "Dokončili někteří z vašich respondentů a hodnotitelů hodnocení, zatímco u jiných ještě probíhá? Žádný strach! Zprávy si můžete zobrazit kliknutím na „<b>Uzavřít</b>“ u vybraného respondenta. Chcete-li zobrazit zprávu uzavřeného respondenta, klikněte na „Otevřít“.<br> Poznámka: K uzavření zprávy respondenta je nutné, aby bylo dokončeno alespoň sebehodnocení, jedno hodnocení nadřízeným a dvě hodnocení kolegy nebo týmem."
      },
      {
        "language": "EN",
        "text": "Have some of your candidates and evaluators completed their assessments while others are still in progress? No worries! You can view their reports by clicking “<b>Close</b>” for the chosen candidate. To view the closed candidate’s report, click on “Open”.<br> Note: To close a candidate's report, it is required a minimum of self-assessment, one manager assessment, and two peer or team assessments to be completed."
      }
    ]
  },
  {
    "key": "txt_Clickhere_464",
    "text": "Click here to export respondents in an Excel sheet, view the assessment questions in PDF format, or update the deadline and automated reminder dates.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتحميل المستجيبين بصيغة Excel، أو عرض أسئلة التقييم بصيغة PDF، أو لتحديث تاريخ الإكمال وتواريخ التذكير التلقائي."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Befragten in eine Excel-Tabelle zu exportieren, die Bewertungsfragen im PDF-Format anzuzeigen oder die Frist und die automatischen Erinnerungstermine zu aktualisieren."
      },
      {
        "language": "PT",
        "text": "Clique aqui para exportar os respondentes em uma planilha Excel, visualizar as questões da avaliação em formato PDF ou atualizar o prazo e as datas dos lembretes automáticos."
      },
      {
        "language": "IT",
        "text": "Clicca qui per esportare i rispondenti in un foglio Excel, visualizzare le domande dell'Assessment in PDF o aggiornare la scadenza e le date dei promemoria automatici."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, chcete-li exportovat respondenty do souboru Excel, zobrazit otázky hodnocení ve formátu PDF nebo aktualizovat termín odevzdání a data automatických připomínek."
      },
      {
        "language": "EN",
        "text": "Click here to export respondents in an Excel sheet, view the assessment questions in PDF format, or update the deadline and automated reminder dates."
      }
    ]
  },
  {
    "key": "txt_Forgottoa_733",
    "text": "Forgot to add an evaluator? No worries, click here and start adding.",
    "translations": [
      {
        "language": "AR",
        "text": "هل نسيت إضافة مقيّم؟ لا تقلق انقر هنا وابدأ بالإضافة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Haben Sie vergessen, einen Bewerter hinzuzufügen? Keine Sorge, klicken Sie hier und beginnen Sie mit dem Hinzufügen."
      },
      {
        "language": "PT",
        "text": "Esqueceu de adicionar um avaliador? Não se preocupe, clique aqui e comece a adicionar."
      },
      {
        "language": "IT",
        "text": "Hai dimenticato di aggiungere un valutatore? Nessun problema, clicca qui per farlo."
      },
      {
        "language": "CS",
        "text": "Zapomněli jste přidat hodnotitele? Žádný problém, klikněte sem a začněte s přidáváním."
      },
      {
        "language": "EN",
        "text": "Forgot to add an evaluator? No worries, click here and start adding."
      }
    ]
  },
  {
    "key": "txt_Forgottoa_291",
    "text": "Forgot to add a respondent? No worries. Click here to start adding.",
    "translations": [
      {
        "language": "AR",
        "text": "هل نسيت إضافة مستجيب؟ لا تقلق انقر هنا وابدأ بالإضافة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Haben Sie vergessen, einen Befragten hinzuzufügen? Keine Sorge. Klicken Sie hier, um mit dem Hinzufügen zu beginnen."
      },
      {
        "language": "PT",
        "text": "Esqueceu de adicionar um entrevistado? Sem problemas. Clique aqui para começar a adicionar."
      },
      {
        "language": "IT",
        "text": "Hai dimenticato di aggiungere un rispondente? Nessun problema, clicca qui per farlo."
      },
      {
        "language": "CS",
        "text": "Zapomněli jste přidat respondenta? Žádný problém. Klikněte sem a začněte přidávat."
      },
      {
        "language": "EN",
        "text": "Forgot to add a respondent? No worries. Click here to start adding."
      }
    ]
  },
  {
    "key": "txt_AddRespon_358",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Befragten hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar respondente"
      },
      {
        "language": "IT",
        "text": "Aggiungi un rispondente"
      },
      {
        "language": "CS",
        "text": "Přidat respondenta"
      },
      {
        "language": "EN",
        "text": "Add Respondent"
      }
    ]
  },
  {
    "key": "txt_Sendmanua_979",
    "text": "Send manual reminders or delete the respondent.",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات يدوية أو قم بحذف المستجيب."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Senden Sie manuelle Erinnerungen oder löschen Sie den Befragten."
      },
      {
        "language": "PT",
        "text": "Envie lembretes manuais ou exclua o entrevistado."
      },
      {
        "language": "IT",
        "text": "Invia promemoria manuali o elimina il rispondente."
      },
      {
        "language": "CS",
        "text": "Odeslat ručně nastavené upomínky nebo odstranit respondenta."
      },
      {
        "language": "EN",
        "text": "Send manual reminders or delete the respondent."
      }
    ]
  },
  {
    "key": "txt_Clickhere_804",
    "text": "Click here to select respondents and send reminders to respondents who did not complete the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتحديد المستجيبين لكي تقوم بإرسال تذكيرات للمستجيبين الذين لم يستكملوا التقييم."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um Befragte auszuwählen und Erinnerungen an Befragte zu senden, die die Bewertung nicht abgeschlossen haben."
      },
      {
        "language": "PT",
        "text": "Clique aqui para selecionar os entrevistados e enviar lembretes aos entrevistados que não concluíram a avaliação."
      },
      {
        "language": "IT",
        "text": "Clicca qui per selezionare i rispondenti e inviare un promemoria a chi non ha completato l'Assessment."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, abyste vybrali respondenty a zaslali upomínky těm, kteří hodnocení nedokončili."
      },
      {
        "language": "EN",
        "text": "Click here to select respondents and send reminders to respondents who did not complete the assessment."
      }
    ]
  },
  {
    "key": "txt_SelectRes_161",
    "text": "Select Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Wählen Sie Kandidaten aus"
      },
      {
        "language": "PT",
        "text": "Selecione os entrevistados"
      },
      {
        "language": "IT",
        "text": "Seleziona i rispondenti"
      },
      {
        "language": "CS",
        "text": "Vybrat respondenty"
      },
      {
        "language": "EN",
        "text": "Select Respondents"
      }
    ]
  },
  {
    "key": "txt_response_rate_desc",
    "text": "Track your respondents' progress! <br> Note: We recommend a 65% - 75% response rate for a better analysis.",
    "translations": [
      {
        "language": "AR",
        "text": "تتبع معدل الاستجابة للمستجيبين.<br>ملحوظة: نوصي بمعدل استجابة يتراوح بين 65% - 75% لتحليلات أفضل."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Verfolgen Sie den Fortschritt Ihrer Befragten! <br> Hinweis: Für eine bessere Analyse empfehlen wir eine Rücklaufquote von 65 % bis 75 %."
      },
      {
        "language": "PT",
        "text": "Acompanhe o progresso dos seus entrevistados! <br> Nota: Recomendamos uma taxa de resposta de 65% - 75% para uma melhor análise."
      },
      {
        "language": "IT",
        "text": "Monitora l'avanzamento dei tuoi rispondenti! \nNota: Consigliamo un tasso di risposta del 65%-75% per garantire un’analisi più accurata."
      },
      {
        "language": "CS",
        "text": "Sledujte, jak respondenti pokračují! <br> Poznámka: Pro lepší analýzu doporučujeme míru odezvy 65 % až 75 %."
      },
      {
        "language": "EN",
        "text": "Track your respondents' progress! <br> Note: We recommend a 65% - 75% response rate for a better analysis."
      }
    ]
  },
  {
    "key": "txtAddEvaluators360_desc",
    "text": "Click here to define each candidate’s evaluator and their relationship type from the dropdown menu.<br>Note: Each candidate must at least have 1 manager and 2 peers/team.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتحديد مقيم كل مرشح ونوع العلاقة من القائمة المنسدلة. <br>ملاحظة: يجب أن يكون لدى كل مرشح مدير واحد و2 من الزملاء أو أعضاء الفريق كحد أدنى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um den Bewerter jedes Kandidaten und seinen Beziehungstyp aus dem Dropdown-Menü zu definieren.<br>Hinweis: Jeder Kandidat muss mindestens 1 Manager und 2 Kollegen/Team haben."
      },
      {
        "language": "PT",
        "text": "Clique aqui para definir o avaliador de cada candidato e seu tipo de relacionamento no menu suspenso.<br>Observação: Cada candidato deve ter pelo menos 1 gestor e 2 pares/equipe."
      },
      {
        "language": "IT",
        "text": "Clicca qui per definire ciascun valutatore per candidato e il tipo di relazione dal menu a tendina. \nNota: Ogni candidato deve avere almeno 1 manager e 2 tra colleghi e  team."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a z rozevíracího seznamu vyberte hodnotitele každého respondenta a typ jejich vztahu.<br>Poznámka: Každý respondent musí mít alespoň 1 nadřízeného a 2 kolegy z týmu."
      },
      {
        "language": "EN",
        "text": "Click here to define each candidate’s evaluator and their relationship type from the dropdown menu.<br>Note: Each candidate must at least have 1 manager and 2 peers/team."
      }
    ]
  },
  {
    "key": "txtAddRespondents_desc",
    "text": "To start adding respondents, click on “<b>Add Respondents</b>”. <br>Hint: We recommend adding by using Excel to save time and simplify your experience!",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة المستجيبين، انقر على \"<b>إضافة مستجيبين</b>\".<br>تلميح: نوصي باستخدام ملف Excel لتوفير الوقت وتسهيل تجربتك!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Um mit dem Hinzufügen von Befragten zu beginnen, klicken Sie auf „<b>Befragte hinzufügen</b>“. <br>Hinweis: Wir empfehlen das Hinzufügen mithilfe von Excel, um Zeit zu sparen und den Prozess zu vereinfachen!"
      },
      {
        "language": "PT",
        "text": "Para começar a adicionar entrevistados, clique em “<b>Adicionar Respondentes</b>”. <br>Dica: recomendamos adicionar usando o Excel para economizar tempo e simplificar sua experiência!"
      },
      {
        "language": "IT",
        "text": "Per iniziare ad aggiungere rispondenti, clicca su “Aggiungi i rispondenti”. \nSuggerimento: Consigliamo di usare Excel per risparmiare tempo e semplificare l'operazione!"
      },
      {
        "language": "CS",
        "text": "Chcete-li začít přidávat respondenty, klikněte na „<b>Přidat respondenty</b>“. <br>Tip: Pro úsporu času a zjednodušení práce doporučujeme přidávat respondenty pomocí aplikace Excel!"
      },
      {
        "language": "EN",
        "text": "To start adding respondents, click on “<b>Add Respondents</b>”. <br>Hint: We recommend adding by using Excel to save time and simplify your experience!"
      }
    ]
  },
  {
    "key": "txt_respondents_desc",
    "text": "In the “<b>Respondents</b>” page, you add the Respondents (Candidates & Evaluators) you want to invite to the assessment manually, by Excel file, or from your respondent pool.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"<b>المستجيبين</b>\"، يمكنك إضافة المستجيبين (المرشحون والمقيّمون) الذين ترغب في دعوتهم للتقييم يدوياً أو عبر ملف Excel أو من خلال مجموعة المستجيبين الخاصة بك."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Auf der Seite „<b>Befragte</b>“ fügen Sie die Befragten (Kandidaten und Bewerter), die Sie zur Bewertung einladen möchten, manuell, per Excel-Datei oder aus Ihrem Befragtenpool hinzu."
      },
      {
        "language": "PT",
        "text": "Na página “<b>Respondentes</b>”, você adiciona os respondentes (candidatos e avaliadores) que deseja convidar para a avaliação manualmente, por arquivo Excel ou do seu grupo de respondentes."
      },
      {
        "language": "IT",
        "text": "Nella pagina “Rispondenti”, aggiungi i rispondenti (Candidati e Valutatori) che vuoi invitare a compilare l'Assessment manualmente, tramite file Excel, o dal tuo pool di rispondenti."
      },
      {
        "language": "CS",
        "text": "Na stránce „<b>Respondenti</b>“ můžete přidat respondenty (uchazeče a hodnotitele), které chcete pozvat k hodnocení, a to ručně, pomocí souboru Excel nebo z vašeho seznamu respondentů."
      },
      {
        "language": "EN",
        "text": "In the “<b>Respondents</b>” page, you add the Respondents (Candidates & Evaluators) you want to invite to the assessment manually, by Excel file, or from your respondent pool."
      }
    ]
  },
  {
    "key": "txt_Anotherst_290",
    "text": "Another step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من خطوة أخرى؛ انقر هنا للانتقال إلى الخطوة التالية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ein weiterer Schritt ist abgeschlossen; Klicken Sie hier für den nächsten Schritt."
      },
      {
        "language": "PT",
        "text": "Outra etapa está concluída; clique aqui para o próximo passo."
      },
      {
        "language": "IT",
        "text": "Un altro passaggio è completo; clicca qui per il prossimo."
      },
      {
        "language": "CS",
        "text": "Další krok je hotový; klikněte sem pro další krok."
      },
      {
        "language": "EN",
        "text": "Another step is done; click here for the next step."
      }
    ]
  },
  {
    "key": "txt_Enablethi_554",
    "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتفعيل هذا الخيار في حال كنت تريد من المستجيبين أن يقوموا بتعبئة المعلومات من المعايير المختارة أعلاه أثناء التقييم."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Aktivieren Sie diese Option, wenn Sie möchten, dass Ihre Befragten während der Beurteilung die Informationen aus den oben ausgewählten Kriterien eingeben."
      },
      {
        "language": "PT",
        "text": "Ative esta opção se quiser que seus respondentes preencham as informações dos critérios selecionados acima durante a avaliação."
      },
      {
        "language": "IT",
        "text": "Attiva questa opzione se desideri che i rispondenti compilino le informazioni in base ai criteri selezionati durante l'Assessment."
      },
      {
        "language": "CS",
        "text": "Tuto možnost zapněte, pokud chcete, aby respondenti při vyplňování dotazníku zadávali údaje podle výše vybraných kritérií."
      },
      {
        "language": "EN",
        "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the assessment."
      }
    ]
  },
  {
    "key": "txt_Responden_378",
    "text": "Respondent Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات المستجيب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Informationen zum Kandidat"
      },
      {
        "language": "PT",
        "text": "Informações do entrevistado"
      },
      {
        "language": "IT",
        "text": "Informazioni sul rispondente"
      },
      {
        "language": "CS",
        "text": "Údaje o dotazovaném"
      },
      {
        "language": "EN",
        "text": "Respondent Information"
      }
    ]
  },
  {
    "key": "txt_Youcancre_675",
    "text": "You can create additional criteria.<br> Fill in the criterion name and its options.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إنشاء معايير إضافية. <br>قم بتعبئة اسم المعيار وخياراته التابعة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sie können zusätzliche Kriterien erstellen.<br> Geben Sie den Namen des Kriteriums und seine Optionen ein."
      },
      {
        "language": "PT",
        "text": "Você pode criar critérios adicionais.<br> Preencha o nome do critério e suas opções."
      },
      {
        "language": "IT",
        "text": "Puoi creare dei criteri aggiuntivi. \nInserisci il nome del criterio e le relative opzioni."
      },
      {
        "language": "CS",
        "text": "Můžete vytvořit další kritéria.<br> Zadejte název kritéria a jeho možnosti."
      },
      {
        "language": "EN",
        "text": "You can create additional criteria.<br> Fill in the criterion name and its options."
      }
    ]
  },
  {
    "key": "txt_CustomCri_298",
    "text": "Custom Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير مخصصة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Benutzerdefinierte Kriterien"
      },
      {
        "language": "PT",
        "text": "Critérios personalizados"
      },
      {
        "language": "IT",
        "text": "Criteri personalizzati"
      },
      {
        "language": "CS",
        "text": "Vlastní kritéria"
      },
      {
        "language": "EN",
        "text": "Custom Criteria"
      }
    ]
  },
  {
    "key": "analytical-criteria_desc",
    "text": "In “<b>Analytical Criteria</b>”, you select the criteria based on your preference as a filter for the analysis.<br> Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive detailed analysis and comparison!",
    "translations": [
      {
        "language": "AR",
        "text": "في \"<b>المعايير التحليلية</b>\"، يمكنك اختيار المعايير استنادًا إلى تفضيلاتك لعرض التحليلات المفصلة. <br>تلميح: كلما قمت باختيار معايير أكثر كلما زادت تفاصيل تقاريرنا، مما يوفر لك تحليلًا مفصلًا شاملاً ومقارنًا!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Unter „<b>Analytische Kriterien</b>“ wählen Sie die Kriterien nach Ihren Wünschen als Filter für die Analyse aus.<br> Hinweis: Wenn Sie Ihre Auswahl an Kriterien erweitern, gehen unsere Berichte tiefer und liefern Ihnen eine Umfassende Detailanalyse und Vergleich!"
      },
      {
        "language": "PT",
        "text": "Em “<b>Critérios Analíticos</b>”, você seleciona os critérios com base em sua preferência como um filtro para a análise.<br> Dica: à medida que você expande sua seleção de critérios, nossos relatórios se aprofundam, fornecendo uma análise e comparação abrangente e detalhada!"
      },
      {
        "language": "IT",
        "text": "In “Criteri analitici”, selezioni i criteri in base alle tue preferenze come filtro per l'analisi. \nSuggerimento: Ampliando i criteri selezionati, i nostri report si arricchiscono di approfondimenti, offrendoti un’analisi completa e dettagliata con confronti mirati."
      },
      {
        "language": "CS",
        "text": "V části „<b>Analytická kritéria</b>“ si vyberete kritéria podle svých preferencí, která budou sloužit jako filtr pro analýzu.<br> Tip: Čím více kritérií vyberete, tím podrobnější budou naše zprávy a získáte tak komplexní a detailní analýzu a srovnání!"
      },
      {
        "language": "EN",
        "text": "In “<b>Analytical Criteria</b>”, you select the criteria based on your preference as a filter for the analysis.<br> Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive detailed analysis and comparison!"
      }
    ]
  },
  {
    "key": "txt_Thefirsts_969",
    "text": "The first step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من الخطوة الأولى. انقر هنا للانتقال إلى الخطوة التالية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ein weiterer Schritt ist abgeschlossen; Klicken Sie hier für den nächsten Schritt."
      },
      {
        "language": "PT",
        "text": "A primeira etapa está concluída; clique aqui para o próximo passo."
      },
      {
        "language": "IT",
        "text": "Il primo passaggio è completo; clicca qui per il prossimo."
      },
      {
        "language": "CS",
        "text": "První krok je hotový; klikněte sem pro další krok."
      },
      {
        "language": "EN",
        "text": "The first step is done; click here for the next step."
      }
    ]
  },
  {
    "key": "txtViewTemplate_desc",
    "text": "Click here to view and download the competencies and statements for each template.<br>Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض وتحميل الجدارات والمهارات والعبارات الخاصة بكل نموذج. <br>ملحوظة: متوفر بصيغة PDF."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Kompetenzen und Erklärungen für jede Vorlage anzuzeigen und herunterzuladen.<br>Hinweis: Verfügbar im PDF-Format."
      },
      {
        "language": "PT",
        "text": "Clique aqui para visualizar e baixar as competências e demonstrativos de cada modelo.<br>Observação: Disponível em formato PDF."
      },
      {
        "language": "IT",
        "text": "Clicca qui per visualizzare e scaricare le competenze e le affermazioni di ogni template. \nNota: Disponibile in formato PDF."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, abyste si prohlédli a stáhli kompetence a popisy pro jednotlivé šablony.<br>Poznámka: K dispozici ve formátu PDF."
      },
      {
        "language": "EN",
        "text": "Click here to view and download the competencies and statements for each template.<br>Note: Available in PDF format."
      }
    ]
  },
  {
    "key": "txt_manage_templates_desc",
    "text": "Unlock the power of customization with your very own template, where you can tailor competencies and statements to match your unique needs!",
    "translations": [
      {
        "language": "AR",
        "text": "استفد من خاصية التخصيص من خلال إنشاء نموذج خاص بك حيث يمكنك إضافة الجدارات والمهارات والعبارات لتتناسب مع أهدافك الفريدة!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Nutzen Sie die Möglichkeiten der Individualisierung mit Ihrer ganz eigenen Vorlage, in der Sie Kompetenzen und Aussagen an Ihre individuellen Bedürfnisse anpassen können!"
      },
      {
        "language": "PT",
        "text": "Desbloqueie o poder da personalização com seu próprio modelo, onde você pode adaptar competências e declarações para atender às suas necessidades exclusivas!"
      },
      {
        "language": "IT",
        "text": "Sfrutta le potenzialità della personalizzazione attraverso il tuo template dedicato, dove puoi adattare le competenze e le affermazioni in base alle tue specifiche esigenze!"
      },
      {
        "language": "CS",
        "text": "Využijte možnosti přizpůsobení pomocí vlastní šablony, ve které si můžete kompetence a popisy přizpůsobit tak, aby odpovídaly vašim konkrétním potřebám!"
      },
      {
        "language": "EN",
        "text": "Unlock the power of customization with your very own template, where you can tailor competencies and statements to match your unique needs!"
      }
    ]
  },
  {
    "key": "txtSelectTemplate_desc",
    "text": "You have the option to select from Zenithr’s predefined templates or custom templates!",
    "translations": [
      {
        "language": "AR",
        "text": "لديك الخيار للاختيار من نماذج زينيثر المخصصة أو المُعرفة مسبقاً!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sie haben die Möglichkeit, aus den vordefinierten Vorlagen von Zenithr oder benutzerdefinierten Vorlagen auszuwählen!"
      },
      {
        "language": "PT",
        "text": "Você tem a opção de selecionar modelos predefinidos ou modelos personalizados do Zenithr!"
      },
      {
        "language": "IT",
        "text": "Puoi scegliere tra i template predefiniti di Zenithr o quelli personalizzati!"
      },
      {
        "language": "CS",
        "text": "Máte možnost vybrat si z předdefinovaných šablon Zenithr nebo z vlastních šablon!"
      },
      {
        "language": "EN",
        "text": "You have the option to select from Zenithr’s predefined templates or custom templates!"
      }
    ]
  },
  {
    "key": "txt_Clickhere_707",
    "text": "Click here to clone or rename the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لاستنساخ أو لإعادة تسمية التقييم."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Bewertung zu kopieren oder umzubenennen."
      },
      {
        "language": "PT",
        "text": "Clique aqui para clonar ou renomear a avaliação."
      },
      {
        "language": "IT",
        "text": "Clicca qui per clonare o rinominare l'Assessment."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, chcete-li hodnocení zkopírovat nebo přejmenovat."
      },
      {
        "language": "EN",
        "text": "Click here to clone or rename the assessment."
      }
    ]
  },
  {
    "key": "txt_Clickhere_637",
    "text": "Click here to delete a draft assessment.<br> Note: only draft assessments can be deleted",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لحذف التقييمات المسودة. <br>ملحوظة: يمكن حذف تقييمات المسودة فقط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um einen Beurteilungsentwurf zu löschen.<br> Hinweis: Es können nur Beurteilungsentwürfe gelöscht werden"
      },
      {
        "language": "PT",
        "text": "Clique aqui para excluir um rascunho de avaliação.<br> Observação: somente rascunhos de avaliação podem ser excluídos"
      },
      {
        "language": "IT",
        "text": "Clicca qui per eliminare un'Assessment in bozza. \nNota: Solo gli Assessment in bozza possono essere eliminati"
      },
      {
        "language": "CS",
        "text": "Klikněte sem, chcete-li smazat návrh hodnocení.<br> Poznámka: smazat lze pouze návrhy hodnocení"
      },
      {
        "language": "EN",
        "text": "Click here to delete a draft assessment.<br> Note: only draft assessments can be deleted"
      }
    ]
  },
  {
    "key": "txt_Pointthem_895",
    "text": "Point the mouse over the assessment list to open the draft, live, and closed assessments.",
    "translations": [
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق قائمة التقييمات لفتح التقييمات بحالة المسودة، المباشرة، والمنتهية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bewegen Sie die Maus über die Bewertungsliste, um die entworfenen, laufenden und geschlossenen Bewertungen zu öffnen."
      },
      {
        "language": "PT",
        "text": "Aponte o mouse sobre a lista de avaliações para abrir as avaliações preliminares, em tempo real e fechadas."
      },
      {
        "language": "IT",
        "text": "Posiziona il cursore sull'elenco degli Assessment per aprire quelli in bozza, attivi e chiusi."
      },
      {
        "language": "CS",
        "text": "Přejděte kurzorem myši nad seznam hodnocení a zobrazí se vám rozpracovaná, aktuální a uzavřená hodnocení."
      },
      {
        "language": "EN",
        "text": "Point the mouse over the assessment list to open the draft, live, and closed assessments."
      }
    ]
  },
  {
    "key": "txt_newAsm_desc",
    "text": "To create a new 360/180 assessment, click on “<b>New Assessment</b>”.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"<b>تقييم جديد</b>\" لإنشاء تقييم 360/180 جديد."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Um eine neue 360/180-Bewertung zu erstellen, klicken Sie auf „<b>Neue Bewertung</b>“."
      },
      {
        "language": "PT",
        "text": "Para criar uma nova avaliação 360/180, clique em “<b>Nova Avaliação</b>”."
      },
      {
        "language": "IT",
        "text": "Per creare un nuovo Assessment 360/180, clicca su “Nuovo Assessment”."
      },
      {
        "language": "CS",
        "text": "Chcete-li vytvořit nové 360/180° hodnocení, klikněte na „<b>Nové hodnocení</b>“."
      },
      {
        "language": "EN",
        "text": "To create a new 360/180 assessment, click on “<b>New Assessment</b>”."
      }
    ]
  },
  {
    "key": "txtEdit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": "Edytuj"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bearbeiten"
      },
      {
        "language": "PT",
        "text": "Editar"
      },
      {
        "language": "IT",
        "text": "Modifica"
      },
      {
        "language": "CS",
        "text": "Upravit"
      },
      {
        "language": "EN",
        "text": "Edit"
      }
    ]
  },
  {
    "key": "txt_upto3Managers",
    "text": "(Up to 3 emails per candidate)",
    "translations": [
      {
        "language": "AR",
        "text": "(3 رسائل بريد إلكتروني لكل مرشح كحد أٌقصى)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "(Bis zu 3 E-Mails pro Kandidat)"
      },
      {
        "language": "PT",
        "text": "(Até 3 emails por candidato)"
      },
      {
        "language": "IT",
        "text": "(Fino a 3 email per candidato)"
      },
      {
        "language": "CS",
        "text": "(Maximálně 3 e-maily na uchazeče)"
      },
      {
        "language": "EN",
        "text": "(Up to 3 emails per candidate)"
      }
    ]
  },
  {
    "key": "txt_sharing",
    "text": "Sharing",
    "translations": [
      {
        "language": "AR",
        "text": "جاري المشاركة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Teilen"
      },
      {
        "language": "PT",
        "text": "Compartilhamento"
      },
      {
        "language": "IT",
        "text": "Condivisione"
      },
      {
        "language": "CS",
        "text": "Sdílení"
      },
      {
        "language": "EN",
        "text": "Sharing"
      }
    ]
  },
  {
    "key": "txt_done",
    "text": "Done",
    "translations": [
      {
        "language": "AR",
        "text": "تم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Erledigt"
      },
      {
        "language": "PT",
        "text": "Feito"
      },
      {
        "language": "IT",
        "text": "Completato"
      },
      {
        "language": "CS",
        "text": "Hotovo"
      },
      {
        "language": "EN",
        "text": "Done"
      }
    ]
  },
  {
    "key": "txt_success_share",
    "text": "The report have been shared successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تم مشاركة التقرير بنجاح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Der Bericht wurde erfolgreich geteilt"
      },
      {
        "language": "PT",
        "text": "O relatório foi compartilhado com sucesso"
      },
      {
        "language": "IT",
        "text": "Il report è stato condiviso con successo"
      },
      {
        "language": "CS",
        "text": "Zpráva byla úspěšně odeslána"
      },
      {
        "language": "EN",
        "text": "The report have been shared successfully"
      }
    ]
  },
  {
    "key": "txt_ShareManagerEmail",
    "text": "Please fill the Manager’s emails for each candidate.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة البريد الإلكتروني الخاص بالمدير لكل مرشح."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bitte füllen Sie für jeden Kandidaten die E-Mail-Adresse des Managers aus."
      },
      {
        "language": "PT",
        "text": "Por favor, preencha os e-mails do gerente para cada candidato."
      },
      {
        "language": "IT",
        "text": "Inserisci le email del manager per ogni candidato."
      },
      {
        "language": "CS",
        "text": "Uveďte prosím e-mailové adresy vedoucích jednotlivých uchazečů."
      },
      {
        "language": "EN",
        "text": "Please fill the Manager’s emails for each candidate."
      }
    ]
  },
  {
    "key": "txt_share_now",
    "text": "Share Now",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة اللآن"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Jetzt teilen"
      },
      {
        "language": "PT",
        "text": "Compartilhe agora"
      },
      {
        "language": "IT",
        "text": "Condividi ora"
      },
      {
        "language": "CS",
        "text": "Sdílet nyní"
      },
      {
        "language": "EN",
        "text": "Share Now"
      }
    ]
  },
  {
    "key": "txt_mangsEmail",
    "text": "Manager’s Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني للمدير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "E-Mail des Managers"
      },
      {
        "language": "PT",
        "text": "E-mail do gerente"
      },
      {
        "language": "IT",
        "text": "Email del manager"
      },
      {
        "language": "CS",
        "text": "E-mail manažera"
      },
      {
        "language": "EN",
        "text": "Manager’s Email"
      }
    ]
  },
  {
    "key": "txt_name_email",
    "text": "Name / Email",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم/البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Name/E-Mail"
      },
      {
        "language": "PT",
        "text": "Nome / E-mail"
      },
      {
        "language": "IT",
        "text": "Nome/Email"
      },
      {
        "language": "CS",
        "text": "Jméno / E-mail"
      },
      {
        "language": "EN",
        "text": "Name / Email"
      }
    ]
  },
  {
    "key": "txt_Selected_Candidates",
    "text": "Selected Candidates",
    "translations": [
      {
        "language": "AR",
        "text": "المرشحون المختارون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ausgewählte Kandidaten"
      },
      {
        "language": "PT",
        "text": "Candidatos Selecionados"
      },
      {
        "language": "IT",
        "text": "Candidati selezionati"
      },
      {
        "language": "CS",
        "text": "Vybraní respondenti"
      },
      {
        "language": "EN",
        "text": "Selected Candidates"
      }
    ]
  },
  {
    "key": "txt_report_type",
    "text": "Report Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع التقرير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Berichtstyp"
      },
      {
        "language": "PT",
        "text": "Tipo de relatório"
      },
      {
        "language": "IT",
        "text": "Tipo di report"
      },
      {
        "language": "CS",
        "text": "Typ zprávy"
      },
      {
        "language": "EN",
        "text": "Report Type"
      }
    ]
  },
  {
    "key": "txt_review_share12",
    "text": "Review the details below before proceeding:",
    "translations": [
      {
        "language": "AR",
        "text": "قم بمراجعة التفاصيل أدناه قبل المتابعة:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Überprüfen Sie die folgenden Details, bevor Sie fortfahren:"
      },
      {
        "language": "PT",
        "text": "Revise os detalhes abaixo antes de prosseguir:"
      },
      {
        "language": "IT",
        "text": "Rivedi i dettagli qui sotto prima di procedere:"
      },
      {
        "language": "CS",
        "text": "Než budete pokračovat, prostudujte si níže uvedené informace:"
      },
      {
        "language": "EN",
        "text": "Review the details below before proceeding:"
      }
    ]
  },
  {
    "key": "txt_assessmentResult",
    "text": "Assessment Results",
    "translations": [
      {
        "language": "AR",
        "text": "نتائج التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bewertungsergebnisse"
      },
      {
        "language": "PT",
        "text": "Resultados da avaliação"
      },
      {
        "language": "IT",
        "text": "Risultati dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Výsledky hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Results"
      }
    ]
  },
  {
    "key": "txtx_select_reportSections",
    "text": "Select Report Sections",
    "translations": [
      {
        "language": "AR",
        "text": "حدد أقسام التقرير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Berichtsabschnitte auswählen"
      },
      {
        "language": "PT",
        "text": "Selecione as seções do relatório"
      },
      {
        "language": "IT",
        "text": "Seleziona le sezioni del report"
      },
      {
        "language": "CS",
        "text": "Vybrat části zprávy"
      },
      {
        "language": "EN",
        "text": "Select Report Sections"
      }
    ]
  },
  {
    "key": "txt_add_email",
    "text": "If you want to add a new email, type it above and press Enter.\t",
    "translations": [
      {
        "language": "AR",
        "text": "إذا كنت ترغب في إضافة بريد إلكتروني جديد، فاكتبه أعلاه واضغط على مفتاح الإدخال."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Wenn Sie eine neue E-Mail hinzufügen möchten, geben Sie sie oben ein und drücken Sie die Eingabetaste."
      },
      {
        "language": "PT",
        "text": "Se você deseja adicionar um novo e-mail, digite-o acima e pressione Enter."
      },
      {
        "language": "IT",
        "text": "Se desideri aggiungere una nuova email, inseriscita sopra e premi Invio."
      },
      {
        "language": "CS",
        "text": "Pokud chcete přidat novou e-mailovou adresu, zadejte ji do pole výše a stiskněte klávesu Enter."
      },
      {
        "language": "EN",
        "text": "If you want to add a new email, type it above and press Enter.\t"
      }
    ]
  },
  {
    "key": "txt_recipientEmails",
    "text": "Recipient Emails",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني للمستلمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "E-Mails der Empfänger"
      },
      {
        "language": "PT",
        "text": "E-mails de destinatários"
      },
      {
        "language": "IT",
        "text": "Email dei destinatari"
      },
      {
        "language": "CS",
        "text": "E-mailové adresy příjemců"
      },
      {
        "language": "EN",
        "text": "Recipient Emails"
      }
    ]
  },
  {
    "key": "txtShareMangInfo",
    "text": "The management report includes evaluator details and may reveal sensitive information.",
    "translations": [
      {
        "language": "AR",
        "text": "يشمل التقرير الإداري تفاصيل المقيِّمين وقد يكشف عن معلومات حساسة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Der Managementbericht enthält Angaben zum Gutachter und kann vertrauliche Informationen preisgeben."
      },
      {
        "language": "PT",
        "text": "O relatório de gestão inclui detalhes do avaliador e pode revelar informações sensíveis."
      },
      {
        "language": "IT",
        "text": "Il report per il management include i dettagli dei valutatori e potrebbe rivelare informazioni sensibili."
      },
      {
        "language": "CS",
        "text": "Zpráva vedení obsahuje údaje o hodnotitelích a může obsahovat citlivé informace."
      },
      {
        "language": "EN",
        "text": "The management report includes evaluator details and may reveal sensitive information."
      }
    ]
  },
  {
    "key": "txt_recommended",
    "text": "Recommended",
    "translations": [
      {
        "language": "AR",
        "text": "موصى به"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Empfohlen"
      },
      {
        "language": "PT",
        "text": "Recomendado"
      },
      {
        "language": "IT",
        "text": "Consigliato"
      },
      {
        "language": "CS",
        "text": "Doporučeno"
      },
      {
        "language": "EN",
        "text": "Recommended"
      }
    ]
  },
  {
    "key": "txtManagementReport",
    "text": "Management Report",
    "translations": [
      {
        "language": "AR",
        "text": "التقرير الإداري "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Lagebericht"
      },
      {
        "language": "PT",
        "text": "Relatório de Gestão"
      },
      {
        "language": "IT",
        "text": "Report per il management"
      },
      {
        "language": "CS",
        "text": "Zpráva vedení"
      },
      {
        "language": "EN",
        "text": "Management Report"
      }
    ]
  },
  {
    "key": "txtCandidateReport",
    "text": "Candidate Report",
    "translations": [
      {
        "language": "AR",
        "text": "التقرير للمرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidatenbericht"
      },
      {
        "language": "PT",
        "text": "Relatório do Candidato"
      },
      {
        "language": "IT",
        "text": "Candidate Report"
      },
      {
        "language": "CS",
        "text": "Zpráva o respondentovi"
      },
      {
        "language": "EN",
        "text": "Candidate Report"
      }
    ]
  },
  {
    "key": "txt_select_report",
    "text": "Select Report Type",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار نوع التقرير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Berichtstyp auswählen"
      },
      {
        "language": "PT",
        "text": "Selecione o tipo de relatório"
      },
      {
        "language": "IT",
        "text": "Seleziona il tipo di report"
      },
      {
        "language": "CS",
        "text": "Vyberte typ zprávy"
      },
      {
        "language": "EN",
        "text": "Select Report Type"
      }
    ]
  },
  {
    "key": "txt_shareWith",
    "text": "Share with",
    "translations": [
      {
        "language": "AR",
        "text": "شارك مع"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Teilen mit"
      },
      {
        "language": "PT",
        "text": "Compartilhar com"
      },
      {
        "language": "IT",
        "text": "Condividi con"
      },
      {
        "language": "CS",
        "text": "Sdílet s"
      },
      {
        "language": "EN",
        "text": "Share with"
      }
    ]
  },
  {
    "key": "txt_other_stackholders",
    "text": "Other Stakeholders",
    "translations": [
      {
        "language": "AR",
        "text": "أصحاب المعنيين الآخرين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Andere Stakeholder"
      },
      {
        "language": "PT",
        "text": "Outros empilhadores"
      },
      {
        "language": "IT",
        "text": "Altri stakeholder"
      },
      {
        "language": "CS",
        "text": "Další zainteresované strany"
      },
      {
        "language": "EN",
        "text": "Other Stakeholders"
      }
    ]
  },
  {
    "key": "txt_candidates_managers",
    "text": "Candidates' Managers",
    "translations": [
      {
        "language": "AR",
        "text": "مدراء المرشحين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidatenmanager"
      },
      {
        "language": "PT",
        "text": "Gestores de Candidatos"
      },
      {
        "language": "IT",
        "text": "Manager dei candidati"
      },
      {
        "language": "CS",
        "text": "Manažer respondentů"
      },
      {
        "language": "EN",
        "text": "Candidates' Managers"
      }
    ]
  },
  {
    "key": "txt_candidates_only",
    "text": "Candidates Only",
    "translations": [
      {
        "language": "AR",
        "text": "المرشحون فقط"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Nur für Kandidaten"
      },
      {
        "language": "PT",
        "text": "Apenas candidatos"
      },
      {
        "language": "IT",
        "text": "Solo candidati"
      },
      {
        "language": "CS",
        "text": "Pouze pro uchazeče"
      },
      {
        "language": "EN",
        "text": "Candidates Only"
      }
    ]
  },
  {
    "key": "txt_share_options",
    "text": "Sharing Options",
    "translations": [
      {
        "language": "AR",
        "text": "خيارات المشاركة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Freigabeoptionen"
      },
      {
        "language": "PT",
        "text": "Opções de compartilhamento"
      },
      {
        "language": "IT",
        "text": "Opzioni di condivisione"
      },
      {
        "language": "CS",
        "text": "Možnosti sdílení"
      },
      {
        "language": "EN",
        "text": "Sharing Options"
      }
    ]
  },
  {
    "key": "txt_review_share",
    "text": "Review & Share",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة ومشاركة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Überprüfen und teilen"
      },
      {
        "language": "PT",
        "text": "Revise e compartilhe"
      },
      {
        "language": "IT",
        "text": "Rivedi e condividi"
      },
      {
        "language": "CS",
        "text": "Ohodnoťte a sdílejte"
      },
      {
        "language": "EN",
        "text": "Review & Share"
      }
    ]
  },
  {
    "key": "txt_select_candidate",
    "text": "Select Candidates",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المرشحين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidaten auswählen"
      },
      {
        "language": "PT",
        "text": "Selecione os candidatos"
      },
      {
        "language": "IT",
        "text": "Seleziona i candidati"
      },
      {
        "language": "CS",
        "text": "Vybrat respondenty"
      },
      {
        "language": "EN",
        "text": "Select Candidates"
      }
    ]
  },
  {
    "key": "txt_shareResults",
    "text": "Share Results",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة النتائج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ergebnisse teilen"
      },
      {
        "language": "PT",
        "text": "Compartilhar resultados"
      },
      {
        "language": "IT",
        "text": "Condividi i risultati"
      },
      {
        "language": "CS",
        "text": "Sdílet výsledky"
      },
      {
        "language": "EN",
        "text": "Share Results"
      }
    ]
  },
  {
    "key": "txtAverageScore_info",
    "text": "Compare against the average evaluators scores.\t",
    "translations": [
      {
        "language": "AR",
        "text": "قارن مع متوسط نتائج المقيمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Zeigt die durchschnittliche Punktzahl oder den berechneten Wert aller Bewertungszyklen."
      },
      {
        "language": "PT",
        "text": "Apresenta a pontuação média ou valor calculado de todos os ciclos de avaliação."
      },
      {
        "language": "IT",
        "text": "Mostra il punteggio medio o il valore ottenuto sulla base dei punteggi di tutti i valutatori nell'Assessment attuale."
      },
      {
        "language": "CS",
        "text": "Porovnejte s průměrným hodnocením hodnotitelů."
      },
      {
        "language": "EN",
        "text": "Compare against the average evaluators scores.\t"
      }
    ]
  },
  {
    "key": "txtPreviousScore_info",
    "text": "Compare against the previous score",
    "translations": [
      {
        "language": "AR",
        "text": "قارن مع النتيجة السابقة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Zeigt die Punktzahl oder den Wert aus dem letzten Bewertungszyklus an."
      },
      {
        "language": "PT",
        "text": "Exibe a pontuação ou valor do último ciclo de avaliação."
      },
      {
        "language": "IT",
        "text": "Mostra il punteggio o il valore dell'ultimo Assessment compilato."
      },
      {
        "language": "CS",
        "text": "Porovnejte s předchozím skóre"
      },
      {
        "language": "EN",
        "text": "Compare against the previous score"
      }
    ]
  },
  {
    "key": "txt_Norespond_739",
    "text": "No respondents",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد مستجيبون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Keine Befragten"
      },
      {
        "language": "PT",
        "text": "Nenhum respondente"
      },
      {
        "language": "IT",
        "text": "Nessun rispondente"
      },
      {
        "language": "CS",
        "text": "Žádní respondenti"
      },
      {
        "language": "EN",
        "text": "No respondents"
      }
    ]
  },
  {
    "key": "txt_Finalize_669",
    "text": "Finalize",
    "translations": [
      {
        "language": "AR",
        "text": "إنهاء"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Abschließen"
      },
      {
        "language": "PT",
        "text": "Finalizar"
      },
      {
        "language": "IT",
        "text": "Finalizza"
      },
      {
        "language": "CS",
        "text": "Dokončit"
      },
      {
        "language": "EN",
        "text": "Finalize"
      }
    ]
  },
  {
    "key": "txt_DataValid_195",
    "text": "Data Validation",
    "translations": [
      {
        "language": "AR",
        "text": "التحقق من صحة البيانات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Datenvalidierung"
      },
      {
        "language": "PT",
        "text": "Validação de dados"
      },
      {
        "language": "IT",
        "text": "Validazione dati"
      },
      {
        "language": "CS",
        "text": "Ověření dat"
      },
      {
        "language": "EN",
        "text": "Data Validation"
      }
    ]
  },
  {
    "key": "txt_evaluators_comments",
    "text": "Evaluators’ Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تعليقات المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kommentare der Gutachter"
      },
      {
        "language": "PT",
        "text": "Comentários dos avaliadores"
      },
      {
        "language": "IT",
        "text": "Commenti dei Valutatori"
      },
      {
        "language": "CS",
        "text": "Komentáře hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Evaluators’ Comments"
      }
    ]
  },
  {
    "key": "txtEvaluatorName",
    "text": "Evaluator Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المقيّم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Name des Bewerters"
      },
      {
        "language": "PT",
        "text": "Nome do avaliador"
      },
      {
        "language": "IT",
        "text": "Nome del valutatore"
      },
      {
        "language": "CS",
        "text": "Jméno hodnotitele"
      },
      {
        "language": "EN",
        "text": "Evaluator Name"
      }
    ]
  },
  {
    "key": "txt_evaluator_analysis",
    "text": "Evaluator Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Evaluator-Analyse"
      },
      {
        "language": "PT",
        "text": "Análise do Avaliador"
      },
      {
        "language": "IT",
        "text": "Analisi del valutatore"
      },
      {
        "language": "CS",
        "text": "Analýza hodnotitele"
      },
      {
        "language": "EN",
        "text": "Evaluator Analysis"
      }
    ]
  },
  {
    "key": "txt_candidate_report_desc",
    "text": "Detailed report on individual candidate assessments.",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير مُفصّل عن تقييمات المرشحين الفردية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Detaillierter Bericht über die Beurteilungen einzelner Kandidaten."
      },
      {
        "language": "PT",
        "text": "Relatório detalhado sobre avaliações individuais de candidatos."
      },
      {
        "language": "IT",
        "text": "Report dettagliato degli Assessment dei singoli candidati."
      },
      {
        "language": "CS",
        "text": "Podrobná zpráva o hodnocení jednotlivých uchazečů."
      },
      {
        "language": "EN",
        "text": "Detailed report on individual candidate assessments."
      }
    ]
  },
  {
    "key": "txt_180_candidate_report",
    "text": "180 Candidate Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير °180 للمرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "180 Kandidatenbericht"
      },
      {
        "language": "PT",
        "text": "180 Relatório do Candidato"
      },
      {
        "language": "IT",
        "text": "Candidate Report 180°"
      },
      {
        "language": "CS",
        "text": "180° Zpráva pro respondenta"
      },
      {
        "language": "EN",
        "text": "180 Candidate Report"
      }
    ]
  },
  {
    "key": "txt_360_candidate_report",
    "text": "360 Candidate Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير °360 للمرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "360-Grad-Kandidatenbericht"
      },
      {
        "language": "PT",
        "text": "Relatório de Candidato 360"
      },
      {
        "language": "IT",
        "text": "Candidate Report 360°"
      },
      {
        "language": "CS",
        "text": "Zpráva hodnocení 360"
      },
      {
        "language": "EN",
        "text": "360 Candidate Report"
      }
    ]
  },
  {
    "key": "txt_management_report_desc",
    "text": "Insightful analysis on managerial performance and feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات مُفصلة عن وآراء وتعليقات الإدارة وأدائهم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Aufschlussreiche Analyse der Leistung und des Feedbacks von Führungskräften"
      },
      {
        "language": "PT",
        "text": "Análise criteriosa sobre desempenho gerencial e feedback"
      },
      {
        "language": "IT",
        "text": "Analisi approfondita sulla performance manageriale e sul feedback ricevuto"
      },
      {
        "language": "CS",
        "text": "Podrobná analýza manažerských výkonů a zpětné vazby"
      },
      {
        "language": "EN",
        "text": "Insightful analysis on managerial performance and feedback"
      }
    ]
  },
  {
    "key": "txt_180_management_report",
    "text": "180 Management Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير °180 الإداري "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "180 Lagebericht"
      },
      {
        "language": "PT",
        "text": "180 Relatório de Gestão"
      },
      {
        "language": "IT",
        "text": "Management Report 180°"
      },
      {
        "language": "CS",
        "text": "180° Zpráva pro manažera"
      },
      {
        "language": "EN",
        "text": "180 Management Report"
      }
    ]
  },
  {
    "key": "txt_360_management_report",
    "text": "360 Management Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير °360 الإداري "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "360 Lagebericht"
      },
      {
        "language": "PT",
        "text": "Relatório de Gestão 360"
      },
      {
        "language": "IT",
        "text": "Management Report 360°"
      },
      {
        "language": "CS",
        "text": "Zpráva hodnocení 360"
      },
      {
        "language": "EN",
        "text": "360 Management Report"
      }
    ]
  },
  {
    "key": "txt_download_reports_desc",
    "text": "Select the type of report you wish to download.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد نوع التقرير الذي ترغب في تحميله."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Wählen Sie den Berichtstyp aus, den Sie herunterladen möchten."
      },
      {
        "language": "PT",
        "text": "Selecione o tipo de relatório que deseja baixar."
      },
      {
        "language": "IT",
        "text": "Seleziona il tipo di report che desideri scaricare."
      },
      {
        "language": "CS",
        "text": "Vyberte typ zprávy, kterou si chcete stáhnout."
      },
      {
        "language": "EN",
        "text": "Select the type of report you wish to download."
      }
    ]
  },
  {
    "key": "txt_forcandidate",
    "text": "For Candidate",
    "translations": [
      {
        "language": "AR",
        "text": "للمرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Für Kandidaten"
      },
      {
        "language": "PT",
        "text": "Para Candidato"
      },
      {
        "language": "IT",
        "text": "Per candidato"
      },
      {
        "language": "CS",
        "text": "Pro uchazeče"
      },
      {
        "language": "EN",
        "text": "For Candidate"
      }
    ]
  },
  {
    "key": "txt_competency_score_breakdown",
    "text": "Competency Score Breakdown",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع درجات الجدارة والمهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Aufschlüsselung der Kompetenzpunktzahlen"
      },
      {
        "language": "PT",
        "text": "Detalhamento da pontuação de competência"
      },
      {
        "language": "IT",
        "text": "Dettaglio dei punteggi per competenza"
      },
      {
        "language": "CS",
        "text": "Rozpis bodového hodnocení kompetencí"
      },
      {
        "language": "EN",
        "text": "Competency Score Breakdown"
      }
    ]
  },
  {
    "key": "txt_chang_percentage",
    "text": "Change %",
    "translations": [
      {
        "language": "AR",
        "text": "التغيير %"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ändern %"
      },
      {
        "language": "PT",
        "text": "Mudar %"
      },
      {
        "language": "IT",
        "text": "Variazione %"
      },
      {
        "language": "CS",
        "text": "Změna v %"
      },
      {
        "language": "EN",
        "text": "Change %"
      }
    ]
  },
  {
    "key": "txt_candidate_analysis",
    "text": "Candidate Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات المرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidatenanalyse"
      },
      {
        "language": "PT",
        "text": "Análise de Candidato"
      },
      {
        "language": "IT",
        "text": "Analisi del candidato"
      },
      {
        "language": "CS",
        "text": "Analýza respondentů"
      },
      {
        "language": "EN",
        "text": "Candidate Analysis"
      }
    ]
  },
  {
    "key": "txtView",
    "text": "View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Siehe hier"
      },
      {
        "language": "PT",
        "text": "Visualizar"
      },
      {
        "language": "IT",
        "text": "Visualizza"
      },
      {
        "language": "CS",
        "text": "Zobrazit"
      },
      {
        "language": "EN",
        "text": "View"
      }
    ]
  },
  {
    "key": "txt_evaluators_res_rate",
    "text": "Evaluators Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل استجابة المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Antwortrate der Gutachter"
      },
      {
        "language": "PT",
        "text": "Taxa de resposta dos avaliadores"
      },
      {
        "language": "IT",
        "text": "Tasso di risposta dei valutatori"
      },
      {
        "language": "CS",
        "text": "Míra odezvy hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Evaluators Response Rate"
      }
    ]
  },
  {
    "key": "txt_candidates_res_rate",
    "text": "Candidates Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل استجابة المرشحين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Antwortrate der Kandidaten"
      },
      {
        "language": "PT",
        "text": "Taxa de resposta dos candidatos"
      },
      {
        "language": "IT",
        "text": "Tasso di risposta dei candidati"
      },
      {
        "language": "CS",
        "text": "Míra odezvy uchazečů"
      },
      {
        "language": "EN",
        "text": "Candidates Response Rate"
      }
    ]
  },
  {
    "key": "txtSthWrong",
    "text": "Something went wrong",
    "translations": [
      {
        "language": "AR",
        "text": "حدث خطأ"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": "Coś poszło nie tak"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Da ist etwas schiefgelaufen"
      },
      {
        "language": "PT",
        "text": "Algo deu errado"
      },
      {
        "language": "IT",
        "text": "Si è verificato un errore"
      },
      {
        "language": "CS",
        "text": "Došlo k chybě"
      },
      {
        "language": "EN",
        "text": "Something went wrong"
      }
    ]
  },
  {
    "key": "txt_view_assessment",
    "text": "View Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bewertung ansehen"
      },
      {
        "language": "PT",
        "text": "Ver avaliação"
      },
      {
        "language": "IT",
        "text": "Visualizza l'Assessment"
      },
      {
        "language": "CS",
        "text": "Zobrazit hodnocení"
      },
      {
        "language": "EN",
        "text": "View Assessment"
      }
    ]
  },
  {
    "key": "txt_edit_timeframe",
    "text": "Edit Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المدة الزمنية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Zeitraum bearbeiten"
      },
      {
        "language": "PT",
        "text": "Editar prazo"
      },
      {
        "language": "IT",
        "text": "Modifica l'intervallo di tempo"
      },
      {
        "language": "CS",
        "text": "Upravit časový rámec"
      },
      {
        "language": "EN",
        "text": "Edit Timeframe"
      }
    ]
  },
  {
    "key": "txt_evaluators_reminders",
    "text": "Are you sure you want send reminder to selected evaluators?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد إرسال تذكيرات إلى المُقيِّمين المُختارين؟"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Möchten Sie ausgewählten Gutachtern wirklich eine Erinnerung senden?"
      },
      {
        "language": "PT",
        "text": "Tem certeza de que deseja enviar um lembrete aos avaliadores selecionados?"
      },
      {
        "language": "IT",
        "text": "Sei sicuro di voler inviare un promemoria ai valutatori selezionati?"
      },
      {
        "language": "CS",
        "text": "Opravdu chcete odeslat upomínku vybraným hodnotitelům?"
      },
      {
        "language": "EN",
        "text": "Are you sure you want send reminder to selected evaluators?"
      }
    ]
  },
  {
    "key": "txt_candidates_reminders",
    "text": "Are you sure you want to send the reminder to the selected candidates along with their evaluators?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من أنك تريد إرسال تذكيرات إلى المرشحين المختارين مع المقيّمين الخاصين بهم؟"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Möchten Sie die Erinnerung wirklich an die ausgewählten Kandidaten und ihre Gutachter senden?"
      },
      {
        "language": "PT",
        "text": "Tem certeza de que deseja enviar o lembrete aos candidatos selecionados juntamente com seus avaliadores?"
      },
      {
        "language": "IT",
        "text": "Sei sicuro di voler inviare il promemoria ai candidati selezionati insieme ai loro valutatori?"
      },
      {
        "language": "CS",
        "text": "Opravdu chcete odeslat upomínku vybraným uchazečům i jejich hodnotitelům?"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to send the reminder to the selected candidates along with their evaluators?"
      }
    ]
  },
  {
    "key": "txt_delete",
    "text": "Delete\t",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Löschen"
      },
      {
        "language": "PT",
        "text": "Excluir"
      },
      {
        "language": "IT",
        "text": "Elimina"
      },
      {
        "language": "CS",
        "text": "Smazat"
      },
      {
        "language": "EN",
        "text": "Delete\t"
      }
    ]
  },
  {
    "key": "txt_close_selected",
    "text": "Close Selected",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق المرشحين المختارين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Auswahl schließen"
      },
      {
        "language": "PT",
        "text": "Fechar selecionado"
      },
      {
        "language": "IT",
        "text": "Chiudi i selezionati"
      },
      {
        "language": "CS",
        "text": "Zavřít výběr"
      },
      {
        "language": "EN",
        "text": "Close Selected"
      }
    ]
  },
  {
    "key": "txt_open_report",
    "text": "Open Report",
    "translations": [
      {
        "language": "AR",
        "text": "فتح التقرير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bericht öffnen"
      },
      {
        "language": "PT",
        "text": "Abrir relatório"
      },
      {
        "language": "IT",
        "text": "Apri il report"
      },
      {
        "language": "CS",
        "text": "Otevřít zprávu"
      },
      {
        "language": "EN",
        "text": "Open Report"
      }
    ]
  },
  {
    "key": "txt_inactive",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعّال"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Inaktiv"
      },
      {
        "language": "PT",
        "text": "Inativo"
      },
      {
        "language": "IT",
        "text": "Inattivo"
      },
      {
        "language": "CS",
        "text": "Neaktivní"
      },
      {
        "language": "EN",
        "text": "Inactive"
      }
    ]
  },
  {
    "key": "txt_all_candidates",
    "text": "All Candidates",
    "translations": [
      {
        "language": "AR",
        "text": "كل المرشحين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Alle Kandidaten"
      },
      {
        "language": "PT",
        "text": "Todos os candidatos"
      },
      {
        "language": "IT",
        "text": "Tutti i candidati"
      },
      {
        "language": "CS",
        "text": "Všichni respondenti"
      },
      {
        "language": "EN",
        "text": "All Candidates"
      }
    ]
  },
  {
    "key": "txt_candidate_by_status",
    "text": "Candidates By Status",
    "translations": [
      {
        "language": "AR",
        "text": "المرشحون حسب الحالة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidaten nach Status"
      },
      {
        "language": "PT",
        "text": "Candidatos por status"
      },
      {
        "language": "IT",
        "text": "Candidati per statuo"
      },
      {
        "language": "CS",
        "text": "Respondenti podle stavu"
      },
      {
        "language": "EN",
        "text": "Candidates By Status"
      }
    ]
  },
  {
    "key": "txt_viewAnalysis",
    "text": "View Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التحليلات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Analyse anzeigen"
      },
      {
        "language": "PT",
        "text": "Ver análise"
      },
      {
        "language": "IT",
        "text": "Visualizza l'analisi"
      },
      {
        "language": "CS",
        "text": "Zobrazit analýzu"
      },
      {
        "language": "EN",
        "text": "View Analysis"
      }
    ]
  },
  {
    "key": "txt_preview",
    "text": "Preview",
    "translations": [
      {
        "language": "AR",
        "text": "معاينة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorschau"
      },
      {
        "language": "PT",
        "text": "Visualização"
      },
      {
        "language": "IT",
        "text": "Anteprima"
      },
      {
        "language": "CS",
        "text": "Náhled"
      },
      {
        "language": "EN",
        "text": "Preview"
      }
    ]
  },
  {
    "key": "txt_competencies_statements",
    "text": "Competencies/Statements",
    "translations": [
      {
        "language": "AR",
        "text": "الجدارة والمهارة/العبارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kompetenzen/Statements"
      },
      {
        "language": "PT",
        "text": "Competências/Declarações"
      },
      {
        "language": "IT",
        "text": "Competenze/Affermazioni"
      },
      {
        "language": "CS",
        "text": "Kompetence/Popisy"
      },
      {
        "language": "EN",
        "text": "Competencies/Statements"
      }
    ]
  },
  {
    "key": "txt_example_statement",
    "text": "I feel motivated and inspired at the workplace",
    "translations": [
      {
        "language": "AR",
        "text": "أشعر بالتحفيز والإلهام في مكان العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ich fühle mich am Arbeitsplatz motiviert und inspiriert"
      },
      {
        "language": "PT",
        "text": "Sinto-me motivado e inspirado no local de trabalho"
      },
      {
        "language": "IT",
        "text": "Mi sento motivato e ispirato sul luogo di lavoro"
      },
      {
        "language": "CS",
        "text": "V práci se cítím motivovaný a inspirovaný"
      },
      {
        "language": "EN",
        "text": "I feel motivated and inspired at the workplace"
      }
    ]
  },
  {
    "key": "txt_sample_quest",
    "text": "Sample Question",
    "translations": [
      {
        "language": "AR",
        "text": "عينة سؤال"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Beispielfrage"
      },
      {
        "language": "PT",
        "text": "Exemplo de pergunta"
      },
      {
        "language": "IT",
        "text": "Domanda di esempio"
      },
      {
        "language": "CS",
        "text": "Ukázková otázka"
      },
      {
        "language": "EN",
        "text": "Sample Question"
      }
    ]
  },
  {
    "key": "txt_question_perv",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "معاينة السؤال"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorschau Frage"
      },
      {
        "language": "PT",
        "text": "Visualização da pergunta"
      },
      {
        "language": "IT",
        "text": "Anteprima della domanda"
      },
      {
        "language": "CS",
        "text": "Náhled otázky"
      },
      {
        "language": "EN",
        "text": "Question Preview"
      }
    ]
  },
  {
    "key": "txt_reupload_template",
    "text": "Reupload Template",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تحميل النموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlage erneut hochladen"
      },
      {
        "language": "PT",
        "text": "Recarregar modelo"
      },
      {
        "language": "IT",
        "text": "Ricarica il template"
      },
      {
        "language": "CS",
        "text": "Šablona pro opětovné nahrání"
      },
      {
        "language": "EN",
        "text": "Reupload Template"
      }
    ]
  },
  {
    "key": "txt_submit_respondents",
    "text": "Submit Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المستجيبون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidaten eingeben"
      },
      {
        "language": "PT",
        "text": "Enviar respondentes"
      },
      {
        "language": "IT",
        "text": "Conferma i rispondenti"
      },
      {
        "language": "CS",
        "text": "Odeslat odpovědi"
      },
      {
        "language": "EN",
        "text": "Submit Respondents"
      }
    ]
  },
  {
    "key": "txt_UploadData",
    "text": "Upload Data",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المعلومات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Daten hochladen"
      },
      {
        "language": "PT",
        "text": "Carregar dados"
      },
      {
        "language": "IT",
        "text": "Carica i dati"
      },
      {
        "language": "CS",
        "text": "Nahrát data"
      },
      {
        "language": "EN",
        "text": "Upload Data"
      }
    ]
  },
  {
    "key": "txt_to_continue",
    "text": "to Continue",
    "translations": [
      {
        "language": "AR",
        "text": "للاستمرار"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Weiter"
      },
      {
        "language": "PT",
        "text": "para continuar"
      },
      {
        "language": "IT",
        "text": "per continuare"
      },
      {
        "language": "CS",
        "text": "pokračovat"
      },
      {
        "language": "EN",
        "text": "to Continue"
      }
    ]
  },
  {
    "key": "txt_click",
    "text": "Click",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Klicken"
      },
      {
        "language": "PT",
        "text": "Clique"
      },
      {
        "language": "IT",
        "text": "Clicca"
      },
      {
        "language": "CS",
        "text": "Klikněte"
      },
      {
        "language": "EN",
        "text": "Click"
      }
    ]
  },
  {
    "key": "txt_respondents_uploaded_success",
    "text": "Respondents uploaded successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم إضافة المستجيبين بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "KandidatInnen erfolgreich hochgeladen"
      },
      {
        "language": "PT",
        "text": "Os entrevistados foram enviados com sucesso!"
      },
      {
        "language": "IT",
        "text": "Rispondenti caricati con successo!"
      },
      {
        "language": "CS",
        "text": "Odpovědi byly úspěšně nahrány!"
      },
      {
        "language": "EN",
        "text": "Respondents uploaded successfully!"
      }
    ]
  },
  {
    "key": "reupload_txt",
    "text": "Please reupload the file after you’ve fixed the validation errors mentioned above.",
    "translations": [
      {
        "language": "AR",
        "text": "يُرجى إعادة رفع الملف بعد إصلاح أخطاء التحقق المذكورة أعلاه."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bitte laden Sie die Datei erneut hoch, nachdem Sie die oben genannten Validierungsfehler behoben haben."
      },
      {
        "language": "PT",
        "text": "Carregue novamente o arquivo depois de corrigir os erros de validação mencionados acima."
      },
      {
        "language": "IT",
        "text": "Ricarica il file dopo aver corretto gli errori di validazione indicati sopra."
      },
      {
        "language": "CS",
        "text": "Po opravě výše uvedených chyb při ověřování souboru prosím nahrajte znovu."
      },
      {
        "language": "EN",
        "text": "Please reupload the file after you’ve fixed the validation errors mentioned above."
      }
    ]
  },
  {
    "key": "txt_validation_err",
    "text": "Validation Error at Row #",
    "translations": [
      {
        "language": "AR",
        "text": "خطأ التحقق في الصف رقم #"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Validierungsfehler in Zeile Nr."
      },
      {
        "language": "PT",
        "text": "Erro de validação na linha #"
      },
      {
        "language": "IT",
        "text": "Errore di validazione alla riga #"
      },
      {
        "language": "CS",
        "text": "Chyba ověření v řádku č."
      },
      {
        "language": "EN",
        "text": "Validation Error at Row #"
      }
    ]
  },
  {
    "key": "txt_respondents_v_err",
    "text": "Respondents have the following validation errors:",
    "translations": [
      {
        "language": "AR",
        "text": "تم العثور على مستجيبين لديهم أخطاء التحقق التالية:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bei den Befragten treten die folgenden Validierungsfehler auf:"
      },
      {
        "language": "PT",
        "text": "Os entrevistados apresentam os seguintes erros de validação:"
      },
      {
        "language": "IT",
        "text": "I rispondenti presentano i seguenti errori di validazione:"
      },
      {
        "language": "CS",
        "text": "U respondentů se vyskytují následující chyby při ověřování:"
      },
      {
        "language": "EN",
        "text": "Respondents have the following validation errors:"
      }
    ]
  },
  {
    "key": "txt_respondents_detected_valid",
    "text": "Respondents detected as valid!",
    "translations": [
      {
        "language": "AR",
        "text": "مستجيبًا صالحًا تم الكشف عنهم!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "KandidatInnen als gültig erkannt!"
      },
      {
        "language": "PT",
        "text": "Respondentes detectados como válidos!"
      },
      {
        "language": "IT",
        "text": "Rispondenti rilevati come validi!"
      },
      {
        "language": "CS",
        "text": "Respondenti byli identifikováni jako platní!"
      },
      {
        "language": "EN",
        "text": "Respondents detected as valid!"
      }
    ]
  },
  {
    "key": "txt_respondents_detected",
    "text": "Respondents detected!",
    "translations": [
      {
        "language": "AR",
        "text": "مستجيباً تم الكشف عنهم!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Befragte erkannt!"
      },
      {
        "language": "PT",
        "text": "Entrevistados detectados!"
      },
      {
        "language": "IT",
        "text": "Rispondenti rilevati!"
      },
      {
        "language": "CS",
        "text": "Respondenti byli zjištěni!"
      },
      {
        "language": "EN",
        "text": "Respondents detected!"
      }
    ]
  },
  {
    "key": "txtRetryDownload",
    "text": "Retry if download didn’t start",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إعادة المحاولة إذا لم يبدأ التحميل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Erneut versuchen, wenn der Download nicht gestartet wurde"
      },
      {
        "language": "PT",
        "text": "Tente novamente se o download não tiver iniciado"
      },
      {
        "language": "IT",
        "text": "Riprova se il download non è partito"
      },
      {
        "language": "CS",
        "text": "Pokud se stahování nespustilo, zkuste to znovu"
      },
      {
        "language": "EN",
        "text": "Retry if download didn’t start"
      }
    ]
  },
  {
    "key": "txt_dowloadstarted",
    "text": "Download Started...",
    "translations": [
      {
        "language": "AR",
        "text": "جاري التحميل..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Download gestartet..."
      },
      {
        "language": "PT",
        "text": "Download iniciado..."
      },
      {
        "language": "IT",
        "text": "Download avviato..."
      },
      {
        "language": "CS",
        "text": "Stahování bylo zahájeno..."
      },
      {
        "language": "EN",
        "text": "Download Started..."
      }
    ]
  },
  {
    "key": "txt_download_template",
    "text": "Download Template",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل النموذج."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlage herunterladen"
      },
      {
        "language": "PT",
        "text": "Baixar modelo"
      },
      {
        "language": "IT",
        "text": "Scarica il template"
      },
      {
        "language": "CS",
        "text": "Stáhnout šablonu"
      },
      {
        "language": "EN",
        "text": "Download Template"
      }
    ]
  },
  {
    "key": "txt_note2",
    "text": "Note #2:",
    "translations": [
      {
        "language": "AR",
        "text": "ملاحظة رقم 2:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Hinweis Nr. 2:"
      },
      {
        "language": "PT",
        "text": "Nota nº 2:"
      },
      {
        "language": "IT",
        "text": "Nota #2:"
      },
      {
        "language": "CS",
        "text": "Poznámka č. 2:"
      },
      {
        "language": "EN",
        "text": "Note #2:"
      }
    ]
  },
  {
    "key": "txt_note1",
    "text": "Note #1: ",
    "translations": [
      {
        "language": "AR",
        "text": "ملاحظة رقم 1:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Hinweis Nr. 1:"
      },
      {
        "language": "PT",
        "text": "Nota nº 1:"
      },
      {
        "language": "IT",
        "text": "Nota #1:"
      },
      {
        "language": "CS",
        "text": "Poznámka č. 1:"
      },
      {
        "language": "EN",
        "text": "Note #1: "
      }
    ]
  },
  {
    "key": "upload_note2",
    "text": "Delete the example rows",
    "translations": [
      {
        "language": "AR",
        "text": "قم بحذف الصفوف النموذجية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Löschen Sie die Beispielzeilen"
      },
      {
        "language": "PT",
        "text": "Exclua as linhas de exemplo"
      },
      {
        "language": "IT",
        "text": "Elimina le righe di esempio"
      },
      {
        "language": "CS",
        "text": "Odstranit ukázkové řádky"
      },
      {
        "language": "EN",
        "text": "Delete the example rows"
      }
    ]
  },
  {
    "key": "upload_note1",
    "text": "Fill the data without altering the premade structure of the template or changing the file extension (.csv). ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة البيانات دون تغيير النموذج المعُرف مسبقاً أو تغيير نوع الملف (.csv)."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Füllen Sie die Daten aus, ohne die vorgefertigte Struktur der Vorlage zu verändern oder die Dateierweiterung (.csv) zu ändern."
      },
      {
        "language": "PT",
        "text": "Preencha os dados sem alterar a estrutura pré-fabricada do template ou alterar a extensão do arquivo (.csv)."
      },
      {
        "language": "IT",
        "text": "Compila i dati senza alterare la struttura preimpostata del template o modificare l'estensione del file (.csv)."
      },
      {
        "language": "CS",
        "text": "Vyplňte údaje, aniž byste měnili předem připravenou strukturu šablony nebo příponu souboru (.csv)."
      },
      {
        "language": "EN",
        "text": "Fill the data without altering the premade structure of the template or changing the file extension (.csv). "
      }
    ]
  },
  {
    "key": "txt_TocreateR_364",
    "text": "To create Respondent in bulk, download the premade spreadsheet template (.csv) file, and fill it with your data.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إضافة العديد من المست باستخدام جدول البيانات المُعرف مسبقاً (.csv) وهو يتضمن جميع المعلومات المطلوبة والتي يتطلب منك بتعبئتها."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Um Befragte als Paket zu erstellen, laden Sie die vorgefertigte Tabelle (.csv) herunter und füllen Sie sie mit Ihren Daten."
      },
      {
        "language": "PT",
        "text": "Para criar o Respondent em massa, baixe o arquivo de modelo de planilha predefinido (.csv) e preencha-o com seus dados."
      },
      {
        "language": "IT",
        "text": "Per creare rispondenti in blocco, scarica il template precompilato (.csv) e inserisci i tuoi dati."
      },
      {
        "language": "CS",
        "text": "Chcete-li hromadně vytvořit respondenty, stáhněte si předem připravenou šablonu tabulky ve formátu CSV a vyplňte ji svými údaji."
      },
      {
        "language": "EN",
        "text": "To create Respondent in bulk, download the premade spreadsheet template (.csv) file, and fill it with your data."
      }
    ]
  },
  {
    "key": "txtImportData",
    "text": "Import Data",
    "translations": [
      {
        "language": "AR",
        "text": "رفع المعلومات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Daten importieren"
      },
      {
        "language": "PT",
        "text": "Importar dados"
      },
      {
        "language": "IT",
        "text": "Importa i dati"
      },
      {
        "language": "CS",
        "text": "Importovat data"
      },
      {
        "language": "EN",
        "text": "Import Data"
      }
    ]
  },
  {
    "key": "txt_res_pool",
    "text": "Respondents Pool",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidaten Pool"
      },
      {
        "language": "PT",
        "text": "Grupo de entrevistados"
      },
      {
        "language": "IT",
        "text": "Pool di rispondenti"
      },
      {
        "language": "CS",
        "text": "Skupina respondentů"
      },
      {
        "language": "EN",
        "text": "Respondents Pool"
      }
    ]
  },
  {
    "key": "txt_bulk_upload",
    "text": "Bulk Upload",
    "translations": [
      {
        "language": "AR",
        "text": "رفع جدول البيانات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Massen-Upload"
      },
      {
        "language": "PT",
        "text": "Upload em massa"
      },
      {
        "language": "IT",
        "text": "Caricamento in blocco"
      },
      {
        "language": "CS",
        "text": "Hromadné nahrávání"
      },
      {
        "language": "EN",
        "text": "Bulk Upload"
      }
    ]
  },
  {
    "key": "txtSelectionDesc1",
    "text": "Select how you want to add new respondent to the platform:",
    "translations": [
      {
        "language": "AR",
        "text": "قم باختيار الطريقة لإضافة مستجيب جديد إلى المنصة:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Wählen Sie aus, wie Sie der Plattform neue Befragte hinzufügen möchten:"
      },
      {
        "language": "PT",
        "text": "Selecione como deseja adicionar novo respondente à plataforma:"
      },
      {
        "language": "IT",
        "text": "Seleziona il modo in cui vuoi aggiungere un nuovo rispondente alla piattaforma:"
      },
      {
        "language": "CS",
        "text": "Vyberte, jakým způsobem chcete na platformu přidat nového respondenta:"
      },
      {
        "language": "EN",
        "text": "Select how you want to add new respondent to the platform:"
      }
    ]
  },
  {
    "key": "txtSearchRespondent",
    "text": "Search Respondents...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث عن المستجيبين..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Befragte suchen …"
      },
      {
        "language": "PT",
        "text": "Pesquisar entrevistados..."
      },
      {
        "language": "IT",
        "text": "Cerca i rispondenti..."
      },
      {
        "language": "CS",
        "text": "Vyhledat respondenty..."
      },
      {
        "language": "EN",
        "text": "Search Respondents..."
      }
    ]
  },
  {
    "key": "txt_add",
    "text": "Add",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar"
      },
      {
        "language": "IT",
        "text": "Aggiungi"
      },
      {
        "language": "CS",
        "text": "Přidat"
      },
      {
        "language": "EN",
        "text": "Add"
      }
    ]
  },
  {
    "key": "txt_remove",
    "text": "Remove",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Entfernen"
      },
      {
        "language": "PT",
        "text": "Remover"
      },
      {
        "language": "IT",
        "text": "Rimuovi"
      },
      {
        "language": "CS",
        "text": "Odebrat"
      },
      {
        "language": "EN",
        "text": "Remove"
      }
    ]
  },
  {
    "key": "txt_filled",
    "text": "Filled",
    "translations": [
      {
        "language": "AR",
        "text": "معبأ"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ausgefüllt"
      },
      {
        "language": "PT",
        "text": "Preenchido"
      },
      {
        "language": "IT",
        "text": "Compilato"
      },
      {
        "language": "CS",
        "text": "Vyplněno"
      },
      {
        "language": "EN",
        "text": "Filled"
      }
    ]
  },
  {
    "key": "txt_empty_respondents",
    "text": "No respondents added yet!",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم إضافة أي مستجيبين بعد!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sie müssen Befragte importieren"
      },
      {
        "language": "PT",
        "text": "Nenhum respondente adicionado ainda!"
      },
      {
        "language": "IT",
        "text": "Ancora nessun rispondente aggiunto!"
      },
      {
        "language": "CS",
        "text": "Zatím nebyl přidán žádný respondent!"
      },
      {
        "language": "EN",
        "text": "No respondents added yet!"
      }
    ]
  },
  {
    "key": "txt_partially_filled",
    "text": "Partially Filled",
    "translations": [
      {
        "language": "AR",
        "text": "معبأ جزئيًا"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Teilweise gefüllt"
      },
      {
        "language": "PT",
        "text": "Parcialmente preenchido"
      },
      {
        "language": "IT",
        "text": "Parzialmente compilato"
      },
      {
        "language": "CS",
        "text": "Částečně obsazeno"
      },
      {
        "language": "EN",
        "text": "Partially Filled"
      }
    ]
  },
  {
    "key": "txt_empty",
    "text": "Empty",
    "translations": [
      {
        "language": "AR",
        "text": "فارغ"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Leer"
      },
      {
        "language": "PT",
        "text": "Vazio"
      },
      {
        "language": "IT",
        "text": "Vuoto"
      },
      {
        "language": "CS",
        "text": "Prázdný"
      },
      {
        "language": "EN",
        "text": "Empty"
      }
    ]
  },
  {
    "key": "txtAllRights",
    "text": "All Rights Reserved",
    "translations": [
      {
        "language": "AR",
        "text": "جميع الحقوق محفوظة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": "Wszelkie prawa zastrzeżone"
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Alle Rechte vorbehalten"
      },
      {
        "language": "PT",
        "text": "Todos os direitos reservados"
      },
      {
        "language": "IT",
        "text": "Tutti i diritti riservati"
      },
      {
        "language": "CS",
        "text": " Všechna práva vyhrazena"
      },
      {
        "language": "EN",
        "text": "All Rights Reserved"
      }
    ]
  },
  {
    "key": "txt_created_on",
    "text": "Generated on",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإنشاء:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Generiert am"
      },
      {
        "language": "PT",
        "text": "Gerado em"
      },
      {
        "language": "IT",
        "text": "Generato il"
      },
      {
        "language": "CS",
        "text": "Vytvořeno dne"
      },
      {
        "language": "EN",
        "text": "Generated on"
      }
    ]
  },
  {
    "key": "txt_invalidC180_evaluators",
    "text": "The candidate should have at least 3 Peers/Team.\t",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون لدى المرشح 3 زملاء أو فريق العمل كحد أدنى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Der Kandidat sollte mindestens 3 Peers/Team haben."
      },
      {
        "language": "PT",
        "text": "O candidato deverá ter pelo menos 3 Pares/Equipe."
      },
      {
        "language": "IT",
        "text": "Il candidato deve avere almeno 3 valutatori tra i colleghi e il team."
      },
      {
        "language": "CS",
        "text": "Uchazeč by měl mít alespoň 3 kolegy/členy týmu."
      },
      {
        "language": "EN",
        "text": "The candidate should have at least 3 Peers/Team.\t"
      }
    ]
  },
  {
    "key": "txt_invalidC360_evaluators",
    "text": "The candidate should have 1-2 managers and at least 2 peers/team members.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون للمرشح  مدير واحد و2 من الزملاء أو أعضاء الفريق كحد أدنى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Der Kandidat sollte 1–2 Manager und mindestens 2 Kollegen/Teammitglieder haben."
      },
      {
        "language": "PT",
        "text": "O candidato deve ter de 1 a 2 gerentes e pelo menos 2 pares/membros da equipe."
      },
      {
        "language": "IT",
        "text": "Il candidato deve avere 1-2 manager e almeno 2 valutatori  tra i colleghi e il team."
      },
      {
        "language": "CS",
        "text": "Uchazeč by měl mít 1–2 nadřízené a alespoň 2 kolegy/členy týmu."
      },
      {
        "language": "EN",
        "text": "The candidate should have 1-2 managers and at least 2 peers/team members."
      }
    ]
  },
  {
    "key": "txt_invalidE_rows",
    "text": "These rows in the Excel sheet are missing one or more of the required fields (name, email address, phone number, or evaluator code):\t",
    "translations": [
      {
        "language": "AR",
        "text": "تفتقر هذه الصفوف في ملف Excel إلى واحد أو أكثر من الحقول المطلوبة (الاسم، عنوان البريد الإلكتروني، رقم الهاتف، أو رمز المُقَيِّم):"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " In den folgenden Zeilen der Excel-Tabelle fehlt eines oder mehrere der erforderlichen Felder (Name, E-Mail-Adresse, Telefonnummer oder Bewertercode):"
      },
      {
        "language": "PT",
        "text": "Estas linhas na planilha do Excel estão faltando um ou mais campos obrigatórios (nome, endereço de e-mail, número de telefone ou código do avaliador):"
      },
      {
        "language": "IT",
        "text": "Queste righe nel foglio Excel non contengono uno o più campi obbligatori (nome, email, numero di telefono o codice valutatore):"
      },
      {
        "language": "CS",
        "text": "V těchto řádcích tabulky Excel chybí jedno nebo více povinných polí (jméno, e-mailová adresa, telefonní číslo nebo kód hodnotitele):"
      },
      {
        "language": "EN",
        "text": "These rows in the Excel sheet are missing one or more of the required fields (name, email address, phone number, or evaluator code):\t"
      }
    ]
  },
  {
    "key": "txt_invalid_evaluators",
    "text": "These candidates have invalid evaluators:",
    "translations": [
      {
        "language": "AR",
        "text": "هؤلاء المرشحين لديهم مُقيِّمون  في صيغة غير صالحة:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Diese Kandidaten haben ungültige Gutachter:"
      },
      {
        "language": "PT",
        "text": "Estes candidatos têm avaliadores inválidos:"
      },
      {
        "language": "IT",
        "text": "Questi candidati presentano valutatori non conformi:"
      },
      {
        "language": "CS",
        "text": "Tito respondenti mají neplatné hodnotitele:"
      },
      {
        "language": "EN",
        "text": "These candidates have invalid evaluators:"
      }
    ]
  },
  {
    "key": "txt_invalid_rows",
    "text": "These rows in the Excel sheet are missing one or more of the required fields (name, email address, relation, or Evaluating ID or phone number): ",
    "translations": [
      {
        "language": "AR",
        "text": "تفتقر هذه الصفوف في ملف Excel إلى واحد أو أكثر من الحقول المطلوبة (الاسم، عنوان البريد الإلكتروني، العلاقة، أو معرف التقييم أو رقم الهاتف):\n"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " In den folgenden Zeilen der Excel-Tabelle fehlt eines oder mehrere der erforderlichen Felder (Name, E-Mail-Adresse, Beziehung oder Auswertungs-ID bzw. Telefonnummer):"
      },
      {
        "language": "PT",
        "text": "Estas linhas na planilha do Excel estão faltando um ou mais dos campos obrigatórios (nome, endereço de e-mail, parentesco ou ID de avaliação ou número de telefone):"
      },
      {
        "language": "IT",
        "text": "Queste righe nel foglio Excel non contengono uno o più campi obbligatori (nome, email, relazione, ID del valutato o numero di telefono):"
      },
      {
        "language": "CS",
        "text": "V těchto řádcích tabulky Excel chybí jedno nebo více povinných polí (jméno, e-mailová adresa, vztah, identifikační číslo pro vyhodnocení nebo telefonní číslo):"
      },
      {
        "language": "EN",
        "text": "These rows in the Excel sheet are missing one or more of the required fields (name, email address, relation, or Evaluating ID or phone number): "
      }
    ]
  },
  {
    "key": "txtMaxRespondentsForDemo",
    "text": "Max Respondents for Demo accounts, please add up to 4",
    "translations": [
      {
        "language": "AR",
        "text": "لقد وصلت للحد الأقصى للمستجيبين في الحساب التجريبي، يُرجى إضافة 4 مستجيبين كحد أقصى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Maximale Teilnehmerzahl für Demokonten, bitte bis zu 4 hinzufügen"
      },
      {
        "language": "PT",
        "text": "Máximo de entrevistados para contas de demonstração, adicione até 4"
      },
      {
        "language": "IT",
        "text": "Numero massimo di rispondenti per gli account demo, aggiungine fino a 4."
      },
      {
        "language": "CS",
        "text": "Maximální počet respondentů pro demo účty: prosím, zadejte maximálně 4"
      },
      {
        "language": "EN",
        "text": "Max Respondents for Demo accounts, please add up to 4"
      }
    ]
  },
  {
    "key": "txt_Entertext_408",
    "text": "Enter text (max 400 characters)",
    "translations": [
      {
        "language": "AR",
        "text": "أدخل نصًا (400 حرف كحد أقصى)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Text eingeben (max. 400 Zeichen)"
      },
      {
        "language": "PT",
        "text": "Insira o texto (máximo de 400 caracteres)"
      },
      {
        "language": "IT",
        "text": "Inserisci il testo (max 400 caratteri)"
      },
      {
        "language": "CS",
        "text": "Zadejte text (max. 400 znaků)"
      },
      {
        "language": "EN",
        "text": "Enter text (max 400 characters)"
      }
    ]
  },
  {
    "key": "txtNumberOfStatements",
    "text": "Number of Statements",
    "translations": [
      {
        "language": "AR",
        "text": "عدد العبارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Anzahl der Anweisungen"
      },
      {
        "language": "PT",
        "text": "Número de declarações"
      },
      {
        "language": "IT",
        "text": "Numero di affermazioni"
      },
      {
        "language": "CS",
        "text": "Počet výpisů"
      },
      {
        "language": "EN",
        "text": "Number of Statements"
      }
    ]
  },
  {
    "key": "Email-Templates",
    "text": "Email Templates",
    "translations": [
      {
        "language": "AR",
        "text": "دعوات استكمال التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "E-Mail-Vorlagen"
      },
      {
        "language": "PT",
        "text": "Modelos de e-mail"
      },
      {
        "language": "IT",
        "text": "Template email"
      },
      {
        "language": "CS",
        "text": "Šablony e-mailů"
      },
      {
        "language": "EN",
        "text": "Email Templates"
      }
    ]
  },
  {
    "key": "Timeframe",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Zeitrahmen"
      },
      {
        "language": "PT",
        "text": "Prazo"
      },
      {
        "language": "IT",
        "text": "Intervallo di tempo"
      },
      {
        "language": "CS",
        "text": "Časový rámec"
      },
      {
        "language": "EN",
        "text": "Timeframe"
      }
    ]
  },
  {
    "key": "analytical-criteria",
    "text": "Analytical Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير التحليلية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Analytische Kriterien"
      },
      {
        "language": "PT",
        "text": "Critérios Analíticos"
      },
      {
        "language": "IT",
        "text": "Criteri analitici"
      },
      {
        "language": "CS",
        "text": "Analytická kritéria"
      },
      {
        "language": "EN",
        "text": "Analytical Criteria"
      }
    ]
  },
  {
    "key": "template-selection",
    "text": "Template Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار النموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlagenauswahl"
      },
      {
        "language": "PT",
        "text": "Seleção de modelo"
      },
      {
        "language": "IT",
        "text": "Selezione del template"
      },
      {
        "language": "CS",
        "text": "Výběr šablony"
      },
      {
        "language": "EN",
        "text": "Template Selection"
      }
    ]
  },
  {
    "key": "Select-Template",
    "text": "Select Template",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار النموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlage auswählen"
      },
      {
        "language": "PT",
        "text": "Selecione o modelo"
      },
      {
        "language": "IT",
        "text": "Seleziona il template"
      },
      {
        "language": "CS",
        "text": "Vyberte šablonu"
      },
      {
        "language": "EN",
        "text": "Select Template"
      }
    ]
  },
  {
    "key": "txt_360180feedback",
    "text": "360° / 180° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360/°180"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "360° / 180° Feedback"
      },
      {
        "language": "PT",
        "text": "Feedback de 360° / 180°"
      },
      {
        "language": "IT",
        "text": "Feedback 360°/180°"
      },
      {
        "language": "CS",
        "text": "360 zpětná vazba"
      },
      {
        "language": "EN",
        "text": "360° / 180° Feedback"
      }
    ]
  },
  {
    "key": "assessment180errors",
    "text": "Please Add at least 3 Team evaluators. If peers are included, at least 2 Peer evaluators are required.  ",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون لكل مرشح  3 أعضاء فريق كحد أدنى. إذا تم تضمين الزملاء، يجب أن يكون هناك 2 من الزملاء كحد أدنى."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Bitte fügen Sie mindestens 3 Team-Evaluatoren hinzu. Wenn Peers einbezogen werden, sind mindestens 2 Peer-Evaluatoren erforderlich."
      },
      {
        "language": "PT",
        "text": "Adicione pelo menos 3 avaliadores da equipe. Se os pares forem incluídos, serão necessários pelo menos 2 pares avaliadores."
      },
      {
        "language": "IT",
        "text": "Aggiungi almeno 3 valutatori del team. Se sono inclusi i colleghi, almeno 2 valutatori richiesti."
      },
      {
        "language": "CS",
        "text": "Přidejte prosím alespoň 3 hodnotitele z týmu. Pokud jsou mezi nimi i kolegové, musí být alespoň 2 z nich kolegové."
      },
      {
        "language": "EN",
        "text": "Please Add at least 3 Team evaluators. If peers are included, at least 2 Peer evaluators are required.  "
      }
    ]
  },
  {
    "key": "assessment360errors",
    "text": "Please add at least 1 manager and 2 Peers/Team to this Candidate",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إضافة مدير واحد و2 من الزملاء أو أعضاء الفريق كحد أدنى لهذا المرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bitte fügen Sie diesem Kandidaten 1-2 Manager und mindestens 2 Kollegen/Team hinzu"
      },
      {
        "language": "PT",
        "text": "Adicione pelo menos 1 gerente e 2 colegas/equipe a este candidato"
      },
      {
        "language": "IT",
        "text": "Aggiungi a questo candidato almeno 1 manager e 2 tra i colleghi e il team "
      },
      {
        "language": "CS",
        "text": "Přidejte k tomuto uchazeči alespoň 1 nadřízeného a 2 kolegy z týmu"
      },
      {
        "language": "EN",
        "text": "Please add at least 1 manager and 2 Peers/Team to this Candidate"
      }
    ]
  },
  {
    "key": "txtIncomplete",
    "text": "Incomplete",
    "translations": [
      {
        "language": "AR",
        "text": "غير مكتمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Unvollständig"
      },
      {
        "language": "PT",
        "text": "Incompleto"
      },
      {
        "language": "IT",
        "text": "Incompleto"
      },
      {
        "language": "CS",
        "text": "Neúplné"
      },
      {
        "language": "EN",
        "text": "Incomplete"
      }
    ]
  },
  {
    "key": "txtSearchEvaluators",
    "text": "Search Evaluators ...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث عن المقيِّمين..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Gutachter suchen ..."
      },
      {
        "language": "PT",
        "text": "Avaliadores de pesquisa ..."
      },
      {
        "language": "IT",
        "text": "Cerca i valutatori..."
      },
      {
        "language": "CS",
        "text": "Vyhledat hodnotitele …"
      },
      {
        "language": "EN",
        "text": "Search Evaluators ..."
      }
    ]
  },
  {
    "key": "txtPeer",
    "text": "Peer",
    "translations": [
      {
        "language": "AR",
        "text": "زميل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Peer"
      },
      {
        "language": "PT",
        "text": "Par"
      },
      {
        "language": "IT",
        "text": "Collega"
      },
      {
        "language": "CS",
        "text": "Kolega"
      },
      {
        "language": "EN",
        "text": "Peer"
      }
    ]
  },
  {
    "key": "txtManager",
    "text": "Manager",
    "translations": [
      {
        "language": "AR",
        "text": "مدير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Manager"
      },
      {
        "language": "PT",
        "text": "Gerente"
      },
      {
        "language": "IT",
        "text": "Manager"
      },
      {
        "language": "CS",
        "text": "Manažer"
      },
      {
        "language": "EN",
        "text": "Manager"
      }
    ]
  },
  {
    "key": "txtAddEvaluators",
    "text": "Add Evaluator(s)",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bewerter hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar avaliador(es)"
      },
      {
        "language": "IT",
        "text": "Aggiungi uno o più valutatori"
      },
      {
        "language": "CS",
        "text": "Přidat hodnotitele"
      },
      {
        "language": "EN",
        "text": "Add Evaluator(s)"
      }
    ]
  },
  {
    "key": "txtSomeEvaluatorsFor",
    "text": "No Evaluators added yet for ",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم إضافة أي مُقَيِّم بعد لـ"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Noch keine Gutachter hinzugefügt für"
      },
      {
        "language": "PT",
        "text": "Nenhum avaliador adicionado ainda para"
      },
      {
        "language": "IT",
        "text": "Ancora nessun valutatore aggiunto per"
      },
      {
        "language": "CS",
        "text": "Zatím nebyli přidáni žádní hodnotitelé pro"
      },
      {
        "language": "EN",
        "text": "No Evaluators added yet for "
      }
    ]
  },
  {
    "key": "txt_sts_per_competency",
    "text": "Statements per Competency",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات لكل جدارة ومهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Aussagen pro Kompetenz"
      },
      {
        "language": "PT",
        "text": "Declarações por Competência"
      },
      {
        "language": "IT",
        "text": "Affermazioni per competenza"
      },
      {
        "language": "CS",
        "text": "Popisy jednotlivých kompetencí"
      },
      {
        "language": "EN",
        "text": "Statements per Competency"
      }
    ]
  },
  {
    "key": "txt_cofirm_send",
    "text": "Confirm & Send",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد وإرسال"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bestätigen und senden"
      },
      {
        "language": "PT",
        "text": "Confirmar e enviar"
      },
      {
        "language": "IT",
        "text": "Conferma e invia"
      },
      {
        "language": "CS",
        "text": "Potvrdit a odeslat"
      },
      {
        "language": "EN",
        "text": "Confirm & Send"
      }
    ]
  },
  {
    "key": "txt_units",
    "text": "Units",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Units"
      },
      {
        "language": "PT",
        "text": "Unidades"
      },
      {
        "language": "IT",
        "text": "Unità"
      },
      {
        "language": "CS",
        "text": "Jednotky"
      },
      {
        "language": "EN",
        "text": "Units"
      }
    ]
  },
  {
    "key": "txt_units_deducted",
    "text": "Units to be deducted",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات التي سيتم خصمها"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Abzuziehende Units"
      },
      {
        "language": "PT",
        "text": "Unidades a serem deduzidas"
      },
      {
        "language": "IT",
        "text": "Unità da detrarre"
      },
      {
        "language": "CS",
        "text": "Jednotky, které se odečtou"
      },
      {
        "language": "EN",
        "text": "Units to be deducted"
      }
    ]
  },
  {
    "key": "txt_confirm_180",
    "text": "By clicking [Confirm & Send] you will invite [##] respondents to take this 180° Feedback Assessment:",
    "translations": [
      {
        "language": "AR",
        "text": "بالنقر على [تأكيد وإرسال] ستقوم بدعوة [##] من المستجيبين لأداء تقييم 180°:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Durch Klicken auf [Bestätigen und senden] laden Sie [##] Befragte ein, an dieser 180°-Feedback-Bewertung teilzunehmen:"
      },
      {
        "language": "PT",
        "text": "Ao clicar em [Confirmar e Enviar], você convidará [##] entrevistados a fazer esta avaliação de feedback 180°:"
      },
      {
        "language": "IT",
        "text": "Cliccando [Conferma e invia] inviterai [##] rispondenti a partecipare a questo Assessment 180°:"
      },
      {
        "language": "CS",
        "text": "Kliknutím na [Potvrdit a odeslat] pozvete [##] respondentů\nk vyplnění tohoto hodnocení 180° zpětné vazby:"
      },
      {
        "language": "EN",
        "text": "By clicking [Confirm & Send] you will invite [##] respondents to take this 180° Feedback Assessment:"
      }
    ]
  },
  {
    "key": "txt_confirm_360",
    "text": "By clicking [Confirm & Send] you will invite [##] respondents to take this 360° Feedback Assessment:",
    "translations": [
      {
        "language": "AR",
        "text": "بالنقر على [تأكيد وإرسال] ستقوم بدعوة [##] من المستجيبين لأداء تقييم 360°:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Durch Klicken auf [Bestätigen und senden] laden Sie [##] Befragte ein, an dieser 360°-Feedback-Bewertung teilzunehmen:"
      },
      {
        "language": "PT",
        "text": "Ao clicar em [Confirmar e Enviar], você convidará [##] entrevistados a fazer esta avaliação de feedback 360°:"
      },
      {
        "language": "IT",
        "text": "Cliccando [Conferma e invia] inviterai [##] rispondenti a compilare questo Assessment 360°:"
      },
      {
        "language": "CS",
        "text": "Kliknutím na [Potvrdit a odeslat] pozvete [##] respondentů\nk vyplnění tohoto hodnocení 360° zpětné vazby:"
      },
      {
        "language": "EN",
        "text": "By clicking [Confirm & Send] you will invite [##] respondents to take this 360° Feedback Assessment:"
      }
    ]
  },
  {
    "key": "txtSelectAll",
    "text": "Select All",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الكل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Alles auswählen"
      },
      {
        "language": "PT",
        "text": "Selecionar tudo"
      },
      {
        "language": "IT",
        "text": "Seleziona tutti"
      },
      {
        "language": "CS",
        "text": "Vybrat vše"
      },
      {
        "language": "EN",
        "text": "Select All"
      }
    ]
  },
  {
    "key": "txt_show_values",
    "text": "Show Values",
    "translations": [
      {
        "language": "AR",
        "text": "عرض القيم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Werte anzeigen"
      },
      {
        "language": "PT",
        "text": "Mostrar valores"
      },
      {
        "language": "IT",
        "text": "Mostra i valori"
      },
      {
        "language": "CS",
        "text": "Zobrazit hodnoty"
      },
      {
        "language": "EN",
        "text": "Show Values"
      }
    ]
  },
  {
    "key": "txtSearchCandidate",
    "text": "Search Candidates...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث عن المرشحين..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidaten suchen ..."
      },
      {
        "language": "PT",
        "text": "Pesquisar candidatos..."
      },
      {
        "language": "IT",
        "text": "Cerca i candidati..."
      },
      {
        "language": "CS",
        "text": "Vyhledat uchazeče…"
      },
      {
        "language": "EN",
        "text": "Search Candidates..."
      }
    ]
  },
  {
    "key": "txt_continueto-lib",
    "text": "Continue to Template Library",
    "translations": [
      {
        "language": "AR",
        "text": "الاستمرار إلى مكتبة النماذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Weiter zur Vorlagenbibliothek"
      },
      {
        "language": "PT",
        "text": "Continuar para a biblioteca de modelos"
      },
      {
        "language": "IT",
        "text": "Vai alla library dei template"
      },
      {
        "language": "CS",
        "text": "Pokračovat do knihovny šablon"
      },
      {
        "language": "EN",
        "text": "Continue to Template Library"
      }
    ]
  },
  {
    "key": "txtEmptyEvaluators",
    "text": "You need to select Candidates before adding Evaluator(s)",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تحديد المرشح لإضافة المقيّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sie müssen Kandidaten auswählen, bevor Sie Gutachter hinzufügen können."
      },
      {
        "language": "PT",
        "text": "Você precisa selecionar Candidatos antes de adicionar Avaliador(es)"
      },
      {
        "language": "IT",
        "text": "Devi selezionare i candidati prima di aggiungere uno o più valutatori"
      },
      {
        "language": "CS",
        "text": "před přidáním hodnotitele (hodnotitelů)"
      },
      {
        "language": "EN",
        "text": "You need to select Candidates before adding Evaluator(s)"
      }
    ]
  },
  {
    "key": "txtAddCandidate(s)",
    "text": "Add Candidate(s)",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مرشح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kandidaten hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar candidato(s)"
      },
      {
        "language": "IT",
        "text": "Aggiungi uno o più candidati"
      },
      {
        "language": "CS",
        "text": "Přidat uchazeče"
      },
      {
        "language": "EN",
        "text": "Add Candidate(s)"
      }
    ]
  },
  {
    "key": "txtEmptyCandidates",
    "text": "Candidates will appear here once you add them!",
    "translations": [
      {
        "language": "AR",
        "text": "سيظهر المرشحون هنا بمجرد إضافتهم!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sobald Sie Kandidaten hinzugefügt haben, werden sie hier angezeigt!"
      },
      {
        "language": "PT",
        "text": "Os candidatos aparecerão aqui assim que você adicioná-los!"
      },
      {
        "language": "IT",
        "text": "I candidati appariranno qui una volta aggiunti!"
      },
      {
        "language": "CS",
        "text": "Jakmile kandidáty přidáte, zobrazí se zde!"
      },
      {
        "language": "EN",
        "text": "Candidates will appear here once you add them!"
      }
    ]
  },
  {
    "key": "txtUnitsUsage",
    "text": "Units Usage",
    "translations": [
      {
        "language": "AR",
        "text": "استخدام الوحدات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Unit Verbrauch"
      },
      {
        "language": "PT",
        "text": "Uso de unidades"
      },
      {
        "language": "IT",
        "text": "Utilizzo delle unità"
      },
      {
        "language": "CS",
        "text": "Použití jednotek"
      },
      {
        "language": "EN",
        "text": "Units Usage"
      }
    ]
  },
  {
    "key": "txtAddRespondents",
    "text": "Add Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Befragte hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar entrevistados"
      },
      {
        "language": "IT",
        "text": "Aggiungi i rispondenti"
      },
      {
        "language": "CS",
        "text": "Přidat respondenty"
      },
      {
        "language": "EN",
        "text": "Add Respondents"
      }
    ]
  },
  {
    "key": "txtImportRespondents",
    "text": "Import Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "رفع المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Befragte importieren"
      },
      {
        "language": "PT",
        "text": "Importar respondentes"
      },
      {
        "language": "IT",
        "text": "Importa i rispondenti"
      },
      {
        "language": "CS",
        "text": "Načíst respondenty"
      },
      {
        "language": "EN",
        "text": "Import Respondents"
      }
    ]
  },
  {
    "key": "txt_delete_assessment",
    "text": "Are you sure you want to delete this Assessment?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا التقييم؟"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Möchten Sie diese Bewertung wirklich löschen?"
      },
      {
        "language": "PT",
        "text": "Tem certeza de que deseja excluir esta avaliação?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questo Assessment?"
      },
      {
        "language": "CS",
        "text": "Opravdu chcete toto hodnocení smazat?"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this Assessment?"
      }
    ]
  },
  {
    "key": "txt_gotit",
    "text": "Got it",
    "translations": [
      {
        "language": "AR",
        "text": "تم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Verstanden"
      },
      {
        "language": "PT",
        "text": "Entendi"
      },
      {
        "language": "IT",
        "text": "Capito"
      },
      {
        "language": "CS",
        "text": "Jasně"
      },
      {
        "language": "EN",
        "text": "Got it"
      }
    ]
  },
  {
    "key": "txt_cancel_saved",
    "text": "Your changes has been saved as a draft",
    "translations": [
      {
        "language": "AR",
        "text": "تم حفظ تغييراتك كمسودة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ihre Änderungen wurden als Entwurf gespeichert"
      },
      {
        "language": "PT",
        "text": "Suas alterações foram salvas como rascunho"
      },
      {
        "language": "IT",
        "text": "Le tue modifiche sono state salvate come bozza"
      },
      {
        "language": "CS",
        "text": "Vaše změny byly uloženy jako koncept"
      },
      {
        "language": "EN",
        "text": "Your changes has been saved as a draft"
      }
    ]
  },
  {
    "key": "txtExportTemplate",
    "text": "Export Template",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل النموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlage exportieren"
      },
      {
        "language": "PT",
        "text": "Exportar modelo"
      },
      {
        "language": "IT",
        "text": "Esporta il template"
      },
      {
        "language": "CS",
        "text": "Šablona pro export"
      },
      {
        "language": "EN",
        "text": "Export Template"
      }
    ]
  },
  {
    "key": "txtSelectCompetenciesStatementsPreview",
    "text": "Preview the Competencies and Statements by selecting a Template from the list on the left",
    "translations": [
      {
        "language": "AR",
        "text": "قم بمعاينة الجدارات والمهارات والعبارات عن طريق اختيار النموذج من القائمة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sehen Sie sich die Kompetenzen und Aussagen in der Vorschau an, indem Sie eine Vorlage aus der Liste links auswählen"
      },
      {
        "language": "PT",
        "text": "Visualize as Competências e Declarações selecionando um Modelo na lista à esquerda"
      },
      {
        "language": "IT",
        "text": "Visualizza in anteprima le competenze e le affermazioni selezionando un template dall'elenco a sinistra"
      },
      {
        "language": "CS",
        "text": "Prohlédněte si kompetence a popisy výběrem šablony ze seznamu vlevo"
      },
      {
        "language": "EN",
        "text": "Preview the Competencies and Statements by selecting a Template from the list on the left"
      }
    ]
  },
  {
    "key": "txtTemplatePreview",
    "text": "Template Preview",
    "translations": [
      {
        "language": "AR",
        "text": "معاينة النموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlagenvorschau"
      },
      {
        "language": "PT",
        "text": "Visualização do modelo"
      },
      {
        "language": "IT",
        "text": "Anteprima del template"
      },
      {
        "language": "CS",
        "text": "Náhled šablony"
      },
      {
        "language": "EN",
        "text": "Template Preview"
      }
    ]
  },
  {
    "key": "txtTypeToSearch",
    "text": "Type to search...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب للبحث..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Suchen Sie hier..."
      },
      {
        "language": "PT",
        "text": "Digite para pesquisar..."
      },
      {
        "language": "IT",
        "text": "Digita per cercare..."
      },
      {
        "language": "CS",
        "text": "Zadejte text pro vyhledávání…"
      },
      {
        "language": "EN",
        "text": "Type to search..."
      }
    ]
  },
  {
    "key": "txtTemplateChoicePage",
    "text": "Streamline assessments with our predefined templates or create your own for saving time and enhancing results.",
    "translations": [
      {
        "language": "AR",
        "text": "لتوفير الوقت وتعزيز النتائج، قم بتبسيط عمليات التقييم باستخدام النماذج المُعرفة مسبقاً  أو قم بتخصيص نماذجك الخاصة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Optimieren Sie Bewertungen mit unseren vordefinierten Vorlagen oder erstellen Sie Ihre eigenen, um Zeit zu sparen und Ergebnisse zu verbessern."
      },
      {
        "language": "PT",
        "text": "Simplifique as avaliações com nossos modelos predefinidos ou crie os seus próprios para economizar tempo e melhorar os resultados."
      },
      {
        "language": "IT",
        "text": "Semplifica gli Assessment utilizzando i nostri template predefiniti oppure crea un modello personalizzato per risparmiare tempo e ottenere risultati più efficaci."
      },
      {
        "language": "CS",
        "text": "Zefektivněte hodnocení pomocí našich předdefinovaných šablon nebo si vytvořte vlastní, abyste ušetřili čas a dosáhli lepších výsledků."
      },
      {
        "language": "EN",
        "text": "Streamline assessments with our predefined templates or create your own for saving time and enhancing results."
      }
    ]
  },
  {
    "key": "txtChooseTemplate",
    "text": "Choose a Template",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار نموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Wählen Sie eine Vorlage aus"
      },
      {
        "language": "PT",
        "text": "Escolha um modelo"
      },
      {
        "language": "IT",
        "text": "Scegli un template"
      },
      {
        "language": "CS",
        "text": "Vyberte šablonu"
      },
      {
        "language": "EN",
        "text": "Choose a Template"
      }
    ]
  },
  {
    "key": "txt_evaluators_email",
    "text": "Evaluators Email Templates",
    "translations": [
      {
        "language": "AR",
        "text": "نماذج البريد الإلكتروني للمقيِّمين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "E-Mail-Vorlagen für Evaluatoren"
      },
      {
        "language": "PT",
        "text": "Modelos de e-mail para avaliadores"
      },
      {
        "language": "IT",
        "text": "Template email dei valutatori"
      },
      {
        "language": "CS",
        "text": "Šablony e-mailů pro hodnotitele"
      },
      {
        "language": "EN",
        "text": "Evaluators Email Templates"
      }
    ]
  },
  {
    "key": "txtPublish",
    "text": "Publish",
    "translations": [
      {
        "language": "AR",
        "text": "نشر التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Veröffentlichen"
      },
      {
        "language": "PT",
        "text": "Publicar"
      },
      {
        "language": "IT",
        "text": "Pubblica"
      },
      {
        "language": "CS",
        "text": "Zveřejnit"
      },
      {
        "language": "EN",
        "text": "Publish"
      }
    ]
  },
  {
    "key": "txt_candidate_email",
    "text": "Candidate Email Templates",
    "translations": [
      {
        "language": "AR",
        "text": "نماذج البريد الإلكتروني للمرشحين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "E-Mail-Vorlagen für Kandidaten"
      },
      {
        "language": "PT",
        "text": "Modelos de e-mail de candidato"
      },
      {
        "language": "IT",
        "text": "Template email per i candidati"
      },
      {
        "language": "CS",
        "text": "Šablony e-mailů pro uchazeče"
      },
      {
        "language": "EN",
        "text": "Candidate Email Templates"
      }
    ]
  },
  {
    "key": "txtMoreThan7Notallowed",
    "text": "More than 7 (Not allowed)",
    "translations": [
      {
        "language": "AR",
        "text": "أكثر من 7 (غير مسموح)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Mehr als 7 (Nicht erlaubt)"
      },
      {
        "language": "PT",
        "text": "Mais de 7 (Não permitido)"
      },
      {
        "language": "IT",
        "text": "Più di 7 (Non consentito)"
      },
      {
        "language": "CS",
        "text": "Více než 7 (Není povoleno)"
      },
      {
        "language": "EN",
        "text": "More than 7 (Not allowed)"
      }
    ]
  },
  {
    "key": "txt6to7NotRecommended",
    "text": "6 to 7 (Not Recommended)",
    "translations": [
      {
        "language": "AR",
        "text": "6 إلى 7 (غير موصى به)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "6 bis 7 (nicht empfohlen)"
      },
      {
        "language": "PT",
        "text": "6 a 7 (não recomendado)"
      },
      {
        "language": "IT",
        "text": "Da 6 a 7 (Non consigliato)"
      },
      {
        "language": "CS",
        "text": "6 až 7 (nedoporučuje se)"
      },
      {
        "language": "EN",
        "text": "6 to 7 (Not Recommended)"
      }
    ]
  },
  {
    "key": "txt5Recommended",
    "text": "5 (Recommended)",
    "translations": [
      {
        "language": "AR",
        "text": "5 (موصى به)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "(empfohlen)"
      },
      {
        "language": "PT",
        "text": "5 (recomendado)"
      },
      {
        "language": "IT",
        "text": "5 (Consigliato)"
      },
      {
        "language": "CS",
        "text": "5 (doporučeno)"
      },
      {
        "language": "EN",
        "text": "5 (Recommended)"
      }
    ]
  },
  {
    "key": "txt3-4NotRecommended",
    "text": "3 to 4 (Not Recommended)",
    "translations": [
      {
        "language": "AR",
        "text": "3 إلى 4 (غير موصى به)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "3 bis 4 (nicht empfohlen)"
      },
      {
        "language": "PT",
        "text": "3 a 4 (não recomendado)"
      },
      {
        "language": "IT",
        "text": "Da 3 a 4 (Non consigliato)"
      },
      {
        "language": "CS",
        "text": "3 až 4 (nedoporučuje se)"
      },
      {
        "language": "EN",
        "text": "3 to 4 (Not Recommended)"
      }
    ]
  },
  {
    "key": "txtLessThan3",
    "text": "Less than 3 (Not allowed)",
    "translations": [
      {
        "language": "AR",
        "text": "أقل من 3 (غير مسموح)"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Weniger als 3 (Nicht erlaubt)"
      },
      {
        "language": "PT",
        "text": "Menos de 3 (não permitido)"
      },
      {
        "language": "IT",
        "text": "Meno di 3 (Non consentito)"
      },
      {
        "language": "CS",
        "text": "Méně než 3 (není povoleno)"
      },
      {
        "language": "EN",
        "text": "Less than 3 (Not allowed)"
      }
    ]
  },
  {
    "key": "txtStatementsPerCompetency",
    "text": "Number of Statements per competency",
    "translations": [
      {
        "language": "AR",
        "text": "عدد العبارات لكل جدارة ومهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Anzahl der Aussagen pro Kompetenz"
      },
      {
        "language": "PT",
        "text": "Número de Declarações por competência"
      },
      {
        "language": "IT",
        "text": "Numero di affermazioni per competenza"
      },
      {
        "language": "CS",
        "text": "Počet výroků na kompetenci"
      },
      {
        "language": "EN",
        "text": "Number of Statements per competency"
      }
    ]
  },
  {
    "key": "txt_customize_emails",
    "text": "Customize Email Templates",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص نماذج البريد الإلكتروني"
      },
      {
        "language": "DE",
        "text": "E-Mail-Vorlagen anpassen"
      },
      {
        "language": "PT",
        "text": "Personalize modelos de e-mail"
      },
      {
        "language": "IT",
        "text": "Personalizza il template email"
      },
      {
        "language": "CS",
        "text": "Přizpůsobení šablon e-mailů"
      },
      {
        "language": "EN",
        "text": "Customize Email Templates"
      }
    ]
  },
  {
    "key": "txtNoStatementsForCompetency",
    "text": "No Statements selected yet for this competency",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم اختيار أي عبارات لهذه الجدارة والمهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Für diese Kompetenz wurden noch keine Vorgaben ausgewählt"
      },
      {
        "language": "PT",
        "text": "Nenhuma declaração selecionada ainda para esta competência"
      },
      {
        "language": "IT",
        "text": "Ancora nessuna affermazione selezionata per questa competenza"
      },
      {
        "language": "CS",
        "text": "Pro tuto kompetenci zatím nebyly vybrány žádné výroky"
      },
      {
        "language": "EN",
        "text": "No Statements selected yet for this competency"
      }
    ]
  },
  {
    "key": "txtCreateStatement",
    "text": "Create Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorgaben erstellen"
      },
      {
        "language": "PT",
        "text": "Criar declaração"
      },
      {
        "language": "IT",
        "text": "Crea un'affermazione"
      },
      {
        "language": "CS",
        "text": "Vytvořit příkaz"
      },
      {
        "language": "EN",
        "text": "Create Statement"
      }
    ]
  },
  {
    "key": "txtUpdateStatement",
    "text": "Update Statement",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث العبارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Update"
      },
      {
        "language": "PT",
        "text": "Declaração de atualização"
      },
      {
        "language": "IT",
        "text": "Aggiorna un'affermazione"
      },
      {
        "language": "CS",
        "text": "Prohlášení o aktualizaci"
      },
      {
        "language": "EN",
        "text": "Update Statement"
      }
    ]
  },
  {
    "key": "txt_select_assessment_date",
    "text": "Select your assessment start and completion dates to keep track of progress and stay on schedule",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد تواريخ البدء والإكمال للتقييم"
      },
      {
        "language": "DE",
        "text": "Wählen Sie Start- und Abschlussdaten für Ihr Assessment aus, um den Fortschritt zu verfolgen und im Zeitplan zu bleiben"
      },
      {
        "language": "PT",
        "text": "Selecione as datas de início e conclusão da avaliação para acompanhar o progresso e cumprir o cronograma"
      },
      {
        "language": "IT",
        "text": "Seleziona la data di inizio e di completamento dell'Assessment per tenere traccia dell’avanzamento e garantire il rispetto delle tempistiche"
      },
      {
        "language": "CS",
        "text": "Zadejte datum zahájení a ukončení hodnocení, abyste mohli sledovat průběh a dodržet časový plán"
      },
      {
        "language": "EN",
        "text": "Select your assessment start and completion dates to keep track of progress and stay on schedule"
      }
    ]
  },
  {
    "key": "txt_start_completion_date",
    "text": "Start & Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء والإكمال"
      },
      {
        "language": "DE",
        "text": "Start- und Fertigstellungsdatum"
      },
      {
        "language": "PT",
        "text": "Data de início e conclusão"
      },
      {
        "language": "IT",
        "text": "Data di inizio e di completamento"
      },
      {
        "language": "CS",
        "text": "Datum zahájení a ukončení"
      },
      {
        "language": "EN",
        "text": "Start & Completion Date"
      }
    ]
  },
  {
    "key": "txt_statements_selected",
    "text": "Statements Selected",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات المختارة"
      },
      {
        "language": "DE",
        "text": "Ausgewählte Aussagen"
      },
      {
        "language": "PT",
        "text": "Declarações Selecionadas"
      },
      {
        "language": "IT",
        "text": "Affermazioni selezionate"
      },
      {
        "language": "CS",
        "text": "Vybraná prohlášení"
      },
      {
        "language": "EN",
        "text": "Statements Selected"
      }
    ]
  },
  {
    "key": "txt_competencies_selected",
    "text": "Competencies Selected",
    "translations": [
      {
        "language": "AR",
        "text": "الجدارات والمهارات المختارة"
      },
      {
        "language": "DE",
        "text": "Ausgewählte Kompetenzen"
      },
      {
        "language": "PT",
        "text": "Competências selecionadas"
      },
      {
        "language": "IT",
        "text": "Competenze selezionate"
      },
      {
        "language": "CS",
        "text": "Vybrané kompetence"
      },
      {
        "language": "EN",
        "text": "Competencies Selected"
      }
    ]
  },
  {
    "key": "txt_review_template",
    "text": "Review Template",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة النموذج"
      },
      {
        "language": "DE",
        "text": "Vorlage überprüfen"
      },
      {
        "language": "PT",
        "text": "Modelo de revisão"
      },
      {
        "language": "IT",
        "text": "Rivedi il template"
      },
      {
        "language": "CS",
        "text": "Šablona recenze"
      },
      {
        "language": "EN",
        "text": "Review Template"
      }
    ]
  },
  {
    "key": "txt_timeframe_remiders",
    "text": "Set Timeframe & Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد المدة الزمنية والتذكيرات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Zeitrahmen und Erinnerungen festlegen"
      },
      {
        "language": "PT",
        "text": "Definir prazo e lembretes"
      },
      {
        "language": "IT",
        "text": "Imposta l'intervallo di tempo e il promemoria"
      },
      {
        "language": "CS",
        "text": "Nastavit časový rámec a připomenutí"
      },
      {
        "language": "EN",
        "text": "Set Timeframe & Reminders"
      }
    ]
  },
  {
    "key": "txtNewStatement",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Neue Vorgabe"
      },
      {
        "language": "PT",
        "text": "Nova Declaração"
      },
      {
        "language": "IT",
        "text": "Nuova affermazione"
      },
      {
        "language": "CS",
        "text": "Nové prohlášení"
      },
      {
        "language": "EN",
        "text": "New Statement"
      }
    ]
  },
  {
    "key": "txt_360180TemplateLibrary",
    "text": "360/180 Template Library",
    "translations": [
      {
        "language": "AR",
        "text": "مكتبة نماذج °360/°180"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "360/180-Vorlagenbibliothek"
      },
      {
        "language": "PT",
        "text": "Biblioteca de modelos 360/180"
      },
      {
        "language": "IT",
        "text": "Library dei template 360°/180°"
      },
      {
        "language": "CS",
        "text": "Knihovna šablon"
      },
      {
        "language": "EN",
        "text": "360/180 Template Library"
      }
    ]
  },
  {
    "key": "txt_template_success",
    "text": "Template Created Successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاء النموذج بنجاح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlage erfolgreich erstellt"
      },
      {
        "language": "PT",
        "text": "Modelo criado com sucesso"
      },
      {
        "language": "IT",
        "text": "Template creato con successo"
      },
      {
        "language": "CS",
        "text": "Šablona byla úspěšně vytvořena"
      },
      {
        "language": "EN",
        "text": "Template Created Successfully"
      }
    ]
  },
  {
    "key": "txtUpdateCompetency",
    "text": "Update Competency",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث الجدارة والمهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kompetenz aktualisieren"
      },
      {
        "language": "PT",
        "text": "Atualizar competência"
      },
      {
        "language": "IT",
        "text": "Aggiorna una competenza"
      },
      {
        "language": "CS",
        "text": "Aktualizace kompetencí"
      },
      {
        "language": "EN",
        "text": "Update Competency"
      }
    ]
  },
  {
    "key": "txt_save_draft",
    "text": "Save As Draft",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ كمسودة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Als Entwurf speichern"
      },
      {
        "language": "PT",
        "text": "Salvar como rascunho"
      },
      {
        "language": "IT",
        "text": "Salva come bozza"
      },
      {
        "language": "CS",
        "text": "Uložit jako koncept"
      },
      {
        "language": "EN",
        "text": "Save As Draft"
      }
    ]
  },
  {
    "key": "txt_cancelMsg2",
    "text": "Select how do you want to proceed:",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد كيف تريد المتابعة:"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Wählen Sie aus, wie Sie fortfahren möchten:"
      },
      {
        "language": "PT",
        "text": "Selecione como deseja prosseguir:"
      },
      {
        "language": "IT",
        "text": "Seleziona come vuoi procedere:"
      },
      {
        "language": "CS",
        "text": "Vyberte, jak chcete pokračovat:"
      },
      {
        "language": "EN",
        "text": "Select how do you want to proceed:"
      }
    ]
  },
  {
    "key": "txt_cancelMsg1",
    "text": "You’ve made changes to this setup!",
    "translations": [
      {
        "language": "AR",
        "text": "لقد قمت بإجراء تغييرات على هذا الإعداد!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sie haben Änderungen an diesem Setup vorgenommen!"
      },
      {
        "language": "PT",
        "text": "Você fez alterações nesta configuração!"
      },
      {
        "language": "IT",
        "text": "Hai modificato questa configurazione!"
      },
      {
        "language": "CS",
        "text": "Provedli jste změny v tomto nastavení!"
      },
      {
        "language": "EN",
        "text": "You’ve made changes to this setup!"
      }
    ]
  },
  {
    "key": "txtCreateCompetency",
    "text": "Create Competency",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء جدارة ومهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kompetenz hinzufügen"
      },
      {
        "language": "PT",
        "text": "Criar Competência"
      },
      {
        "language": "IT",
        "text": "Crea una competenza"
      },
      {
        "language": "CS",
        "text": "Vytvořit kompetenci"
      },
      {
        "language": "EN",
        "text": "Create Competency"
      }
    ]
  },
  {
    "key": "txtSelectCategory",
    "text": "Select Category",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الفئة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kategorie auswählen"
      },
      {
        "language": "PT",
        "text": "Selecione a categoria"
      },
      {
        "language": "IT",
        "text": "Seleziona una categoria"
      },
      {
        "language": "CS",
        "text": "Vyberte kategorii"
      },
      {
        "language": "EN",
        "text": "Select Category"
      }
    ]
  },
  {
    "key": "txtResetWeights",
    "text": "Reset Weights",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تعيين الأوزان"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Gewichtung zurücksetzen"
      },
      {
        "language": "PT",
        "text": "Redefinir pesos"
      },
      {
        "language": "IT",
        "text": "Ripristina i pesi"
      },
      {
        "language": "CS",
        "text": "Reset"
      },
      {
        "language": "EN",
        "text": "Reset Weights"
      }
    ]
  },
  {
    "key": "txt_competency_valid_req",
    "text": "It’s recommended to select 5 to 15 competencies",
    "translations": [
      {
        "language": "AR",
        "text": "يوصي باختيار 5 إلى 15 مهارة وجدارة "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Es wird empfohlen, 5 bis 15 Kompetenzen auszuwählen"
      },
      {
        "language": "PT",
        "text": "Recomenda-se selecionar de 5 a 15 competências"
      },
      {
        "language": "IT",
        "text": "Si consiglia di selezionare da 5 a 15 competenze"
      },
      {
        "language": "CS",
        "text": "Doporučuje se vybrat 5 až 15 kompetencí"
      },
      {
        "language": "EN",
        "text": "It’s recommended to select 5 to 15 competencies"
      }
    ]
  },
  {
    "key": "txt_no_competencies",
    "text": "No competencies selected yet",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم تحديد أي جدارة ومهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Noch keine Kompetenzen ausgewählt"
      },
      {
        "language": "PT",
        "text": "Nenhuma competência selecionada ainda"
      },
      {
        "language": "IT",
        "text": "Ancora nessuna competenza selezionata"
      },
      {
        "language": "CS",
        "text": "Zatím nebyly vybrány žádné kompetence"
      },
      {
        "language": "EN",
        "text": "No competencies selected yet"
      }
    ]
  },
  {
    "key": "txt_180_template",
    "text": "180° Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °180"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "180°-Beurteilung"
      },
      {
        "language": "PT",
        "text": "Avaliação 180°"
      },
      {
        "language": "IT",
        "text": "Assessment 180°"
      },
      {
        "language": "CS",
        "text": "180° Hodnocení"
      },
      {
        "language": "EN",
        "text": "180° Assessment"
      }
    ]
  },
  {
    "key": "txt_360_template",
    "text": "360° Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج °360"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "360° Vorlage"
      },
      {
        "language": "PT",
        "text": "Modelo 360°"
      },
      {
        "language": "IT",
        "text": "Template 360°"
      },
      {
        "language": "CS",
        "text": "360° Předloha"
      },
      {
        "language": "EN",
        "text": "360° Template"
      }
    ]
  },
  {
    "key": "txtNewTemplate",
    "text": "New Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج جديد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Neue Vorlage"
      },
      {
        "language": "PT",
        "text": "Novo modelo"
      },
      {
        "language": "IT",
        "text": "Nuovo template"
      },
      {
        "language": "CS",
        "text": "Nová šablona"
      },
      {
        "language": "EN",
        "text": "New Template"
      }
    ]
  },
  {
    "key": "txt_template_type",
    "text": "Template Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع النموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlagentyp"
      },
      {
        "language": "PT",
        "text": "Tipo de modelo"
      },
      {
        "language": "IT",
        "text": "Tipo di template"
      },
      {
        "language": "CS",
        "text": "Typ šablony"
      },
      {
        "language": "EN",
        "text": "Template Type"
      }
    ]
  },
  {
    "key": "txt_drafts",
    "text": "Drafts",
    "translations": [
      {
        "language": "AR",
        "text": "المسودات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Entwürfe"
      },
      {
        "language": "PT",
        "text": "Rascunhos"
      },
      {
        "language": "IT",
        "text": "Bozze"
      },
      {
        "language": "CS",
        "text": "Návrhy"
      },
      {
        "language": "EN",
        "text": "Drafts"
      }
    ]
  },
  {
    "key": "txt_publihshed",
    "text": "Published",
    "translations": [
      {
        "language": "AR",
        "text": "تم النشر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Veröffentlicht"
      },
      {
        "language": "PT",
        "text": "Publicado"
      },
      {
        "language": "IT",
        "text": "Pubblicato"
      },
      {
        "language": "CS",
        "text": "Zveřejněno"
      },
      {
        "language": "EN",
        "text": "Published"
      }
    ]
  },
  {
    "key": "txt_all",
    "text": "All",
    "translations": [
      {
        "language": "AR",
        "text": "الكل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Alle"
      },
      {
        "language": "PT",
        "text": "Todos"
      },
      {
        "language": "IT",
        "text": "Tutti"
      },
      {
        "language": "CS",
        "text": "Vše"
      },
      {
        "language": "EN",
        "text": "All"
      }
    ]
  },
  {
    "key": "txt_clone",
    "text": "Clone",
    "translations": [
      {
        "language": "AR",
        "text": "استنساخ"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kopieren"
      },
      {
        "language": "PT",
        "text": "Clone"
      },
      {
        "language": "IT",
        "text": "Clona"
      },
      {
        "language": "CS",
        "text": "Zkopírovat"
      },
      {
        "language": "EN",
        "text": "Clone"
      }
    ]
  },
  {
    "key": "txtNewCompetency",
    "text": "New Competency",
    "translations": [
      {
        "language": "AR",
        "text": "جدارة ومهارة جديدة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Neue Kompetenz"
      },
      {
        "language": "PT",
        "text": "Nova Competência"
      },
      {
        "language": "IT",
        "text": "Nuova competenza"
      },
      {
        "language": "CS",
        "text": "Nová kompetence"
      },
      {
        "language": "EN",
        "text": "New Competency"
      }
    ]
  },
  {
    "key": "txtReviewPublish",
    "text": "Review & Publish",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة ونشر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Überprüfen und veröffentlichen"
      },
      {
        "language": "PT",
        "text": "Revise e publique"
      },
      {
        "language": "IT",
        "text": "Rivedi e pubblica"
      },
      {
        "language": "CS",
        "text": "Zkontrolovat a publikovat"
      },
      {
        "language": "EN",
        "text": "Review & Publish"
      }
    ]
  },
  {
    "key": "txtSelectStatements",
    "text": "Select Statements",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار العبارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorgaben auswählen"
      },
      {
        "language": "PT",
        "text": "Selecione declarações"
      },
      {
        "language": "IT",
        "text": "Seleziona le affermazioni"
      },
      {
        "language": "CS",
        "text": "Příkazy SELECT"
      },
      {
        "language": "EN",
        "text": "Select Statements"
      }
    ]
  },
  {
    "key": "txtSelectCompetencies",
    "text": "Select Competencies",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الجدارة والمهارة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kompetenzen auswählen"
      },
      {
        "language": "PT",
        "text": "Selecione Competências"
      },
      {
        "language": "IT",
        "text": "Seleziona le competenze"
      },
      {
        "language": "CS",
        "text": "Vyberte kompetence"
      },
      {
        "language": "EN",
        "text": "Select Competencies"
      }
    ]
  },
  {
    "key": "COMPLETED",
    "text": "Published",
    "translations": [
      {
        "language": "AR",
        "text": "تم النشر"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Veröffentlicht"
      },
      {
        "language": "PT",
        "text": "Publicado"
      },
      {
        "language": "IT",
        "text": "Completato"
      },
      {
        "language": "CS",
        "text": "Zveřejněno"
      },
      {
        "language": "EN",
        "text": "Published"
      }
    ]
  },
  {
    "key": "txt_template_library",
    "text": "Template Library",
    "translations": [
      {
        "language": "AR",
        "text": "مكتبة النماذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlagenbibliothek"
      },
      {
        "language": "PT",
        "text": "Biblioteca de modelos"
      },
      {
        "language": "IT",
        "text": "Library dei template"
      },
      {
        "language": "CS",
        "text": "Knihovna šablon"
      },
      {
        "language": "EN",
        "text": "Template Library"
      }
    ]
  },
  {
    "key": "txt_new_template",
    "text": "New Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج جديد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Neue Vorlage"
      },
      {
        "language": "PT",
        "text": "Novo modelo"
      },
      {
        "language": "IT",
        "text": "Nuovo template"
      },
      {
        "language": "CS",
        "text": "Nová šablona"
      },
      {
        "language": "EN",
        "text": "New Template"
      }
    ]
  },
  {
    "key": "txt_manage_templates",
    "text": "Manage Templates",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة النماذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Vorlagen verwalten"
      },
      {
        "language": "PT",
        "text": "Gerenciar modelos"
      },
      {
        "language": "IT",
        "text": "Gestisci il template"
      },
      {
        "language": "CS",
        "text": "Správa šablon"
      },
      {
        "language": "EN",
        "text": "Manage Templates"
      }
    ]
  },
  {
    "key": "assessment360",
    "text": "360° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "360° Feedback"
      },
      {
        "language": "PT",
        "text": "Feedback 360°"
      },
      {
        "language": "IT",
        "text": "Feedback 360°"
      },
      {
        "language": "CS",
        "text": "360 Zpětná vazba"
      },
      {
        "language": "EN",
        "text": "360° Feedback"
      }
    ]
  },
  {
    "key": "assessment180",
    "text": "180° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °180"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "180° Feedback"
      },
      {
        "language": "PT",
        "text": "Feedback de 180°"
      },
      {
        "language": "IT",
        "text": "Feedback 180°"
      },
      {
        "language": "CS",
        "text": "180° Zpětná vazba"
      },
      {
        "language": "EN",
        "text": "180° Feedback"
      }
    ]
  },
  {
    "key": "txtNewAssessment",
    "text": "New Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم جديد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Neues Assessment"
      },
      {
        "language": "PT",
        "text": "Nova avaliação"
      },
      {
        "language": "IT",
        "text": "Nuovo Assessment"
      },
      {
        "language": "CS",
        "text": "Nové hodnocení"
      },
      {
        "language": "EN",
        "text": "New Assessment"
      }
    ]
  },
  {
    "key": "txt_180_assessment_desc",
    "text": "Measures a manager's performance against behavioral competencies as rated by their team members.",
    "translations": [
      {
        "language": "AR",
        "text": "أداة قياس التي يقيّم بها أعضاء الفريق أداء المدير مقابل جداراته ومهاراته السلوكية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Misst die Leistung eines Managers anhand der Verhaltenskompetenzen, die von seinen Teammitgliedern bewertet werden."
      },
      {
        "language": "PT",
        "text": "Mede o desempenho de um gerente em relação às competências comportamentais avaliadas pelos membros de sua equipe."
      },
      {
        "language": "IT",
        "text": "Valuta la performance di un manager rispetto alle competenze comportamentali, valutate dai membri del suo team."
      },
      {
        "language": "CS",
        "text": "Měří výkon manažera na základě behaviorálních kompetencí, jak je hodnotí členové jeho týmu."
      },
      {
        "language": "EN",
        "text": "Measures a manager's performance against behavioral competencies as rated by their team members."
      }
    ]
  },
  {
    "key": "txt_180_assessment",
    "text": "180° Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °180"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "180°-Beurteilung"
      },
      {
        "language": "PT",
        "text": "Avaliação 180°"
      },
      {
        "language": "IT",
        "text": "Assessment 180°"
      },
      {
        "language": "CS",
        "text": "180° Hodnocení"
      },
      {
        "language": "EN",
        "text": "180° Assessment"
      }
    ]
  },
  {
    "key": "txt_360_assessment_desc",
    "text": "Assesses an individual's performance against behavioral competencies through ratings provided by others.",
    "translations": [
      {
        "language": "AR",
        "text": "أداة قياس التي يقيّم بها الآخرون أداء الفرد مقابل جداراته ومهاراته السلوكية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bewertet die Leistung einer Person hinsichtlich ihrer Verhaltenskompetenzen mittels Fremdbeurteilung."
      },
      {
        "language": "PT",
        "text": "Avalia o desempenho de um indivíduo em relação às competências comportamentais por meio de classificações fornecidas por terceiros."
      },
      {
        "language": "IT",
        "text": "Valuta la performance di un individuo rispetto alle competenze comportamentali attraverso valutazioni fornite da altri."
      },
      {
        "language": "CS",
        "text": "Hodnotí výkon jednotlivce z hlediska behaviorálních kompetencí na základě hodnocení od ostatních."
      },
      {
        "language": "EN",
        "text": "Assesses an individual's performance against behavioral competencies through ratings provided by others."
      }
    ]
  },
  {
    "key": "txt_360_assessment",
    "text": "360° Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "360° Assessment"
      },
      {
        "language": "PT",
        "text": "Avaliação 360°"
      },
      {
        "language": "IT",
        "text": "Assessment 360°"
      },
      {
        "language": "CS",
        "text": "360° Hodnocení"
      },
      {
        "language": "EN",
        "text": "360° Assessment"
      }
    ]
  },
  {
    "key": "txt_assessment_type",
    "text": "Assessment Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع التقييم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Assessment typ"
      },
      {
        "language": "PT",
        "text": "Tipo de avaliação"
      },
      {
        "language": "IT",
        "text": "Tipo di Assessment"
      },
      {
        "language": "CS",
        "text": "Typ hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Type"
      }
    ]
  },
  {
    "key": "txt_continue",
    "text": "Continue",
    "translations": [
      {
        "language": "AR",
        "text": "متابعة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Weiter"
      },
      {
        "language": "PT",
        "text": "Continuar"
      },
      {
        "language": "IT",
        "text": "Continua"
      },
      {
        "language": "CS",
        "text": "Pokračovat"
      },
      {
        "language": "EN",
        "text": "Continue"
      }
    ]
  },
  {
    "key": "txt_sort_by",
    "text": "Sort by",
    "translations": [
      {
        "language": "AR",
        "text": "تصنيف حسب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Sortieren nach"
      },
      {
        "language": "PT",
        "text": "Ordenar por"
      },
      {
        "language": "IT",
        "text": "Ordina per"
      },
      {
        "language": "CS",
        "text": "Seřadit podle"
      },
      {
        "language": "EN",
        "text": "Sort by"
      }
    ]
  },
  {
    "key": "txt_continue_setup",
    "text": "Continue Setup ",
    "translations": [
      {
        "language": "AR",
        "text": "متابعة الإعداد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Mit der Einrichtung fortfahren"
      },
      {
        "language": "PT",
        "text": "Continuar configuração"
      },
      {
        "language": "IT",
        "text": "Continua la configurazione"
      },
      {
        "language": "CS",
        "text": "Pokračovat v nastavení"
      },
      {
        "language": "EN",
        "text": "Continue Setup "
      }
    ]
  },
  {
    "key": "txtOpen",
    "text": "Open",
    "translations": [
      {
        "language": "AR",
        "text": "فتح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "öffnen"
      },
      {
        "language": "PT",
        "text": "Abrir"
      },
      {
        "language": "IT",
        "text": "Apri"
      },
      {
        "language": "CS",
        "text": "Otevřít"
      },
      {
        "language": "EN",
        "text": "Open"
      }
    ]
  },
  {
    "key": "txt_new_assessment",
    "text": "New Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم جديد"
      },
      {
        "language": "DE",
        "text": "Neues Assessment"
      },
      {
        "language": "PT",
        "text": "Nova avaliação"
      },
      {
        "language": "IT",
        "text": "Nuovo Assessment"
      },
      {
        "language": "CS",
        "text": "Nové hodnocení"
      },
      {
        "language": "EN",
        "text": "New Assessment"
      }
    ]
  },
  {
    "key": "txt_type",
    "text": "Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع التقييم"
      },
      {
        "language": "DE",
        "text": "Typ"
      },
      {
        "language": "PT",
        "text": "Tipo"
      },
      {
        "language": "IT",
        "text": "Tipo"
      },
      {
        "language": "CS",
        "text": "Typ"
      },
      {
        "language": "EN",
        "text": "Type"
      }
    ]
  },
  {
    "key": "txt_created",
    "text": "Created",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإنشاء"
      },
      {
        "language": "DE",
        "text": "Erstellt"
      },
      {
        "language": "PT",
        "text": "Criado"
      },
      {
        "language": "IT",
        "text": "Creato"
      },
      {
        "language": "CS",
        "text": "Vytvořeno"
      },
      {
        "language": "EN",
        "text": "Created"
      }
    ]
  },
  {
    "key": "txt_template",
    "text": "Template",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان النموذج"
      },
      {
        "language": "DE",
        "text": "Vorlage"
      },
      {
        "language": "PT",
        "text": "Modelo"
      },
      {
        "language": "IT",
        "text": "Template"
      },
      {
        "language": "CS",
        "text": "Šablona"
      },
      {
        "language": "EN",
        "text": "Template"
      }
    ]
  },
  {
    "key": "txt_circle_assessment_title",
    "text": "360°/180° Assessments",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات °360/°180"
      },
      {
        "language": "DE",
        "text": "360°/180°-Bewertungen"
      },
      {
        "language": "PT",
        "text": "Avaliações 360°/180°"
      },
      {
        "language": "IT",
        "text": "Assessment 360°/180°"
      },
      {
        "language": "CS",
        "text": "Hodnocení 360"
      },
      {
        "language": "EN",
        "text": "360°/180° Assessments"
      }
    ]
  },
  {
    "key": "test",
    "text": "test",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة"
      },
      {
        "language": "DE",
        "text": "testen"
      },
      {
        "language": "PT",
        "text": "teste"
      },
      {
        "language": "IT",
        "text": "test"
      },
      {
        "language": "CS",
        "text": "test"
      },
      {
        "language": "EN",
        "text": "test"
      }
    ]
  },
  {
    "key": "txt_Youcandow_623",
    "text": "You can download the list of respondents with their assessment status! <br>Note: Available in Excel format.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المستجيبين مع حالة التقييم الخاص بهم!  <br>ملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "DE",
        "text": "Sie können die Liste der Befragten mit ihrem Bewertungsstatus herunterladen! <br>Hinweis: Verfügbar im Excel-Format."
      },
      {
        "language": "PT",
        "text": "Você pode baixar a lista de entrevistados com seu status de avaliação! <br>Nota: Disponível em formato Excel."
      },
      {
        "language": "IT",
        "text": "Puoi scaricare l'elenco dei rispondenti con il relativo stato di compilazione dell'Assessment! \nNota: Disponibile in formato Excel."
      },
      {
        "language": "CS",
        "text": "Můžete si stáhnout seznam respondentů s informacemi o stavu jejich hodnocení! <br>Poznámka: K dispozici ve formátu Excel."
      },
      {
        "language": "EN",
        "text": "You can download the list of respondents with their assessment status! <br>Note: Available in Excel format."
      }
    ]
  },
  {
    "key": "txtResponses_desc",
    "text": "On the “<b>Respondent Analysis</b>” page, the assessment status for the list of candidates and evaluators who participated is displayed.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"تحليل المستجيبون\"، يتم عرض حالة التقييم لقائمة المرشحين والمقيمين المشاركين."
      },
      {
        "language": "DE",
        "text": "Auf der Seite „<b>Befragtenanalyse</b>“ wird der Bewertungsstatus für die Liste der teilnehmenden Kandidaten und Bewerter angezeigt."
      },
      {
        "language": "PT",
        "text": "Na página “<b>Análise dos Respondentes</b>” é exibido o status da avaliação da lista de candidatos e avaliadores que participaram."
      },
      {
        "language": "IT",
        "text": "Nella pagina “Analisi dei rispondenti”, viene mostrato lo stato di compilazione dell'Assessment relativo ai candidati e ai loro valutatori."
      },
      {
        "language": "CS",
        "text": "Na stránce „<b>Analýza respondentů</b>“ se zobrazuje stav hodnocení u seznamu uchazečů a hodnotitelů, kteří se hodnocení zúčastnili."
      },
      {
        "language": "EN",
        "text": "On the “<b>Respondent Analysis</b>” page, the assessment status for the list of candidates and evaluators who participated is displayed."
      }
    ]
  },
  {
    "key": "txt_ShowComme_desc",
    "text": "Click here to show the comments (if any).",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التعليقات (إن وجدت)."
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um Kommentare anzuzeigen (falls vorhanden)."
      },
      {
        "language": "PT",
        "text": "Clique aqui para mostrar os comentários (se houver)."
      },
      {
        "language": "IT",
        "text": "Clicca qui per mostrare i commenti (se presenti)."
      },
      {
        "language": "CS",
        "text": "Klikněte sem pro zobrazení komentářů (jsou-li k dispozici)."
      },
      {
        "language": "EN",
        "text": "Click here to show the comments (if any)."
      }
    ]
  },
  {
    "key": "txt_ShowComme_882",
    "text": "Show Comments",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التعليقات"
      },
      {
        "language": "DE",
        "text": "Kommentare anzeigen"
      },
      {
        "language": "PT",
        "text": "Mostrar comentários"
      },
      {
        "language": "IT",
        "text": "Mostra i commenti"
      },
      {
        "language": "CS",
        "text": "Zobrazit komentáře"
      },
      {
        "language": "EN",
        "text": "Show Comments"
      }
    ]
  },
  {
    "key": "txtComments360_desc",
    "text": "In the “<b>Comments</b>” page, written Strength Areas and Areas of Improvements from candidates (self) and evaluators during the assessment are shown under Self, and Evaluators (Manager, Peers, Team, and Customers)<br> Note: Evaluators' comments are anonymous.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"<b>التعليقات</b>\"، يتم عرض تعليقات نقاط القوة ومجالات التحسين من المرشحين والمقيمين أثناء أداء التقييم وتكون التعليقات من التقييم الذاتي والتقييم من المدراء والزملاء وأعضاء الفريق والعملاء."
      },
      {
        "language": "DE",
        "text": "Auf der Seite „<b>Kommentare</b>“ werden unter „Selbst“ und „Bewerter“ (Manager, Kollegen, Team und Kunden) schriftliche Stärkebereiche und Verbesserungsbereiche von Kandidaten (selbst) und Bewertern während der Beurteilung angezeigt.<br > Hinweis: Die Kommentare der Bewerter sind anonym."
      },
      {
        "language": "PT",
        "text": "Na página “<b>Comentários</b>”, as Áreas Fortes e as Áreas de Melhorias escritas pelos candidatos (próprios) e avaliadores durante a avaliação são mostradas em Próprio e Avaliadores (Gerente, Pares, Equipe e Clientes)<br> Observação: os comentários dos avaliadores são anônimos."
      },
      {
        "language": "IT",
        "text": "Nella pagina “Commenti”, i punti di forza e le aree di miglioramento scritte dai candidati (autovalutazione) e dai valutatori durante la compilazione dell'Assessment sono mostrate sotto “Autovalutazione” e “Valutatori (Manager, Colleghi, Team e Clienti)”. \nNota: I commenti dei valutatori sono anonimi."
      },
      {
        "language": "CS",
        "text": "Na stránce „<b>Komentáře</b>“ se v sekci „Vlastní“ zobrazují silné stránky a oblasti k zlepšení, které během hodnocení uvedli respondenti (sami o sobě) a hodnotitelé, a v sekci „Hodnotitelé“ (nadřízení, kolegové, tým a zákazníci)<br> Poznámka: Komentáře hodnotitelů jsou anonymní."
      },
      {
        "language": "EN",
        "text": "In the “<b>Comments</b>” page, written Strength Areas and Areas of Improvements from candidates (self) and evaluators during the assessment are shown under Self, and Evaluators (Manager, Peers, Team, and Customers)<br> Note: Evaluators' comments are anonymous."
      }
    ]
  },
  {
    "key": "txt_SelectCom_desc",
    "text": "Select a competency to unveil the candidate's score breakdown for each statement within that competency.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد الجدارة والمهارة لكي تكشف عن تفصيل معدل أداء المرشح في كل عبارة تحت الجدارة والمهارة المحددة."
      },
      {
        "language": "DE",
        "text": "Wählen Sie eine Kompetenz aus, um die Punkteaufschlüsselung des Kandidaten für jede Aussage dieser Kompetenz anzuzeigen."
      },
      {
        "language": "PT",
        "text": "Selecione uma competência para revelar o detalhamento da pontuação do candidato para cada afirmação dentro dessa competência."
      },
      {
        "language": "IT",
        "text": "Seleziona una competenza per visualizzare il dettaglio dei punteggi del candidato per ciascuna affermazione relativa a quella competenza."
      },
      {
        "language": "CS",
        "text": "Vyberte kompetenci a zobrazte rozpis bodového hodnocení uchazeče pro jednotlivá tvrzení v rámci této kompetence."
      },
      {
        "language": "EN",
        "text": "Select a competency to unveil the candidate's score breakdown for each statement within that competency."
      }
    ]
  },
  {
    "key": "txt_CompetenciesAndStatements_desc",
    "text": "Switch between “<b>Competencies</b>” and “<b>Statements</b>” to view the detailed score for each competency and its corresponding statements for each candidate.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"<b>الجدارات والمهارات</b>\" أو \"<b>العبارات</b>\" لعرض معدل التقييم المٌفصل لكل جدارة ومهارة والعبارات التابعة لها لكل مرشح."
      },
      {
        "language": "DE",
        "text": "Wechseln Sie zwischen „<b>Kompetenzen</b>“ und „<b>Aussagen</b>“, um die detaillierte Punktzahl für jede Kompetenz und die entsprechenden Aussagen für jeden Kandidaten anzuzeigen."
      },
      {
        "language": "PT",
        "text": "Alterne entre “<b>Competências</b>” e “<b>Declarações</b>” para visualizar a pontuação detalhada de cada competência e suas declarações correspondentes para cada candidato."
      },
      {
        "language": "IT",
        "text": "Passa da “Competenze” ad “Affermazioni” per vedere il punteggio dettagliato di ogni competenza e delle relative affermazioni per ciascun candidato."
      },
      {
        "language": "CS",
        "text": "Přepínejte mezi položkami „<b>Kompetence</b>“ a „<b>Popisy</b>“, abyste si u každého uchazeče prohlédli podrobné hodnocení jednotlivých kompetencí a příslušné popisy."
      },
      {
        "language": "EN",
        "text": "Switch between “<b>Competencies</b>” and “<b>Statements</b>” to view the detailed score for each competency and its corresponding statements for each candidate."
      }
    ]
  },
  {
    "key": "txt_CompetenciesAndStatements",
    "text": "Competencies & Statements",
    "translations": [
      {
        "language": "AR",
        "text": "الجدارات والمهارات والعبارات"
      },
      {
        "language": "DE",
        "text": "Kompetenzen & Aussagen"
      },
      {
        "language": "PT",
        "text": "Competências e Declarações"
      },
      {
        "language": "IT",
        "text": "Competenze e affermazioni"
      },
      {
        "language": "CS",
        "text": "Kompetence a popisy"
      },
      {
        "language": "EN",
        "text": "Competencies & Statements"
      }
    ]
  },
  {
    "key": "txtSelectedCandidate_desc",
    "text": "Click here to expand and select from the list of candidates.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض قائمة المرشحين واختيار المرشح."
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Kandidatenliste zu erweitern und aus der Kandidatenliste auszuwählen."
      },
      {
        "language": "PT",
        "text": "Clique aqui para expandir e selecionar na lista de candidatos."
      },
      {
        "language": "IT",
        "text": "Clicca qui per aprire e selezionare dall'elenco dei candidati."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, abyste rozbalili seznam kandidátů a vybrali si z něj."
      },
      {
        "language": "EN",
        "text": "Click here to expand and select from the list of candidates."
      }
    ]
  },
  {
    "key": "txtCompetencies_desc",
    "text": "On the “<b>Competencies</b>” page, you can delve into an in-depth analysis of how each candidate has scored on the selected competencies and statements during the assessment setup.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"الجدارات والمهارات\"</b> يمكنك التعمق في تحليل مُفصل للنتيجة الكلية لكل جدارة ومهارة لكل مرشح."
      },
      {
        "language": "DE",
        "text": "Auf der Seite „<b>Kompetenzen</b>“ können Sie eine detaillierte Analyse darüber durchführen, wie jeder Kandidat während des Assessements bei den ausgewählten Kompetenzen und Aussagen abgeschnitten hat."
      },
      {
        "language": "PT",
        "text": "Na página “<b>Competências</b>”, você pode se aprofundar em uma análise aprofundada de como cada candidato obteve pontuação nas competências e declarações selecionadas durante a configuração da avaliação."
      },
      {
        "language": "IT",
        "text": "Nella pagina “Competenze”, puoi eseguire un'analisi più approfondita rispetto al punteggio ottenuto da ciascun candidato in base alle competenze e alle affermazioni selezionate durante la configurazione dell'Assessment."
      },
      {
        "language": "CS",
        "text": "Na stránce „<b>Kompetence</b>“ si můžete prohlédnout podrobnou analýzu toho, jak si jednotliví kandidáti vedli v rámci vybraných kompetencí a tvrzení během nastavení hodnocení."
      },
      {
        "language": "EN",
        "text": "On the “<b>Competencies</b>” page, you can delve into an in-depth analysis of how each candidate has scored on the selected competencies and statements during the assessment setup."
      }
    ]
  },
  {
    "key": "txtOverallResponseRate_desc",
    "text": "This chart displays the overall response rate for candidates and evaluators.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض هذا الرسم البياني معدل الاستجابة الإجمالي للمرشحين والمقيمين."
      },
      {
        "language": "DE",
        "text": "Dieses Diagramm zeigt die allgemeine Antwortrate für Kandidaten und Bewerter."
      },
      {
        "language": "PT",
        "text": "Este gráfico exibe a taxa geral de resposta para candidatos e avaliadores."
      },
      {
        "language": "IT",
        "text": "Questo grafico mostra il tasso di risposta complessivo dei candidati e valutatori."
      },
      {
        "language": "CS",
        "text": "Tento graf znázorňuje celkovou míru odezvy u uchazečů a hodnotitelů."
      },
      {
        "language": "EN",
        "text": "This chart displays the overall response rate for candidates and evaluators."
      }
    ]
  },
  {
    "key": "txt_Candidate_383",
    "text": "Candidate List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المرشحون"
      },
      {
        "language": "DE",
        "text": "Kandidatenliste"
      },
      {
        "language": "PT",
        "text": "Lista de Candidatos"
      },
      {
        "language": "IT",
        "text": "Elenco dei candidati"
      },
      {
        "language": "CS",
        "text": "Seznam respondentů"
      },
      {
        "language": "EN",
        "text": "Candidate List"
      }
    ]
  },
  {
    "key": "txt_Youcandow_637",
    "text": "You can download the candidates’ list and overall performance score across all competencies for a detailed comparison.<br><br>Note: Available in Excel format.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المرشحين ومعدل تقييم الأداء العام لجميع الجدارات والمهارات لإجراء مقارنة تفصيلية.<br><br>ملحوظه متوفر في صيغة Excel."
      },
      {
        "language": "DE",
        "text": "Sie können die Kandidatenliste und die Gesamtleistungsbewertung aller Kompetenzen für einen detaillierten Vergleich herunterladen.<br><br>Hinweis: Im Excel-Format verfügbar."
      },
      {
        "language": "PT",
        "text": "Você pode baixar a lista de candidatos e a pontuação geral de desempenho em todas as competências para uma comparação detalhada.<br><br>Observação: disponível em formato Excel."
      },
      {
        "language": "IT",
        "text": "Puoi scaricare l'elenco dei candidati e il punteggio di performance complessivo di tutte le competenze per un confronto dettagliato.\n\nNota: Disponibile in formato Excel."
      },
      {
        "language": "CS",
        "text": "Pro podrobné srovnání si můžete stáhnout seznam respondnetů a celkové hodnocení výkonnosti ve všech kompetencích.<br><br>Poznámka: K dispozici ve formátu Excel."
      },
      {
        "language": "EN",
        "text": "You can download the candidates’ list and overall performance score across all competencies for a detailed comparison.<br><br>Note: Available in Excel format."
      }
    ]
  },
  {
    "key": "txt_DownloadC_654",
    "text": "Download Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المقارنة"
      },
      {
        "language": "DE",
        "text": "Vergleich herunterladen"
      },
      {
        "language": "PT",
        "text": "Baixar comparação"
      },
      {
        "language": "IT",
        "text": "Scarica la comparazione"
      },
      {
        "language": "CS",
        "text": "Stáhnout srovnání"
      },
      {
        "language": "EN",
        "text": "Download Comparison"
      }
    ]
  },
  {
    "key": "txt_FilterSort_376",
    "text": "Filter & Sort",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية وتصنيف"
      },
      {
        "language": "DE",
        "text": "Filtern & Sortieren"
      },
      {
        "language": "PT",
        "text": "Filtrar e classificar"
      },
      {
        "language": "IT",
        "text": "Filtra e ordina"
      },
      {
        "language": "CS",
        "text": "Filtrovat a třídit"
      },
      {
        "language": "EN",
        "text": "Filter & Sort"
      }
    ]
  },
  {
    "key": "txtAverageScore_desc",
    "text": "Are you curious about identifying top performers and those with room for skill improvement? We've got you covered! Click <b>“Average Score”</b> to see which candidates are above the evaluator's average score and who might benefit from skill development!",
    "translations": [
      {
        "language": "AR",
        "text": "هل ترغب في التعرف على المرشحين الأفضل أداء وأولئك الذين لديهم مجال إلى تحسين مهاراتهم؟ لدينا ما تحتاج! انقر على \"<b>متوسط النتيجة</b>\" لعرض المرشحين الذين يفوقون معدل نتائج المقيمين والذين قد يستفيدون من تطوير مهاراتهم!"
      },
      {
        "language": "DE",
        "text": "Möchten Sie Spitzenkräfte und solche mit Verbesserungspotenzial identifizieren? Dann sind Sie bei uns richtig! Klicken Sie auf <b>„Durchschnittspunktzahl“</b>, um zu sehen, welche Kandidaten über der Durchschnittspunktzahl des Prüfers liegen und wer von einer Kompetenzentwicklung profitieren könnte!"
      },
      {
        "language": "PT",
        "text": "Você está curioso para identificar os melhores desempenhos e aqueles com espaço para melhorar suas habilidades? Nós ajudamos você! Clique em <b>“Pontuação Média”</b> para ver quais candidatos estão acima da pontuação média do avaliador e quem pode se beneficiar com o desenvolvimento de habilidades!"
      },
      {
        "language": "IT",
        "text": "Vuoi scoprire chi sono i top performer e chi ha margini di miglioramento? Ci pensiamo noi! Clicca su “Punteggio medio” per vedere quali candidati superano il punteggio medio dei valutatori e chi potrebbe trarre beneficio da un percorso di sviluppo delle competenze!"
      },
      {
        "language": "CS",
        "text": "Zajímá vás, jak rozpoznat ty nejlepší uchazeče a ty, kteří mají prostor pro zlepšení svých dovedností? Máme pro vás řešení! Klikněte na <b>„Průměrné skóre“</b> a zjistěte, kteří uchazeči dosáhli skóre vyššího než je průměr hodnotitele a komu by se mohlo hodit zdokonalit své dovednosti!"
      },
      {
        "language": "EN",
        "text": "Are you curious about identifying top performers and those with room for skill improvement? We've got you covered! Click <b>“Average Score”</b> to see which candidates are above the evaluator's average score and who might benefit from skill development!"
      }
    ]
  },
  {
    "key": "txtPreviousScore_desc",
    "text": "The <b>previous score</b> shows your candidates’ current score compared to the previous score (if any). <br>Hint: Blue color represents self-score while the green color represents the evaluators score.",
    "translations": [
      {
        "language": "AR",
        "text": "تُظهر \"<b>النتيجة السابقة</b>\" النتيجة الحالية للمرشح مقارنة بالنتيجة السابقة (إن وجدت). <br>تلميح: يُمثل اللون الأزرق النتيجة الذاتية ويُمثل اللون الأخضر نتيجة المقيّمين."
      },
      {
        "language": "DE",
        "text": "Die <b>vorherige Punktzahl</b> zeigt die aktuelle Punktzahl Ihrer Kandidaten im Vergleich zur vorherigen Punktzahl (falls vorhanden). <br>Hinweis: Die blaue Farbe stellt die Selbstbewertung dar, während die grüne Farbe die Bewertung des Bewerters darstellt."
      },
      {
        "language": "PT",
        "text": "A <b>pontuação anterior</b> mostra a pontuação atual dos seus candidatos em comparação com a pontuação anterior (se houver). <br>Dica: a cor azul representa a autopontuação, enquanto a cor verde representa a pontuação dos avaliadores."
      },
      {
        "language": "IT",
        "text": "Il punteggio precedente mostra il punteggio attuale dei candidati comparato a quello precedente (se presente). \nSuggerimento: Il colore blu rappresenta l’autovalutazione, il verde il punteggio dei valutatori."
      },
      {
        "language": "CS",
        "text": "<b>Předchozí skóre</b> zobrazuje aktuální skóre vašich respondentů v porovnání s předchozím skóre (pokud existuje). <br>Tip: Modrá barva označuje vlastní skóre, zatímco zelená barva označuje skóre hodnotitele."
      },
      {
        "language": "EN",
        "text": "The <b>previous score</b> shows your candidates’ current score compared to the previous score (if any). <br>Hint: Blue color represents self-score while the green color represents the evaluators score."
      }
    ]
  },
  {
    "key": "txt_download_desc",
    "text": "Click here to download the report and turn on the sections you want to include.<br><br> Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF.\"",
    "translations": [
      {
        "language": "AR",
        "text": " انقر هنا لتحميل التقرير واختر الأقسام التي ترغب في تضمينها في التقرير.<br><br> تلميح: قم بالوصول بسهولة إلى تقارير الوحدات التنظيمية المفصلة عن طريق اختيار نوع الوحدة التنظيمية في قائمة <b>\"تصفح عن طريق\" </b>وابدأ بالتحميل الآن! - متوفر في صيغة PDF. "
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um den Bericht herunterzuladen und die Abschnitte zu aktivieren, die Sie einschließen möchten.<br><br> Tipp: Greifen Sie auf detaillierte Berichte einfach zu, indem Sie im Menü „Anzeigen nach“ Ihren bevorzugten Typ auswählen und sofort mit dem Herunterladen beginnen! – Als PDF verfügbar.“"
      },
      {
        "language": "PT",
        "text": "Clique aqui para baixar o relatório e ativar as seções que deseja incluir.<br><br> Dica: acesse facilmente relatórios detalhados de entidades escolhendo seu tipo de entidade preferido no menu \"Visualizar por\" e comece a baixar agora! - Disponível em PDF.\""
      },
      {
        "language": "IT",
        "text": "Clicca qui per scaricare il report e selezionare le sezioni da includere. \nSuggerimento: Accedi facilmente ai report dettagliati per livello organizzativo scegliendo il tipo preferito nel menu \"Visualizza per\" e inizia subito a scaricare! - Disponibile in PDF."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, abyste si zprávu stáhli, a zaškrtněte sekce, které chcete zahrnout.<br><br> Tip: K podrobným zprávám o entitách se snadno dostanete tak, že v nabídce „Zobrazit podle“ vyberete požadovaný typ entity a začnete stahovat hned teď! – K dispozici ve formátu PDF."
      },
      {
        "language": "EN",
        "text": "Click here to download the report and turn on the sections you want to include.<br><br> Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF.\""
      }
    ]
  },
  {
    "key": "txt_download",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "DE",
        "text": "Herunterladen"
      },
      {
        "language": "PT",
        "text": "Download"
      },
      {
        "language": "IT",
        "text": "Scarica"
      },
      {
        "language": "CS",
        "text": "Stáhnout"
      },
      {
        "language": "EN",
        "text": "Download"
      }
    ]
  },
  {
    "key": "txtViewBy",
    "text": "View by",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح عن طريق"
      },
      {
        "language": "DE",
        "text": "Anzeigen"
      },
      {
        "language": "PT",
        "text": "Ver por"
      },
      {
        "language": "IT",
        "text": "Visualizza per"
      },
      {
        "language": "CS",
        "text": "Zobrazit podle"
      },
      {
        "language": "EN",
        "text": "View by"
      }
    ]
  },
  {
    "key": "txtOverview_desc",
    "text": "The <b>“Overview”</b> page displays the total number of candidates & evaluators, their overall response rate, and overall performance score. ",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة <b>\"نظرة عامة\"</b> تعرض عدد المرشحين والمقيمين ومعدل الاستجابة العام ومعدل التقييم العام."
      },
      {
        "language": "DE",
        "text": " Auf der Seite <b>„Übersicht“</b> werden die Gesamtzahl der Kandidaten und Gutachter, ihre Gesamtantwortrate und die Gesamtleistungsbewertung angezeigt."
      },
      {
        "language": "PT",
        "text": "A página <b>“Visão geral”</b> exibe o número total de candidatos e avaliadores, sua taxa de resposta geral e pontuação geral de desempenho."
      },
      {
        "language": "IT",
        "text": "La pagina “Panoramica” mostra il numero totale di candidati e valutatori, il loro tasso di risposta complessivo e il punteggio di performance complessivo."
      },
      {
        "language": "CS",
        "text": "Stránka <b>„Přehled“</b> zobrazuje celkový počet uchazečů a hodnotitelů, jejich celkovou míru odezvy a celkové skóre výkonu."
      },
      {
        "language": "EN",
        "text": "The <b>“Overview”</b> page displays the total number of candidates & evaluators, their overall response rate, and overall performance score. "
      }
    ]
  },
  {
    "key": "txt_Clickonclose_627",
    "text": "Click on <b>“Close Now”</b> to close the assessment. <br><br>Note: You cannot add or delete respondents once you close the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"أغلق الآن\"</b> لإغلاق التقييم. <br><br>ملحوظة: لن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      },
      {
        "language": "DE",
        "text": "Klicken Sie auf <b>„Jetzt abschließen“</b>, um das Assessment zu schließen. <br><br>Hinweis: Nachdem Sie das Assessmen geschlossen haben, können Sie keine Befragten mehr hinzufügen oder löschen."
      },
      {
        "language": "PT",
        "text": "Clique em <b>“Fechar agora”</b> para fechar a avaliação. <br><br>Observação: você não poderá adicionar ou excluir respondentes depois de fechar a avaliação."
      },
      {
        "language": "IT",
        "text": "Clicca su “Chiudi ora” per chiudere l'Assessment. \nNota: Una volta chiuso, non potrai più aggiungere o eliminare rispondenti."
      },
      {
        "language": "CS",
        "text": "Klikněte na <b>„Zavřít nyní“</b>, abyste hodnocení uzavřeli. <br><br>Poznámka: Po uzavření hodnocení již nelze přidávat ani mazat respondenty."
      },
      {
        "language": "EN",
        "text": "Click on <b>“Close Now”</b> to close the assessment. <br><br>Note: You cannot add or delete respondents once you close the assessment."
      }
    ]
  },
  {
    "key": "txt_CloseAsse_144",
    "text": "Close Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق التقييم"
      },
      {
        "language": "DE",
        "text": "Assessment abschließen"
      },
      {
        "language": "PT",
        "text": "Fechar avaliação"
      },
      {
        "language": "IT",
        "text": "Chiudi l'Assessment"
      },
      {
        "language": "CS",
        "text": "Závěrečné hodnocení"
      },
      {
        "language": "EN",
        "text": "Close Assessment"
      }
    ]
  },
  {
    "key": "txt_Havesomeo_945",
    "text": "Have some of your candidates and evaluators completed their assessments while others are still in progress? No worries! You can view their reports by clicking <b>“Close Now”</b> for the chosen candidate. To view the closed candidate’s report, click on “📶”. <br><br>Note: To close a candidate's report, it is required a minimum of self-assessment, one manager assessment, and two peer or team assessments to be completed.",
    "translations": [
      {
        "language": "AR",
        "text": "هل استكمل بعض المرشحين والمقيمين لديك تقييماتهم بينما لا يزال البعض الآخر قيد الإنجاز؟ لا تقلق! يمكنك عرض هذه التقارير بالنقر على <b>\"أغلق الآن\" </b>للمرشح المختار. وللاطلاع على تقرير المرشح المغلق انقر على “📶”. <br><br>ملحوظة: لإغلاق تقرير المرشح، يلزم استكمال التقييم الذاتي، وتقييم مدير واحد، وتقييمين من الزملاء أو أعضاء الفريق كحد أدنى."
      },
      {
        "language": "DE",
        "text": "Haben einige Ihrer Kandidaten und Gutachter ihre Assessements abgeschlossen, während andere noch dabei sind? Kein Problem! Sie können ihre Berichte anzeigen, indem Sie für den ausgewählten Kandidaten auf <b>„Jetzt schließen“</b> klicken. Um den Bericht des geschlossenen Kandidaten anzuzeigen, klicken Sie auf „📶“. <br><br>Hinweis: Um den Bericht eines Kandidaten zu schließen, müssen mindestens eine Selbstbewertung, eine Managerbewertung und zwei Peer- oder Teambewertungen abgeschlossen sein."
      },
      {
        "language": "PT",
        "text": "Alguns de seus candidatos e avaliadores concluíram suas avaliações enquanto outros ainda estão em andamento? Sem problemas! Você pode visualizar seus relatórios clicando em <b>“Fechar agora”</b> para o candidato escolhido. Para visualizar o relatório do candidato fechado, clique em “📶”. <br><br>Nota: Para fechar o relatório de um candidato, é necessário um mínimo de autoavaliação, uma avaliação de gerente e duas avaliações de pares ou de equipe a serem concluídas."
      },
      {
        "language": "IT",
        "text": "Alcuni dei tuoi candidati e valutatori hanno completato il loro Assessment mentre altri sono ancora in corso? Nessun problema! Puoi visualizzare i loro report cliccando su “Chiudi ora” per il candidato scelto. Per aprire il report chiuso di un candidato, clicca su “📶”. \nNota: Per chiudere il report di un candidato è necessario almeno un'autovalutazione, una valutazione del manager e due valutazioni dei colleghi o del team."
      },
      {
        "language": "CS",
        "text": "Dokončili někteří z vašich respondentů a hodnotitelů hodnocení, zatímco u jiných ještě probíhá? Žádný problém! Zprávy si můžete prohlédnout kliknutím na <b>„Uzavřít nyní“</b> u vybraného respondenta. Chcete-li zobrazit zprávu uzavřeného respondenta, klikněte na „📶“. <br><br>Poznámka: K uzavření zprávy respondenta je nutné, aby bylo vyplněno minimálně sebehodnocení, jedno hodnocení manažera a dvě hodnocení kolegy nebo týmu."
      },
      {
        "language": "EN",
        "text": "Have some of your candidates and evaluators completed their assessments while others are still in progress? No worries! You can view their reports by clicking <b>“Close Now”</b> for the chosen candidate. To view the closed candidate’s report, click on “📶”. <br><br>Note: To close a candidate's report, it is required a minimum of self-assessment, one manager assessment, and two peer or team assessments to be completed."
      }
    ]
  },
  {
    "key": "txt_OpenCandi_762",
    "text": "Open Candidate Report",
    "translations": [
      {
        "language": "AR",
        "text": "فتح تقرير المرشح "
      },
      {
        "language": "DE",
        "text": "Kandidatenbericht öffnen"
      },
      {
        "language": "PT",
        "text": "Relatório de candidato aberto"
      },
      {
        "language": "IT",
        "text": "Apri il Candidate Report"
      },
      {
        "language": "CS",
        "text": "Otevřít zprávu o respondentech"
      },
      {
        "language": "EN",
        "text": "Open Candidate Report"
      }
    ]
  },
  {
    "key": "txt_Diditgobe_595",
    "text": "Did it go beyond the completion date? Click here to update the deadline and automated reminder dates.",
    "translations": [
      {
        "language": "AR",
        "text": "هل تجاوزت تاريخ الإكمال؟ انقر هنا لتحديث تاريخ الإكمال وتواريخ التذكيرالتلقائي."
      },
      {
        "language": "DE",
        "text": "Ist der Fertigstellungstermin überschritten? Klicken Sie hier, um die Frist und die automatischen Erinnerungstermine zu aktualisieren."
      },
      {
        "language": "PT",
        "text": "Ultrapassou a data de conclusão? Clique aqui para atualizar o prazo e as datas dos lembretes automáticos."
      },
      {
        "language": "IT",
        "text": "È stata superata la data di completamento? Clicca qui per aggiornare la scadenza e le date dei promemoria automatici."
      },
      {
        "language": "CS",
        "text": "Překročila se lhůta pro dokončení? Klikněte sem a aktualizujte termín a data automatických připomínek."
      },
      {
        "language": "EN",
        "text": "Did it go beyond the completion date? Click here to update the deadline and automated reminder dates."
      }
    ]
  },
  {
    "key": "txt_UpdateDat_741",
    "text": "Update Dates",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث التواريخ"
      },
      {
        "language": "DE",
        "text": "Daten aktualisieren"
      },
      {
        "language": "PT",
        "text": "Datas de atualização"
      },
      {
        "language": "IT",
        "text": "Aggiorna le date"
      },
      {
        "language": "CS",
        "text": "Data aktualizací"
      },
      {
        "language": "EN",
        "text": "Update Dates"
      }
    ]
  },
  {
    "key": "txt_Youcandow_719",
    "text": "You can download the list of respondents with their assessment status!<br><br> Note: Available in Excel format.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المستجيبين مع حالة التقييم الخاص بهم!  <br><br>ملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "DE",
        "text": "Sie können die Liste der Befragten mit ihrem Assessment-status herunterladen!<br><br> Hinweis: Im Excel-Format verfügbar."
      },
      {
        "language": "PT",
        "text": "Você pode baixar a lista de respondentes com seu status de avaliação!<br><br> Observação: Disponível em formato Excel."
      },
      {
        "language": "IT",
        "text": "Puoi scaricare l'elenco dei rispondenti con il relativo stato di compilazione dell'Assessment! \nNota: Disponibile in formato Excel."
      },
      {
        "language": "CS",
        "text": "Můžete si stáhnout seznam respondentů s informacemi o stavu jejich hodnocení!<br><br> Poznámka: K dispozici ve formátu Excel."
      },
      {
        "language": "EN",
        "text": "You can download the list of respondents with their assessment status!<br><br> Note: Available in Excel format."
      }
    ]
  },
  {
    "key": "txt_ExportRes_357",
    "text": "Export Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المستجيبون"
      },
      {
        "language": "DE",
        "text": "Befragte exportieren"
      },
      {
        "language": "PT",
        "text": "Exportar respondentes"
      },
      {
        "language": "IT",
        "text": "Esporta i rispondenti"
      },
      {
        "language": "CS",
        "text": "Exportovat respondenty"
      },
      {
        "language": "EN",
        "text": "Export Respondents"
      }
    ]
  },
  {
    "key": "txt_MoreActio_358",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية "
      },
      {
        "language": "DE",
        "text": "Weitere Optionen"
      },
      {
        "language": "PT",
        "text": "Mais ações"
      },
      {
        "language": "IT",
        "text": "Altre azioni"
      },
      {
        "language": "CS",
        "text": "Další akce"
      },
      {
        "language": "EN",
        "text": "More Actions"
      }
    ]
  },
  {
    "key": "txt_Clickhere_603",
    "text": "Click here to send reminders to respondents who did not complete the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لإرسال تذكيرات للمستجيبين الذين لم يستكملوا التقييم."
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um den Befragten, die das Assessment noch nicht abgeschlossen haben, Erinnerungen zu senden."
      },
      {
        "language": "PT",
        "text": "Clique aqui para enviar lembretes aos entrevistados que não concluíram a avaliação."
      },
      {
        "language": "IT",
        "text": "Clicca qui per inviare un promemoria ai rispondenti che non hanno completato l'Assessment."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a pošlete upomínky respondentům, kteří hodnocení nedokončili."
      },
      {
        "language": "EN",
        "text": "Click here to send reminders to respondents who did not complete the assessment."
      }
    ]
  },
  {
    "key": "txt_Trackyour_136",
    "text": "Track your respondents' progress! <br><br> Note: We recommend a 65% - 75% response rate for a better analysis.",
    "translations": [
      {
        "language": "AR",
        "text": "تتبع معدل الاستجابة للمستجيبين. <br><br> ملحوظة: نوصي بمعدل استجابة يترواح بين 65% - 75% لتحليلات أفضل."
      },
      {
        "language": "DE",
        "text": "Verfolgen Sie den Fortschritt Ihrer Befragten! <br><br> Hinweis: Für eine bessere Analyse empfehlen wir eine Antwortrate von 65 % – 75 %."
      },
      {
        "language": "PT",
        "text": "Acompanhe o progresso dos seus entrevistados! <br><br> Nota: Recomendamos uma taxa de resposta de 65% - 75% para uma melhor análise."
      },
      {
        "language": "IT",
        "text": "Monitora l'avanzamento dei tuoi rispondenti! \nNota: Consigliamo un tasso di risposta del 65%-75% per garantire un’analisi più accurata."
      },
      {
        "language": "CS",
        "text": "Sledujte, jak respondenti pokračují! <br><br> Poznámka: Pro lepší analýzu doporučujeme míru odezvy 65 % až 75 %."
      },
      {
        "language": "EN",
        "text": "Track your respondents' progress! <br><br> Note: We recommend a 65% - 75% response rate for a better analysis."
      }
    ]
  },
  {
    "key": "txt_Clickhere_208",
    "text": "Click here to delete a draft assessment.<br><br> Note: only draft assessments can be deleted",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لحذف التقييمات المسودة. <br><br>ملحوظة: يمكن حذف تقييمات المسودة فقط"
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um einen Assessment- Entwurf zu löschen.<br><br> Hinweis: Nur Assessment- Entwürfe können gelöscht werden."
      },
      {
        "language": "PT",
        "text": "Clique aqui para excluir um rascunho de avaliação.<br><br> Observação: apenas rascunhos de avaliação podem ser excluídos"
      },
      {
        "language": "IT",
        "text": "Clicca qui per eliminare un'Assessment in bozza. \n\nNota: Solo gli Assessment in bozza possono essere eliminate"
      },
      {
        "language": "CS",
        "text": "Klikněte sem, chcete-li smazat návrh hodnocení.<br><br> Poznámka: smazat lze pouze návrhy hodnocení"
      },
      {
        "language": "EN",
        "text": "Click here to delete a draft assessment.<br><br> Note: only draft assessments can be deleted"
      }
    ]
  },
  {
    "key": "txt_DeleteAss_720",
    "text": "Delete Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "حذف تقييم"
      },
      {
        "language": "DE",
        "text": "Assessment löschen"
      },
      {
        "language": "PT",
        "text": "Excluir avaliação"
      },
      {
        "language": "IT",
        "text": "Elimina l'Assessment"
      },
      {
        "language": "CS",
        "text": "Odstranit hodnocení"
      },
      {
        "language": "EN",
        "text": "Delete Assessment"
      }
    ]
  },
  {
    "key": "txt_OpenAsses_625",
    "text": "Open Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "فتح تقييم"
      },
      {
        "language": "DE",
        "text": "Assessement öffnen"
      },
      {
        "language": "PT",
        "text": "Avaliação Aberta"
      },
      {
        "language": "IT",
        "text": "Apri l'Assessment"
      },
      {
        "language": "CS",
        "text": "Otevřené hodnocení"
      },
      {
        "language": "EN",
        "text": "Open Assessment"
      }
    ]
  },
  {
    "key": "txt_Tocreatea_600",
    "text": "To create a new assessment, click on <b>“New Setup”</b>.",
    "translations": [
      {
        "language": "AR",
        "text": "انقرعلى <b>\"إعداد جديد\"</b> لإنشاء تقييم جديد."
      },
      {
        "language": "DE",
        "text": "Um eine neues Assessment zu erstellen, klicken Sie auf <b>„Neues Setup“</b>."
      },
      {
        "language": "PT",
        "text": "Para criar uma nova avaliação, clique em <b>“Nova Configuração”</b>."
      },
      {
        "language": "IT",
        "text": "Per creare un nuovo Assessment, clicca su “Nuova configurazione”."
      },
      {
        "language": "CS",
        "text": "Chcete-li vytvořit nové hodnocení, klikněte na <b>„Nové nastavení“</b>."
      },
      {
        "language": "EN",
        "text": "To create a new assessment, click on <b>“New Setup”</b>."
      }
    ]
  },
  {
    "key": "txt_send_invitations_desc",
    "text": "Once you set up the <b>“Invitation Email”</b>, click here to send the assessment invitations and go live! ",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد أن تقوم بإعداد <b>\"دعوة لاستكمال التقييم\"</b>، انقر هنا لإرسال دعوات التقييم وإطلاق التقييم مباشرةً!"
      },
      {
        "language": "DE",
        "text": " Sobald Sie die <b>„Einladungs-E-Mail“</b> eingerichtet haben, klicken Sie hier, um die Assessment-Einladungen zu versenden und live zu gehen!"
      },
      {
        "language": "PT",
        "text": "Depois de configurar o <b>“E-mail de convite”</b>, clique aqui para enviar os convites de avaliação e entrar no ar!"
      },
      {
        "language": "IT",
        "text": "Dopo aver configurato l’“Email di invito”, clicca qui per inviare gli inviti alla compilazione dell'Assessment e avviare il processo!"
      },
      {
        "language": "CS",
        "text": "Jakmile nastavíte <b>„Pozvánkový e-mail“</b>, klikněte sem, abyste odeslali pozvánky k hodnocení a spustili test!"
      },
      {
        "language": "EN",
        "text": "Once you set up the <b>“Invitation Email”</b>, click here to send the assessment invitations and go live! "
      }
    ]
  },
  {
    "key": "txt_Invitatio_desc",
    "text": "Customize the invitation email template for the candidate and evaluator, or use the default template generated by Zenithr.<br>Hint: Do not erase the assessment link. If erased, click on the default button.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل الدعوة الخاص بالمرشح والمقيّم او استخدم النموذج الأساسي المُعرف من زينثر.<br> ملحوظة: لا تقم بمسح رابط التقييم. إذا تم مسحه، انقر على \"النموذج الأساسي\"."
      },
      {
        "language": "DE",
        "text": "Passen Sie die Einladungs-E-Mail-Vorlage für den Kandidaten und den Bewerter an oder verwenden Sie die von Zenithr generierte Standardvorlage.<br>Hinweis: Löschen Sie den Assessment link nicht. Wenn gelöscht, klicken Sie auf die Standardschaltfläche."
      },
      {
        "language": "PT",
        "text": "Personalize o modelo de e-mail de convite para o candidato e avaliador ou use o modelo padrão gerado pela Zenithr.<br>Dica: não apague o link da avaliação. Se apagado, clique no botão padrão."
      },
      {
        "language": "IT",
        "text": "Personalizza il template email di invito per il candidato e il valutatore o usa quello predefinito di Zenithr. \nSuggerimento: Non eliminare il link dell'Assessment. Se viene eliminato, clicca sul pulsante predefinito."
      },
      {
        "language": "CS",
        "text": "Jakmile nastavíte <b>„Pozvánkový e-mail“</b>, klikněte sem, abyste odeslali pozvánky k hodnocení a spustili test!"
      },
      {
        "language": "EN",
        "text": "Customize the invitation email template for the candidate and evaluator, or use the default template generated by Zenithr.<br>Hint: Do not erase the assessment link. If erased, click on the default button."
      }
    ]
  },
  {
    "key": "txt_Invitatio_189",
    "text": "Invitation Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج الدعوة"
      },
      {
        "language": "DE",
        "text": "Einladungsvorlage"
      },
      {
        "language": "PT",
        "text": "Modelo de convite"
      },
      {
        "language": "IT",
        "text": "Template di invito"
      },
      {
        "language": "CS",
        "text": "Šablona pozvánky"
      },
      {
        "language": "EN",
        "text": "Invitation Template"
      }
    ]
  },
  {
    "key": "txt_Clickhere_391",
    "text": "Click here to switch between the candidate’s and evaluator’s templates.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض نموذج المرشح والمقيّم."
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um zwischen den Vorlagen des Kandidaten und des Bewerters zu wechseln."
      },
      {
        "language": "PT",
        "text": "Clique aqui para alternar entre os modelos do candidato e do avaliador."
      },
      {
        "language": "IT",
        "text": "Clicca qui per passare dal template del candidato a quello del valutatore e viceversa."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a přepínejte mezi šablonami pro uchazeče a hodnotitele."
      },
      {
        "language": "EN",
        "text": "Click here to switch between the candidate’s and evaluator’s templates."
      }
    ]
  },
  {
    "key": "txt_TemplateV_619",
    "text": "Template View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النموذج"
      },
      {
        "language": "DE",
        "text": "Vorlagenansicht"
      },
      {
        "language": "PT",
        "text": "Visualização de modelo"
      },
      {
        "language": "IT",
        "text": "Visualizzazione del template"
      },
      {
        "language": "CS",
        "text": "Zobrazení šablony"
      },
      {
        "language": "EN",
        "text": "Template View"
      }
    ]
  },
  {
    "key": "txt_invitation_email_desc",
    "text": "In the <b>“Invitation Email”</b>, you invite the respondents you input in the <b>“Candidates”</b> section through email.",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"دعوة لاستكمال التقييم\"</b> تقوم بدعوة المستجيبين المضافين في خطوة <b>\"المرشحون\"</b> من خلال البريد الإلكتروني."
      },
      {
        "language": "DE",
        "text": "Im <b>„Einladungs-E-Mail“</b> laden Sie die Befragten, die Sie im Abschnitt <b>„Kandidaten“</b> eingegeben haben, per E-Mail ein."
      },
      {
        "language": "PT",
        "text": "No <b>“E-mail de convite”</b>, você convida os entrevistados inseridos na seção <b>“Candidatos”</b> por e-mail."
      },
      {
        "language": "IT",
        "text": "Nell’“Email di invito”, inviti i rispondenti inseriti nella sezione “Candidati” tramite email."
      },
      {
        "language": "CS",
        "text": "V <b>„Pozvánce e-mailem“</b> pozvete e-mailem respondenty, které jste zadali v sekci <b>„Respondenti“</b>."
      },
      {
        "language": "EN",
        "text": "In the <b>“Invitation Email”</b>, you invite the respondents you input in the <b>“Candidates”</b> section through email."
      }
    ]
  },
  {
    "key": "txt_Onemorest_880",
    "text": "One more step, and you’re ready to go!",
    "translations": [
      {
        "language": "AR",
        "text": "تبقى خطوة أخرى وتنتهي من إعداد التقييم!"
      },
      {
        "language": "DE",
        "text": "Noch ein Schritt und schon kann es losgehen!"
      },
      {
        "language": "PT",
        "text": "Mais um passo e você está pronto para começar!"
      },
      {
        "language": "IT",
        "text": "Un ultimo passaggio e sei pronto!"
      },
      {
        "language": "CS",
        "text": "Ještě jeden krok a můžete začít!"
      },
      {
        "language": "EN",
        "text": "One more step, and you’re ready to go!"
      }
    ]
  },
  {
    "key": "txt_reminder_template_desc",
    "text": "Customize the reminder email template for the candidate and evaluator, or use the default template generated by Zenithr.<br>Hint: Do not erase the assessment link. If erased, click on the default button.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل التذكير الخاص بالمرشح والمقيّم أو استخدم النموذج الأساسي المُعرف من زينثر.<br>ملحوظة: لا تقم بمسح رابط التقييم. إذا تم مسحه، انقر على \"النموذج الأساسي\"."
      },
      {
        "language": "DE",
        "text": "Passen Sie die Erinnerungs-E-Mail-Vorlage für den Kandidaten und den Bewerter an oder verwenden Sie die von Zenithr generierte Standardvorlage.<br>Hinweis: Löschen Sie den Bewertungslink nicht. Falls Sie ihn versehentlich gelöscht haben, klicken Sie auf die Standardschaltfläche."
      },
      {
        "language": "PT",
        "text": "Personalize o modelo de e-mail de lembrete para o candidato e o avaliador ou use o modelo padrão gerado pela Zenithr.<br>Dica: não apague o link da avaliação. Se apagado, clique no botão padrão."
      },
      {
        "language": "IT",
        "text": "Personalizza il template dell'email di promemoria per il candidato e il valutatore o usa quello predefinito di Zenithr. \nSuggerimento: Non eliminare il link dell'Assessment. Se eliminato, clicca sul pulsante predefinito."
      },
      {
        "language": "CS",
        "text": "Upravte šablonu e-mailu s připomenutím pro uchazeče a hodnotitele, nebo použijte výchozí šablonu vygenerovanou systémem Zenithr.<br>Tip: Odkaz na hodnocení nevymažte. Pokud jste jej omylem smazali, klikněte na tlačítko „Výchozí“."
      },
      {
        "language": "EN",
        "text": "Customize the reminder email template for the candidate and evaluator, or use the default template generated by Zenithr.<br>Hint: Do not erase the assessment link. If erased, click on the default button."
      }
    ]
  },
  {
    "key": "txt_Automated_desc",
    "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف 3 تذكيرات تلقائية كحد أقصى في تواريخ محددة لإرسال تذكيرات تلقائية للمستجيبين الذين لم يستكملوا التقييم."
      },
      {
        "language": "DE",
        "text": "Fügen Sie bis zu 3 automatische Erinnerungen zu bestimmten Terminen hinzu, um automatisch Erinnerungen an Befragte zu senden, die das Assessment noch nicht abgeschlossen haben."
      },
      {
        "language": "PT",
        "text": "Adicione até três lembretes automatizados em datas específicas para enviar lembretes automaticamente aos entrevistados que não concluíram a avaliação."
      },
      {
        "language": "IT",
        "text": "Aggiungi fino a 3 promemoria automatici in date specifiche per inviare automaticamente avvisi ai rispondenti che non hanno completato l'Assessment."
      },
      {
        "language": "CS",
        "text": "Nastavte až 3 automatické upomínky na konkrétní data, aby se automaticky zasílaly upomínky respondentům, kteří hodnocení nedokončili."
      },
      {
        "language": "EN",
        "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the assessment."
      }
    ]
  },
  {
    "key": "txt_Automated_813",
    "text": "Automated Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "التذكيرات التلقائية"
      },
      {
        "language": "DE",
        "text": "Automatische Erinnerungen"
      },
      {
        "language": "PT",
        "text": "Lembretes automatizados"
      },
      {
        "language": "IT",
        "text": "Promemoria automatici"
      },
      {
        "language": "CS",
        "text": "Automatické upomínky"
      },
      {
        "language": "EN",
        "text": "Automated Reminders"
      }
    ]
  },
  {
    "key": "txt_Setthecom_342",
    "text": "Set the completion date of your assessment!<br> Hint: You can extend the completion date after you send the invitations!",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ إكمال التقييم!<br> تلميح: يمكنك تمديد تاريخ الإكمال بعد إرسال الدعوات!"
      },
      {
        "language": "DE",
        "text": "Legen Sie das Abschlussdatum Ihrer Assessments fest!<br> Hinweis: Sie können das Abschlussdatum verlängern, nachdem Sie die Einladungen verschickt haben!"
      },
      {
        "language": "PT",
        "text": "Defina a data de conclusão da sua avaliação!<br> Dica: você pode estender a data de conclusão após enviar os convites!"
      },
      {
        "language": "IT",
        "text": "Imposta la data di completamento del tuo Assessment! \nSuggerimento: Puoi estendere la data di completamento dopo aver mandato gli inviti!"
      },
      {
        "language": "CS",
        "text": "Nastavte termín dokončení hodnocení!<br> Tip: Termín dokončení můžete prodloužit i po odeslání pozvánek!"
      },
      {
        "language": "EN",
        "text": "Set the completion date of your assessment!<br> Hint: You can extend the completion date after you send the invitations!"
      }
    ]
  },
  {
    "key": "txt_Assessmen_142",
    "text": "Assessment Deadline",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ إكمال التقييم"
      },
      {
        "language": "DE",
        "text": "Assessment Deadline"
      },
      {
        "language": "PT",
        "text": "Prazo de Avaliação"
      },
      {
        "language": "IT",
        "text": "Scadenza dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Termín odevzdání hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Deadline"
      }
    ]
  },
  {
    "key": "txt_timeframe_desc",
    "text": "In “<b>Timeframe</b>”, you set the assessment deadline in addition to automated reminders.",
    "translations": [
      {
        "language": "AR",
        "text": "في \"<b>المدة الزمنية</b>\"، يمكنك تحديد الإطار الزمني للتقييم بالإضافة إلى تذكيرات تلقائية لاستكمال التقييم."
      },
      {
        "language": "DE",
        "text": "Unter „<b>Zeitrahmen</b>“ legen Sie neben automatischen Erinnerungen auch die Deadline fest."
      },
      {
        "language": "PT",
        "text": "Em “<b>Prazo</b>”, você define o prazo da avaliação além dos lembretes automatizados."
      },
      {
        "language": "IT",
        "text": "In “Intervallo di tempo”, puoi impostare la scadenza dell'Assessment insieme ai promemoria automatici."
      },
      {
        "language": "CS",
        "text": "V části „<b>Časový rámec</b>“ nastavíte termín odevzdání hodnocení a také automatické upomínky."
      },
      {
        "language": "EN",
        "text": "In “<b>Timeframe</b>”, you set the assessment deadline in addition to automated reminders."
      }
    ]
  },
  {
    "key": "txt_Youarerea_647",
    "text": "You are ready to go to the next step!",
    "translations": [
      {
        "language": "AR",
        "text": "أنت جاهز للانتقال إلى الخطوة التالية!"
      },
      {
        "language": "DE",
        "text": "Sie sind bereit, mit dem nächsten Schritt fortzufahren!"
      },
      {
        "language": "PT",
        "text": "Você está pronto para ir para a próxima etapa!"
      },
      {
        "language": "IT",
        "text": "Sei pronto per il passaggio successivo!"
      },
      {
        "language": "CS",
        "text": "Jste připraveni přejít k dalšímu kroku!"
      },
      {
        "language": "EN",
        "text": "You are ready to go to the next step!"
      }
    ]
  },
  {
    "key": "txt_AddEvalua_desc",
    "text": "Click here to define each candidate’s evaluator and their relationship type from the dropdown menu.<br><br>Note: Each candidate must at least have 1 manager and 2 peers/team.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتحديد مقيم كل مرشح ونوع العلاقة من القائمة المنسدلة. <br><br>ملاحظة: يجب أن يكون لدى كل مرشح مدير واحد و 2 من الزملاء أو أعضاء الفريق كحد أدنى."
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um den Bewerter jedes Kandidaten und seinen Beziehungstyp aus dem Dropdown-Menü zu definieren.<br><br>Hinweis: Jeder Kandidat muss mindestens 1 Manager und 2 Kollegen/Team haben."
      },
      {
        "language": "PT",
        "text": "Clique aqui para definir o avaliador de cada candidato e seu tipo de relacionamento no menu suspenso.<br><br>Observação: Cada candidato deve ter pelo menos 1 gestor e 2 pares/equipe."
      },
      {
        "language": "IT",
        "text": "Clicca qui per definire ciascun valutatore per candidato e il tipo di relazione dal menu a tendina. \nNota: Ogni candidato deve avere almeno 1 manager e 2 colleghi/team."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a v rozevíracím menu vyberte hodnotitele pro každého kandidáta a typ jejich vztahu.<br><br>Poznámka: Každý respondent musí mít alespoň 1 nadřízeného a 2 kolegy/členy týmu."
      },
      {
        "language": "EN",
        "text": "Click here to define each candidate’s evaluator and their relationship type from the dropdown menu.<br><br>Note: Each candidate must at least have 1 manager and 2 peers/team."
      }
    ]
  },
  {
    "key": "txt_AddEvalua_785",
    "text": "Add Evaluator",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مقيّم"
      },
      {
        "language": "DE",
        "text": "Bewerter hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar avaliador"
      },
      {
        "language": "IT",
        "text": "Aggiungi un valutatore"
      },
      {
        "language": "CS",
        "text": "Přidat hodnotitele"
      },
      {
        "language": "EN",
        "text": "Add Evaluator"
      }
    ]
  },
  {
    "key": "txt_AddCandid_desc",
    "text": "To start adding candidates, click on <b>“Add Candidate”</b>.<br><br> Hint: We recommend adding by using Excel to save time and simplify your experience!",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة المستجيبين، انقر على <b>\"إضافة مرشح\"</b>. <br><br> تلميح: نوصي باستخدام ملف Excel لتوفير الوقت وتسهيل تجربتك!"
      },
      {
        "language": "DE",
        "text": "Um mit dem Hinzufügen von Kandidaten zu beginnen, klicken Sie auf <b>„Kandidat hinzufügen“</b>.<br><br> Hinweis: Wir empfehlen, mithilfe von Excel zu importieren, um Zeit zu sparen und den Prozess zu vereinfachen!"
      },
      {
        "language": "PT",
        "text": "Para começar a adicionar candidatos, clique em <b>“Adicionar Candidato”</b>.<br><br> Dica: Recomendamos adicionar usando o Excel para economizar tempo e simplificar sua experiência!"
      },
      {
        "language": "IT",
        "text": "Per iniziare ad aggiungere candidati, clicca su “Aggiungi un candidato”. \n\nSuggerimento: Consigliamo di usare Excel per risparmiare tempo e semplificare l'operazione!"
      },
      {
        "language": "CS",
        "text": "Chcete-li začít přidávat respondenty, klikněte na <b>„Přidat respondenta“</b>.<br><br> Tip: Pro úsporu času a zjednodušení práce doporučujeme přidávat respondenty pomocí aplikace Excel!"
      },
      {
        "language": "EN",
        "text": "To start adding candidates, click on <b>“Add Candidate”</b>.<br><br> Hint: We recommend adding by using Excel to save time and simplify your experience!"
      }
    ]
  },
  {
    "key": "txt_AddCandid_200",
    "text": "Add Candidate",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مرشح"
      },
      {
        "language": "DE",
        "text": "Kandidaten hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar candidato"
      },
      {
        "language": "IT",
        "text": "Aggiungi un candidato"
      },
      {
        "language": "CS",
        "text": "Přidat uchazeče"
      },
      {
        "language": "EN",
        "text": "Add Candidate"
      }
    ]
  },
  {
    "key": "txtCandidates_desc",
    "text": "In the <b>“Candidates”</b> page, you add the Respondents (Candidates & Evaluators) you want to invite to the assessment manually, by Excel file, or from your respondent pool.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"المرشحون\"</b>، يمكنك إضافة المستجيبين (المرشحون والمقيّمون) الذين ترغب في دعوتهم للتقييم يدوياً أو عبر ملف Excel أو من خلال مجموعة المستجيبين الخاصة بك."
      },
      {
        "language": "DE",
        "text": "Auf der Seite <b>„Kandidaten“</b> fügen Sie die Teilnehmer (Kandidaten und Bewerter) hinzu, die Sie manuell, per Excel-Datei oder aus Ihrem Teilnehmerpool zur Bewertung einladen möchten."
      },
      {
        "language": "PT",
        "text": "Na página <b>“Candidatos”</b>, você adiciona os respondentes (candidatos e avaliadores) que deseja convidar para a avaliação manualmente, por arquivo Excel ou do seu grupo de respondentes."
      },
      {
        "language": "IT",
        "text": "Nella pagina “Candidati”, aggiungi i rispondenti (Candidati e Valutatori) che desideri invitare alla compilazione dell'Assessment manualmente, tramite file Excel, o dal tuo pool di rispondenti."
      },
      {
        "language": "CS",
        "text": "Na stránce <b>„Respondenti“</b> přidáte respondenty (kandidáty a hodnotitele), které chcete pozvat k hodnocení, a to ručně, prostřednictvím souboru Excel nebo z vašeho seznamu respondentů."
      },
      {
        "language": "EN",
        "text": "In the <b>“Candidates”</b> page, you add the Respondents (Candidates & Evaluators) you want to invite to the assessment manually, by Excel file, or from your respondent pool."
      }
    ]
  },
  {
    "key": "txt_Togglethe_828",
    "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the assessment.<br><img class=\"mt-2\" src=\"assets/img/tours/assessment-res-info.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "ققم بتفعيل هذا الخيار في حال كنت تريد من المستجيبين أن يقوموا بتعبئة المعلومات من المعايير المختارة أعلاه أثناء التقييم.<br/><img class=\"mt-2\" src=\"assets/img/tours/assessment-res-info.gif\" />"
      },
      {
        "language": "DE",
        "text": "Aktivieren Sie diese Option, wenn Ihre Befragten beim Durchführen der Bewertung die Informationen aus den oben ausgewählten Kriterien eingeben sollen.<br><img class=\"mt-2\" src=\"assets/img/tours/assessment-res-info.gif\" />"
      },
      {
        "language": "PT",
        "text": "Ative esta opção se quiser que seus entrevistados preencham as informações dos critérios selecionados acima durante a avaliação.<br><img class=\"mt-2\" src=\"assets/img/tours/assessment-res-info.gif\" />"
      },
      {
        "language": "IT",
        "text": "Attiva questa opzione se desideri che i rispondenti compilino le informazioni in base ai criteri selezionati durante l'Assessment.\n<img class=\"mt-2\" src=\"assets/img/tours/assessment-res-info.gif\" />"
      },
      {
        "language": "CS",
        "text": "Tuto možnost zapněte, pokud chcete, aby respondenti při vyplňování dotazníku zadávali údaje podle výše vybraných kritérií.<br><img class=\"mt-2\" src=\"assets/img/tours/assessment-res-info.gif\" />"
      },
      {
        "language": "EN",
        "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the assessment.<br><img class=\"mt-2\" src=\"assets/img/tours/assessment-res-info.gif\" />"
      }
    ]
  },
  {
    "key": "txt_analytical_criteria_desc",
    "text": "In <b>“Analytical Criteria”</b>, you select the criteria based on your preference as a filter for the analysis.<br><br> Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive detailed analysis and comparison!",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"المعايير التحليلية\"</b>، يمكنك اختيار المعايير استنادًا إلى تفضيلاتك لعرض التحليلات المفصلة. <br><br>تلميح: كلما قمت باختيار معايير أكثركلما زادت تفاصيل تقاريرنا، مما يوفر لك تحليلًا مفصلًا شاملاً ومقارنًا!"
      },
      {
        "language": "DE",
        "text": "Unter <b>„Analysekriterien“</b> wählen Sie die Kriterien nach Ihren Wünschen als Filter für die Analyse aus.<br><br> Tipp: Je mehr Kriterien Sie auswählen, desto tiefer gehen unsere Berichte und bieten Ihnen eine umfassende Detailanalyse und einen Vergleich!"
      },
      {
        "language": "PT",
        "text": "Em <b>“Critérios Analíticos”</b>, você seleciona os critérios com base em sua preferência como um filtro para a análise.<br><br> Dica: à medida que você expande sua seleção de critérios, nossos relatórios se aprofundam, fornecendo uma análise e comparação abrangente e detalhada!"
      },
      {
        "language": "IT",
        "text": "In “Criteri analitici”, selezioni i criteri in base alle tue preferenze come filtro per l'analisi. \n\nSuggerimento: Ampliando i criteri selezionati, i nostri report si arricchiscono di approfondimenti, offrendoti un’analisi completa e dettagliata con confronti mirati."
      },
      {
        "language": "CS",
        "text": "V části <b>„Analytická kritéria“</b> si vyberete kritéria podle svých preferencí, která budou sloužit jako filtr pro analýzu.<br><br> Tip: Čím více kritérií vyberete, tím podrobnější budou naše zprávy a tím komplexnější a detailnější analýzu a srovnání vám poskytnou!"
      },
      {
        "language": "EN",
        "text": "In <b>“Analytical Criteria”</b>, you select the criteria based on your preference as a filter for the analysis.<br><br> Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive detailed analysis and comparison!"
      }
    ]
  },
  {
    "key": "SaveTemplate_desc",
    "text": "Click <b>“Save Template”</b> to save and start using your template!",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"حفظ النموذج\"</b> للحفظ والبدء في استخدام النموذج الخاص بك."
      },
      {
        "language": "DE",
        "text": "Klicken Sie auf <b>„Vorlage speichern“</b>, um Ihre Vorlage zu speichern und zu verwenden!"
      },
      {
        "language": "PT",
        "text": "Clique em <b>“Salvar modelo”</b> para salvar e começar a usar seu modelo!"
      },
      {
        "language": "IT",
        "text": "Clicca su “Salva il template” per salvare e iniziare a utilizzare il tuo template!"
      },
      {
        "language": "CS",
        "text": "Klikněte na <b>„Uložit šablonu“</b>, abyste šablonu uložili a mohli ji začít používat!"
      },
      {
        "language": "EN",
        "text": "Click <b>“Save Template”</b> to save and start using your template!"
      }
    ]
  },
  {
    "key": "txtAddCompetency_desc",
    "text": "Click “<b>Add Competency</b>” to add competencies and their corresponding definition!",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على  \"<b>إضافة جدارة ومهارة</b>\" لإضافة الجدارات والمهارات والتعريف الخاص بهم!"
      },
      {
        "language": "DE",
        "text": "Klicken Sie auf „<b>Kompetenz hinzufügen</b>“, um Kompetenzen und die entsprechende Definition hinzuzufügen!"
      },
      {
        "language": "PT",
        "text": "Clique em “<b>Adicionar Competência</b>” para adicionar competências e sua definição correspondente!"
      },
      {
        "language": "IT",
        "text": "Clicca su “Aggiungi una competenza” per aggiungere competenze e la loro relativa definizione!"
      },
      {
        "language": "CS",
        "text": "Klikněte na „<b>Přidat kompetenci</b>“, abyste přidali kompetence a jejich definice!"
      },
      {
        "language": "EN",
        "text": "Click “<b>Add Competency</b>” to add competencies and their corresponding definition!"
      }
    ]
  },
  {
    "key": "txt_Youhaveth_928",
    "text": "You have the flexibility to assign weights to competencies according to their importance to your organization! <br>Note: Weights are automatically distributed equally to a total of 100%.",
    "translations": [
      {
        "language": "AR",
        "text": "لديك المرونة في تعيين أوزان للجدارات والمهارات وفقاُ لأهميتها لمؤسستك! <br>ملحوظة: يتم توزيع الأوزان بشكل متساوي تلقائياً إلى إجمالي 100%."
      },
      {
        "language": "DE",
        "text": "Sie haben die Möglichkeit, Kompetenzen entsprechend ihrer Bedeutung für Ihr Unternehmen zu gewichten! <br>Hinweis: Die Gewichtungen werden automatisch gleichmäßig auf insgesamt 100 % verteilt."
      },
      {
        "language": "PT",
        "text": "Você tem flexibilidade para atribuir pesos às competências de acordo com sua importância para sua organização! <br>Nota: Os pesos são automaticamente distribuídos igualmente até um total de 100%."
      },
      {
        "language": "IT",
        "text": "Hai la possibilità di attribuire dei pesi alle competenze in base alla loro importanza per la tua organizzazione!\nNota: I pesi vengono distribuiti automaticamente in modo uniforme fino a raggiungere un totale del 100%."
      },
      {
        "language": "CS",
        "text": "Máte možnost přiřadit jednotlivým kompetencím váhu podle toho, jak jsou pro vaši organizaci důležité! <br>Poznámka: Váhy se automaticky rovnoměrně rozdělí tak, aby jejich součet činil 100 %."
      },
      {
        "language": "EN",
        "text": "You have the flexibility to assign weights to competencies according to their importance to your organization! <br>Note: Weights are automatically distributed equally to a total of 100%."
      }
    ]
  },
  {
    "key": "txt_AssignWei_241",
    "text": "Assign Weight",
    "translations": [
      {
        "language": "AR",
        "text": "تعيين الوزن"
      },
      {
        "language": "DE",
        "text": "Gewichtung zuweisen"
      },
      {
        "language": "PT",
        "text": "Atribuir peso"
      },
      {
        "language": "IT",
        "text": "Assegna il peso"
      },
      {
        "language": "CS",
        "text": "Přiřadit váhu"
      },
      {
        "language": "EN",
        "text": "Assign Weight"
      }
    ]
  },
  {
    "key": "txt_Clickhere_582",
    "text": "Click here to view the statements under each competency and add custom statements by clicking <b>“Add Statement”</b>! <br><br>Hint: You can add custom statements to predefined competencies.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض العبارات تحت كل جدارة ومهارة وقم بإضافة عبارات مخصصة من خلال النقر على <b>\"إضافة عبارة\"</b>. <br><br>تلميح: باستطاعك إضافة عبارات مخصصة تحت الجدارات والمهارات المُعرفة مسبقاً."
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Aussagen zu jeder Kompetenz anzuzeigen und benutzerdefinierte Aussagen hinzuzufügen, indem Sie auf <b>„Erklärung hinzufügen“ klicken</b>! <br><br>Hinweis: Sie können benutzerdefinierte Aussagen zu vordefinierten Kompetenzen hinzufügen."
      },
      {
        "language": "PT",
        "text": "Clique aqui para visualizar as declarações de cada competência e adicionar declarações personalizadas clicando em <b>“Adicionar Declaração”</b>! <br><br>Dica: você pode adicionar declarações personalizadas a competências predefinidas."
      },
      {
        "language": "IT",
        "text": "Clicca qui per visualizzare le affermazioni sotto ogni competenza e aggiungine di personalizzate cliccando su “Aggiungi un'affermazione”! \n\n\nSuggerimento: Puoi aggiungere affermazioni personalizzate anche alle competenze predefinite."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, abyste si prohlédli popisy u jednotlivých kompetencí, a přidejte vlastní popisy kliknutím na <b>„Přidat popis“</b>! <br><br>Tip: K předdefinovaným kompetencím můžete přidávat vlastní popisy."
      },
      {
        "language": "EN",
        "text": "Click here to view the statements under each competency and add custom statements by clicking <b>“Add Statement”</b>! <br><br>Hint: You can add custom statements to predefined competencies."
      }
    ]
  },
  {
    "key": "txt_ViewState_966",
    "text": "View Statements",
    "translations": [
      {
        "language": "AR",
        "text": "عرض العبارات"
      },
      {
        "language": "DE",
        "text": "Aussagen anzeigen"
      },
      {
        "language": "PT",
        "text": "Ver declarações"
      },
      {
        "language": "IT",
        "text": "Visualizza le affermazioni"
      },
      {
        "language": "CS",
        "text": "Zobrazit výpisy"
      },
      {
        "language": "EN",
        "text": "View Statements"
      }
    ]
  },
  {
    "key": "txt_Clickhere_189",
    "text": "Click here to select the competencies you want to include in your template.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لاختيار الجدارات والمهارات التي تريد تضمينها في النموذج الخاص بك."
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Kompetenzen auszuwählen, die Sie in Ihre Vorlage aufnehmen möchten."
      },
      {
        "language": "PT",
        "text": "Clique aqui para selecionar as competências que deseja incluir em seu modelo."
      },
      {
        "language": "IT",
        "text": "Clicca qui per selezionare le competenze da includere nel tuo template."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a vyberte kompetence, které chcete zahrnout do své šablony."
      },
      {
        "language": "EN",
        "text": "Click here to select the competencies you want to include in your template."
      }
    ]
  },
  {
    "key": "txt_SelectCom_841",
    "text": "Select Competency",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الجدارة والمهارة"
      },
      {
        "language": "DE",
        "text": "Wählen Sie Kompetenz aus"
      },
      {
        "language": "PT",
        "text": "Selecione Competência"
      },
      {
        "language": "IT",
        "text": "Seleziona una competenza"
      },
      {
        "language": "CS",
        "text": "Vyberte kompetenci"
      },
      {
        "language": "EN",
        "text": "Select Competency"
      }
    ]
  },
  {
    "key": "txtCategories_desc",
    "text": "Here you can view the categories and explore competencies.",
    "translations": [
      {
        "language": "AR",
        "text": "من هنا يمكنك عرض التصنيفات والاطلاع على الجدارات والمهارات."
      },
      {
        "language": "DE",
        "text": "Hier können Sie die Kategorien einsehen und Kompetenzen erkunden."
      },
      {
        "language": "PT",
        "text": "Aqui você pode visualizar as categorias e explorar competências."
      },
      {
        "language": "IT",
        "text": "Qui puoi visualizzare le categorie e approfondire le competenze."
      },
      {
        "language": "CS",
        "text": "Zde si můžete prohlédnout kategorie a seznámit se s jednotlivými kompetencemi."
      },
      {
        "language": "EN",
        "text": "Here you can view the categories and explore competencies."
      }
    ]
  },
  {
    "key": "txt_Fillinyou_596",
    "text": "Fill in your template title.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان النموذج."
      },
      {
        "language": "DE",
        "text": "Geben Sie den Titel Ihrer Vorlage ein."
      },
      {
        "language": "PT",
        "text": "Preencha o título do seu modelo."
      },
      {
        "language": "IT",
        "text": "Inserisci il titolo del tuo template."
      },
      {
        "language": "CS",
        "text": "Zadejte název šablony."
      },
      {
        "language": "EN",
        "text": "Fill in your template title."
      }
    ]
  },
  {
    "key": "txt_Nextstep_435",
    "text": "Next step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      },
      {
        "language": "DE",
        "text": "Nächster Schritt!"
      },
      {
        "language": "PT",
        "text": "Próximo passo!"
      },
      {
        "language": "IT",
        "text": "Prossimo passaggio!"
      },
      {
        "language": "CS",
        "text": "Další krok!"
      },
      {
        "language": "EN",
        "text": "Next step!"
      }
    ]
  },
  {
    "key": "txt_Clickhere_127",
    "text": "Click here to view the selected template in the builder format.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض النموذج المختار في صيغة إعدادات النموذج. "
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die ausgewählte Vorlage im Builder-Format anzuzeigen."
      },
      {
        "language": "PT",
        "text": "Clique aqui para visualizar o modelo selecionado no formato construtor."
      },
      {
        "language": "IT",
        "text": "Clicca qui per visualizzare il template selezionato in formato builder."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a zobrazte vybranou šablonu ve formátu editoru."
      },
      {
        "language": "EN",
        "text": "Click here to view the selected template in the builder format."
      }
    ]
  },
  {
    "key": "txt_Clickhere_467",
    "text": "Click here to edit your template.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتعديل النموذج."
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um Ihre Vorlage zu bearbeiten."
      },
      {
        "language": "PT",
        "text": "Clique aqui para editar seu modelo."
      },
      {
        "language": "IT",
        "text": "Clicca qui per modificare il tuo template."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a upravte svou šablonu."
      },
      {
        "language": "EN",
        "text": "Click here to edit your template."
      }
    ]
  },
  {
    "key": "txtCreateTemplate_desc",
    "text": "Unlock the power of customization with your very own template, where you can tailor competencies and statements to match your unique needs!",
    "translations": [
      {
        "language": "AR",
        "text": "استفد من خاصية التخصيص من خلال إنشاء نموذج خاص بك حيث يمكنك إضافة الجدارات والمهارات والعبارات لتتناسب مع أهدافك الفريدة!"
      },
      {
        "language": "DE",
        "text": "Nutzen Sie die Möglichkeiten der Individualisierung mit Ihrer ganz eigenen Vorlage, in der Sie Kompetenzen und Aussagen an Ihre individuellen Bedürfnisse anpassen können!"
      },
      {
        "language": "PT",
        "text": "Desbloqueie o poder da personalização com seu próprio modelo, onde você pode adaptar competências e declarações para atender às suas necessidades exclusivas!"
      },
      {
        "language": "IT",
        "text": "Sfrutta le potenzialità della personalizzazione attraverso il tuo template dedicato, dove puoi adattare le competenze e le affermazioni in base alle tue specifiche esigenze!"
      },
      {
        "language": "CS",
        "text": "Využijte možnosti přizpůsobení pomocí vlastní šablony, ve které si můžete kompetence a popisy přizpůsobit tak, aby odpovídaly vašim konkrétním potřebám!"
      },
      {
        "language": "EN",
        "text": "Unlock the power of customization with your very own template, where you can tailor competencies and statements to match your unique needs!"
      }
    ]
  },
  {
    "key": "txt_Clickhere_352",
    "text": "Click here to view and download the competencies and statements for each template. <br><br>Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض وتحميل الجدارات والمهارات والعبارات الخاصة بكل نموذج.<br><br> ملحوظة: متوفر بصيغة PDF."
      },
      {
        "language": "DE",
        "text": "Klicken Sie hier, um die Kompetenzen und Aussagen für jede Vorlage anzuzeigen und herunterzuladen. <br><br>Hinweis: Im PDF-Format verfügbar."
      },
      {
        "language": "PT",
        "text": "Clique aqui para visualizar e baixar as competências e declarações de cada modelo. <br><br>Nota: Disponível em formato PDF."
      },
      {
        "language": "IT",
        "text": "Clicca qui per visualizzare e scaricare le competenze e le affermazioni di ogni template. \n\n\nNota: Disponibile in formato PDF."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, abyste si prohlédli a stáhli kompetence a popisy pro jednotlivé šablony. <br><br>Poznámka: K dispozici ve formátu PDF."
      },
      {
        "language": "EN",
        "text": "Click here to view and download the competencies and statements for each template. <br><br>Note: Available in PDF format."
      }
    ]
  },
  {
    "key": "txt_Youhaveth_523",
    "text": "You have the option to select from Zenithr’s predefined templates!",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك الاختيار من نماذج زينثر المُعرفة مسبقاً!"
      },
      {
        "language": "DE",
        "text": "Sie haben die Möglichkeit, aus den vordefinierten Vorlagen von Zenithr auszuwählen!"
      },
      {
        "language": "PT",
        "text": "Você tem a opção de selecionar um dos modelos predefinidos do Zenithr!"
      },
      {
        "language": "IT",
        "text": "Puoi scegliere tra i template predefiniti di Zenithr!"
      },
      {
        "language": "CS",
        "text": "Máte možnost vybrat si z předdefinovaných šablon služby Zenithr!"
      },
      {
        "language": "EN",
        "text": "You have the option to select from Zenithr’s predefined templates!"
      }
    ]
  },
  {
    "key": "txt_translation_desc",
    "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام  بالمهمة بالنياية عنك!"
      },
      {
        "language": "DE",
        "text": " Übersetzen Sie Text manuell mit einem Klick auf „🌐“ oder „✨“ und überlassen Sie die Arbeit unserem magischen KI-Tool!"
      },
      {
        "language": "PT",
        "text": "Traduza o texto manualmente com um clique em “🌐” ou “✨” e deixe nossa ferramenta mágica de IA fazer o trabalho para você!"
      },
      {
        "language": "IT",
        "text": "Traduci il testo manualmente cliccando su “🌐” o “✨” e lascia che il nostro magico strumento di AI faccia il lavoro per te!"
      },
      {
        "language": "CS",
        "text": "Přeložte text ručně kliknutím na „🌐“ nebo „✨“ a nechte naši kouzelnou AI, aby to za vás zařídila!"
      },
      {
        "language": "EN",
        "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you! "
      }
    ]
  },
  {
    "key": "txt_Translati_697",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      },
      {
        "language": "DE",
        "text": "Übersetzung"
      },
      {
        "language": "PT",
        "text": "Tradução"
      },
      {
        "language": "IT",
        "text": "Traduzione"
      },
      {
        "language": "CS",
        "text": "Překlad"
      },
      {
        "language": "EN",
        "text": "Translation"
      }
    ]
  },
  {
    "key": "txtAssessmentDetails_desc",
    "text": "Fill in your assessment \"Title\".<br> You can add a description as well.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان التقييم. <br> يمكنك أيضاً إضافة وصف للتقييم."
      },
      {
        "language": "DE",
        "text": "Geben Sie den „Titel“ Ihrer Bewertung ein.<br> Sie können auch eine Beschreibung hinzufügen."
      },
      {
        "language": "PT",
        "text": "Preencha sua avaliação \"Título\".<br> Você também pode adicionar uma descrição."
      },
      {
        "language": "IT",
        "text": "Compila il campo \"Titolo\" del tuo Assessment. \nPuoi aggiungere anche una descrizione."
      },
      {
        "language": "CS",
        "text": "Zadejte „název“ svého hodnocení. <br> Můžete přidat i popis."
      },
      {
        "language": "EN",
        "text": "Fill in your assessment \"Title\".<br> You can add a description as well."
      }
    ]
  },
  {
    "key": "txtAssessmentDetails",
    "text": "Assessment Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل التقييم"
      },
      {
        "language": "DE",
        "text": "Assessment Details"
      },
      {
        "language": "PT",
        "text": "Detalhes da avaliação"
      },
      {
        "language": "IT",
        "text": "Dettagli dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Podrobnosti o hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Details"
      }
    ]
  },
  {
    "key": "txtAssessmentInfo_desc",
    "text": "In <b>“Assessment Information”</b>, you specify the main elements, including the assessment title and assessment template, which includes the competencies & statements!",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"معلومات التقييم\"</b> تُحدد العناصر الرئيسية، بما في ذلك عنوان التقييم ونموذج التقييم والذي يتضمن الجدارات والمهارات والعبارات!"
      },
      {
        "language": "DE",
        "text": "Unter <b>„Assessment-informationen“</b> geben Sie die wichtigsten Elemente an, darunter den Assessmenttitel und die Assessmentvorlage, die die Kompetenzen und Aussagen enthält!"
      },
      {
        "language": "PT",
        "text": "Em <b>“Informações da Avaliação”</b>, você especifica os elementos principais, incluindo o título da avaliação e o modelo de avaliação, que inclui as competências e declarações!"
      },
      {
        "language": "IT",
        "text": "In “Informazioni sull'Assessment”, specifici gli elementi principali, inclusi il titolo e il template, che comprende le competenze e le affermazioni!"
      },
      {
        "language": "CS",
        "text": "V části <b>„Informace o hodnocení“</b> zadáte hlavní prvky, včetně názvu hodnocení a šablony hodnocení, která obsahuje kompetence a popisy!"
      },
      {
        "language": "EN",
        "text": "In <b>“Assessment Information”</b>, you specify the main elements, including the assessment title and assessment template, which includes the competencies & statements!"
      }
    ]
  },
  {
    "key": "txtLive",
    "text": "Live",
    "translations": [
      {
        "language": "AR",
        "text": "مباشر"
      },
      {
        "language": "DE",
        "text": "Live"
      },
      {
        "language": "PT",
        "text": "Ao vivo"
      },
      {
        "language": "IT",
        "text": "Attivo"
      },
      {
        "language": "CS",
        "text": "Živě"
      },
      {
        "language": "EN",
        "text": "Live"
      }
    ]
  },
  {
    "key": "txt_Closed_367",
    "text": "Closed",
    "translations": [
      {
        "language": "AR",
        "text": "مغلق"
      },
      {
        "language": "DE",
        "text": "Abgeschlossen"
      },
      {
        "language": "PT",
        "text": "Fechado"
      },
      {
        "language": "IT",
        "text": "Chiuso"
      },
      {
        "language": "CS",
        "text": "Zavřeno"
      },
      {
        "language": "EN",
        "text": "Closed"
      }
    ]
  },
  {
    "key": "txtClear",
    "text": "Clear",
    "translations": [
      {
        "language": "AR",
        "text": "مسح"
      },
      {
        "language": "DE",
        "text": "Löschen"
      },
      {
        "language": "PT",
        "text": "Claro"
      },
      {
        "language": "IT",
        "text": "Cancella"
      },
      {
        "language": "CS",
        "text": "Vymazat"
      },
      {
        "language": "EN",
        "text": "Clear"
      }
    ]
  },
  {
    "key": "txtNotApplicable",
    "text": "Not applicable",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      },
      {
        "language": "DE",
        "text": "Nicht zutreffend."
      },
      {
        "language": "PT",
        "text": "Não aplicável"
      },
      {
        "language": "IT",
        "text": "Non applicabile"
      },
      {
        "language": "CS",
        "text": "Neplatí"
      },
      {
        "language": "EN",
        "text": "Not applicable"
      }
    ]
  },
  {
    "key": "txtRatingScaleDesc",
    "text": "The rating scale determines how the statements were rated and what each score represents.",
    "translations": [
      {
        "language": "AR",
        "text": "يحدد مقياس التقييم آلية تقييم العبارات والأسئلة وماذا تمثل النتائج التي تم الحصول عليها."
      },
      {
        "language": "DE",
        "text": "Die Bewertungsskala legt fest, wie die Aussagen bewertet wurden und was die einzelnen Punktzahlen aussagen."
      },
      {
        "language": "PT",
        "text": "A escala de avaliação determina como as afirmações foram avaliadas e o que cada pontuação representa."
      },
      {
        "language": "IT",
        "text": "La scala di valutazione determina il criterio di attribuzione dei punteggi alle affermazioni e il significato di ciascun punteggio"
      },
      {
        "language": "CS",
        "text": "Hodnotící stupnice určuje, jak byly jednotlivé výroky ohodnoceny a co jednotlivé skóre znamenají."
      },
      {
        "language": "EN",
        "text": "The rating scale determines how the statements were rated and what each score represents."
      }
    ]
  },
  {
    "key": "txt_RatingScale",
    "text": "Rating Scale",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس التقييم"
      },
      {
        "language": "DE",
        "text": "Bewertungsskala"
      },
      {
        "language": "PT",
        "text": "Escala de avaliação"
      },
      {
        "language": "IT",
        "text": "Scala di valutazione"
      },
      {
        "language": "CS",
        "text": "Hodnotící stupnice"
      },
      {
        "language": "EN",
        "text": "Rating Scale"
      }
    ]
  },
  {
    "key": "GOODEXP",
    "text": "Good Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة جيدة"
      },
      {
        "language": "DE",
        "text": "Gute Erfahrung"
      },
      {
        "language": "PT",
        "text": "Boa experiência"
      },
      {
        "language": "IT",
        "text": "Buona esperienza"
      },
      {
        "language": "CS",
        "text": "Příjemná zkušenost"
      },
      {
        "language": "EN",
        "text": "Good Experience"
      }
    ]
  },
  {
    "key": "VERYGOODEXP",
    "text": "Very Good Experience\t",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة جيدة للغاية"
      },
      {
        "language": "DE",
        "text": " Sehr gute Erfahrung"
      },
      {
        "language": "PT",
        "text": "Experiência muito boa"
      },
      {
        "language": "IT",
        "text": "Ottima esperienza"
      },
      {
        "language": "CS",
        "text": "Velmi dobrá zkušenost"
      },
      {
        "language": "EN",
        "text": "Very Good Experience\t"
      }
    ]
  },
  {
    "key": "txt_CloseCand_365",
    "text": "Close Candidate",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق المرشح"
      },
      {
        "language": "DE",
        "text": "Kandidat schließen"
      },
      {
        "language": "PT",
        "text": "Fechar Candidato"
      },
      {
        "language": "IT",
        "text": "Chiudi il candidato"
      },
      {
        "language": "CS",
        "text": "Zavřít profil respondenta"
      },
      {
        "language": "EN",
        "text": "Close Candidate"
      }
    ]
  },
  {
    "key": "txt_candidate_closed",
    "text": "This candidate will now be closed and you will no longer be able make any changes related to his evaluation.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إغلاق هذا المرشح ولن تتمكن من إجراء أي تغييرات تتعلق بتقييمه."
      },
      {
        "language": "DE",
        "text": "Dieser Kandidat wird nun geschlossen und Sie können keine Änderungen mehr an seiner Bewertung vornehmen."
      },
      {
        "language": "PT",
        "text": "Este candidato será encerrado e você não poderá mais fazer alterações relacionadas à avaliação dele."
      },
      {
        "language": "IT",
        "text": "Questo candidato ora verrà chiuso e non sarà più possibile apportare modifiche alla sua valutazione."
      },
      {
        "language": "CS",
        "text": "Tento kandidát bude nyní uzavřen a již nebudete moci provádět žádné změny týkající se jeho hodnocení."
      },
      {
        "language": "EN",
        "text": "This candidate will now be closed and you will no longer be able make any changes related to his evaluation."
      }
    ]
  },
  {
    "key": "txtNoPermissonToAccess",
    "text": "Permission Required To Access This Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "مطلوب ترخيص للسماح في الدخول إلى الصفحة"
      },
      {
        "language": "DE",
        "text": "Für den Zugriff auf dieses Assessment ist eine Berechtigung erforderlich"
      },
      {
        "language": "PT",
        "text": "Permissão necessária para acessar esta avaliação"
      },
      {
        "language": "IT",
        "text": "Autorizzazione richiesta per accedere a questo Assessment"
      },
      {
        "language": "CS",
        "text": "K přístupu k tomuto hodnocení je nutné povolení"
      },
      {
        "language": "EN",
        "text": "Permission Required To Access This Assessment"
      }
    ]
  },
  {
    "key": "txtNoPermissonToAccessEntity",
    "text": "Permission Required To Access This Entity",
    "translations": [
      {
        "language": "AR",
        "text": "مطلوب ترخيص للسماح في الدخول الى الوحدة"
      },
      {
        "language": "DE",
        "text": "Für den Zugriff ist eine Berechtigung erforderlich"
      },
      {
        "language": "PT",
        "text": "Permissão necessária para acessar esta entidade"
      },
      {
        "language": "IT",
        "text": "Autorizzazione richiesta per accedere a questo livello organizzativo"
      },
      {
        "language": "CS",
        "text": "K přístupu k této entitě je vyžadováno oprávnění"
      },
      {
        "language": "EN",
        "text": "Permission Required To Access This Entity"
      }
    ]
  },
  {
    "key": "txtAverage",
    "text": "Average",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط"
      },
      {
        "language": "DE",
        "text": "Durchschnitt"
      },
      {
        "language": "PT",
        "text": "Média"
      },
      {
        "language": "IT",
        "text": "Media"
      },
      {
        "language": "CS",
        "text": "Průměr"
      },
      {
        "language": "EN",
        "text": "Average"
      }
    ]
  },
  {
    "key": "btn_next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "DE",
        "text": "Nächster"
      },
      {
        "language": "PT",
        "text": "Próximo"
      },
      {
        "language": "IT",
        "text": "Avanti"
      },
      {
        "language": "CS",
        "text": "Další"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "btn_previous",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      },
      {
        "language": "DE",
        "text": "Vorherige"
      },
      {
        "language": "PT",
        "text": "Anterior"
      },
      {
        "language": "IT",
        "text": "Indietro"
      },
      {
        "language": "CS",
        "text": "Předchozí"
      },
      {
        "language": "EN",
        "text": "Previous"
      }
    ]
  },
  {
    "key": "txtPoweredby",
    "text": "Powered by:",
    "translations": [
      {
        "language": "AR",
        "text": "مشغّل بواسطة"
      },
      {
        "language": "DE",
        "text": "Powered by:"
      },
      {
        "language": "PT",
        "text": "Distribuído por:"
      },
      {
        "language": "IT",
        "text": "Offerto da:"
      },
      {
        "language": "CS",
        "text": "Provozuje:"
      },
      {
        "language": "EN",
        "text": "Powered by:"
      }
    ]
  },
  {
    "key": "txtExportReport",
    "text": "Download Report",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "DE",
        "text": "Bericht herunterladen"
      },
      {
        "language": "PT",
        "text": "Baixar relatório"
      },
      {
        "language": "IT",
        "text": "Scarica il report"
      },
      {
        "language": "CS",
        "text": "Stáhnout zprávu"
      },
      {
        "language": "EN",
        "text": "Download Report"
      }
    ]
  },
  {
    "key": "txt_comment",
    "text": "Comment",
    "translations": [
      {
        "language": "AR",
        "text": "تعليق"
      },
      {
        "language": "DE",
        "text": "Kommentar"
      },
      {
        "language": "PT",
        "text": "Comentário"
      },
      {
        "language": "IT",
        "text": "Commento"
      },
      {
        "language": "CS",
        "text": "Komentář"
      },
      {
        "language": "EN",
        "text": "Comment"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة"
      },
      {
        "language": "DE",
        "text": "Überblick"
      },
      {
        "language": "PT",
        "text": "Visão geral"
      },
      {
        "language": "IT",
        "text": "Panoramica"
      },
      {
        "language": "CS",
        "text": "Přehled"
      },
      {
        "language": "EN",
        "text": "Overview"
      }
    ]
  },
  {
    "key": "txtComment",
    "text": "Comment",
    "translations": [
      {
        "language": "AR",
        "text": "تعليق"
      },
      {
        "language": "DE",
        "text": "Kommentar"
      },
      {
        "language": "PT",
        "text": "Comentário"
      },
      {
        "language": "IT",
        "text": "Commento"
      },
      {
        "language": "CS",
        "text": "Komentář"
      },
      {
        "language": "EN",
        "text": "Comment"
      }
    ]
  },
  {
    "key": "txt_response_rate",
    "text": "Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة الكلي"
      },
      {
        "language": "DE",
        "text": "Antwortrate"
      },
      {
        "language": "PT",
        "text": "Taxa de resposta"
      },
      {
        "language": "IT",
        "text": "Tasso di risposta"
      },
      {
        "language": "CS",
        "text": "Míra odezvy"
      },
      {
        "language": "EN",
        "text": "Response Rate"
      }
    ]
  },
  {
    "key": "txtExportCommentsUnavailable",
    "text": "Comments Unavailable",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات غير متاحة"
      },
      {
        "language": "DE",
        "text": "Kommentare nicht verfügbar"
      },
      {
        "language": "PT",
        "text": "Comentários indisponíveis"
      },
      {
        "language": "IT",
        "text": "Commenti non disponibili"
      },
      {
        "language": "CS",
        "text": "Komentáře nejsou k dispozici"
      },
      {
        "language": "EN",
        "text": "Comments Unavailable"
      }
    ]
  },
  {
    "key": "txtAll",
    "text": "All",
    "translations": [
      {
        "language": "AR",
        "text": "الكل"
      },
      {
        "language": "DE",
        "text": "Alle"
      },
      {
        "language": "PT",
        "text": "Todos"
      },
      {
        "language": "IT",
        "text": "Tutti"
      },
      {
        "language": "CS",
        "text": "Vše"
      },
      {
        "language": "EN",
        "text": "All"
      }
    ]
  },
  {
    "key": "txtManagers",
    "text": "Managers",
    "translations": [
      {
        "language": "AR",
        "text": "المدراء"
      },
      {
        "language": "DE",
        "text": "Manager"
      },
      {
        "language": "PT",
        "text": "Gerentes"
      },
      {
        "language": "IT",
        "text": "Manager"
      },
      {
        "language": "CS",
        "text": "Manažeři"
      },
      {
        "language": "EN",
        "text": "Managers"
      }
    ]
  },
  {
    "key": "MANAGER",
    "text": "Manager",
    "translations": [
      {
        "language": "AR",
        "text": "مدير"
      },
      {
        "language": "DE",
        "text": "Manager"
      },
      {
        "language": "PT",
        "text": "Gerente"
      },
      {
        "language": "IT",
        "text": "Manager"
      },
      {
        "language": "CS",
        "text": "Manažer"
      },
      {
        "language": "EN",
        "text": "Manager"
      }
    ]
  },
  {
    "key": "txtPeers",
    "text": "Peers",
    "translations": [
      {
        "language": "AR",
        "text": "الزملاء"
      },
      {
        "language": "DE",
        "text": "Peers"
      },
      {
        "language": "PT",
        "text": "Pares"
      },
      {
        "language": "IT",
        "text": "Colleghi"
      },
      {
        "language": "CS",
        "text": "Kolega"
      },
      {
        "language": "EN",
        "text": "Peers"
      }
    ]
  },
  {
    "key": "txtTeam",
    "text": "Team",
    "translations": [
      {
        "language": "AR",
        "text": "أعضاء الفريق"
      },
      {
        "language": "DE",
        "text": "Team"
      },
      {
        "language": "PT",
        "text": "Equipe"
      },
      {
        "language": "IT",
        "text": "Team"
      },
      {
        "language": "CS",
        "text": "Tým"
      },
      {
        "language": "EN",
        "text": "Team"
      }
    ]
  },
  {
    "key": "txtCustomers",
    "text": "Customers",
    "translations": [
      {
        "language": "AR",
        "text": "العملاء"
      },
      {
        "language": "DE",
        "text": "Kunden"
      },
      {
        "language": "PT",
        "text": "Clientes"
      },
      {
        "language": "IT",
        "text": "Clienti"
      },
      {
        "language": "CS",
        "text": "Zákazníci"
      },
      {
        "language": "EN",
        "text": "Customers"
      }
    ]
  },
  {
    "key": "txtCustomer",
    "text": "Customer",
    "translations": [
      {
        "language": "AR",
        "text": "العميل"
      },
      {
        "language": "DE",
        "text": "Kunde"
      },
      {
        "language": "PT",
        "text": "Cliente"
      },
      {
        "language": "IT",
        "text": "Cliente"
      },
      {
        "language": "CS",
        "text": "Zákazník"
      },
      {
        "language": "EN",
        "text": "Customer"
      }
    ]
  },
  {
    "key": "PEER",
    "text": "Peer",
    "translations": [
      {
        "language": "AR",
        "text": "زميل"
      },
      {
        "language": "DE",
        "text": "Peer"
      },
      {
        "language": "PT",
        "text": "Par"
      },
      {
        "language": "IT",
        "text": "Collega"
      },
      {
        "language": "CS",
        "text": "Kolega"
      },
      {
        "language": "EN",
        "text": "Peer"
      }
    ]
  },
  {
    "key": "TEAM",
    "text": "Team",
    "translations": [
      {
        "language": "AR",
        "text": "عضو فريق"
      },
      {
        "language": "DE",
        "text": "Team"
      },
      {
        "language": "PT",
        "text": "Equipe"
      },
      {
        "language": "IT",
        "text": "Team"
      },
      {
        "language": "CS",
        "text": "Tým"
      },
      {
        "language": "EN",
        "text": "Team"
      }
    ]
  },
  {
    "key": "CUSTOMER",
    "text": "Customer",
    "translations": [
      {
        "language": "AR",
        "text": "عميل"
      },
      {
        "language": "DE",
        "text": "Kunde"
      },
      {
        "language": "PT",
        "text": "Cliente"
      },
      {
        "language": "IT",
        "text": "Cliente"
      },
      {
        "language": "CS",
        "text": "Zákazník"
      },
      {
        "language": "EN",
        "text": "Customer"
      }
    ]
  },
  {
    "key": "txtHowtousethisreport",
    "text": "How to Use the Report",
    "translations": [
      {
        "language": "AR",
        "text": "كيف يمكن الاستفادة من التقرير؟"
      },
      {
        "language": "DE",
        "text": "So verwenden Sie den Bericht"
      },
      {
        "language": "PT",
        "text": "Como usar o relatório"
      },
      {
        "language": "IT",
        "text": "Come utilizzare questo report"
      },
      {
        "language": "CS",
        "text": "Jak používat tuto zprávu"
      },
      {
        "language": "EN",
        "text": "How to Use the Report"
      }
    ]
  },
  {
    "key": "txt_progress",
    "text": "Progress",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "DE",
        "text": "Fortschritt"
      },
      {
        "language": "PT",
        "text": "Progresso"
      },
      {
        "language": "IT",
        "text": "Avanzamento"
      },
      {
        "language": "CS",
        "text": "Pokrok"
      },
      {
        "language": "EN",
        "text": "Progress"
      }
    ]
  },
  {
    "key": "by",
    "text": "by",
    "translations": [
      {
        "language": "AR",
        "text": "حسب"
      },
      {
        "language": "DE",
        "text": "von"
      },
      {
        "language": "PT",
        "text": "por"
      },
      {
        "language": "IT",
        "text": "da"
      },
      {
        "language": "CS",
        "text": "autor:"
      },
      {
        "language": "EN",
        "text": "by"
      }
    ]
  },
  {
    "key": "txtIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "مقدمة"
      },
      {
        "language": "DE",
        "text": "Einführung"
      },
      {
        "language": "PT",
        "text": "Introdução"
      },
      {
        "language": "IT",
        "text": "Introduzione"
      },
      {
        "language": "CS",
        "text": "Úvod"
      },
      {
        "language": "EN",
        "text": "Introduction"
      }
    ]
  },
  {
    "key": "txttableofcontents",
    "text": "Table of Contents",
    "translations": [
      {
        "language": "AR",
        "text": "جدول المحتويات"
      },
      {
        "language": "DE",
        "text": "Inhaltsverzeichnis"
      },
      {
        "language": "PT",
        "text": "Índice"
      },
      {
        "language": "IT",
        "text": "Indice"
      },
      {
        "language": "CS",
        "text": "Obsah"
      },
      {
        "language": "EN",
        "text": "Table of Contents"
      }
    ]
  },
  {
    "key": "txtExcludingSelf",
    "text": "(Excluding Self)",
    "translations": [
      {
        "language": "AR",
        "text": "(ما عدا المرشح)"
      },
      {
        "language": "DE",
        "text": "(Selbst ausgenommen)"
      },
      {
        "language": "PT",
        "text": "(excluindo eu mesmo)"
      },
      {
        "language": "IT",
        "text": "(Esclusa autovalutazione)"
      },
      {
        "language": "CS",
        "text": "(kromě sebe)"
      },
      {
        "language": "EN",
        "text": "(Excluding Self)"
      }
    ]
  },
  {
    "key": "txtCompChartYAxis",
    "text": "Score (out of 5)",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة: من 5"
      },
      {
        "language": "DE",
        "text": "Punktzahl (von 5)"
      },
      {
        "language": "PT",
        "text": "Pontuação (de 5)"
      },
      {
        "language": "IT",
        "text": "Punteggio (su 5)"
      },
      {
        "language": "CS",
        "text": "Hodnocení (z 5)"
      },
      {
        "language": "EN",
        "text": "Score (out of 5)"
      }
    ]
  },
  {
    "key": "txtCompChartXAxis",
    "text": "Candidates (Self / Evaluators)",
    "translations": [
      {
        "language": "AR",
        "text": "المرشحون: ذاتي / مقيمون"
      },
      {
        "language": "DE",
        "text": "Kandidaten (Selbst / Gutachter)"
      },
      {
        "language": "PT",
        "text": "Candidatos (Auto / Avaliadores)"
      },
      {
        "language": "IT",
        "text": "Candidati (Valutati/Valutatori)"
      },
      {
        "language": "CS",
        "text": "Respondenti (vlastní hodnocení / hodnocení ze strany hodnotitelů)"
      },
      {
        "language": "EN",
        "text": "Candidates (Self / Evaluators)"
      }
    ]
  },
  {
    "key": "txtCandidateID",
    "text": "Candidate ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي للمرشح"
      },
      {
        "language": "DE",
        "text": "Kandidaten-ID"
      },
      {
        "language": "PT",
        "text": "ID do candidato"
      },
      {
        "language": "IT",
        "text": "ID del candidato"
      },
      {
        "language": "CS",
        "text": "Identifikační číslo respondenta"
      },
      {
        "language": "EN",
        "text": "Candidate ID"
      }
    ]
  },
  {
    "key": "txtCandidateName",
    "text": "Candidate's Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المرشح"
      },
      {
        "language": "DE",
        "text": "Name des Kandidaten"
      },
      {
        "language": "PT",
        "text": "Nome do Candidato"
      },
      {
        "language": "IT",
        "text": "Nome del candidato"
      },
      {
        "language": "CS",
        "text": "Jméno uchazeče"
      },
      {
        "language": "EN",
        "text": "Candidate's Name"
      }
    ]
  },
  {
    "key": "txtNoofEvaluators",
    "text": "# of Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المقيمين"
      },
      {
        "language": "DE",
        "text": "Anzahl der Bewerter"
      },
      {
        "language": "PT",
        "text": "Nº de avaliadores"
      },
      {
        "language": "IT",
        "text": "# di valutatori"
      },
      {
        "language": "CS",
        "text": "Počet hodnotitelů"
      },
      {
        "language": "EN",
        "text": "# of Evaluators"
      }
    ]
  },
  {
    "key": "txtCompChartTitle",
    "text": "Candidates Performance Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة تقييم أداء المرشحين"
      },
      {
        "language": "DE",
        "text": "Leistungsbewertung der Kandidaten"
      },
      {
        "language": "PT",
        "text": "Pontuação de desempenho dos candidatos"
      },
      {
        "language": "IT",
        "text": "Punteggio della performance dei candidati"
      },
      {
        "language": "CS",
        "text": "Hodnocení výkonu uchazečů"
      },
      {
        "language": "EN",
        "text": "Candidates Performance Score"
      }
    ]
  },
  {
    "key": "txtRank",
    "text": "Rank",
    "translations": [
      {
        "language": "AR",
        "text": "المركز"
      },
      {
        "language": "DE",
        "text": "Rang"
      },
      {
        "language": "PT",
        "text": "Classificação"
      },
      {
        "language": "IT",
        "text": "Classifica"
      },
      {
        "language": "CS",
        "text": "Pořadí"
      },
      {
        "language": "EN",
        "text": "Rank"
      }
    ]
  },
  {
    "key": "txtOverallResponseRate",
    "text": "Overall Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة العام"
      },
      {
        "language": "DE",
        "text": "Gesamtantwortrate"
      },
      {
        "language": "PT",
        "text": "Taxa geral de resposta"
      },
      {
        "language": "IT",
        "text": "Tasso di risposta complessivo"
      },
      {
        "language": "CS",
        "text": "Celková míra odezvy"
      },
      {
        "language": "EN",
        "text": "Overall Response Rate"
      }
    ]
  },
  {
    "key": "txtcompetencyOverallScore",
    "text": "competency / Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة الكلية لكل جدارة ومهارة"
      },
      {
        "language": "DE",
        "text": "Kompetenz / Gesamtpunktzahl"
      },
      {
        "language": "PT",
        "text": "competência / pontuação geral"
      },
      {
        "language": "IT",
        "text": "Competenza/Punteggio complessivo"
      },
      {
        "language": "CS",
        "text": "kompetence / Celkové skóre"
      },
      {
        "language": "EN",
        "text": "competency / Overall Score"
      }
    ]
  },
  {
    "key": "txtSelf",
    "text": "Self",
    "translations": [
      {
        "language": "AR",
        "text": "ذاتي"
      },
      {
        "language": "DE",
        "text": "Selbst"
      },
      {
        "language": "PT",
        "text": "Auto"
      },
      {
        "language": "IT",
        "text": "Autovalutazione"
      },
      {
        "language": "CS",
        "text": "Já"
      },
      {
        "language": "EN",
        "text": "Self"
      }
    ]
  },
  {
    "key": "txtStatement",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      },
      {
        "language": "DE",
        "text": "Stellungnahme"
      },
      {
        "language": "PT",
        "text": "Declaração"
      },
      {
        "language": "IT",
        "text": "Affermazione"
      },
      {
        "language": "CS",
        "text": "Prohlášení"
      },
      {
        "language": "EN",
        "text": "Statement"
      }
    ]
  },
  {
    "key": "txtStrengthAreas",
    "text": "Strength Areas",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط القوة"
      },
      {
        "language": "DE",
        "text": "Stärken"
      },
      {
        "language": "PT",
        "text": "Áreas fortes"
      },
      {
        "language": "IT",
        "text": "Punti di forza"
      },
      {
        "language": "CS",
        "text": "Silné stránky"
      },
      {
        "language": "EN",
        "text": "Strength Areas"
      }
    ]
  },
  {
    "key": "txtAreasofImprovements",
    "text": "Areas of Improvements",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التحسين"
      },
      {
        "language": "DE",
        "text": "Bereiche für Verbesserungen"
      },
      {
        "language": "PT",
        "text": "Áreas de Melhorias"
      },
      {
        "language": "IT",
        "text": "Aree di miglioramento"
      },
      {
        "language": "CS",
        "text": "Oblasti, v nichž je třeba provést zlepšení"
      },
      {
        "language": "EN",
        "text": "Areas of Improvements"
      }
    ]
  },
  {
    "key": "txtSelected",
    "text": "Selected",
    "translations": [
      {
        "language": "AR",
        "text": "المختارة"
      },
      {
        "language": "DE",
        "text": "Ausgewählt"
      },
      {
        "language": "PT",
        "text": "Selecionado"
      },
      {
        "language": "IT",
        "text": "Selezionato"
      },
      {
        "language": "CS",
        "text": "Vybrané"
      },
      {
        "language": "EN",
        "text": "Selected"
      }
    ]
  },
  {
    "key": "txtTotalWeight",
    "text": "Total Weight",
    "translations": [
      {
        "language": "AR",
        "text": "الوزن الكلي"
      },
      {
        "language": "DE",
        "text": "Gesamtgewichtung"
      },
      {
        "language": "PT",
        "text": "Peso total"
      },
      {
        "language": "IT",
        "text": "Peso totale"
      },
      {
        "language": "CS",
        "text": "Celková Váha"
      },
      {
        "language": "EN",
        "text": "Total Weight"
      }
    ]
  },
  {
    "key": "txtWeight",
    "text": "Weight",
    "translations": [
      {
        "language": "AR",
        "text": "الوزن "
      },
      {
        "language": "DE",
        "text": "Gewichtung"
      },
      {
        "language": "PT",
        "text": "Peso"
      },
      {
        "language": "IT",
        "text": "Peso"
      },
      {
        "language": "CS",
        "text": "Váha"
      },
      {
        "language": "EN",
        "text": "Weight"
      }
    ]
  },
  {
    "key": "txtSelectedCandidate",
    "text": "Select Candidate",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المرشح"
      },
      {
        "language": "DE",
        "text": "Kandidaten auswählen"
      },
      {
        "language": "PT",
        "text": "Selecione o candidato"
      },
      {
        "language": "IT",
        "text": "Seleziona un candidato"
      },
      {
        "language": "CS",
        "text": "Vyberte respondenta"
      },
      {
        "language": "EN",
        "text": "Select Candidate"
      }
    ]
  },
  {
    "key": "txtLocked",
    "text": "Locked",
    "translations": [
      {
        "language": "AR",
        "text": "مقفل"
      },
      {
        "language": "DE",
        "text": "Gesperrt"
      },
      {
        "language": "PT",
        "text": "Bloqueado"
      },
      {
        "language": "IT",
        "text": "Bloccato"
      },
      {
        "language": "CS",
        "text": "Zamčeno"
      },
      {
        "language": "EN",
        "text": "Locked"
      }
    ]
  },
  {
    "key": "txt_fill_fields",
    "text": "Please, fill all required fields!",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة جميع الحقول المطلوبة!"
      },
      {
        "language": "DE",
        "text": "Bitte füllen Sie alle erforderlichen Felder aus!"
      },
      {
        "language": "PT",
        "text": "Por favor, preencha todos os campos obrigatórios!"
      },
      {
        "language": "IT",
        "text": "Compila tutti i campi obbligatori!"
      },
      {
        "language": "CS",
        "text": "Vyplňte prosím všechna povinná pole!"
      },
      {
        "language": "EN",
        "text": "Please, fill all required fields!"
      }
    ]
  },
  {
    "key": "txt_wrong_text_count",
    "text": "Exceeded text limit.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز عدد الأحرف المسموح به"
      },
      {
        "language": "DE",
        "text": "Textlimit überschritten."
      },
      {
        "language": "PT",
        "text": "Limite de texto excedido."
      },
      {
        "language": "IT",
        "text": "Limite di testo superato."
      },
      {
        "language": "CS",
        "text": "Překročen limit délky textu."
      },
      {
        "language": "EN",
        "text": "Exceeded text limit."
      }
    ]
  },
  {
    "key": "txt360FeedbackAssessment",
    "text": "360° Feedback Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم أداء °360 "
      },
      {
        "language": "DE",
        "text": "360° Feedback-Beurteilung"
      },
      {
        "language": "PT",
        "text": "Avaliação de Feedback 360°"
      },
      {
        "language": "IT",
        "text": "Feedback Assessment 360°"
      },
      {
        "language": "CS",
        "text": "Hodnocení 360°"
      },
      {
        "language": "EN",
        "text": "360° Feedback Assessment"
      }
    ]
  },
  {
    "key": "txt360FeedbackAssessmentReport",
    "text": "360° Feedback Assessment Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير تقييم أداء°360"
      },
      {
        "language": "DE",
        "text": "360° Feedback-Bewertungsbericht"
      },
      {
        "language": "PT",
        "text": "Relatório de avaliação de feedback 360°"
      },
      {
        "language": "IT",
        "text": "Report Assessment 360°"
      },
      {
        "language": "CS",
        "text": "Zpráva o hodnocení 360° zpětné vazby"
      },
      {
        "language": "EN",
        "text": "360° Feedback Assessment Report"
      }
    ]
  },
  {
    "key": "txtDefinition",
    "text": "Definition",
    "translations": [
      {
        "language": "AR",
        "text": "التعريف"
      },
      {
        "language": "DE",
        "text": "Definition"
      },
      {
        "language": "PT",
        "text": "Definição"
      },
      {
        "language": "IT",
        "text": "Definizione"
      },
      {
        "language": "CS",
        "text": "Definice"
      },
      {
        "language": "EN",
        "text": "Definition"
      }
    ]
  },
  {
    "key": "txtPreparedFor",
    "text": "Prepared For",
    "translations": [
      {
        "language": "AR",
        "text": "أُعدَّ لـ"
      },
      {
        "language": "DE",
        "text": "Vorbereitet für"
      },
      {
        "language": "PT",
        "text": "Preparado para"
      },
      {
        "language": "IT",
        "text": "Preparato per"
      },
      {
        "language": "CS",
        "text": "Připraveno pro"
      },
      {
        "language": "EN",
        "text": "Prepared For"
      }
    ]
  },
  {
    "key": "txtratingscale",
    "text": "<h4>Rating Scale</h4><p class=\"s-12 mb-4\">The rating scale determines how the statements were rated and what each score represents.</p><table class=\"layout-fixed text-center\"><thead>  <tr class=\"v-align-middle\">    <th>N/A</th>    <th>1</th>    <th>2</th>    <th>3</th>    <th>4</th>    <th>5</th>  </tr>  </thead>  <tbody>  <tr class=\"v-align-middle\">    <td>Not applicable </br>  <span class=\\\"w-4 h-3 rounded-sm bg-zen-orange\\\"></span></td>    <td>Strongly disagree</td>    <td>Disagree</td>    <td>Neutral</td>    <td>Agree</td>    <td>Strongly Agree</td>  </tr>  </tbody></table>",
    "translations": [
      {
        "language": "AR",
        "text": "<h4>مقياس التقييم</h4>\n<p class=\"s-12 mb-4\">\nيحدد مقياس التقييم آلية تقييم العبارات والأسئلة وماذا تمثل النتائج التي تم الحصول عليها.\n</p>\n<table class=\"layout-fixed text-center\">\n<tr class=\"v-align-middle\">\n<th>لا ينطبق</th>\n    <th>1</th>\n    <th>2</th>\n    <th>3</th>\n    <th>4</th>\n    <th>5</th>\n  </tr>\n  </thead>\n  <tbody>\n  <tr class=\"v-align-middle\">\n    <td>لا ينطبق</td>\n    <td>لا أوافق بشدة</td>\n    <td>لا أوافق</td>\n    <td>محايد</td>\n    <td>أوافق</td>\n    <td>أوافق بشدة</td>\n  </tr>\n  </tbody>\n</table>\n"
      },
      {
        "language": "DE",
        "text": "<h4>Bewertungsskala</h4><p class=\"s-12 mb-4\">Die Bewertungsskala bestimmt, wie die Aussagen bewertet wurden und was jeder Wert darstellt.</p><table class=\"layout-fixed text-center\"><thead> <tr class=\"v-align-middle\"> <th>N/A</th> <th>1</th> <th>2</th> <th>3</th> <th>4</th> <th>5</th> </tr> </thead> <tbody> <tr class=\"v-align-middle\"> <td>Nicht zutreffend </br> <span class=\\\"w-4 h-3 rounded-sm bg-zen-orange\\\"></span></td> <td>Stimme überhaupt nicht zu</td> <td>Stimme nicht zu</td> <td>Neutral</td> <td>Stimme zu</td> <td>Stimme voll und ganz zu</td> </tr> </tbody></table>"
      },
      {
        "language": "PT",
        "text": "<h4>Escala de avaliação</h4><p class=\"s-12 mb-4\">A escala de classificação determina como as afirmações foram avaliadas e o que cada pontuação representa.</p><table class=\"layout-fixed text-center\"><thead> <tr class=\"v-align-middle\"> <th>N/A</th> <th>1</th> <th>2</th> <th>3</th> <th>4</th> <th>5</th> </tr> </thead> <tbody> <tr class=\"v-align-middle\"> <td>Não aplicável </br> <span class=\\\"w-4 h-3 round-sm bg-zen-orange\\\"></span></td> <td>Discordo totalmente</td> <td>Discordo</td> <td>Neutro</td> <td>Concordo</td> <td>Concordo plenamente</td> </tr> </tbody></table>"
      },
      {
        "language": "IT",
        "text": "<h4>Rating Scale</h4><p class=\"s-12 mb-4\">La scala di valutazione determina il criterio di attribuzione dei punteggi alle affermazioni e il significato di ciascun punteggio.</p><table class=\"layout-fixed text-center\"><thead>  <tr class=\"v-align-middle\">    <th>N/A</th>    <th>1</th>    <th>2</th>    <th>3</th>    <th>4</th>    <th>5</th>  </tr>  </thead>  <tbody>  <tr class=\"v-align-middle\">    <td>Non applicabile </br>  <span class=\\\"w-4 h-3 rounded-sm bg-zen-orange\\\"></span></td>    <td>Completamente in disaccordo</td>    <td>In disaccordo</td>    <td>Neutrale</td>    <td>D'Accordo</td>    <td>Completamente d'accordo</td>  </tr>  </tbody></table>"
      },
      {
        "language": "CS",
        "text": "<h4>Rating Scale</h4><p class=\"s-12 mb-4\">Hodnotící stupnice určuje, jak byly jednotlivé výroky ohodnoceny a co jednotlivé skóre představuje.</p><table class=\"layout-fixed text-center\"><thead>  <tr class=\"v-align-middle\">    <th>N/A</th>    <th>1</th>    <th>2</th>    <th>3</th>    <th>4</th>    <th>5</th>  </tr>  </thead>  <tbody>  <tr class=\"v-align-middle\">    <td>Neplatný</br>  <span class=\\\"w-4 h-3 rounded-sm bg-zen-orange\\\"></span></td>    <td>Vůbec nesouhlasím</td>    <td>Nesouhlasím</td>    <td>Neutrální</td>    <td>Souhlasím</td>    <td>Naprosto souhlasím</td>  </tr>  </tbody></table>"
      },
      {
        "language": "EN",
        "text": "<h4>Rating Scale</h4><p class=\"s-12 mb-4\">The rating scale determines how the statements were rated and what each score represents.</p><table class=\"layout-fixed text-center\"><thead>  <tr class=\"v-align-middle\">    <th>N/A</th>    <th>1</th>    <th>2</th>    <th>3</th>    <th>4</th>    <th>5</th>  </tr>  </thead>  <tbody>  <tr class=\"v-align-middle\">    <td>Not applicable </br>  <span class=\\\"w-4 h-3 rounded-sm bg-zen-orange\\\"></span></td>    <td>Strongly disagree</td>    <td>Disagree</td>    <td>Neutral</td>    <td>Agree</td>    <td>Strongly Agree</td>  </tr>  </tbody></table>"
      }
    ]
  },
  {
    "key": "txtHowtousethisreportparacan",
    "text": "<p class=\"mb-4\">This report is a representation of your evaluators feedback.</p>\n  <p class=\"mb-4\">The competencies overview will display your self-evaluated score compared to the evaluator’s score.</p>\n  <p class=\"mb-4\">It will highlight your top five hidden strengths and blind spots that can be used as a reference for areas of improvement and encouragement.</p>\n",
    "translations": [
      {
        "language": "AR",
        "text": "<p class=\"mb-4\">يبين هذا التقرير آراء وملاحظات الأفراد الذين قاموا بتقييمك.</p>\n  <p class=\"mb-4\">ستجد نتيجة التقييمك الذاتي ونتائج تقييم الآخرين لل في قسم \"النظرة العامة على الجدارات والمهارات\" في هذا التقرير.</p>\n  <p class=\"mb-4\">هذا التقرير يسلط الضوء على أعلى (5) نقاط للقوة المجهولة ونقاط الضعف غير المدركة لاستخدامها كحافز للتطوير والتحسين الذاتي.</p>\n"
      },
      {
        "language": "DE",
        "text": "<p class=\"mb-4\">Dieser Bericht ist eine Darstellung des Feedbacks Ihres Bewerters.</p> <p class=\"mb-4\">Die Kompetenzübersicht zeigt Ihre selbstbewertete Punktzahl im Vergleich zur Punktzahl des Bewerters.</p> <p class=\"mb-4\">Sie hebt Ihre fünf größten verborgenen Stärken und blinden Flecken hervor, die als Referenz für Bereiche verwendet werden können, in denen Verbesserungen und Ermutigungen erforderlich sind.</p>"
      },
      {
        "language": "PT",
        "text": "<p class=\"mb-4\">Este relatório é uma representação do feedback dos seus avaliadores.</p>\n<p class=\"mb-4\">A visão geral das competências exibirá sua pontuação autoavaliada em comparação com a pontuação do avaliador.</p>\n<p class=\"mb-4\">Ele destacará seus cinco principais pontos fortes e pontos cegos ocultos que podem ser usados ​​como referência para áreas de melhoria e incentivo.</p>"
      },
      {
        "language": "IT",
        "text": "<p class=\"mb-4\">Questo report è una rappresentazione dei feedback dei tuoi valutatori.</p>\n  <p class=\"mb-4\">L'overview delle competenze mostrerà il tuo punteggio dell'autovalutazione comparato con quello del valutatore.</p>\n  <p class=\"mb-4\">Evidenzia i tuoi 5 punti di forza nascosti e i punti ciechi che possono essere usati come guida per crescere e incoraggiarti.</p>\n"
      },
      {
        "language": "CS",
        "text": "<p class=\"mb-4\">Tato zpráva obsahuje zpětnou vazbu od vašich hodnotitelů.</p>\n  <p class=\"mb-4\">V přehledu kompetencí se zobrazí vaše vlastní hodnocení ve srovnání s hodnocením hodnotitele.</p>\n  <p class=\"mb-4\">Ukáže vám vašich pět nejvýznamnějších skrytých silných stránek a slabých míst, které můžete využít jako vodítko pro oblasti, v nichž se můžete zlepšovat, a jako zdroj motivace.</p>\n"
      },
      {
        "language": "EN",
        "text": "<p class=\"mb-4\">This report is a representation of your evaluators feedback.</p>\n  <p class=\"mb-4\">The competencies overview will display your self-evaluated score compared to the evaluator’s score.</p>\n  <p class=\"mb-4\">It will highlight your top five hidden strengths and blind spots that can be used as a reference for areas of improvement and encouragement.</p>\n"
      }
    ]
  },
  {
    "key": "360txtIntroductionpara1",
    "text": "360-degree performance appraisal is one of the most important modern methods of evaluating an employee's behavior in the working environment to show different views on his professional performance, unlike the traditional performance appraisal, which mainly focuses on management / superior feedback. <br/> This report is designed to derive feedback from the candidate's managers, peers, team members, and customers to provide different garnered views. It is meant to serve as a starting baseline for workplace development.",
    "translations": [
      {
        "language": "AR",
        "text": "يعد تقييم 360° من أهم الأساليب الحديثة لتقييم سلوك الموظف في بيئة العمل بهدف إظهار وجهات النظر المختلفة حول أدائه المهني على عكس تقييم الأداء التقليدي الذي يعتمد بشكل رئيسي على آراء وملاحظات المدير المباشر/ الإدارة. <br/>  تم تصميم هذا التقرير لاستخلاص الملاحظات والآراء من مدراء المرشح، وزملائه، وأعضاء فريقه، والعملاء، لتوفير وجهات نظر مختلفة حول أدائه وسلوكه المهني. والهدف من هذا التقرير هو أن يكون نقطة البداية لتحسين وتطوير بيئة العمل."
      },
      {
        "language": "DE",
        "text": "Die 360-Grad-Leistungsbeurteilung ist eine der wichtigsten modernen Methoden zur Bewertung des Verhaltens eines Mitarbeiters im Arbeitsumfeld und zeigt im Gegensatz zur traditionellen Leistungsbeurteilung, bei der es vor allem um das Feedback des Managements/Vorgesetzten geht, unterschiedliche Sichtweisen auf seine berufliche Leistung auf."
      },
      {
        "language": "PT",
        "text": "A avaliação de desempenho 360 graus é um dos métodos modernos mais importantes de avaliação do comportamento de um funcionário no ambiente de trabalho para mostrar diferentes visões sobre seu desempenho profissional, ao contrário da avaliação de desempenho tradicional, que foca principalmente no feedback da gestão/superior."
      },
      {
        "language": "IT",
        "text": "L'Assessment 360° rappresenta una delle metodologie più rilevanti e moderne per analizzare il comportamento dei dipendenti nell'ambiente di lavoro, offrendo punti di vista diversi rispetto alla loro performance professionale, diversamente dalla valutazione tradizionale, che si basa soprattutto sul feedback del management o dei responsabili."
      },
      {
        "language": "CS",
        "text": "360stupňové hodnocení výkonu je jednou z nejdůležitějších moderních metod hodnocení chování zaměstnance v pracovním prostředí, která umožňuje získat různé pohledy na jeho pracovní výkon, na rozdíl od tradičního hodnocení výkonu, které se zaměřuje hlavně na zpětnou vazbu od vedení/nadřízených."
      },
      {
        "language": "EN",
        "text": "360-degree performance appraisal is one of the most important modern methods of evaluating an employee's behavior in the working environment to show different views on his professional performance, unlike the traditional performance appraisal, which mainly focuses on management / superior feedback."
      }
    ]
  },
  {
    "key": "txtIntroductionpara2",
    "text": "This report is designed to derive feedback from the candidate's managers, peers, team members, and customers to provide different garnered views. It is meant to serve as a starting baseline for workplace development.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تصميم هذا التقرير لاستخلاص الملاحظات والآراء من مدراء المرشح، وزملائه، وأعضاء فريقه، والعملاء، لتوفير وجهات نظر مختلفة حول أدائه وسلوكه المهني. والهدف من هذا التقرير هو أن يكون نقطة البداية لتحسين وتطوير بيئة العمل."
      },
      {
        "language": "DE",
        "text": "Dieser Bericht soll Feedback von Vorgesetzten, Kollegen, Teammitgliedern und Kunden des Kandidaten einholen, um verschiedene Ansichten zu liefern. Er soll als Ausgangspunkt für die Entwicklung am Arbeitsplatz dienen."
      },
      {
        "language": "PT",
        "text": "Este relatório foi projetado para obter feedback dos gerentes, colegas, membros da equipe e clientes do candidato para fornecer diferentes opiniões coletadas. Destina-se a servir como base inicial para o desenvolvimento do local de trabalho."
      },
      {
        "language": "IT",
        "text": "Questo report è progettato per raccogliere i feedback dai manager, dai colleghi, dai membri del team e dai clienti di un candidato, al fine di offrire prospettive diversificate. È pensato per costituire una base di partenza per lo sviluppo professionale."
      },
      {
        "language": "CS",
        "text": "Účelem této zprávy je získat zpětnou vazbu od nadřízených, kolegů, členů týmu a zákazníků daného respondenta, aby bylo možné shromáždit různé pohledy. Má sloužit jako výchozí základ pro rozvoj na pracovišti."
      },
      {
        "language": "EN",
        "text": "This report is designed to derive feedback from the candidate's managers, peers, team members, and customers to provide different garnered views. It is meant to serve as a starting baseline for workplace development."
      }
    ]
  },
  {
    "key": "txtobjectivespara",
    "text": "\n  <h4 >Objectives of this Report</h4>\n              <ul class=\"bullets\">\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify and understand the candidate's professional behavior in certain situations and how it affects the workplace and its performance</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify the Candidate's hidden strengths and understand how they may be beneficial to the workplace.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify the Candidate's blind spots, identify the reason behind them, and how they can be improved.</p>\n                </li>\n\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Access the scores for every competency and statement chosen from the extensive library of customizable and predefined templates.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Obtain open-ended statements or feedback submitted by evaluators and use it to improve the Candidate's ways of doing things. </p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Garner a better understanding of the Candidate's characteristics and use that information to improve performance. </p>\n                </li>\n              </ul>\n            ",
    "translations": [
      {
        "language": "AR",
        "text": "\n  <h4 >أهداف التقرير:</h4>\n\n              <ul class=\"bullets\">\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>تحديد وفهم السلوك المهني للمرشح في مواقف معينة، وكيف يؤثر ذلك على أداء العمل.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>تحديد نقاط القوة المجهولة للمرشح ومعرفة كيف يمكن الاستفادة منها لتطوير مكان العمل.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>تحديد وفهم نقاط الضعف غير المدركة للمرشح وما هي المسببات وراءها، وكيف يمكن العمل على تحسينها وتطويرها.</p>\n                </li>\n\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>الإطلاع على النتائج الخاصة بكل الجدارات والمهارات المختارة من قاعدة البيانات التي تحتوي على نماذج مخصصة أو معرّفة مسبقاً.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>الحصول على ملاحظات وآراء من المقيمين واستخدامها لتطوير طريقة المرشح في إنجاز الأعمال.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>الوصول إلى فهم أفضل لمميزات المرشح وتوظيف هذه المعلومات لتطوير أدائه. </p>\n                </li>\n              </ul>\n            "
      },
      {
        "language": "DE",
        "text": "<h4 >Ziele dieses Berichts</h4> <ul class=\"bullets\"> <li> <i class=\"fas fa-circle\"></i> <p>Das professionelle Verhalten des Kandidaten in bestimmten Situationen erkennen und verstehen und wie es sich auf den Arbeitsplatz und seine Leistung auswirkt.</p> </li> <li> <i class=\"fas fa-circle\"></i> <p>Die verborgenen Stärken des Kandidaten erkennen und verstehen, wie diese am Arbeitsplatz von Nutzen sein können.</p> </li> <li> <i class=\"fas fa-circle\"></i> <p>Die blinden Flecken des Kandidaten erkennen, die Gründe dafür herausfinden und wie sie verbessert werden können.</p> </li> <li> <i class=\"fas fa-circle\"></i> <p>Greifen Sie auf die Bewertungen für jede Kompetenz und Aussage zu, die Sie aus der umfangreichen Bibliothek anpassbarer und vordefinierter Vorlagen ausgewählt haben.</p> </li> <li> <i class=\"fas fa-circle\"></i> <p>Offene Aussagen erhalten oder Feedback von Gutachtern und nutzen, um die Arbeitsweise des Kandidaten zu verbessern. </p> </li> <li> <i class=\"fas fa-circle\"></i> <p>Erlangen Sie ein besseres Verständnis für die Eigenschaften des Kandidaten und nutzen Sie diese Informationen, um seine Leistung zu verbessern. </p> </li> </ul>"
      },
      {
        "language": "PT",
        "text": "<h4 >Objetivos deste Relatório</h4>\n<ul class=\"balas\">\n<li>\n<i class=\"fas fa-circle\"></i>\n<p>Identificar e compreender o comportamento profissional do candidato em determinadas situações e como isso afeta o local de trabalho e seu desempenho</p>\n</li>\n<li>\n<i class=\"fas fa-circle\"></i>\n<p>Identifique os pontos fortes ocultos do Candidato e entenda como eles podem ser benéficos para o local de trabalho.</p>\n</li>\n<li>\n<i class=\"fas fa-circle\"></i>\n<p>Identifique os pontos cegos do Candidato, identifique a razão por trás deles e como eles podem ser melhorados.</p>\n</li>\n\n<li>\n<i class=\"fas fa-circle\"></i>\n<p>Acesse as pontuações de cada competência e declaração escolhida na extensa biblioteca de modelos personalizáveis ​​e predefinidos.</p>\n</li>\n<li>\n<i class=\"fas fa-circle\"></i>\n<p>Obtenha declarações abertas ou feedback enviado pelos avaliadores e use-os para melhorar a maneira como o Candidato faz as coisas. </p>\n</li>\n<li>\n<i class=\"fas fa-circle\"></i>\n<p>Obtenha uma melhor compreensão das características do Candidato e use essas informações para melhorar o desempenho. </p>\n</li>\n</ul>"
      },
      {
        "language": "IT",
        "text": "\n  <h4 >Obbiettivi di questo Report</h4>\n              <ul class=\"bullets\">\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identificare e comprendere il comportamento professionale del candidato in determinate situazioni e come questo influisce sull’ambiente di lavoro e sulla sua performance.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identificare i punti di forza nascosti del candidato e comprendere come possano apportare benefici al contesto lavorativo.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Individuare i punti ciechi del candidato, comprenderne le cause e il modo in cui possano essere sviluppati.</p>\n                </li>\n\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>\"Consultare i punteggi di ogni competenza e affermazione selezionata dall'ampia library dei template predefiniti e personalizzabili.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Raccogliere le risposte alle domande aperte o i feedback forniti dai valutatori, utilizzandoli per migliorare il modo di agire del candidato.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Comprendere meglio le caratteristiche del candidato e utilizzarle per migliorare la performance. </p>\n                </li>\n              </ul>\n            "
      },
      {
        "language": "CS",
        "text": "\n  <h4 >Objectives of this Report</h4>\n              <ul class=\"bullets\">\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Zjistit a pochopit, jak se uchazeč chová v určitých situacích z profesního hlediska a jaký vliv to má na pracovní prostředí a jeho výkonnost</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Odhalte skryté silné stránky uchazeče a zjistěte, jak by mohly být prospěšné pro pracovní prostředí.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Zjistěte, v jakých oblastech má uchazeč mezery, zjistěte příčiny těchto mezer a jak je lze zlepšit.</p>\n                </li>\n\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Získejte přístup k bodovým hodnocením pro každou kompetenci a každé kritérium vybrané z rozsáhlé knihovny přizpůsobitelných a předdefinovaných šablon.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Získejte otevřené komentáře nebo zpětnou vazbu od hodnotitelů a využijte je ke zlepšení postupů kandidáta. </p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Garner a better understanding of the Candidate's characteristics and use that information to improve performance. </p>\n                </li>\n              </ul>\n            "
      },
      {
        "language": "EN",
        "text": "\n  <h4 >Objectives of this Report</h4>\n              <ul class=\"bullets\">\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify and understand the candidate's professional behavior in certain situations and how it affects the workplace and its performance</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify the Candidate's hidden strengths and understand how they may be beneficial to the workplace.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify the Candidate's blind spots, identify the reason behind them, and how they can be improved.</p>\n                </li>\n\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Access the scores for every competency and statement chosen from the extensive library of customizable and predefined templates.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Obtain open-ended statements or feedback submitted by evaluators and use it to improve the Candidate's ways of doing things. </p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Garner a better understanding of the Candidate's characteristics and use that information to improve performance. </p>\n                </li>\n              </ul>\n            "
      }
    ]
  },
  {
    "key": "txtcalcpros",
    "text": "<h4>Calculation Process</h4>   <div class=\"numbered-point\">  <span>1</span>                      <p>Each statement score is given an average rating based on the received feedback.</p>                      </div>                      <div class=\"numbered-point\">                        <span>2</span>                      <p>Each competency score is calculated as the overall rating score of the selected statements.</p>                      </div>                      <div class=\"numbered-point\">                        <span>3</span>                      <p>“Not Applicable” is excluded from the average score calculation.</p>                      </div>                      <div class=\"numbered-point\">                        <span>4</span>                      <p>The overall performance is calculated as the average rating of the weighted competencies.</p>                      </div>",
    "translations": [
      {
        "language": "AR",
        "text": " <h4>عملية الحساب</h4>  <div class=\"numbered-point\">  <span>1</span>    <p>يتم احتساب نتيجة كل عبارة من خلال أخذ متوسط نتائج اختيارات المقييمين.</p>    </div>    <div class=\"numbered-point\">      <span>2</span>    <p>يتم احتساب نتيجة كل جدارة ومهارة من خلال أخذ متوسط نتائج العبارات المختارة. </p>    </div>    <div class=\"numbered-point\">      <span>3</span>    <p>يتم استثناء خيار \"لا ينطبق\" من حساب معدل التقييم.</p>    </div>    <div class=\"numbered-point\">      <span>4</span>    <p>يتم احتساب معدل تقييم الأداء الكلي بحسب الأوزان المعطاة لكل جدارة ومهارة.  </p>  </div>"
      },
      {
        "language": "DE",
        "text": "  <h4>Berechnungsprozess</h4> <div class=\"numbered-point\"> <span>1</span> <p>Jede Aussagebewertung erhält auf Grundlage des erhaltenen Feedbacks eine Durchschnittsbewertung.</p> </div> <div class=\"numbered-point\"> <span>2</span> <p>Jede Kompetenzbewertung wird als Gesamtbewertung der ausgewählten Aussagen berechnet.</p> </div> <div class=\"numbered-point\"> <span>3</span> <p>„Nicht zutreffend“ wird von der Berechnung der Durchschnittsbewertung ausgeschlossen.</p> </div> <div class=\"numbered-point\"> <span>4</span> <p>Die Gesamtleistung wird als Durchschnittsbewertung der gewichteten Kompetenzen berechnet.</p> </div>"
      },
      {
        "language": "PT",
        "text": "<h4>Processo de cálculo</h4> <div class=\"ponto-numerado\"><span>1</span><p>Cada pontuação recebe uma classificação média com base no feedback recebido.</p></div><div class=\"ponto-numerado\"><span>2</span><p>Cada pontuação de competência é calculada como a pontuação geral das afirmações selecionadas.</p></div><div class=\"ponto-numerado\"><span>3</span><p>“Não aplicável” é excluído do cálculo da pontuação média.</p></div><div class=\"ponto-numerado\"><span>4</span><p>O desempenho geral é calculado como a classificação média das competências ponderadas.</p></div>"
      },
      {
        "language": "IT",
        "text": "  <h4>Procedura di calcolo</h4> <div class=\"numbered-point\">  <span>1</span>                      <p>A ogni affermazione viene attribuito un punteggio medio calcolato sulla base del feedback ricevuto.</p>                      </div>                      <div class=\"numbered-point\">                        <span>2</span>                      <p>Il punteggio di ciascuna competenza si basa sul punteggio complessivo attribuito alle affermazioni selezionate.</p>                      </div>                      <div class=\"numbered-point\">                        <span>3</span>                      <p>L'opzione \"Non applicabile\"è esclusa dal calcolo del punteggio medio.</p>                      </div>                      <div class=\"numbered-point\">                        <span>4</span>                      <p>Il punteggio complessivo della performance viene calcolato attraverso la media ponderata delle competenze.</p>                      </div>"
      },
      {
        "language": "CS",
        "text": "\n  <h4>Calculation Process</h4>\n  <div class=\"numbered-point\">\n  <span>1</span>\n                      <p>Každému hodnocení tvrzení je přiděleno průměrné hodnocení na základě obdržené zpětné vazby.</p>\n                      </div>\n                      <div class=\"numbered-point\">\n                        <span>2</span>\n                      <p>Skóre každé kompetence se vypočítává jako souhrnné hodnocení vybraných tvrzení.</p>\n                      </div>\n                      <div class=\"numbered-point\">\n                        <span>3</span>\n                      <p>“Hodnocení „Neplatí“ se do výpočtu průměrného skóre nezahrnuje.</p>\n                      </div>\n                      <div class=\"numbered-point\">\n                        <span>4</span>\n                      <p>Celkový výkon se vypočítává jako průměrné hodnocení vážených kompetencí.</p>\n                      </div>"
      },
      {
        "language": "EN",
        "text": "\n  <h4>Calculation Process</h4>\n  <div class=\"numbered-point\">\n  <span>1</span>\n                      <p>Each statement score is given an average rating based on the received feedback.</p>\n                      </div>\n                      <div class=\"numbered-point\">\n                        <span>2</span>\n                      <p>Each competency score is calculated as the overall rating score of the selected statements.</p>\n                      </div>\n                      <div class=\"numbered-point\">\n                        <span>3</span>\n                      <p>“Not Applicable” is excluded from the average score calculation.</p>\n                      </div>\n                      <div class=\"numbered-point\">\n                        <span>4</span>\n                      <p>The overall performance is calculated as the average rating of the weighted competencies.</p>\n                      </div>"
      }
    ]
  },
  {
    "key": "txtnote",
    "text": "Note: For confidentiality purposes, any group that is less than the required individuals will be merged with another group and will be included in calculating the average rating.",
    "translations": [
      {
        "language": "AR",
        "text": "لغايات السرية يتم دمج نتائج أي مجموعة يقل عدد المقيمين فيها عن الحد الأدنى المطلوب مع مجموعة أخرى في عملية حساب معدل التقييم النهائي."
      },
      {
        "language": "DE",
        "text": "Hinweis: Aus Vertraulichkeitsgründen wird jede Gruppe, die weniger als die erforderliche Anzahl an Personen umfasst, mit einer anderen Gruppe zusammengelegt und bei der Berechnung der Durchschnittsbewertung berücksichtigt."
      },
      {
        "language": "PT",
        "text": "Nota: Para fins de confidencialidade, qualquer grupo que seja inferior ao número de indivíduos exigido será fundido com outro grupo e será incluído no cálculo da classificação média."
      },
      {
        "language": "IT",
        "text": "Nota: Per garantire la riservatezza, i gruppi composti da un numero di persone inferiore a quello richiesto saranno accorpati ad altri e considerati nel calcolo della valutazione media."
      },
      {
        "language": "CS",
        "text": "Poznámka: Z důvodu zachování důvěrnosti budou všechny skupiny, které nedosahují požadovaného počtu účastníků, sloučeny s jinou skupinou a budou zahrnuty do výpočtu průměrného hodnocení."
      },
      {
        "language": "EN",
        "text": "Note: For confidentiality purposes, any group that is less than the required individuals will be merged with another group and will be included in calculating the average rating."
      }
    ]
  },
  {
    "key": "txtoverall",
    "text": "Competencies Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "بشكل عام"
      },
      {
        "language": "DE",
        "text": "Kompetenzanalyse"
      },
      {
        "language": "PT",
        "text": "Análise de Competências"
      },
      {
        "language": "IT",
        "text": "Analisi delle competenze"
      },
      {
        "language": "CS",
        "text": "Celkově"
      },
      {
        "language": "EN",
        "text": "Competencies Analysis"
      }
    ]
  },
  {
    "key": "txtConfidential",
    "text": "Confidential",
    "translations": [
      {
        "language": "AR",
        "text": "خاص وسري"
      },
      {
        "language": "DE",
        "text": "Vertraulich"
      },
      {
        "language": "PT",
        "text": "Confidencial"
      },
      {
        "language": "IT",
        "text": "Riservato"
      },
      {
        "language": "CS",
        "text": "Důvěrné"
      },
      {
        "language": "EN",
        "text": "Confidential"
      }
    ]
  },
  {
    "key": "txtEvaluatorsFor",
    "text": "Evaluators for ",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون لـ  "
      },
      {
        "language": "DE",
        "text": " Gutachter für"
      },
      {
        "language": "PT",
        "text": "Avaliadores para"
      },
      {
        "language": "IT",
        "text": "Valutatori per"
      },
      {
        "language": "CS",
        "text": "Hodnotitelé pro"
      },
      {
        "language": "EN",
        "text": "Evaluators for "
      }
    ]
  },
  {
    "key": "txtMin3",
    "text": "should be 3 at minimum!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكونوا 3 على الأقل!"
      },
      {
        "language": "DE",
        "text": "mindestens 3!"
      },
      {
        "language": "PT",
        "text": "deve ser 3 no mínimo!"
      },
      {
        "language": "IT",
        "text": "devono essere almeno 3!"
      },
      {
        "language": "CS",
        "text": "měli by být minimálně 3!"
      },
      {
        "language": "EN",
        "text": "should be 3 at minimum!"
      }
    ]
  },
  {
    "key": "txtNoTemplete",
    "text": "A template must be selected to proceed!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار نموذج للمتابعة"
      },
      {
        "language": "DE",
        "text": "Um fortzufahren, muss eine Vorlage ausgewählt werden!"
      },
      {
        "language": "PT",
        "text": "Um modelo deve ser selecionado para prosseguir!"
      },
      {
        "language": "IT",
        "text": "È necessario selezionare un template per procedere!"
      },
      {
        "language": "CS",
        "text": "Chcete-li pokračovat, je nutné vybrat šablonu!"
      },
      {
        "language": "EN",
        "text": "A template must be selected to proceed!"
      }
    ]
  },
  {
    "key": "txtNoStatement",
    "text": "Every Selected competency must at least have one statement.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار عبارة واحدة على الأقل لكل جدارة ومهارة."
      },
      {
        "language": "DE",
        "text": "Jede ausgewählte Kompetenz muss mindestens eine Aussage haben."
      },
      {
        "language": "PT",
        "text": "Cada competência selecionada deve ter pelo menos uma declaração."
      },
      {
        "language": "IT",
        "text": "Ogni competenza selezionata deve avere almeno un'affermazione."
      },
      {
        "language": "CS",
        "text": "Každá vybraná kompetence musí obsahovat alespoň jeden výrok."
      },
      {
        "language": "EN",
        "text": "Every Selected competency must at least have one statement."
      }
    ]
  },
  {
    "key": "txtMin1",
    "text": "should be minimum 1!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون 1 على الأقل!"
      },
      {
        "language": "DE",
        "text": "mindestens 1!"
      },
      {
        "language": "PT",
        "text": "deve ser no mínimo 1!"
      },
      {
        "language": "IT",
        "text": "deve essere almeno 1!"
      },
      {
        "language": "CS",
        "text": "musí být alespoň 1!"
      },
      {
        "language": "EN",
        "text": "should be minimum 1!"
      }
    ]
  },
  {
    "key": "txtsummarycomments",
    "text": "Comments Summary",
    "translations": [
      {
        "language": "AR",
        "text": "ملخص التعليقات"
      },
      {
        "language": "DE",
        "text": "Kommentarzusammenfassung"
      },
      {
        "language": "PT",
        "text": "Resumo de comentários"
      },
      {
        "language": "IT",
        "text": "Sintesi dei commenti"
      },
      {
        "language": "CS",
        "text": "Souhrn komentářů"
      },
      {
        "language": "EN",
        "text": "Comments Summary"
      }
    ]
  },
  {
    "key": "txtsummarycommentsDesc",
    "text": "The following comments are segmented by evaluator group and are presented exactly as the respondent entered them, highlighting [Candidate Name]’s areas of strength and the suggested areas to develop.",
    "translations": [
      {
        "language": "AR",
        "text": "تم عرض التعليقات أدناه تماماً  كما عبر عنها المقيمون، مسلطين الضوء على نقاط القوة ومجالات التحسين المقترحة ل[Candidate Name]."
      },
      {
        "language": "DE",
        "text": "Die folgenden Kommentare sind nach Bewertergruppen segmentiert und werden genau so wiedergegeben, wie der Befragte sie eingegeben hat. Dabei werden die Stärken von [Name des Kandidaten] und die empfohlenen Entwicklungsbereiche hervorgehoben."
      },
      {
        "language": "PT",
        "text": "Os comentários a seguir são segmentados por grupo de avaliadores e apresentados exatamente como o entrevistado os inseriu, destacando os pontos fortes de [Nome do Candidato] e as áreas sugeridas para desenvolvimento."
      },
      {
        "language": "IT",
        "text": "I seguenti commenti sono suddivisi per gruppo di valutatori e vengono riportati esattamente nel modo in cui sono stati inseriti dal rispondente, evidenziando i punti di forza di [Nome Candidato] e le aree di sviluppo suggerite."
      },
      {
        "language": "CS",
        "text": "Následující připomínky jsou rozděleny podle skupin hodnotitelů a jsou uvedeny přesně tak, jak je respondenti zadali, přičemž zdůrazňují silné stránky [jméno respondenta] a oblasti, ve kterých by se měl dále rozvíjet."
      },
      {
        "language": "EN",
        "text": "The following comments are segmented by evaluator group and are presented exactly as the respondent entered them, highlighting [Candidate Name]’s areas of strength and the suggested areas to develop."
      }
    ]
  },
  {
    "key": "txtspiderchart",
    "text": "Spider Chart",
    "translations": [
      {
        "language": "AR",
        "text": "المخطط الشبكي"
      },
      {
        "language": "DE",
        "text": "Spider Chart"
      },
      {
        "language": "PT",
        "text": "Gráfico de aranha"
      },
      {
        "language": "IT",
        "text": "Grafico a ragno"
      },
      {
        "language": "CS",
        "text": "Pavoukový graf"
      },
      {
        "language": "EN",
        "text": "Spider Chart"
      }
    ]
  },
  {
    "key": "txtspiderchartdesc",
    "text": "An illustration of [Candidate Name]’s self-evaluated score compared with the overall evaluators’ score.",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح هذا المخطط مقارنة بين نتيجة [Candidate Name] الذاتية مع معدل نتائج المقيمين الآخرين."
      },
      {
        "language": "DE",
        "text": "Eine Darstellung der von [Name des Kandidaten] selbst bewerteten Punktzahl im Vergleich zur Gesamtpunktzahl der Bewerter."
      },
      {
        "language": "PT",
        "text": "Uma ilustração da pontuação autoavaliada de [Nome do candidato] em comparação com a pontuação geral dos avaliadores."
      },
      {
        "language": "IT",
        "text": "Rappresentazione grafica del punteggio dell'autovalutazione di [Nome Candidato] comparata al punteggio medio attribuito dai valutatori."
      },
      {
        "language": "CS",
        "text": "Graf znázorňující srovnání hodnocení, které si sám stanovil [jméno respondenta], s celkovým hodnocením hodnotitelů."
      },
      {
        "language": "EN",
        "text": "An illustration of [Candidate Name]’s self-evaluated score compared with the overall evaluators’ score."
      }
    ]
  },
  {
    "key": "txtSpiderChartDisclaimer",
    "text": "This figure displays a spider chart, where a range of 3 – 14 competencies must be selected to show data",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض هذا الشكل مخطط العنكبوت، حيث يجب تحديد مدى من 3 - 14 مهارات وجدارات لعرض البيانات"
      },
      {
        "language": "DE",
        "text": "Diese Abbildung zeigt ein Spider Chart, bei dem ein Bereich von 3 bis 10 Kompetenzen ausgewählt werden muss, um Daten anzuzeigen"
      },
      {
        "language": "PT",
        "text": "Esta figura exibe um gráfico de aranha, onde um intervalo de 3 a 10 competências deve ser selecionado para mostrar os dados"
      },
      {
        "language": "IT",
        "text": "Questo grafico mostra un grafico radar, in cui deve essere selezionato un intervallo da 3 a 10 competenze per visualizzare i dati."
      },
      {
        "language": "CS",
        "text": "Tento graf zobrazuje pavoučí diagram, ve kterém je třeba vybrat 3 až 10 kompetencí, aby se zobrazila data"
      },
      {
        "language": "EN",
        "text": "This figure displays a spider chart, where a range of 3 – 10 competencies must be selected to show data"
      }
    ]
  },
  {
    "key": "txtOverallPerformanceScoredesc",
    "text": "Overall Performance Score",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تقييم الأداء العام"
      },
      {
        "language": "DE",
        "text": "Gesamtleistungsergebnis"
      },
      {
        "language": "PT",
        "text": "Pontuação geral de desempenho"
      },
      {
        "language": "IT",
        "text": "Punteggio di performance complessivo"
      },
      {
        "language": "CS",
        "text": "Celkové hodnocení výkonu"
      },
      {
        "language": "EN",
        "text": "Overall Performance Score"
      }
    ]
  },
  {
    "key": "txtOverallPerformanceScoredescdesc",
    "text": "The following indicates the Overall Performance Score for ",
    "translations": [
      {
        "language": "AR",
        "text": "يبين الشكل أدناه النتيجة الكلية لمعدل تقييم الأداء الخاص بـ "
      },
      {
        "language": "DE",
        "text": " Nachfolgend ist der Gesamtleistungswert für"
      },
      {
        "language": "PT",
        "text": "O seguinte indica a pontuação de desempenho geral para"
      },
      {
        "language": "IT",
        "text": "Di seguito è riportato il punteggio di performance complessivo per"
      },
      {
        "language": "CS",
        "text": "Níže je uvedeno celkové skóre výkonu pro"
      },
      {
        "language": "EN",
        "text": "The following indicates the Overall Performance Score for "
      }
    ]
  },
  {
    "key": "txtNumberofEvaluators",
    "text": "Number of Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المقيمين"
      },
      {
        "language": "DE",
        "text": "Anzahl der Gutachter"
      },
      {
        "language": "PT",
        "text": "Número de avaliadores"
      },
      {
        "language": "IT",
        "text": "Numero di valutatori"
      },
      {
        "language": "CS",
        "text": "Počet hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Number of Evaluators"
      }
    ]
  },
  {
    "key": "txtGroup",
    "text": "Group",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة"
      },
      {
        "language": "DE",
        "text": "Gruppe"
      },
      {
        "language": "PT",
        "text": "Grupo"
      },
      {
        "language": "IT",
        "text": "Gruppo"
      },
      {
        "language": "CS",
        "text": "Skupina"
      },
      {
        "language": "EN",
        "text": "Group"
      }
    ]
  },
  {
    "key": "txtGroupsInvited",
    "text": "The following groups of individuals were invited to participate in this assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تم دعوة المجموعات التالية للمشاركة في هذا التقييم."
      },
      {
        "language": "DE",
        "text": "Die folgenden Personengruppen wurden eingeladen, an dieser Bewertung teilzunehmen"
      },
      {
        "language": "PT",
        "text": "Os seguintes grupos de indivíduos foram convidados a participar desta avaliação"
      },
      {
        "language": "IT",
        "text": "I seguenti gruppi di persone sono stati invitati a prendere parte a questo Assessment"
      },
      {
        "language": "CS",
        "text": "K účasti na tomto hodnocení byly přizvány následující skupiny osob"
      },
      {
        "language": "EN",
        "text": "The following groups of individuals were invited to participate in this assessment"
      }
    ]
  },
  {
    "key": "txtCompetenciesOverview",
    "text": "Competencies Overview",
    "translations": [
      {
        "language": "AR",
        "text": "النظرة العامة على الجدارات والمهارات"
      },
      {
        "language": "DE",
        "text": "Kompetenzen Übersicht"
      },
      {
        "language": "PT",
        "text": "Visão Geral das Competências"
      },
      {
        "language": "IT",
        "text": "Panoramica delle competenze"
      },
      {
        "language": "CS",
        "text": "Přehled kompetencí"
      },
      {
        "language": "EN",
        "text": "Competencies Overview"
      }
    ]
  },
  {
    "key": "txtCompetenciesOverviewDesc",
    "text": "The following summarizes the scores of [Candidate Name] for the selected competencies.",
    "translations": [
      {
        "language": "AR",
        "text": "الملخص أدناه يحتوي على نتائج الجدارات والمهارات التي تم اختيارها ل[Candidate Name]."
      },
      {
        "language": "DE",
        "text": "Im Folgenden sind die Punktzahlen von [Name des Kandidaten] für die ausgewählten Kompetenzen zusammengefasst."
      },
      {
        "language": "PT",
        "text": "O seguinte resume as pontuações de [Nome do Candidato] para as competências selecionadas."
      },
      {
        "language": "IT",
        "text": "Di seguito sono sintetizzati i punteggi di [Nome Candidato] per le competenze selezionate"
      },
      {
        "language": "CS",
        "text": "Níže je uveden přehled hodnocení [jméno uchazeče] v rámci vybraných kompetencí."
      },
      {
        "language": "EN",
        "text": "The following summarizes the scores of [Candidate Name] for the selected competencies."
      }
    ]
  },
  {
    "key": "txtStatementsOverview",
    "text": "Statements Overview",
    "translations": [
      {
        "language": "AR",
        "text": "النظرة العامة على العبارات"
      },
      {
        "language": "DE",
        "text": "Aussagen Übersicht"
      },
      {
        "language": "PT",
        "text": "Visão geral das declarações"
      },
      {
        "language": "IT",
        "text": "Panoramica delle affermazioni"
      },
      {
        "language": "CS",
        "text": "Přehled výpisů"
      },
      {
        "language": "EN",
        "text": "Statements Overview"
      }
    ]
  },
  {
    "key": "txtStatementsOverviewDesc",
    "text": "The following summarizes the scores of [Candidate Name] for the selected competencies’ statements.",
    "translations": [
      {
        "language": "AR",
        "text": "الملخص أدناه يحتوي على نتائج عبارات الجدارات والمهارات التي تم اختيارها ل[Candidate Name]."
      },
      {
        "language": "DE",
        "text": "Nachfolgend sind die Bewertungen von [Name des Kandidaten] für die ausgewählten Kompetenzaussagen zusammengefasst."
      },
      {
        "language": "PT",
        "text": "O seguinte resume as pontuações de [Nome do Candidato] para as declarações das competências selecionadas."
      },
      {
        "language": "IT",
        "text": "Di seguito sono sintetizzati i punteggi di [Nome Candidato] per le affermazioni relative alle competenze selezionate"
      },
      {
        "language": "CS",
        "text": "Níže je uveden souhrn hodnocení [jméno uchazeče] u jednotlivých tvrzení týkajících se vybraných kompetencí."
      },
      {
        "language": "EN",
        "text": "The following summarizes the scores of [Candidate Name] for the selected competencies’ statements."
      }
    ]
  },
  {
    "key": "txtHiddenBlind",
    "text": "Hidden Strengths and Blind Spots",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط القوة المجهولة ونقاط الضعف غير المدركة"
      },
      {
        "language": "DE",
        "text": "Versteckte Stärken und blinde Flecken"
      },
      {
        "language": "PT",
        "text": "Pontos fortes ocultos e pontos cegos"
      },
      {
        "language": "IT",
        "text": "Punti di forza nascosti e punti ciechi"
      },
      {
        "language": "CS",
        "text": "Skryté silné stránky a slepá místa"
      },
      {
        "language": "EN",
        "text": "Hidden Strengths and Blind Spots"
      }
    ]
  },
  {
    "key": "txtHiddenBlindDesc",
    "text": "The following tables list the top five hidden strengths and blind spots for [Candidate Name].",
    "translations": [
      {
        "language": "AR",
        "text": "يبين الجدول أدناه أعلى (5) نقاط للقوة المجهولة ونقاط الضعف غير المدركة ل[Candidate Name]."
      },
      {
        "language": "DE",
        "text": "In den folgenden Tabellen sind die fünf wichtigsten verborgenen Stärken und blinden Flecken von [Name des Kandidaten] aufgeführt."
      },
      {
        "language": "PT",
        "text": "As tabelas a seguir listam os cinco principais pontos fortes e pontos cegos ocultos de [Nome do Candidato]."
      },
      {
        "language": "IT",
        "text": "Le seguenti tabelle mostrano i primi cinque punti di forza nascosti e i punti ciechi di [Nome Candidato]."
      },
      {
        "language": "CS",
        "text": "V následujících tabulkách je uvedeno pět nejvýznamnějších skrytých silných stránek a slabých míst [jméno uchazeče]."
      },
      {
        "language": "EN",
        "text": "The following tables list the top five hidden strengths and blind spots for [Candidate Name]."
      }
    ]
  },
  {
    "key": "txtHiddenDesc",
    "text": "Hidden Strengths are the professional behaviors where evaluators have given an average rating more than the candidate has rated them. ",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط القوة المجهولة: هي السلوكيات المهنية التي أعطاها المقيمون درجة تقييم أعلى من تقييم المرشح لنفسه. "
      },
      {
        "language": "DE",
        "text": " Unter versteckten Stärken versteht man berufliche Verhaltensweisen, die von den Prüfern durchschnittlich besser bewertet wurden als vom Kandidaten."
      },
      {
        "language": "PT",
        "text": "Pontos fortes ocultos são os comportamentos profissionais em que os avaliadores deram uma classificação média maior do que a que o candidato os avaliou."
      },
      {
        "language": "IT",
        "text": "I punti di forza nascosti sono quei comportamenti professionali per i quali i valutatori hanno attribuito un punteggio medio superiore rispetto a quello assegnato dal candidato stesso."
      },
      {
        "language": "CS",
        "text": "Skryté silné stránky jsou takové profesní vlastnosti, u nichž hodnotitelé udělili vyšší průměrné hodnocení, než jaké jim dal sám uchazeč."
      },
      {
        "language": "EN",
        "text": "Hidden Strengths are the professional behaviors where evaluators have given an average rating more than the candidate has rated them. "
      }
    ]
  },
  {
    "key": "txtHiddenStrength",
    "text": "Hidden Strengths",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط القوة المجهولة"
      },
      {
        "language": "DE",
        "text": "Versteckte Stärken"
      },
      {
        "language": "PT",
        "text": "Pontos fortes ocultos"
      },
      {
        "language": "IT",
        "text": "Punti di forza nascosti"
      },
      {
        "language": "CS",
        "text": "Skryté přednosti"
      },
      {
        "language": "EN",
        "text": "Hidden Strengths"
      }
    ]
  },
  {
    "key": "txtBlindDesc",
    "text": "Blind Spots are the professional behaviors where evaluators have given an average rating lower than the candidate has rated them.  ",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط الضعف غير المدركة: هي السلوكيات المهنية التي أعطاها المقيمون درجة تقييم أقل من تقييم المرشح لنفسه. "
      },
      {
        "language": "DE",
        "text": " Blinde Flecken sind berufliche Verhaltensweisen, denen die Bewerter im Durchschnitt eine niedrigere Bewertung gegeben haben als die Kandidaten."
      },
      {
        "language": "PT",
        "text": "Pontos cegos são os comportamentos profissionais em que os avaliadores deram uma classificação média inferior à que o candidato os avaliou."
      },
      {
        "language": "IT",
        "text": "I punti ciechi sono i comportamenti professionali per i quali i valutatori hanno attribuito un punteggio medio inferiore rispetto a quello indicato dal candidato stesso."
      },
      {
        "language": "CS",
        "text": "Slepá místa představují oblasti profesního chování, v nichž hodnotitelé udělili nižší průměrné hodnocení, než jaké jim udělil samotný uchazeč."
      },
      {
        "language": "EN",
        "text": "Blind Spots are the professional behaviors where evaluators have given an average rating lower than the candidate has rated them.  "
      }
    ]
  },
  {
    "key": "txtBlind",
    "text": "Blind Spots ",
    "translations": [
      {
        "language": "AR",
        "text": "نقاط الضعف غير المدركة"
      },
      {
        "language": "DE",
        "text": " Blinde Flecken"
      },
      {
        "language": "PT",
        "text": "Pontos Cegos"
      },
      {
        "language": "IT",
        "text": "Punti ciechi"
      },
      {
        "language": "CS",
        "text": "Slepá místa"
      },
      {
        "language": "EN",
        "text": "Blind Spots "
      }
    ]
  },
  {
    "key": "txtAllEvaluators",
    "text": "All evaluators ",
    "translations": [
      {
        "language": "AR",
        "text": "جميع المقيمين"
      },
      {
        "language": "DE",
        "text": " Alle Bewerter"
      },
      {
        "language": "PT",
        "text": "Todos os avaliadores"
      },
      {
        "language": "IT",
        "text": "Tutti i valutatori"
      },
      {
        "language": "CS",
        "text": "Všichni hodnotitelé"
      },
      {
        "language": "EN",
        "text": "All evaluators "
      }
    ]
  },
  {
    "key": "txtTotal",
    "text": "Total ",
    "translations": [
      {
        "language": "AR",
        "text": "المجموع"
      },
      {
        "language": "DE",
        "text": " Gesamt"
      },
      {
        "language": "PT",
        "text": "Total"
      },
      {
        "language": "IT",
        "text": "Totale"
      },
      {
        "language": "CS",
        "text": "Celkem"
      },
      {
        "language": "EN",
        "text": "Total "
      }
    ]
  },
  {
    "key": "txtReportDesc",
    "text": "This report provides a summary of the scores of the feedback that has been received from the candidate and other evaluators on the following competencies:",
    "translations": [
      {
        "language": "AR",
        "text": "هذا التقرير يقدم ملخص لنتائج التقييم من المرشح ومن المقيمين الآخرين للجدارات والمهارات التالية:"
      },
      {
        "language": "DE",
        "text": "Dieser Bericht bietet eine Zusammenfassung der Bewertungen des Feedbacks, das vom Kandidaten und anderen Gutachtern zu den folgenden Kompetenzen erhalten wurde:"
      },
      {
        "language": "PT",
        "text": "Este relatório fornece um resumo das pontuações do feedback recebido do candidato e de outros avaliadores nas seguintes competências:"
      },
      {
        "language": "IT",
        "text": "Questo report fornisce una sintesi dei punteggi dei feedback ricevuti dal candidato e dagli altri valutatori riguardo alle seguenti competenze:"
      },
      {
        "language": "CS",
        "text": "Tato zpráva obsahuje souhrn hodnocení, která jsme obdrželi od uchazeče a dalších hodnotitelů ohledně následujících kompetencí:"
      },
      {
        "language": "EN",
        "text": "This report provides a summary of the scores of the feedback that has been received from the candidate and other evaluators on the following competencies:"
      }
    ]
  },
  {
    "key": "txtPreviousScore",
    "text": "Previous Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة السابقة"
      },
      {
        "language": "DE",
        "text": "Vorheriger Score"
      },
      {
        "language": "PT",
        "text": "Pontuação anterior"
      },
      {
        "language": "IT",
        "text": "Punteggio precedente"
      },
      {
        "language": "CS",
        "text": "Předchozí skóre"
      },
      {
        "language": "EN",
        "text": "Previous Score"
      }
    ]
  },
  {
    "key": "txtChangePercentage",
    "text": "Change Percentage",
    "translations": [
      {
        "language": "AR",
        "text": "معدل التغيير"
      },
      {
        "language": "DE",
        "text": "Prozentsatz ändern"
      },
      {
        "language": "PT",
        "text": "Porcentagem de alteração"
      },
      {
        "language": "IT",
        "text": "Variazione percentuale"
      },
      {
        "language": "CS",
        "text": "Procentuální změna"
      },
      {
        "language": "EN",
        "text": "Change Percentage"
      }
    ]
  },
  {
    "key": "txtAverageScore",
    "text": "Average Score",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط الدرجة"
      },
      {
        "language": "DE",
        "text": "Durchschnittlicher Score"
      },
      {
        "language": "PT",
        "text": "Pontuação Média"
      },
      {
        "language": "IT",
        "text": "Punteggio medio"
      },
      {
        "language": "CS",
        "text": "Průměrné skóre"
      },
      {
        "language": "EN",
        "text": "Average Score"
      }
    ]
  },
  {
    "key": "txtDifference",
    "text": "Difference",
    "translations": [
      {
        "language": "AR",
        "text": "الفرق"
      },
      {
        "language": "DE",
        "text": "Differenz"
      },
      {
        "language": "PT",
        "text": "Diferença"
      },
      {
        "language": "IT",
        "text": "Differenza"
      },
      {
        "language": "CS",
        "text": "Rozdíl"
      },
      {
        "language": "EN",
        "text": "Difference"
      }
    ]
  },
  {
    "key": "txtCompChartFor",
    "text": "For",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      },
      {
        "language": "DE",
        "text": "Für"
      },
      {
        "language": "PT",
        "text": "Para"
      },
      {
        "language": "IT",
        "text": "Per"
      },
      {
        "language": "CS",
        "text": "Pro"
      },
      {
        "language": "EN",
        "text": "For"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      },
      {
        "language": "DE",
        "text": "Okay"
      },
      {
        "language": "PT",
        "text": "OK"
      },
      {
        "language": "IT",
        "text": "Ok"
      },
      {
        "language": "CS",
        "text": "Dobře"
      },
      {
        "language": "EN",
        "text": "Okay"
      }
    ]
  },
  {
    "key": "txt_no_selected",
    "text": "Minimum Record is 1",
    "translations": [
      {
        "language": "AR",
        "text": "الحد الأدنى هو 1"
      },
      {
        "language": "DE",
        "text": "Mindestdatensatz ist 1"
      },
      {
        "language": "PT",
        "text": "O registro mínimo é 1"
      },
      {
        "language": "IT",
        "text": "È necessario almeno 1 elemento."
      },
      {
        "language": "CS",
        "text": "Minimální počet záznamů je 1"
      },
      {
        "language": "EN",
        "text": "Minimum Record is 1"
      }
    ]
  },
  {
    "key": "txt_already_exists",
    "text": "Already Exists",
    "translations": [
      {
        "language": "AR",
        "text": "موجود أصلاً "
      },
      {
        "language": "DE",
        "text": "Existiert bereits"
      },
      {
        "language": "PT",
        "text": "Já existe"
      },
      {
        "language": "IT",
        "text": "Già esistente"
      },
      {
        "language": "CS",
        "text": "Již existuje"
      },
      {
        "language": "EN",
        "text": "Already Exists"
      }
    ]
  },
  {
    "key": "txtNA",
    "text": "N/A",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      },
      {
        "language": "DE",
        "text": "N / A"
      },
      {
        "language": "PT",
        "text": "N / D"
      },
      {
        "language": "IT",
        "text": "N/D"
      },
      {
        "language": "CS",
        "text": "N/A"
      },
      {
        "language": "EN",
        "text": "N/A"
      }
    ]
  },
  {
    "key": "txtNeutral",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "مُحايد"
      },
      {
        "language": "DE",
        "text": "Neutral"
      },
      {
        "language": "PT",
        "text": "Neutro"
      },
      {
        "language": "IT",
        "text": "Neutrale"
      },
      {
        "language": "CS",
        "text": "Neutrální"
      },
      {
        "language": "EN",
        "text": "Neutral"
      }
    ]
  },
  {
    "key": "txtStronglyAgree",
    "text": "Strongly Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق بشدة"
      },
      {
        "language": "DE",
        "text": "Stimme voll und ganz zu"
      },
      {
        "language": "PT",
        "text": "Concordo plenamente"
      },
      {
        "language": "IT",
        "text": "Fortemente d'accordo"
      },
      {
        "language": "CS",
        "text": "Naprosto souhlasím"
      },
      {
        "language": "EN",
        "text": "Strongly Agree"
      }
    ]
  },
  {
    "key": "txtStronglyDisagree",
    "text": "Strongly Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق بشدة"
      },
      {
        "language": "DE",
        "text": "Stimme überhaupt nicht zu"
      },
      {
        "language": "PT",
        "text": "Discordo totalmente"
      },
      {
        "language": "IT",
        "text": "Fortemente in disaccordo"
      },
      {
        "language": "CS",
        "text": "Rozhodně nesouhlasím"
      },
      {
        "language": "EN",
        "text": "Strongly Disagree"
      }
    ]
  },
  {
    "key": "txtDisagree",
    "text": "Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق"
      },
      {
        "language": "DE",
        "text": "Stimme nicht zu"
      },
      {
        "language": "PT",
        "text": "Discordo"
      },
      {
        "language": "IT",
        "text": "In disaccordo"
      },
      {
        "language": "CS",
        "text": "Nesouhlasím"
      },
      {
        "language": "EN",
        "text": "Disagree"
      }
    ]
  },
  {
    "key": "txtAgree",
    "text": "Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق"
      },
      {
        "language": "DE",
        "text": "Stimme zu"
      },
      {
        "language": "PT",
        "text": "Concordar"
      },
      {
        "language": "IT",
        "text": "D'accordo"
      },
      {
        "language": "CS",
        "text": "Souhlasím"
      },
      {
        "language": "EN",
        "text": "Agree"
      }
    ]
  },
  {
    "key": "txtInvitationMissingURL",
    "text": "The email is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا البريد الإلكتروني!"
      },
      {
        "language": "DE",
        "text": "In der E-Mail fehlt ein Link!"
      },
      {
        "language": "PT",
        "text": "O e-mail está faltando um link!"
      },
      {
        "language": "IT",
        "text": "Nell’email manca un link!"
      },
      {
        "language": "CS",
        "text": "V e-mailu chybí odkaz!"
      },
      {
        "language": "EN",
        "text": "The email is missing a link!"
      }
    ]
  },
  {
    "key": "txtReminderMissingURL",
    "text": "The reminder is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا التذكير!"
      },
      {
        "language": "DE",
        "text": "In der Erinnerung fehlt ein Link!"
      },
      {
        "language": "PT",
        "text": "O lembrete está faltando um link!"
      },
      {
        "language": "IT",
        "text": "Nel promemoria manca un link!"
      },
      {
        "language": "CS",
        "text": "V upomínce chybí odkaz!"
      },
      {
        "language": "EN",
        "text": "The reminder is missing a link!"
      }
    ]
  },
  {
    "key": "txtEvaluatorMissing",
    "text": "The email is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا البريد الإلكتروني!"
      },
      {
        "language": "DE",
        "text": "In der E-Mail fehlt ein Link!"
      },
      {
        "language": "PT",
        "text": "O e-mail está faltando um link!"
      },
      {
        "language": "IT",
        "text": "Nell’email manca un link!"
      },
      {
        "language": "CS",
        "text": "V e-mailu chybí odkaz!"
      },
      {
        "language": "EN",
        "text": "The email is missing a link!"
      }
    ]
  },
  {
    "key": "txtEvaluatorReminderMissing",
    "text": "The reminder is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا التذكير!"
      },
      {
        "language": "DE",
        "text": "In der Erinnerung fehlt ein Link!"
      },
      {
        "language": "PT",
        "text": "O lembrete está faltando um link!"
      },
      {
        "language": "IT",
        "text": "Nel promemoria manca un link!"
      },
      {
        "language": "CS",
        "text": "V upomínce chybí odkaz!"
      },
      {
        "language": "EN",
        "text": "The reminder is missing a link!"
      }
    ]
  },
  {
    "key": "txt_unit_deduction",
    "text": "#UNITS# units will be deducted for this action",
    "translations": [
      {
        "language": "AR",
        "text": "#UNITS# وحدة سيتم خصمها لعمل هذا التقييم"
      },
      {
        "language": "DE",
        "text": "Für diese Aktion werden #UNITS# Einheiten abgezogen"
      },
      {
        "language": "PT",
        "text": "#UNITS# unidades serão deduzidas para esta ação"
      },
      {
        "language": "IT",
        "text": "#UNITS# unità verranno detratte per questa azione"
      },
      {
        "language": "CS",
        "text": "Za tuto akci bude odečteno #UNITS# jednotek"
      },
      {
        "language": "EN",
        "text": "#UNITS# units will be deducted for this action"
      }
    ]
  },
  {
    "key": "txtOneStatement",
    "text": "Every Selected competency must at least have one statement.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار عبارة واحدة على الأقل لكل مهارة و جدارة."
      },
      {
        "language": "DE",
        "text": "Jede ausgewählte Kompetenz muss mindestens eine Aussage haben."
      },
      {
        "language": "PT",
        "text": "Cada competência selecionada deve ter pelo menos uma declaração."
      },
      {
        "language": "IT",
        "text": "Ogni competenza selezionata deve avere almeno un'affermazione."
      },
      {
        "language": "CS",
        "text": "Každá vybraná kompetence musí obsahovat alespoň jeden výrok."
      },
      {
        "language": "EN",
        "text": "Every Selected competency must at least have one statement."
      }
    ]
  },
  {
    "key": "txtWeight100",
    "text": "Overall weight must be 100% to proceed.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون الوزن الكلي 100% للمتابعة."
      },
      {
        "language": "DE",
        "text": "Die Gesamtgewichtung muss 100 % betragen, um fortzufahren."
      },
      {
        "language": "PT",
        "text": "O peso total deve ser de 100% para prosseguir."
      },
      {
        "language": "IT",
        "text": "Il peso complessivo deve essere 100% per procedere."
      },
      {
        "language": "CS",
        "text": "Celková váha musí být 100 %, aby bylo možné pokračovat."
      },
      {
        "language": "EN",
        "text": "Overall weight must be 100% to proceed."
      }
    ]
  },
  {
    "key": "txt_full_name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "DE",
        "text": "Name"
      },
      {
        "language": "PT",
        "text": "Nome"
      },
      {
        "language": "IT",
        "text": "Nome"
      },
      {
        "language": "CS",
        "text": "Jméno uchazeče"
      },
      {
        "language": "EN",
        "text": "Name"
      }
    ]
  },
  {
    "key": "txt_ID",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "DE",
        "text": "ID"
      },
      {
        "language": "PT",
        "text": "EU IA"
      },
      {
        "language": "IT",
        "text": "ID"
      },
      {
        "language": "CS",
        "text": "ID"
      },
      {
        "language": "EN",
        "text": "ID"
      }
    ]
  },
  {
    "key": "txtPreviousScoreDesc",
    "text": "Compare against the previous score",
    "translations": [
      {
        "language": "AR",
        "text": "قارن مع النتيجة السابقة"
      },
      {
        "language": "DE",
        "text": "Vergleichen Sie mit dem vorherigen Ergebnis"
      },
      {
        "language": "PT",
        "text": "Compare com a pontuação anterior"
      },
      {
        "language": "IT",
        "text": "Confronta con il punteggio precedente"
      },
      {
        "language": "CS",
        "text": "Porovnejte s předchozím skóre"
      },
      {
        "language": "EN",
        "text": "Compare against the previous score"
      }
    ]
  },
  {
    "key": "txtAverageScoreDesc",
    "text": "Compare against the average evaluators scores.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن مع متوسط نتائج المقيمين"
      },
      {
        "language": "DE",
        "text": "Vergleichen Sie mit den durchschnittlichen Bewertungen der Bewerter."
      },
      {
        "language": "PT",
        "text": "Compare com as pontuações médias dos avaliadores."
      },
      {
        "language": "IT",
        "text": "Confronta con i punteggi medi dei valutatori."
      },
      {
        "language": "CS",
        "text": "Porovnejte s průměrným hodnocením hodnotitelů."
      },
      {
        "language": "EN",
        "text": "Compare against the average evaluators scores."
      }
    ]
  },
  {
    "key": "txtCompare",
    "text": "Compare",
    "translations": [
      {
        "language": "AR",
        "text": "قارن"
      },
      {
        "language": "DE",
        "text": "Vergleichen"
      },
      {
        "language": "PT",
        "text": "Comparar"
      },
      {
        "language": "IT",
        "text": "Confronta"
      },
      {
        "language": "CS",
        "text": "Porovnat"
      },
      {
        "language": "EN",
        "text": "Compare"
      }
    ]
  },
  {
    "key": "txtPrevious",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      },
      {
        "language": "DE",
        "text": "Vorherige"
      },
      {
        "language": "PT",
        "text": "Anterior"
      },
      {
        "language": "IT",
        "text": "Precedente"
      },
      {
        "language": "CS",
        "text": "Předchozí"
      },
      {
        "language": "EN",
        "text": "Previous"
      }
    ]
  },
  {
    "key": "btn_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      },
      {
        "language": "DE",
        "text": "Zurück"
      },
      {
        "language": "PT",
        "text": "Voltar"
      },
      {
        "language": "IT",
        "text": "Indietro"
      },
      {
        "language": "CS",
        "text": "Zpět"
      },
      {
        "language": "EN",
        "text": "Back"
      }
    ]
  },
  {
    "key": "txt_completed",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      },
      {
        "language": "DE",
        "text": "Abgeschlossen"
      },
      {
        "language": "PT",
        "text": "Concluído"
      },
      {
        "language": "IT",
        "text": "Completato"
      },
      {
        "language": "CS",
        "text": "Dokončeno"
      },
      {
        "language": "EN",
        "text": "Completed"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "DE",
        "text": "Suchen"
      },
      {
        "language": "PT",
        "text": "Procurar"
      },
      {
        "language": "IT",
        "text": "Cerca"
      },
      {
        "language": "CS",
        "text": "Hledat"
      },
      {
        "language": "EN",
        "text": "Search"
      }
    ]
  },
  {
    "key": "txt_candidate_name",
    "text": "Candidate's Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المرشح"
      },
      {
        "language": "DE",
        "text": "Name des Kandidaten"
      },
      {
        "language": "PT",
        "text": "Nome do Candidato"
      },
      {
        "language": "IT",
        "text": "Nome del candidato"
      },
      {
        "language": "CS",
        "text": "Jméno uchazeče"
      },
      {
        "language": "EN",
        "text": "Candidate's Name"
      }
    ]
  },
  {
    "key": "btn_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "DE",
        "text": "Bearbeiten"
      },
      {
        "language": "PT",
        "text": "Editar"
      },
      {
        "language": "IT",
        "text": "Modifica"
      },
      {
        "language": "CS",
        "text": "Upravit"
      },
      {
        "language": "EN",
        "text": "Edit"
      }
    ]
  },
  {
    "key": "txtResponses",
    "text": "Respondent Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المستجيبون"
      },
      {
        "language": "DE",
        "text": "Befragtenanalyse"
      },
      {
        "language": "PT",
        "text": "Análise do Respondente"
      },
      {
        "language": "IT",
        "text": "Analisi dei rispondenti"
      },
      {
        "language": "CS",
        "text": "Analýza respondentů"
      },
      {
        "language": "EN",
        "text": "Respondent Analysis"
      }
    ]
  },
  {
    "key": "txt_notcompleted",
    "text": "Not Completed",
    "translations": [
      {
        "language": "AR",
        "text": "غير مكتمل"
      },
      {
        "language": "DE",
        "text": "Nicht abgeschlossen"
      },
      {
        "language": "PT",
        "text": "Não concluído"
      },
      {
        "language": "IT",
        "text": "Non completato"
      },
      {
        "language": "CS",
        "text": "Nedokončeno"
      },
      {
        "language": "EN",
        "text": "Not Completed"
      }
    ]
  },
  {
    "key": "txtBreakout",
    "text": "Breakout:",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل حسب:"
      },
      {
        "language": "DE",
        "text": "Breakout:"
      },
      {
        "language": "PT",
        "text": "Saia:"
      },
      {
        "language": "IT",
        "text": "Filtra:"
      },
      {
        "language": "CS",
        "text": "Průnik:"
      },
      {
        "language": "EN",
        "text": "Breakout:"
      }
    ]
  },
  {
    "key": "txtCandidatePerformanceScore",
    "text": "Candidate Performance Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة تقييم أداء المرشح"
      },
      {
        "language": "DE",
        "text": "Leistungsbewertung des Kandidaten"
      },
      {
        "language": "PT",
        "text": "Pontuação de desempenho do candidato"
      },
      {
        "language": "IT",
        "text": "Punteggio della performance del candidato"
      },
      {
        "language": "CS",
        "text": "Hodnocení výkonu uchazeče"
      },
      {
        "language": "EN",
        "text": "Candidate Performance Score"
      }
    ]
  },
  {
    "key": "txtCompChartAvgSelf",
    "text": "Self Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة الذاتية"
      },
      {
        "language": "DE",
        "text": "Selbstbewertung"
      },
      {
        "language": "PT",
        "text": "Autopontuação"
      },
      {
        "language": "IT",
        "text": "Punteggio dell'autovalutazione"
      },
      {
        "language": "CS",
        "text": "Vlastní skóre"
      },
      {
        "language": "EN",
        "text": "Self Score"
      }
    ]
  },
  {
    "key": "btn_preview_survey",
    "text": "Preview Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التقييم"
      },
      {
        "language": "DE",
        "text": "Assessment Vorschau"
      },
      {
        "language": "PT",
        "text": "Avaliação prévia"
      },
      {
        "language": "IT",
        "text": "Anteprima dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Náhled na hodnocení"
      },
      {
        "language": "EN",
        "text": "Preview Assessment"
      }
    ]
  },
  {
    "key": "txt_employee_ID",
    "text": "Employee ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "DE",
        "text": "Mitarbeiter-ID"
      },
      {
        "language": "PT",
        "text": "ID do funcionário"
      },
      {
        "language": "IT",
        "text": "ID dipendente"
      },
      {
        "language": "CS",
        "text": "Číslo zaměstnance"
      },
      {
        "language": "EN",
        "text": "Employee ID"
      }
    ]
  },
  {
    "key": "txtMinCompetencies",
    "text": "Minimium 3 competencies must be selected!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار 3 مهارات وجدارات على الأقل!"
      },
      {
        "language": "DE",
        "text": "Es müssen mindestens 3 Kompetenzen ausgewählt werden!"
      },
      {
        "language": "PT",
        "text": "Devem ser selecionadas no mínimo 3 competências!"
      },
      {
        "language": "IT",
        "text": "Devono essere selezionate almeno 3 competenze!"
      },
      {
        "language": "CS",
        "text": "Je nutné vybrat minimálně 3 kompetence!"
      },
      {
        "language": "EN",
        "text": "Minimium 3 competencies must be selected!"
      }
    ]
  },
  {
    "key": "txt_start_and_endDate",
    "text": "Please, add start date and end date.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إضافة تاريخ البدء وتاريخ الانتهاء."
      },
      {
        "language": "DE",
        "text": "Bitte fügen Sie Start- und Enddatum hinzu."
      },
      {
        "language": "PT",
        "text": "Por favor, adicione a data de início e a data de término."
      },
      {
        "language": "IT",
        "text": "Aggiungi la data di inizio e di fine."
      },
      {
        "language": "CS",
        "text": "Uveďte prosím datum zahájení a datum ukončení."
      },
      {
        "language": "EN",
        "text": "Please, add start date and end date."
      }
    ]
  },
  {
    "key": "txtMinStatements",
    "text": "Minimium 3 statements must be selected!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار 3 عبارات على الأقل!"
      },
      {
        "language": "DE",
        "text": "Es müssen mindestens 3 Aussagen ausgewählt werden!"
      },
      {
        "language": "PT",
        "text": "Devem ser selecionadas no mínimo 3 afirmações!"
      },
      {
        "language": "IT",
        "text": "Devono essere selezionate almeno 3 affermazioni!"
      },
      {
        "language": "CS",
        "text": "Je třeba vybrat alespoň 3 výroky!"
      },
      {
        "language": "EN",
        "text": "Minimium 3 statements must be selected!"
      }
    ]
  },
  {
    "key": "sameDate",
    "text": "This date has already been set!",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد تاريخ التذكير!"
      },
      {
        "language": "DE",
        "text": "Dieser Termin wurde bereits vergeben!"
      },
      {
        "language": "PT",
        "text": "Esta data já foi definida!"
      },
      {
        "language": "IT",
        "text": "Questa data è già stata impostata!"
      },
      {
        "language": "CS",
        "text": "Tento termín už byl stanoven!"
      },
      {
        "language": "EN",
        "text": "This date has already been set!"
      }
    ]
  },
  {
    "key": "txtSurveyRespondentList",
    "text": "Assessment Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون للتقييم"
      },
      {
        "language": "DE",
        "text": "Liste der Bewertungsteilnehmer"
      },
      {
        "language": "PT",
        "text": "Lista de respondentes da avaliação"
      },
      {
        "language": "IT",
        "text": "Elenco dei rispondenti dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Seznam respondentů hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Respondents List"
      }
    ]
  },
  {
    "key": "txtSearch",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "DE",
        "text": "Suchen"
      },
      {
        "language": "PT",
        "text": "Procurar"
      },
      {
        "language": "IT",
        "text": "Cerca"
      },
      {
        "language": "CS",
        "text": "Hledat"
      },
      {
        "language": "EN",
        "text": "Search"
      }
    ]
  },
  {
    "key": "txt_tenure_group",
    "text": "Tenure Group",
    "translations": [
      {
        "language": "AR",
        "text": "فئات سنوات الخدمة"
      },
      {
        "language": "DE",
        "text": "Mitarbeitenden-Gruppe"
      },
      {
        "language": "PT",
        "text": "Grupo de Posse"
      },
      {
        "language": "IT",
        "text": "Fascia di anzianità aziendale"
      },
      {
        "language": "CS",
        "text": "Skupina pro trvalé zaměstnání"
      },
      {
        "language": "EN",
        "text": "Tenure Group"
      }
    ]
  },
  {
    "key": "txt_resp_by_generation",
    "text": "Respondents by Generation",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب نوع الجيل"
      },
      {
        "language": "DE",
        "text": "KandidatInnen nach Generation"
      },
      {
        "language": "PT",
        "text": "Respondentes por geração"
      },
      {
        "language": "IT",
        "text": "Rispondenti per generazione"
      },
      {
        "language": "CS",
        "text": "Respondenti podle generace"
      },
      {
        "language": "EN",
        "text": "Respondents by Generation"
      }
    ]
  },
  {
    "key": "txt_age_group",
    "text": "Respondents by Age Group",
    "translations": [
      {
        "language": "AR",
        "text": "الفئات العمرية"
      },
      {
        "language": "DE",
        "text": "Befragte nach Altersgruppe"
      },
      {
        "language": "PT",
        "text": "Respondentes por faixa etária"
      },
      {
        "language": "IT",
        "text": "Rispondenti per fascia d'età"
      },
      {
        "language": "CS",
        "text": "Respondenti podle věkových skupin"
      },
      {
        "language": "EN",
        "text": "Respondents by Age Group"
      }
    ]
  },
  {
    "key": "txt_leaver_nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      },
      {
        "language": "DE",
        "text": "Nationalität"
      },
      {
        "language": "PT",
        "text": "Nacionalidade"
      },
      {
        "language": "IT",
        "text": "Nazionalità"
      },
      {
        "language": "CS",
        "text": "Státní příslušnost"
      },
      {
        "language": "EN",
        "text": "Nationality"
      }
    ]
  },
  {
    "key": "txtCompChartAvgEvaluator",
    "text": "Evaluators Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة المقيمين"
      },
      {
        "language": "DE",
        "text": "Bewertung der Bewerter"
      },
      {
        "language": "PT",
        "text": "Pontuação dos avaliadores"
      },
      {
        "language": "IT",
        "text": "Punteggio dei valutatori"
      },
      {
        "language": "CS",
        "text": "Hodnocení hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Evaluators Score"
      }
    ]
  },
  {
    "key": "txtCompChartChooseCompetency",
    "text": "Choose Competencies",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الجدارات والمهارات"
      },
      {
        "language": "DE",
        "text": "Kompetenzen auswählen"
      },
      {
        "language": "PT",
        "text": "Escolha competências"
      },
      {
        "language": "IT",
        "text": "Scegli le competenze"
      },
      {
        "language": "CS",
        "text": "Vyberte kompetence"
      },
      {
        "language": "EN",
        "text": "Choose Competencies"
      }
    ]
  },
  {
    "key": "txtCompChartView",
    "text": "View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض"
      },
      {
        "language": "DE",
        "text": "Siehe"
      },
      {
        "language": "PT",
        "text": "Visualizar"
      },
      {
        "language": "IT",
        "text": "Visualizza"
      },
      {
        "language": "CS",
        "text": "Zobrazit"
      },
      {
        "language": "EN",
        "text": "View"
      }
    ]
  },
  {
    "key": "txtCompChartSortBy",
    "text": "Sort By",
    "translations": [
      {
        "language": "AR",
        "text": "تصنيف حسب"
      },
      {
        "language": "DE",
        "text": "Sortieren nach"
      },
      {
        "language": "PT",
        "text": "Ordenar por"
      },
      {
        "language": "IT",
        "text": "Ordina per"
      },
      {
        "language": "CS",
        "text": "Seřadit podle"
      },
      {
        "language": "EN",
        "text": "Sort By"
      }
    ]
  },
  {
    "key": "txtCompetencyAnalysis",
    "text": "Competency Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الجدارات والمهارات"
      },
      {
        "language": "DE",
        "text": "Kompetenzanalyse"
      },
      {
        "language": "PT",
        "text": "Análise de Competências"
      },
      {
        "language": "IT",
        "text": "Analisi delle competenze"
      },
      {
        "language": "CS",
        "text": "Analýza kompetencí"
      },
      {
        "language": "EN",
        "text": "Competency Analysis"
      }
    ]
  },
  {
    "key": "txtfor",
    "text": "For",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      },
      {
        "language": "DE",
        "text": "Für"
      },
      {
        "language": "PT",
        "text": "Para"
      },
      {
        "language": "IT",
        "text": "Per"
      },
      {
        "language": "CS",
        "text": "Pro"
      },
      {
        "language": "EN",
        "text": "For"
      }
    ]
  },
  {
    "key": "txtTotalNumberofEvaluators",
    "text": "Total Number of Evaluators:",
    "translations": [
      {
        "language": "AR",
        "text": "العدد الكلي للمقيمين:"
      },
      {
        "language": "DE",
        "text": "Gesamtzahl der Gutachter:"
      },
      {
        "language": "PT",
        "text": "Número total de avaliadores:"
      },
      {
        "language": "IT",
        "text": "Numero totale di valutatori:"
      },
      {
        "language": "CS",
        "text": "Celkový počet hodnotitelů:"
      },
      {
        "language": "EN",
        "text": "Total Number of Evaluators:"
      }
    ]
  },
  {
    "key": "txtDetailedScore",
    "text": "Detailed Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة المفصلة"
      },
      {
        "language": "DE",
        "text": "Detaillierte Bewertung"
      },
      {
        "language": "PT",
        "text": "Pontuação detalhada"
      },
      {
        "language": "IT",
        "text": "Punteggio dettagliato"
      },
      {
        "language": "CS",
        "text": "Podrobný výsledek"
      },
      {
        "language": "EN",
        "text": "Detailed Score"
      }
    ]
  },
  {
    "key": "txtstatementOverallScore",
    "text": "statement / Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة الكلية لكل عبارة"
      },
      {
        "language": "DE",
        "text": "Stellungnahme / Gesamtnote"
      },
      {
        "language": "PT",
        "text": "declaração / pontuação geral"
      },
      {
        "language": "IT",
        "text": "affermazione/Punteggio complessivo"
      },
      {
        "language": "CS",
        "text": "hodnocení / Celkové skóre"
      },
      {
        "language": "EN",
        "text": "statement / Overall Score"
      }
    ]
  },
  {
    "key": "txtEvaluatorsComments",
    "text": "Evaluators Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تعليقات المقيمين"
      },
      {
        "language": "DE",
        "text": "Kommentare der Gutachter"
      },
      {
        "language": "PT",
        "text": "Comentários dos avaliadores"
      },
      {
        "language": "IT",
        "text": "Commenti dei valutatori"
      },
      {
        "language": "CS",
        "text": "Komentáře hodnotitelů"
      },
      {
        "language": "EN",
        "text": "Evaluators Comments"
      }
    ]
  },
  {
    "key": "txtResponsesAnalysis",
    "text": "Responses Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الردود"
      },
      {
        "language": "DE",
        "text": "Antwortanalyse"
      },
      {
        "language": "PT",
        "text": "Análise de Respostas"
      },
      {
        "language": "IT",
        "text": "Analisi delle risposte"
      },
      {
        "language": "CS",
        "text": "Analýza odpovědí"
      },
      {
        "language": "EN",
        "text": "Responses Analysis"
      }
    ]
  },
  {
    "key": "txt360ManagementReport",
    "text": "360° Management Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير °360 الإداري "
      },
      {
        "language": "DE",
        "text": "360° Management Report"
      },
      {
        "language": "PT",
        "text": "Relatório de Gestão 360°"
      },
      {
        "language": "IT",
        "text": "Management Report 360°"
      },
      {
        "language": "CS",
        "text": "360 Zpráva"
      },
      {
        "language": "EN",
        "text": "360° Management Report"
      }
    ]
  },
  {
    "key": "txt360CandidateReport",
    "text": "360° Candidate Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير °360 للمرشح"
      },
      {
        "language": "DE",
        "text": "360° Kandidatenbericht"
      },
      {
        "language": "PT",
        "text": "Relatório de Candidato 360°"
      },
      {
        "language": "IT",
        "text": "Candidate Report 360°"
      },
      {
        "language": "CS",
        "text": "360° Zpráva pro respondenta"
      },
      {
        "language": "EN",
        "text": "360° Candidate Report"
      }
    ]
  },
  {
    "key": "Management",
    "text": "Management",
    "translations": [
      {
        "language": "AR",
        "text": "الإدارة"
      },
      {
        "language": "DE",
        "text": "Management"
      },
      {
        "language": "PT",
        "text": "Gerenciamento"
      },
      {
        "language": "IT",
        "text": "Management"
      },
      {
        "language": "CS",
        "text": "Vedení"
      },
      {
        "language": "EN",
        "text": "Management"
      }
    ]
  },
  {
    "key": "btn_update",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      },
      {
        "language": "DE",
        "text": "Aktualisieren"
      },
      {
        "language": "PT",
        "text": "Atualizar"
      },
      {
        "language": "IT",
        "text": "Aggiorna"
      },
      {
        "language": "CS",
        "text": "Aktualizace"
      },
      {
        "language": "EN",
        "text": "Update"
      }
    ]
  },
  {
    "key": "txtof",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      },
      {
        "language": "DE",
        "text": "von"
      },
      {
        "language": "PT",
        "text": "de"
      },
      {
        "language": "IT",
        "text": "di"
      },
      {
        "language": "CS",
        "text": "z"
      },
      {
        "language": "EN",
        "text": "of"
      }
    ]
  },
  {
    "key": "txt_assessment_list",
    "text": "Assessment List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة التقييمات"
      },
      {
        "language": "DE",
        "text": "Assessent-Liste"
      },
      {
        "language": "PT",
        "text": "Lista de Avaliação"
      },
      {
        "language": "IT",
        "text": "Elenco degli Assessment"
      },
      {
        "language": "CS",
        "text": "Seznam hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment List"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "DE",
        "text": "Abbrechen"
      },
      {
        "language": "PT",
        "text": "Cancelar"
      },
      {
        "language": "IT",
        "text": "Annulla"
      },
      {
        "language": "CS",
        "text": "Zrušit"
      },
      {
        "language": "EN",
        "text": "Cancel"
      }
    ]
  },
  {
    "key": "txtEditSurvey",
    "text": "Edit Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل التقييم"
      },
      {
        "language": "DE",
        "text": "Bewertung bearbeiten"
      },
      {
        "language": "PT",
        "text": "Editar avaliação"
      },
      {
        "language": "IT",
        "text": "Modifica l'Assessment"
      },
      {
        "language": "CS",
        "text": "Upravit hodnocení"
      },
      {
        "language": "EN",
        "text": "Edit Assessment"
      }
    ]
  },
  {
    "key": "txtTemplateEmail",
    "text": "This template is optimized for email clients \"Gmail, Outook, ...etc\" please modify with care. If you wish to revert to the default template click on the \"Default Template\" button.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحسين هذا النموذج لمستخدمي البريد الالكتروني الخاص بـ \"Gmail, Outlook,…etc\" الرجاء التعديل بحذر. إذا كنت ترغب بالتحويل للنموذج الأساسي اضغط على زر \"النموذج الأساسي\"."
      },
      {
        "language": "DE",
        "text": "Diese Vorlage ist für E-Mail-Clients wie „Gmail, Outlook usw.“ optimiert. Bitte ändern Sie sie mit Bedacht. Wenn Sie zur Standardvorlage zurückkehren möchten, klicken Sie auf die Schaltfläche „Standardvorlage“."
      },
      {
        "language": "PT",
        "text": "Este modelo é otimizado para clientes de e-mail \"Gmail, Outook, ...etc\", modifique com cuidado. Se desejar reverter para o modelo padrão, clique no botão \"Modelo padrão\"."
      },
      {
        "language": "IT",
        "text": "Questo template è ottimizzato per i client di posta elettronica come \"Gmail, Outlook, ...ecc.\". Modificalo con attenzione. Se desideri ripristinare il template predefinito, clicca sul pulsante \"Template predefinito\"."
      },
      {
        "language": "CS",
        "text": "Tato šablona je optimalizována pro e-mailové klienty jako „Gmail, Outlook atd.“. Při úpravách postupujte opatrně. Pokud se chcete vrátit k výchozí šabloně, klikněte na tlačítko „Výchozí šablona“."
      },
      {
        "language": "EN",
        "text": "This template is optimized for email clients \"Gmail, Outook, ...etc\" please modify with care. If you wish to revert to the default template click on the \"Default Template\" button."
      }
    ]
  },
  {
    "key": "txtDefaultTemplate",
    "text": "Default Template",
    "translations": [
      {
        "language": "AR",
        "text": "النموذج الأساسي"
      },
      {
        "language": "DE",
        "text": "Standardvorlage"
      },
      {
        "language": "PT",
        "text": "Modelo padrão"
      },
      {
        "language": "IT",
        "text": "Template predefinito"
      },
      {
        "language": "CS",
        "text": "Výchozí šablona"
      },
      {
        "language": "EN",
        "text": "Default Template"
      }
    ]
  },
  {
    "key": "txt_deleted",
    "text": "Deleted",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذفه"
      },
      {
        "language": "DE",
        "text": "Gelöscht"
      },
      {
        "language": "PT",
        "text": "Excluído"
      },
      {
        "language": "IT",
        "text": "Eliminato"
      },
      {
        "language": "CS",
        "text": "Smazáno"
      },
      {
        "language": "EN",
        "text": "Deleted"
      }
    ]
  },
  {
    "key": "GENERALCOMMENT",
    "text": "General Comment",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات العامة"
      },
      {
        "language": "DE",
        "text": "Allgemeiner Kommentar"
      },
      {
        "language": "PT",
        "text": "Comentário Geral"
      },
      {
        "language": "IT",
        "text": "Commento generale"
      },
      {
        "language": "CS",
        "text": "Obecná poznámka"
      },
      {
        "language": "EN",
        "text": "General Comment"
      }
    ]
  },
  {
    "key": "btn_remove",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "DE",
        "text": "Löschen"
      },
      {
        "language": "PT",
        "text": "Excluir"
      },
      {
        "language": "IT",
        "text": "Elimina"
      },
      {
        "language": "CS",
        "text": "Smazat"
      },
      {
        "language": "EN",
        "text": "Delete"
      }
    ]
  },
  {
    "key": "txt_send_reminders",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات"
      },
      {
        "language": "DE",
        "text": "Erinnerungen senden"
      },
      {
        "language": "PT",
        "text": "Enviar lembretes"
      },
      {
        "language": "IT",
        "text": "Invia i promemoria"
      },
      {
        "language": "CS",
        "text": "Odeslat připomenutí"
      },
      {
        "language": "EN",
        "text": "Send Reminders"
      }
    ]
  },
  {
    "key": "txt_send_reminder",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكير"
      },
      {
        "language": "DE",
        "text": "Erinnerung senden"
      },
      {
        "language": "PT",
        "text": "Enviar lembrete"
      },
      {
        "language": "IT",
        "text": "Invia un promemoria"
      },
      {
        "language": "CS",
        "text": "Odeslat připomenutí"
      },
      {
        "language": "EN",
        "text": "Send Reminder"
      }
    ]
  },
  {
    "key": "txt_not_started",
    "text": "Not Started",
    "translations": [
      {
        "language": "AR",
        "text": "لم يبدأ"
      },
      {
        "language": "DE",
        "text": "Nicht gestartet"
      },
      {
        "language": "PT",
        "text": "Não iniciado"
      },
      {
        "language": "IT",
        "text": "Non iniziato"
      },
      {
        "language": "CS",
        "text": "Nebylo zahájeno"
      },
      {
        "language": "EN",
        "text": "Not Started"
      }
    ]
  },
  {
    "key": "txt_in_progress",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإتمام"
      },
      {
        "language": "DE",
        "text": "In Bearbeitung"
      },
      {
        "language": "PT",
        "text": "Em andamento"
      },
      {
        "language": "IT",
        "text": "In corso"
      },
      {
        "language": "CS",
        "text": "Probíhá"
      },
      {
        "language": "EN",
        "text": "In Progress"
      }
    ]
  },
  {
    "key": "txt_assessment_progress",
    "text": "Assessment Progress",
    "translations": [
      {
        "language": "AR",
        "text": "حالة التقييم"
      },
      {
        "language": "DE",
        "text": "Assessment-Fortschritt"
      },
      {
        "language": "PT",
        "text": "Progresso da Avaliação"
      },
      {
        "language": "IT",
        "text": "Avanzamento dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Průběh hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Progress"
      }
    ]
  },
  {
    "key": "btn_filter_by",
    "text": "Filter By",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب"
      },
      {
        "language": "DE",
        "text": "Filtern nach"
      },
      {
        "language": "PT",
        "text": "Filtrar por"
      },
      {
        "language": "IT",
        "text": "Filtra per"
      },
      {
        "language": "CS",
        "text": "Filtrovat podle"
      },
      {
        "language": "EN",
        "text": "Filter By"
      }
    ]
  },
  {
    "key": "btnCloseNow",
    "text": "CLOSE NOW",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الآن"
      },
      {
        "language": "DE",
        "text": "JETZT SCHLIESSEN"
      },
      {
        "language": "PT",
        "text": "FECHAR AGORA"
      },
      {
        "language": "IT",
        "text": "CHIUDI ORA"
      },
      {
        "language": "CS",
        "text": "ZAVŘÍT NYNÍ"
      },
      {
        "language": "EN",
        "text": "CLOSE NOW"
      }
    ]
  },
  {
    "key": "txtResponded",
    "text": "Responded",
    "translations": [
      {
        "language": "AR",
        "text": "استجاب منهم"
      },
      {
        "language": "DE",
        "text": "Beantwortet"
      },
      {
        "language": "PT",
        "text": "Respondeu"
      },
      {
        "language": "IT",
        "text": "Risposto"
      },
      {
        "language": "CS",
        "text": "Respondent"
      },
      {
        "language": "EN",
        "text": "Responded"
      }
    ]
  },
  {
    "key": "txtCandidateTemplate",
    "text": "Candidate Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج المرشح"
      },
      {
        "language": "DE",
        "text": "Kandidatenvorlage"
      },
      {
        "language": "PT",
        "text": "Modelo de Candidato"
      },
      {
        "language": "IT",
        "text": "Template del candidato"
      },
      {
        "language": "CS",
        "text": "Šablona pro uchazeče"
      },
      {
        "language": "EN",
        "text": "Candidate Template"
      }
    ]
  },
  {
    "key": "txtevaluatorsTemplate",
    "text": "evaluators Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج المقيم"
      },
      {
        "language": "DE",
        "text": "Gutachter Vorlage"
      },
      {
        "language": "PT",
        "text": "modelo de avaliadores"
      },
      {
        "language": "IT",
        "text": "Template dei valutatori"
      },
      {
        "language": "CS",
        "text": "Šablona pro hodnotitele"
      },
      {
        "language": "EN",
        "text": "evaluators Template"
      }
    ]
  },
  {
    "key": "txtAssessReminderSubject",
    "text": "[Reminder] Assessment Feedback 2022",
    "translations": [
      {
        "language": "AR",
        "text": "[تذكير] تقييم أداء 2022"
      },
      {
        "language": "DE",
        "text": "[Erinnerung] Bewertungsfeedback 2022"
      },
      {
        "language": "PT",
        "text": "[Lembrete] Feedback da avaliação 2022"
      },
      {
        "language": "IT",
        "text": "[Promemoria] Feedback Assessment 2022"
      },
      {
        "language": "CS",
        "text": "[Upomínka] Zpětná vazba k hodnocení 2022"
      },
      {
        "language": "EN",
        "text": "[Reminder] Assessment Feedback 2022"
      }
    ]
  },
  {
    "key": "txt_evaluator_limit_reached",
    "text": "You have exceeded the evaluator limit of #ENO# evaluators for candidate #CANDIDATENAME#, #UNITS# unit(s) will be deducted to increase the limit by #LIMITINCREASE# for the evalutors you are about to add. (1 Unit for every 20 Evaulators)",
    "translations": [
      {
        "language": "AR",
        "text": "لقد تجاوزت العدد المسموح به للمقيمين #ENO# للمرشح #CANDIDATENAME#, سوف يتم خصم #UNITS# وحدات لزيادة العدد المسموح به #LIMITINCREASE# للمقيمين الذين ترغب بإضافاتهم. (1 وحدة لكل 20 مقيم)"
      },
      {
        "language": "DE",
        "text": "Sie haben das Gutachterlimit von #ENO# Gutachtern für den Kandidaten #CANDIDATENAME# überschritten. Es werden #UNITS# Units abgezogen, um das Limit für die Gutachter, die Sie hinzufügen möchten, um #LIMITINCREASE# zu erhöhen. (1 Unit für jeweils 20 Gutachter)"
      },
      {
        "language": "PT",
        "text": "Você excedeu o limite de avaliadores #ENO# para o candidato #CANDIDATENAME#, #UNITS# unidades serão deduzidas para aumentar o limite em #LIMITINCREASE# para os avaliadores que você está prestes a adicionar. (1 unidade para cada 20 avaliadores)"
      },
      {
        "language": "IT",
        "text": "Hai superato il limite di #ENO# valutatori per il candidato #CANDIDATENAME#, verranno detratte #UNITS# unità per aumentare il limite di #LIMITINCREASE# in relazione ai valutatori che stai per aggiungere. (1 unità ogni 20 valutatori)"
      },
      {
        "language": "CS",
        "text": "U respondenta #CANDIDATENAME# jste překročili limit #ENO# hodnotitelů. Aby se limit pro hodnotitele, které se chystáte přidat, zvýšil o #LIMITINCREASE#, bude odečteno #UNITS# jednotek. (1 jednotka na každých 20 hodnotitelů)"
      },
      {
        "language": "EN",
        "text": "You have exceeded the evaluator limit of #ENO# evaluators for candidate #CANDIDATENAME#, #UNITS# unit(s) will be deducted to increase the limit by #LIMITINCREASE# for the evalutors you are about to add. (1 Unit for every 20 Evaulators)"
      }
    ]
  },
  {
    "key": "txt_remove_respondents_confirmation_message",
    "text": "Are you sure you want to delete these respondents?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هؤلاء المستجيبون؟"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diese Befragten wirklich löschen?"
      },
      {
        "language": "PT",
        "text": "Tem certeza de que deseja excluir estes entrevistados?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questi rispondenti?"
      },
      {
        "language": "CS",
        "text": "Opravdu chcete tyto respondenty smazat?"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete these respondents?"
      }
    ]
  },
  {
    "key": "txt_go_closed_360",
    "text": "This assessment will now be closed and you will no longer be able to make any changes or add new respondents. Any candidate without self-evaluation or with less than 1 manager and 2 Team/Peer submitting the assessment will be excluded from the analysis.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إنهاء هذا التقييم الآن ولن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين. سيتم استبعاد المرشح في حال لم يقم بتعبئة التقييم الذاتي أو في حال كان لديه أقل من مدير واحد وتقييمين من فريق/زملاء."
      },
      {
        "language": "DE",
        "text": "Dieses Assessment wird nun geschlossen und Sie können keine Änderungen mehr vornehmen oder neue Befragte hinzufügen. Jeder Kandidat ohne Selbstbewertung oder mit weniger als 1 Manager und 2 Team/Peer, die die Bewertung einreichen, wird von der Analyse ausgeschlossen."
      },
      {
        "language": "PT",
        "text": "Esta avaliação será encerrada e você não poderá mais fazer alterações ou adicionar novos entrevistados. Qualquer candidato sem autoavaliação ou com menos de 1 gestor e 2 Equipes/Pares submetendo a avaliação será excluído da análise."
      },
      {
        "language": "IT",
        "text": "Questo Assessment ora verrà chiuso e non sarà più possibile apportare modifiche o aggiungere nuovi rispondenti. Qualsiasi candidato privo di autovalutazione o con meno di 1 Manager e 2 tra i colleghi e il team come valutatori  che abbiano completato la valutazione sarà escluso dall’analisi."
      },
      {
        "language": "CS",
        "text": "Toto hodnocení bude nyní uzavřeno a již nebudete moci provádět žádné změny ani přidávat nové respondenty. Každý respondent, který nevyplnil sebehodnocení nebo u kterého hodnocení vyplnilo méně než 1 nadřízený a 2 kolegové/členové z týmu, bude z analýzy vyloučen."
      },
      {
        "language": "EN",
        "text": "This assessment will now be closed and you will no longer be able to make any changes or add new respondents. Any candidate without self-evaluation or with less than 1 manager and 2 Team/Peer submitting the assessment will be excluded from the analysis."
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_subject",
    "text": "Delete Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد الحذف"
      },
      {
        "language": "DE",
        "text": "Löschen bestätigt"
      },
      {
        "language": "PT",
        "text": "Excluir confirmação"
      },
      {
        "language": "IT",
        "text": "Conferma eliminazione"
      },
      {
        "language": "CS",
        "text": "Potvrzení smazání"
      },
      {
        "language": "EN",
        "text": "Delete Confirmation"
      }
    ]
  },
  {
    "key": "txt_allocation_confirmation",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "DE",
        "text": "Bestätigung"
      },
      {
        "language": "PT",
        "text": "Confirmação"
      },
      {
        "language": "IT",
        "text": "Conferma"
      },
      {
        "language": "CS",
        "text": "Potvrzení"
      },
      {
        "language": "EN",
        "text": "Confirmation"
      }
    ]
  },
  {
    "key": "txt_one_candidate_needed",
    "text": "At least a candidate and an evaluator of his need to complete the assessment to close",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يتم إكمال التقييم من قِبَل المرشح ومقيّم واحد له على الأقل لإغلاق التقييم"
      },
      {
        "language": "DE",
        "text": "Mindestens ein Kandidat und einer seiner Bewerter müssen die Bewertung abzuschließen, um zu schließen"
      },
      {
        "language": "PT",
        "text": "Pelo menos um candidato e um avaliador precisam concluir a avaliação para fechar"
      },
      {
        "language": "IT",
        "text": "Almeno un candidato e un suo valutatore devono completare l'Assessment per chiuderlo"
      },
      {
        "language": "CS",
        "text": "Každý uchazeč by měl mít 1 hodnocení od nadřízeného a nejméně 2 hodnocení od kolegů/týmu"
      },
      {
        "language": "EN",
        "text": "At least a candidate and an evaluator of his need to complete the assessment to close"
      }
    ]
  },
  {
    "key": "txt_every_candidate_rules_closing",
    "text": "Every candidate should have 1 completed manager and total of 2 completed Peer/Team",
    "translations": [
      {
        "language": "AR",
        "text": "على كل مرشح أن يحظى بمدير واحد بالإضافة إلى اثنان من الزملاء/ أعضاء الفريق ممن أنهوا التقييم"
      },
      {
        "language": "DE",
        "text": "Jeder Kandidat sollte 1 abgeschlossenen Manager und insgesamt 2 abgeschlossene Peer/Team haben"
      },
      {
        "language": "PT",
        "text": "Cada candidato deve ter 1 gerente concluído e um total de 2 pares/equipe concluídos"
      },
      {
        "language": "IT",
        "text": "Ogni candidato deve avere 1 valutazione completata dal manager e un totale di 2 valutazioni completate dai colleghi o dal team"
      },
      {
        "language": "CS",
        "text": "Každý uchazeč by měl mít 1 hodnocení od nadřízeného a nejméně 2 hodnocení od kolegů/týmu"
      },
      {
        "language": "EN",
        "text": "Every candidate should have 1 completed manager and total of 2 completed Peer/Team"
      }
    ]
  },
  {
    "key": "txtHowtousethisreportparaman",
    "text": "<p class=\"mb-4\">This report is a representation of [Candidate Name]’s feedback.</p>\n  <p class=\"mb-4\">The competencies overview will display the [Candidate Name]’s score compared to the evaluator’s score.</p>\n  <p class=\"mb-4\">It will highlight [Candidate Name]’s top five hidden strengths and blind spots that can be used to reference areas of improvement and encouragement.</p>\n",
    "translations": [
      {
        "language": "AR",
        "text": "<p class=\"mb-4\">يبين هذا التقرير آراء وملاحظات الأفراد الذين قاموا بتقييم المرشح .[Candidate Name]</p>\n  <p class=\"mb-4\">ستجد نتيجة التقييم الذاتي للمرشح ونتائج تقييم الآخرين له في قسم \"النظرة العامة على الجدارات والمهارات\" في هذا التقرير.</p>\n  <p class=\"mb-4\">هذا التقرير يسلط الضوء على أعلى (5) نقاط للقوة المجهولة ونقاط الضعف غير المدركة لدى المرشح لاستخدامها كحافز للتطوير والتحسين الذاتي.</p>\n"
      },
      {
        "language": "DE",
        "text": " <p class=\"mb-4\">Dieser Bericht ist eine Darstellung des Feedbacks von [Name des Kandidaten].</p> <p class=\"mb-4\">Die Kompetenzübersicht zeigt die Punktzahl von [Name des Kandidaten] im Vergleich zur Punktzahl des Bewerters.</p> <p class=\"mb-4\">Sie hebt die fünf größten verborgenen Stärken und blinden Flecken von [Name des Kandidaten] hervor, die als Referenz für Bereiche verwendet werden können, in denen Verbesserungen und Ermutigungen erforderlich sind.</p>"
      },
      {
        "language": "PT",
        "text": "<p class=\"mb-4\">Este relatório é uma representação do feedback de [Nome do candidato].</p>\n<p class=\"mb-4\">A visão geral das competências exibirá a pontuação do [Nome do Candidato] em comparação com a pontuação do avaliador.</p>\n<p class=\"mb-4\">Ele destacará os cinco principais pontos fortes e pontos cegos de [Nome do candidato] que podem ser usados ​​para referenciar áreas de melhoria e incentivo.</p>"
      },
      {
        "language": "IT",
        "text": "<p class=\"mb-4\">Questo report rappresenta il feedback di [Nome del candidato+C4].</p>\n  <p class=\"mb-4\">La panoramica delle competenze mostrerà il punteggio di [Nome del Candidato] paragonato con quello del valutatore.</p>\n  <p class=\"mb-4\">Evidenzierà i cinque principali punti di forza nascosti e i punti ciechi di [Nome del Candidato], che possono essere utilizzati per individuare le aree di miglioramento e di incoraggiamento.</p>\n"
      },
      {
        "language": "CS",
        "text": "<p class=\"mb-4\">Tato zpráva představuje zpětnou vazbu od [Jméno uchazeče].</p>\n  \n<p class=\"mb-4\">Přehled kompetencí zobrazí skóre [Jméno kandidáta] ve srovnání se skóre hodnotitele.</p>\n  <p class=\"mb-4\">Zvýrazní pět nejvýznamnějších skrytých silných stránek a slabých míst [Jméno respondenta], které lze použít jako vodítko pro oblasti, v nichž je třeba se zlepšit, a pro povzbuzení.</p>"
      },
      {
        "language": "EN",
        "text": "<p class=\"mb-4\">This report is a representation of [Candidate Name]’s feedback.</p>\n  <p class=\"mb-4\">The competencies overview will display the [Candidate Name]’s score compared to the evaluator’s score.</p>\n  <p class=\"mb-4\">It will highlight [Candidate Name]’s top five hidden strengths and blind spots that can be used to reference areas of improvement and encouragement.</p>\n"
      }
    ]
  },
  {
    "key": "txt_questionnaire_name",
    "text": "Assessment Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم التقييم"
      },
      {
        "language": "DE",
        "text": "Name der Assessment"
      },
      {
        "language": "PT",
        "text": "Nome da Avaliação"
      },
      {
        "language": "IT",
        "text": "Nome dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Název hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Name"
      }
    ]
  },
  {
    "key": "txt_survey_questions",
    "text": "Assessment Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة التقييم"
      },
      {
        "language": "DE",
        "text": "Assessment-Fragen"
      },
      {
        "language": "PT",
        "text": "Perguntas de avaliação"
      },
      {
        "language": "IT",
        "text": "Domande dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Kontrolní otázky"
      },
      {
        "language": "EN",
        "text": "Assessment Questions"
      }
    ]
  },
  {
    "key": "txt_question",
    "text": "Question",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      },
      {
        "language": "DE",
        "text": "Frage"
      },
      {
        "language": "PT",
        "text": "Pergunta"
      },
      {
        "language": "IT",
        "text": "Domanda"
      },
      {
        "language": "CS",
        "text": "Otázka"
      },
      {
        "language": "EN",
        "text": "Question"
      }
    ]
  },
  {
    "key": "txtExportSurvey",
    "text": "Download Assessment Questions",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل أسئلة التقييم"
      },
      {
        "language": "DE",
        "text": "Assessmentfragen herunterladen"
      },
      {
        "language": "PT",
        "text": "Baixar perguntas de avaliação"
      },
      {
        "language": "IT",
        "text": "Scarica le domande dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Stáhnout hodnotící otázky"
      },
      {
        "language": "EN",
        "text": "Download Assessment Questions"
      }
    ]
  },
  {
    "key": "txtExportSurveyasses",
    "text": "Download Assessment Questions",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل أسئلة التقييم"
      },
      {
        "language": "DE",
        "text": "Assessmentfragen herunterladen"
      },
      {
        "language": "PT",
        "text": "Baixar perguntas de avaliação"
      },
      {
        "language": "IT",
        "text": "Scarica le domande dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Stáhnout hodnotící otázky"
      },
      {
        "language": "EN",
        "text": "Download Assessment Questions"
      }
    ]
  },
  {
    "key": "txtCompetencyName",
    "text": "Competency Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الجدارة أو المهارة"
      },
      {
        "language": "DE",
        "text": "Kompetenzname"
      },
      {
        "language": "PT",
        "text": "Nome da Competência"
      },
      {
        "language": "IT",
        "text": "Nome della competenza"
      },
      {
        "language": "CS",
        "text": "Název kompetence"
      },
      {
        "language": "EN",
        "text": "Competency Name"
      }
    ]
  },
  {
    "key": "txtCompetencyDefinition",
    "text": "Competency Definition",
    "translations": [
      {
        "language": "AR",
        "text": "تعريف الجدارة أو المهارة"
      },
      {
        "language": "DE",
        "text": "Kompetenzdefinition"
      },
      {
        "language": "PT",
        "text": "Definição de Competência"
      },
      {
        "language": "IT",
        "text": "Definizione della competenza"
      },
      {
        "language": "CS",
        "text": "Definice kompetence"
      },
      {
        "language": "EN",
        "text": "Competency Definition"
      }
    ]
  },
  {
    "key": "txt_reminder_date",
    "text": "Reminder Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ التذكير"
      },
      {
        "language": "DE",
        "text": "Erinnerungsdatum"
      },
      {
        "language": "PT",
        "text": "Data do lembrete"
      },
      {
        "language": "IT",
        "text": "Data del promemoria"
      },
      {
        "language": "CS",
        "text": "Datum připomenutí"
      },
      {
        "language": "EN",
        "text": "Reminder Date"
      }
    ]
  },
  {
    "key": "txtRelationshipType",
    "text": "Relationship Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع العلاقة"
      },
      {
        "language": "DE",
        "text": "Beziehungstypus"
      },
      {
        "language": "PT",
        "text": "Tipo de relacionamento"
      },
      {
        "language": "IT",
        "text": "Tipo di relazione"
      },
      {
        "language": "CS",
        "text": "Typ vztahu"
      },
      {
        "language": "EN",
        "text": "Relationship Type"
      }
    ]
  },
  {
    "key": "txt_email_address",
    "text": "Email Address",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الالكتروني"
      },
      {
        "language": "DE",
        "text": "E-Mail-Adresse"
      },
      {
        "language": "PT",
        "text": "Endereço de email"
      },
      {
        "language": "IT",
        "text": "Indirizzo email"
      },
      {
        "language": "CS",
        "text": "E-mailová adresa"
      },
      {
        "language": "EN",
        "text": "Email Address"
      }
    ]
  },
  {
    "key": "txt_respondent_name",
    "text": "Respondent's Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "DE",
        "text": "Name des Befragten"
      },
      {
        "language": "PT",
        "text": "Nome do entrevistado"
      },
      {
        "language": "IT",
        "text": "Nome del rispondente"
      },
      {
        "language": "CS",
        "text": "Jméno respondenta"
      },
      {
        "language": "EN",
        "text": "Respondent's Name"
      }
    ]
  },
  {
    "key": "txt_reminder_sent",
    "text": "Email sent to relevant respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال البريد الإلكتروني إلى المستجيبين المعنيين."
      },
      {
        "language": "DE",
        "text": "E-Mail an relevante Befragte gesendet."
      },
      {
        "language": "PT",
        "text": "E-mail enviado aos entrevistados relevantes."
      },
      {
        "language": "IT",
        "text": "Email inviata ai rispondenti corretti."
      },
      {
        "language": "CS",
        "text": "E-mail zaslaný příslušným respondentům."
      },
      {
        "language": "EN",
        "text": "Email sent to relevant respondents."
      }
    ]
  },
  {
    "key": "txt_your",
    "text": "your",
    "translations": [
      {
        "language": "AR",
        "text": "الخاص بك"
      },
      {
        "language": "DE",
        "text": "Ihre/s"
      },
      {
        "language": "PT",
        "text": "seu"
      },
      {
        "language": "IT",
        "text": "tuo"
      },
      {
        "language": "CS",
        "text": "tvoje"
      },
      {
        "language": "EN",
        "text": "your"
      }
    ]
  },
  {
    "key": "txt_yes",
    "text": "Yes",
    "translations": [
      {
        "language": "AR",
        "text": "نعم"
      },
      {
        "language": "DE",
        "text": "Ja"
      },
      {
        "language": "PT",
        "text": "Sim"
      },
      {
        "language": "IT",
        "text": "Sì"
      },
      {
        "language": "CS",
        "text": "Ano"
      },
      {
        "language": "EN",
        "text": "Yes"
      }
    ]
  },
  {
    "key": "txt_remove_candidate_confirmation_message",
    "text": "Are you sure you want to delete this candidate? Respondents for this candidate will be removed as well",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا المرشح؟ سيتم حذف المستجيون لهذا المرشح أيضاً!"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diesen Kandidaten wirklich löschen? Die Antwortenden für diesen Kandidaten werden ebenfalls gelöscht."
      },
      {
        "language": "PT",
        "text": "Tem certeza de que deseja excluir este candidato? Os entrevistados deste candidato também serão removidos"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questo candidato? Anche i rispondenti associati verranno rimossi"
      },
      {
        "language": "CS",
        "text": "Opravdu chcete tohoto uchazeče smazat? Budou odstraněny také odpovědi tohoto uchazeče."
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this candidate? Respondents for this candidate will be removed as well"
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_message",
    "text": "Are you sure you want to delete this respondent?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا المستجيب؟"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diesen Befragten wirklich löschen?"
      },
      {
        "language": "PT",
        "text": "Tem certeza de que deseja excluir este entrevistado?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questo rispondente?"
      },
      {
        "language": "CS",
        "text": "Opravdu chcete tohoto respondenta smazat?"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this respondent?"
      }
    ]
  },
  {
    "key": "txt_you",
    "text": "you",
    "translations": [
      {
        "language": "AR",
        "text": "أنت"
      },
      {
        "language": "DE",
        "text": "Sie"
      },
      {
        "language": "PT",
        "text": "você"
      },
      {
        "language": "IT",
        "text": "tu"
      },
      {
        "language": "CS",
        "text": "ty"
      },
      {
        "language": "EN",
        "text": "you"
      }
    ]
  },
  {
    "key": "btn_save_questionnaire",
    "text": "Save",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ"
      },
      {
        "language": "DE",
        "text": "Speichern"
      },
      {
        "language": "PT",
        "text": "Salvar"
      },
      {
        "language": "IT",
        "text": "Salva"
      },
      {
        "language": "CS",
        "text": "Uložit"
      },
      {
        "language": "EN",
        "text": "Save"
      }
    ]
  },
  {
    "key": "txt_start_date",
    "text": "Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء"
      },
      {
        "language": "DE",
        "text": "Startdatum"
      },
      {
        "language": "PT",
        "text": "Data de início"
      },
      {
        "language": "IT",
        "text": "Data di inizio"
      },
      {
        "language": "CS",
        "text": "Datum zahájení"
      },
      {
        "language": "EN",
        "text": "Start Date"
      }
    ]
  },
  {
    "key": "txt_survey_setup",
    "text": "Assessment Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد التقييم"
      },
      {
        "language": "DE",
        "text": "Einrichtung der Bewertung"
      },
      {
        "language": "PT",
        "text": "Configuração da avaliação"
      },
      {
        "language": "IT",
        "text": "Configurazione dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Nastavení hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Setup"
      }
    ]
  },
  {
    "key": "txt_analytical_criteria",
    "text": "Analytical Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير التحليلية"
      },
      {
        "language": "DE",
        "text": "Analytische Kriterien"
      },
      {
        "language": "PT",
        "text": "Critérios Analíticos"
      },
      {
        "language": "IT",
        "text": "Criteri analitici"
      },
      {
        "language": "CS",
        "text": "Analytická kritéria"
      },
      {
        "language": "EN",
        "text": "Analytical Criteria"
      }
    ]
  },
  {
    "key": "txt_timeframe",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "DE",
        "text": "Zeitrahmen"
      },
      {
        "language": "PT",
        "text": "Prazo"
      },
      {
        "language": "IT",
        "text": "Intervallo di tempo"
      },
      {
        "language": "CS",
        "text": "Časový rámec"
      },
      {
        "language": "EN",
        "text": "Timeframe"
      }
    ]
  },
  {
    "key": "txt_invitation_email",
    "text": "Invitation Email",
    "translations": [
      {
        "language": "AR",
        "text": "دعوة لاستكمال التقييم"
      },
      {
        "language": "DE",
        "text": "Einladungs-E-Mail"
      },
      {
        "language": "PT",
        "text": "E-mail de convite"
      },
      {
        "language": "IT",
        "text": "Email di invito"
      },
      {
        "language": "CS",
        "text": "Pozvánka e-mailem"
      },
      {
        "language": "EN",
        "text": "Invitation Email"
      }
    ]
  },
  {
    "key": "txt_title",
    "text": "title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      },
      {
        "language": "DE",
        "text": "Titel"
      },
      {
        "language": "PT",
        "text": "título"
      },
      {
        "language": "IT",
        "text": "titolo"
      },
      {
        "language": "CS",
        "text": "název"
      },
      {
        "language": "EN",
        "text": "title"
      }
    ]
  },
  {
    "key": "txt_description",
    "text": "Description (Optional)",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "DE",
        "text": "Beschreibung (optional)"
      },
      {
        "language": "PT",
        "text": "Descrição (opcional)"
      },
      {
        "language": "IT",
        "text": "Descrizione (Opzionale)"
      },
      {
        "language": "CS",
        "text": "Popis (volitelné)"
      },
      {
        "language": "EN",
        "text": "Description (Optional)"
      }
    ]
  },
  {
    "key": "Predefined Assessment",
    "text": "Predefined Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم معد مسبقاً"
      },
      {
        "language": "DE",
        "text": "Vordefinierte Bewertung"
      },
      {
        "language": "PT",
        "text": "Avaliação Predefinida"
      },
      {
        "language": "IT",
        "text": "Assessment predefinito"
      },
      {
        "language": "CS",
        "text": "Předdefinované hodnocení"
      },
      {
        "language": "EN",
        "text": "Predefined Assessment"
      }
    ]
  },
  {
    "key": "txt_set_timeframe",
    "text": "Set Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المدة الزمنية"
      },
      {
        "language": "DE",
        "text": "Zeitrahmen festlegen"
      },
      {
        "language": "PT",
        "text": "Definir prazo"
      },
      {
        "language": "IT",
        "text": "Imposta l'intervallo di tempo"
      },
      {
        "language": "CS",
        "text": "Nastavit časový rámec"
      },
      {
        "language": "EN",
        "text": "Set Timeframe"
      }
    ]
  },
  {
    "key": "txt_completion_date",
    "text": "Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال"
      },
      {
        "language": "DE",
        "text": "Fertigstellungstermin"
      },
      {
        "language": "PT",
        "text": "Data de conclusão"
      },
      {
        "language": "IT",
        "text": "Data di completamento"
      },
      {
        "language": "CS",
        "text": "Datum dokončení"
      },
      {
        "language": "EN",
        "text": "Completion Date"
      }
    ]
  },
  {
    "key": "txt_set_reminders",
    "text": "Set Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "ضبط التذكيرات"
      },
      {
        "language": "DE",
        "text": "Erinnerungen festlegen"
      },
      {
        "language": "PT",
        "text": "Definir lembretes"
      },
      {
        "language": "IT",
        "text": "Imposta i promemoria"
      },
      {
        "language": "CS",
        "text": "Nastavit připomenutí"
      },
      {
        "language": "EN",
        "text": "Set Reminders"
      }
    ]
  },
  {
    "key": "txt_add_reminder",
    "text": "Add Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تذكير"
      },
      {
        "language": "DE",
        "text": "Erinnerung hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar lembrete"
      },
      {
        "language": "IT",
        "text": "Aggiungi un promemoria"
      },
      {
        "language": "CS",
        "text": "Přidat upomínku"
      },
      {
        "language": "EN",
        "text": "Add Reminder"
      }
    ]
  },
  {
    "key": "txt_no_reminders",
    "text": "No reminders have been created.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد أية تذكيرات تم ضبطها حتى الآن!"
      },
      {
        "language": "DE",
        "text": "Es wurden keine Erinnerungen erstellt."
      },
      {
        "language": "PT",
        "text": "Nenhum lembrete foi criado."
      },
      {
        "language": "IT",
        "text": "Nessun promemoria creato."
      },
      {
        "language": "CS",
        "text": "Nebyly vytvořeny žádné připomenutí."
      },
      {
        "language": "EN",
        "text": "No reminders have been created."
      }
    ]
  },
  {
    "key": "txt_multiple_reminders",
    "text": "Multiple Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "تذكيرات متعددة"
      },
      {
        "language": "DE",
        "text": "Erinnerungen vervielfachen"
      },
      {
        "language": "PT",
        "text": "Vários lembretes"
      },
      {
        "language": "IT",
        "text": "Promemoria multipli"
      },
      {
        "language": "CS",
        "text": "Více upomínek"
      },
      {
        "language": "EN",
        "text": "Multiple Reminders"
      }
    ]
  },
  {
    "key": "txt_multiple_reminders_description",
    "text": "Remind your respondents at preset times to fill the assessment before the completion date.<br> Set a maximum of 3 Reminders from using the right interface.<br> Click the button below to edit the email template.",
    "translations": [
      {
        "language": "AR",
        "text": "ذكّر المستجيبين بتعبئة التقييم قبل موعد الانتهاء من خلال تذكيرات محددة مسبقًا. اضبط 3 تذكيرات كحد أقصى باستخدام الواجهة اليمنى. اضغط على الزر أدناه لتعديل البريد الالكتروني الخاص بالتذكير."
      },
      {
        "language": "DE",
        "text": "Erinnern Sie Ihre Befragten zu festgelegten Zeiten daran, das Assessment vor dem Abschlussdatum auszufüllen.<br> Legen Sie über die rechte Benutzeroberfläche maximal 3 Erinnerungen fest.<br> Klicken Sie unten auf die Schaltfläche, um die E-Mail-Vorlage zu bearbeiten."
      },
      {
        "language": "PT",
        "text": "Lembre seus respondentes em horários predefinidos de preencher a avaliação antes da data de conclusão.<br> Defina no máximo três lembretes usando a interface correta.<br> Clique no botão abaixo para editar o modelo de e-mail."
      },
      {
        "language": "IT",
        "text": "Ricorda in orari prestabiliti ai tuoi rispondenti di completare l'Assessment prima della data di completamento. Imposta un massimo di 3 promemoria dall'interfaccia a destra. Clicca il pulsante sotto per modificare il template dell'email."
      },
      {
        "language": "CS",
        "text": "V předem nastavených časech připomeňte respondentům, aby vyplnili dotazník ještě před termínem uzávěrky.<br> Prostřednictvím příslušného rozhraní můžete nastavit maximálně 3 připomenutí.<br> Kliknutím na tlačítko níže můžete upravit šablonu e-mailu."
      },
      {
        "language": "EN",
        "text": "Remind your respondents at preset times to fill the assessment before the completion date.<br> Set a maximum of 3 Reminders from using the right interface.<br> Click the button below to edit the email template."
      }
    ]
  },
  {
    "key": "txt_reminder_template",
    "text": "Reminder Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج التذكير"
      },
      {
        "language": "DE",
        "text": "Erinnerungsvorlage"
      },
      {
        "language": "PT",
        "text": "Modelo de lembrete"
      },
      {
        "language": "IT",
        "text": "Template del promemoria"
      },
      {
        "language": "CS",
        "text": "Šablona upomínky"
      },
      {
        "language": "EN",
        "text": "Reminder Template"
      }
    ]
  },
  {
    "key": "txt_send_to",
    "text": "Send To",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال إلى"
      },
      {
        "language": "DE",
        "text": "Senden an"
      },
      {
        "language": "PT",
        "text": "Enviar para"
      },
      {
        "language": "IT",
        "text": "Invia a"
      },
      {
        "language": "CS",
        "text": "Odeslat"
      },
      {
        "language": "EN",
        "text": "Send To"
      }
    ]
  },
  {
    "key": "txt_subject_line",
    "text": "Subject Line",
    "translations": [
      {
        "language": "AR",
        "text": "خانة العنوان"
      },
      {
        "language": "DE",
        "text": "Betreffzeile"
      },
      {
        "language": "PT",
        "text": "Linha de assunto"
      },
      {
        "language": "IT",
        "text": "Oggetto"
      },
      {
        "language": "CS",
        "text": "Předmět"
      },
      {
        "language": "EN",
        "text": "Subject Line"
      }
    ]
  },
  {
    "key": "txt_message_body",
    "text": "Body",
    "translations": [
      {
        "language": "AR",
        "text": "نص الرسالة"
      },
      {
        "language": "DE",
        "text": "Haupttext"
      },
      {
        "language": "PT",
        "text": "Corpo"
      },
      {
        "language": "IT",
        "text": "Corpo del messaggio"
      },
      {
        "language": "CS",
        "text": "Stať"
      },
      {
        "language": "EN",
        "text": "Body"
      }
    ]
  },
  {
    "key": "txt_send_invitations",
    "text": "Send Invitations",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      },
      {
        "language": "DE",
        "text": "Einladungen versenden"
      },
      {
        "language": "PT",
        "text": "Enviar convites"
      },
      {
        "language": "IT",
        "text": "Invia gli inviti"
      },
      {
        "language": "CS",
        "text": "Odeslat pozvánky"
      },
      {
        "language": "EN",
        "text": "Send Invitations"
      }
    ]
  },
  {
    "key": "btn_add_candidate",
    "text": "Add Candidate",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مرشح"
      },
      {
        "language": "DE",
        "text": "Kandidaten hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar candidato"
      },
      {
        "language": "IT",
        "text": "Aggiungi un candidato"
      },
      {
        "language": "CS",
        "text": "Přidat uchazeče"
      },
      {
        "language": "EN",
        "text": "Add Candidate"
      }
    ]
  },
  {
    "key": "txt_selected_competencies",
    "text": "Selected Competencies",
    "translations": [
      {
        "language": "AR",
        "text": "الجدارات والمهارات التي تم اختيارها"
      },
      {
        "language": "DE",
        "text": "Ausgewählte Kompetenzen"
      },
      {
        "language": "PT",
        "text": "Competências Selecionadas"
      },
      {
        "language": "IT",
        "text": "Competenze selezionate"
      },
      {
        "language": "CS",
        "text": "Vybrané kompetence"
      },
      {
        "language": "EN",
        "text": "Selected Competencies"
      }
    ]
  },
  {
    "key": "txtMinCandidate",
    "text": "At least one candidate needs to be added!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة مرشح واحد على الأقل!"
      },
      {
        "language": "DE",
        "text": "Es muss mindestens ein Kandidat hinzugefügt werden!"
      },
      {
        "language": "PT",
        "text": "Pelo menos um candidato precisa ser adicionado!"
      },
      {
        "language": "IT",
        "text": "Almeno un candidato deve essere aggiunto!"
      },
      {
        "language": "CS",
        "text": "Je třeba přidat alespoň jednoho respondenta!"
      },
      {
        "language": "EN",
        "text": "At least one candidate needs to be added!"
      }
    ]
  },
  {
    "key": "btn_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق"
      },
      {
        "language": "DE",
        "text": "Schließen"
      },
      {
        "language": "PT",
        "text": "Fechar"
      },
      {
        "language": "IT",
        "text": "Chiudi"
      },
      {
        "language": "CS",
        "text": "Zavřít"
      },
      {
        "language": "EN",
        "text": "Close"
      }
    ]
  },
  {
    "key": "btn_save_reminder_template",
    "text": "Save Template",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ نموذج التذكير"
      },
      {
        "language": "DE",
        "text": "Vorlage speichern"
      },
      {
        "language": "PT",
        "text": "Salvar modelo"
      },
      {
        "language": "IT",
        "text": "Salva il template"
      },
      {
        "language": "CS",
        "text": "Uložit šablonu"
      },
      {
        "language": "EN",
        "text": "Save Template"
      }
    ]
  },
  {
    "key": "txtEmailTemplate",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الالكتروني"
      },
      {
        "language": "DE",
        "text": "E-Mail-Vorlage"
      },
      {
        "language": "PT",
        "text": "Modelo de e-mail"
      },
      {
        "language": "IT",
        "text": "Template email"
      },
      {
        "language": "CS",
        "text": "Šablona e-mailu"
      },
      {
        "language": "EN",
        "text": "Email Template"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadership",
    "text": "Transformational Leadership",
    "translations": [
      {
        "language": "AR",
        "text": "القيادة التحويلية"
      },
      {
        "language": "DE",
        "text": "Transformationale Führung"
      },
      {
        "language": "PT",
        "text": "Liderança Transformacional"
      },
      {
        "language": "IT",
        "text": "Leadership trasformazionale"
      },
      {
        "language": "CS",
        "text": "Transformační vedení"
      },
      {
        "language": "EN",
        "text": "Transformational Leadership"
      }
    ]
  },
  {
    "key": "txtAssessmentInfo",
    "text": "Assessment Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات التقييم"
      },
      {
        "language": "DE",
        "text": "Assessment informationen"
      },
      {
        "language": "PT",
        "text": "Informações de avaliação"
      },
      {
        "language": "IT",
        "text": "Informazioni sull'Assessment"
      },
      {
        "language": "CS",
        "text": "Informace o hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Information"
      }
    ]
  },
  {
    "key": "txtSelectTemplate",
    "text": "Select Template",
    "translations": [
      {
        "language": "AR",
        "text": "اختر النموذج"
      },
      {
        "language": "DE",
        "text": "Vorlage auswählen"
      },
      {
        "language": "PT",
        "text": "Selecione o modelo"
      },
      {
        "language": "IT",
        "text": "Seleziona il template"
      },
      {
        "language": "CS",
        "text": "Vyberte šablonu"
      },
      {
        "language": "EN",
        "text": "Select Template"
      }
    ]
  },
  {
    "key": "txtSelectTemplateDesc",
    "text": "Tailored for your needs, reuse it in other assessments.",
    "translations": [
      {
        "language": "AR",
        "text": "مخصصة لتلبية احتياجاتك، ويمكنك استخدامها بأي تقييم آخر."
      },
      {
        "language": "DE",
        "text": "Auf Ihre Bedürfnisse zugeschnitten, können Sie es in anderen Assessments wiederverwenden."
      },
      {
        "language": "PT",
        "text": "Adaptado às suas necessidades, reutilize-o em outras avaliações."
      },
      {
        "language": "IT",
        "text": "Personalizzato in base alle le tue esigenze, riutilizzabile per altri Assessment."
      },
      {
        "language": "CS",
        "text": "Přizpůsobte si jej podle svých potřeb a využijte jej i v dalších hodnoceních."
      },
      {
        "language": "EN",
        "text": "Tailored for your needs, reuse it in other assessments."
      }
    ]
  },
  {
    "key": "txtCreateTemplate",
    "text": "Create Template",
    "translations": [
      {
        "language": "AR",
        "text": "أنشئ نموذج"
      },
      {
        "language": "DE",
        "text": "Vorlage erstellen"
      },
      {
        "language": "PT",
        "text": "Criar modelo"
      },
      {
        "language": "IT",
        "text": "Crea il template"
      },
      {
        "language": "CS",
        "text": "Vytvořit šablonu"
      },
      {
        "language": "EN",
        "text": "Create Template"
      }
    ]
  },
  {
    "key": "txtPredefined",
    "text": "Predefined",
    "translations": [
      {
        "language": "AR",
        "text": "معرف مسبقاً"
      },
      {
        "language": "DE",
        "text": "Vordefiniert"
      },
      {
        "language": "PT",
        "text": "Predefinido"
      },
      {
        "language": "IT",
        "text": "Predefinito"
      },
      {
        "language": "CS",
        "text": "Předdefinované"
      },
      {
        "language": "EN",
        "text": "Predefined"
      }
    ]
  },
  {
    "key": "txtAssessmentPreview",
    "text": "Assessment Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التقييم"
      },
      {
        "language": "DE",
        "text": "Assessmentvorschau"
      },
      {
        "language": "PT",
        "text": "Visualização da avaliação"
      },
      {
        "language": "IT",
        "text": "Anteprima dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Náhled na hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Preview"
      }
    ]
  },
  {
    "key": "txtassessmentof",
    "text": "360° Feedback is a measurement of how an individual is rated by others on their performance against their behavioral competencies.",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360 هو أداة قياس للكيفية التي يقيّم بها الآخرون أداء الفرد مقابل جداراته ومهاراته السلوكية."
      },
      {
        "language": "DE",
        "text": "360°-Feedback ist eine Methode zur Messung der Leistung einer Person im Verhältnis zu ihren Verhaltenskompetenzen durch andere."
      },
      {
        "language": "PT",
        "text": "Feedback 360° é uma medida de como um indivíduo é avaliado por outros em relação ao seu desempenho em relação às suas competências comportamentais."
      },
      {
        "language": "IT",
        "text": "L'Assessment 360° misura il modo in cui un individuo viene valutato dagli altri riguardo alla sua performance in base a competenze comportamentali."
      },
      {
        "language": "CS",
        "text": "360° zpětná vazba je hodnocení, kdy ostatní hodnotí výkon jednotlivce z hlediska jeho behaviorálních kompetencí."
      },
      {
        "language": "EN",
        "text": "360° Feedback is a measurement of how an individual is rated by others on their performance against their behavioral competencies."
      }
    ]
  },
  {
    "key": "txtViewTemplate",
    "text": "View Template",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النموذج"
      },
      {
        "language": "DE",
        "text": "Vorlage anzeigen"
      },
      {
        "language": "PT",
        "text": "Ver modelo"
      },
      {
        "language": "IT",
        "text": "Visualizza il template"
      },
      {
        "language": "CS",
        "text": "Zobrazit šablonu"
      },
      {
        "language": "EN",
        "text": "View Template"
      }
    ]
  },
  {
    "key": "txtEditTemplate",
    "text": "Edit Template",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل النموذج"
      },
      {
        "language": "DE",
        "text": "Vorlage bearbeiten"
      },
      {
        "language": "PT",
        "text": "Editar modelo"
      },
      {
        "language": "IT",
        "text": "Modifica il template"
      },
      {
        "language": "CS",
        "text": "Upravit šablonu"
      },
      {
        "language": "EN",
        "text": "Edit Template"
      }
    ]
  },
  {
    "key": "btnBacktoTemplates",
    "text": "Back to Templates",
    "translations": [
      {
        "language": "AR",
        "text": "العودة للنماذج"
      },
      {
        "language": "DE",
        "text": "Zurück zu den Vorlagen"
      },
      {
        "language": "PT",
        "text": "Voltar aos modelos"
      },
      {
        "language": "IT",
        "text": "Torna ai template"
      },
      {
        "language": "CS",
        "text": "Zpět na šablony"
      },
      {
        "language": "EN",
        "text": "Back to Templates"
      }
    ]
  },
  {
    "key": "txtTemplatetitle",
    "text": "Template title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان النموذج"
      },
      {
        "language": "DE",
        "text": "Vorlagentitel"
      },
      {
        "language": "PT",
        "text": "Título do modelo"
      },
      {
        "language": "IT",
        "text": "Titolo del template"
      },
      {
        "language": "CS",
        "text": "Název šablony"
      },
      {
        "language": "EN",
        "text": "Template title"
      }
    ]
  },
  {
    "key": "txtCategories",
    "text": "Categories",
    "translations": [
      {
        "language": "AR",
        "text": "التصنيفات"
      },
      {
        "language": "DE",
        "text": "Kategorien"
      },
      {
        "language": "PT",
        "text": "Categorias"
      },
      {
        "language": "IT",
        "text": "Categorie"
      },
      {
        "language": "CS",
        "text": "Kategorie"
      },
      {
        "language": "EN",
        "text": "Categories"
      }
    ]
  },
  {
    "key": "btnSaveTemplate",
    "text": "Save Template",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ النموذج"
      },
      {
        "language": "DE",
        "text": "Vorlage speichern"
      },
      {
        "language": "PT",
        "text": "Salvar modelo"
      },
      {
        "language": "IT",
        "text": "Salva il template"
      },
      {
        "language": "CS",
        "text": "Uložit šablonu"
      },
      {
        "language": "EN",
        "text": "Save Template"
      }
    ]
  },
  {
    "key": "txtAddStatement",
    "text": "Add Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة عبارة"
      },
      {
        "language": "DE",
        "text": "Aussagen hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar declaração"
      },
      {
        "language": "IT",
        "text": "Aggiungi un'affermazione"
      },
      {
        "language": "CS",
        "text": "Přidat pro"
      },
      {
        "language": "EN",
        "text": "Add Statement"
      }
    ]
  },
  {
    "key": "txtatleast",
    "text": "Recommended 5 to 15 competencies and 3 to 5 statements each.",
    "translations": [
      {
        "language": "AR",
        "text": "يوصي باختيار 5 إلى 15 مهارة وجدارة واختيار 3 إلى 5 عبارات لكل منها."
      },
      {
        "language": "DE",
        "text": "Empfohlen werden 5 bis 15 Kompetenzen und jeweils 3 bis 5 Aussagen."
      },
      {
        "language": "PT",
        "text": "Recomendado de 5 a 15 competências e de 3 a 5 afirmações cada."
      },
      {
        "language": "IT",
        "text": "Consigliate da 5 a 15 competenze e da 3 a 5 affermazioni per ciascuna."
      },
      {
        "language": "CS",
        "text": "Doporučuje se 5 až 15 kompetencí a ke každé 3 až 5 popisů."
      },
      {
        "language": "EN",
        "text": "Recommended 5 to 15 competencies and 3 to 5 statements each."
      }
    ]
  },
  {
    "key": "txtManagersFor",
    "text": "Managers for ",
    "translations": [
      {
        "language": "AR",
        "text": "المديرون لـ "
      },
      {
        "language": "DE",
        "text": " Manager für"
      },
      {
        "language": "PT",
        "text": "Gerentes para"
      },
      {
        "language": "IT",
        "text": "Manager per"
      },
      {
        "language": "CS",
        "text": "Manažeři pro"
      },
      {
        "language": "EN",
        "text": "Managers for "
      }
    ]
  },
  {
    "key": "txt_evaluator_name",
    "text": "Evaluator's Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المقيم"
      },
      {
        "language": "DE",
        "text": "Name des Bewerters"
      },
      {
        "language": "PT",
        "text": "Nome do Avaliador"
      },
      {
        "language": "IT",
        "text": "Nome del valutatore"
      },
      {
        "language": "CS",
        "text": "Jméno hodnotitele"
      },
      {
        "language": "EN",
        "text": "Evaluator's Name"
      }
    ]
  },
  {
    "key": "txtAssessmentTitle",
    "text": "Assessment Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان التقييم"
      },
      {
        "language": "DE",
        "text": "Titel der Bewertung"
      },
      {
        "language": "PT",
        "text": "Título da Avaliação"
      },
      {
        "language": "IT",
        "text": "Titolo dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Název hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Title"
      }
    ]
  },
  {
    "key": "txt_new_setup",
    "text": "New Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد جديد"
      },
      {
        "language": "DE",
        "text": "Neues Setup"
      },
      {
        "language": "PT",
        "text": "Nova configuração"
      },
      {
        "language": "IT",
        "text": "Nuova configurazione"
      },
      {
        "language": "CS",
        "text": "Nové nastavení"
      },
      {
        "language": "EN",
        "text": "New Setup"
      }
    ]
  },
  {
    "key": "txt_added_success",
    "text": "Added Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإضافة بنجاح!"
      },
      {
        "language": "DE",
        "text": "Erfolgreich hinzugefügt!"
      },
      {
        "language": "PT",
        "text": "Adicionado com sucesso!"
      },
      {
        "language": "IT",
        "text": "Aggiunto con successo!"
      },
      {
        "language": "CS",
        "text": "Úspěšně přidáno!"
      },
      {
        "language": "EN",
        "text": "Added Successfully!"
      }
    ]
  },
  {
    "key": "txt_removed_success",
    "text": "Deleted Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم الحذف بنجاح!"
      },
      {
        "language": "DE",
        "text": "Erfolgreich gelöscht!"
      },
      {
        "language": "PT",
        "text": "Excluído com sucesso!"
      },
      {
        "language": "IT",
        "text": "Eliminato con successo!"
      },
      {
        "language": "CS",
        "text": "Úspěšně smazáno!"
      },
      {
        "language": "EN",
        "text": "Deleted Successfully!"
      }
    ]
  },
  {
    "key": "txt_updated_success",
    "text": "Updated Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث بنجاح!"
      },
      {
        "language": "DE",
        "text": "Erfolgreich aktualisiert!"
      },
      {
        "language": "PT",
        "text": "Atualizado com sucesso!"
      },
      {
        "language": "IT",
        "text": "Aggiornato con successo!"
      },
      {
        "language": "CS",
        "text": "Úspěšně aktualizováno!"
      },
      {
        "language": "EN",
        "text": "Updated Successfully!"
      }
    ]
  },
  {
    "key": "txtTitle",
    "text": "Assessment Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان التقييم"
      },
      {
        "language": "DE",
        "text": "Titel der Bewertung"
      },
      {
        "language": "PT",
        "text": "Título da Avaliação"
      },
      {
        "language": "IT",
        "text": "Titolo dell'Assessment"
      },
      {
        "language": "CS",
        "text": "Název hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment Title"
      }
    ]
  },
  {
    "key": "txt_date_created",
    "text": "Date Created",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإنشاء"
      },
      {
        "language": "DE",
        "text": "Erstellungsdatum"
      },
      {
        "language": "PT",
        "text": "Data de criação"
      },
      {
        "language": "IT",
        "text": "Data di creazione"
      },
      {
        "language": "CS",
        "text": "Datum vytvoření"
      },
      {
        "language": "EN",
        "text": "Date Created"
      }
    ]
  },
  {
    "key": "txtForCompetency",
    "text": "For Competency",
    "translations": [
      {
        "language": "AR",
        "text": "لكل جدارة ومهارة"
      },
      {
        "language": "DE",
        "text": "Für Kompetenz"
      },
      {
        "language": "PT",
        "text": "Por Competência"
      },
      {
        "language": "IT",
        "text": "Per competenza"
      },
      {
        "language": "CS",
        "text": "Pro kompetenci"
      },
      {
        "language": "EN",
        "text": "For Competency"
      }
    ]
  },
  {
    "key": "txtAddCompetency",
    "text": "Add Competency",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة جدارة ومهارة"
      },
      {
        "language": "DE",
        "text": "Kompetenz hinzufügen"
      },
      {
        "language": "PT",
        "text": "Adicionar competência"
      },
      {
        "language": "IT",
        "text": "Aggiungi una competenza"
      },
      {
        "language": "CS",
        "text": "Přidat kompetenci"
      },
      {
        "language": "EN",
        "text": "Add Competency"
      }
    ]
  },
  {
    "key": "TransformationalLeadership",
    "text": "Transformational Leadership",
    "translations": [
      {
        "language": "AR",
        "text": "القيادة التحويلية"
      },
      {
        "language": "DE",
        "text": "Transformationale Führung"
      },
      {
        "language": "PT",
        "text": "Liderança Transformacional"
      },
      {
        "language": "IT",
        "text": "Leadership trasformazionale"
      },
      {
        "language": "CS",
        "text": "Transformační vedení"
      },
      {
        "language": "EN",
        "text": "Transformational Leadership"
      }
    ]
  },
  {
    "key": "txtManagement",
    "text": "Management",
    "translations": [
      {
        "language": "AR",
        "text": "الإدارة"
      },
      {
        "language": "DE",
        "text": "Management"
      },
      {
        "language": "PT",
        "text": "Gerenciamento"
      },
      {
        "language": "IT",
        "text": "Management"
      },
      {
        "language": "CS",
        "text": "Vedení"
      },
      {
        "language": "EN",
        "text": "Management"
      }
    ]
  },
  {
    "key": "txtSelfDevelopment",
    "text": "Self-Development",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير الذات"
      },
      {
        "language": "DE",
        "text": "Selbstentwicklung"
      },
      {
        "language": "PT",
        "text": "Autodesenvolvimento"
      },
      {
        "language": "IT",
        "text": "Sviluppo personale"
      },
      {
        "language": "CS",
        "text": "Osobní rozvoj"
      },
      {
        "language": "EN",
        "text": "Self-Development"
      }
    ]
  },
  {
    "key": "SelfDevelopment",
    "text": "Self-Development",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير الذات"
      },
      {
        "language": "DE",
        "text": "Selbstentwicklung"
      },
      {
        "language": "PT",
        "text": "Autodesenvolvimento"
      },
      {
        "language": "IT",
        "text": "Sviluppo personale"
      },
      {
        "language": "CS",
        "text": "Osobní rozvoj"
      },
      {
        "language": "EN",
        "text": "Self-Development"
      }
    ]
  },
  {
    "key": "txtWorkingwithOthers",
    "text": "Working with Others",
    "translations": [
      {
        "language": "AR",
        "text": "العمل مع الآخرين"
      },
      {
        "language": "DE",
        "text": "Zusammenarbeit mit anderen"
      },
      {
        "language": "PT",
        "text": "Trabalhando com outras pessoas"
      },
      {
        "language": "IT",
        "text": "Collaborazione con gli altri"
      },
      {
        "language": "CS",
        "text": "Spolupráce s ostatními"
      },
      {
        "language": "EN",
        "text": "Working with Others"
      }
    ]
  },
  {
    "key": "WorkingWithOthers",
    "text": "Working with Others",
    "translations": [
      {
        "language": "AR",
        "text": "العمل مع الآخرين"
      },
      {
        "language": "DE",
        "text": "Zusammenarbeit mit anderen"
      },
      {
        "language": "PT",
        "text": "Trabalhando com outras pessoas"
      },
      {
        "language": "IT",
        "text": "Collaborazione con gli altri"
      },
      {
        "language": "CS",
        "text": "Spolupráce s ostatními"
      },
      {
        "language": "EN",
        "text": "Working with Others"
      }
    ]
  },
  {
    "key": "txtDeliveringResults",
    "text": "Delivering Results",
    "translations": [
      {
        "language": "AR",
        "text": "تحقيق النتائج"
      },
      {
        "language": "DE",
        "text": "Ergebnisse liefern"
      },
      {
        "language": "PT",
        "text": "Entregando Resultados"
      },
      {
        "language": "IT",
        "text": "Conseguimento dei risultati"
      },
      {
        "language": "CS",
        "text": "Dosahování výsledků"
      },
      {
        "language": "EN",
        "text": "Delivering Results"
      }
    ]
  },
  {
    "key": "DeliveringResults",
    "text": "Delivering Results",
    "translations": [
      {
        "language": "AR",
        "text": "تحقيق النتائج"
      },
      {
        "language": "DE",
        "text": "Ergebnisse liefern"
      },
      {
        "language": "PT",
        "text": "Entregando Resultados"
      },
      {
        "language": "IT",
        "text": "Conseguimento dei risultati"
      },
      {
        "language": "CS",
        "text": "Dosahování výsledků"
      },
      {
        "language": "EN",
        "text": "Delivering Results"
      }
    ]
  },
  {
    "key": "btnExport",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "DE",
        "text": "Herunterladen"
      },
      {
        "language": "PT",
        "text": "Download"
      },
      {
        "language": "IT",
        "text": "Scarica"
      },
      {
        "language": "CS",
        "text": "Stáhnout"
      },
      {
        "language": "EN",
        "text": "Download"
      }
    ]
  },
  {
    "key": "btn_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "DE",
        "text": "Löschen"
      },
      {
        "language": "PT",
        "text": "Excluir"
      },
      {
        "language": "IT",
        "text": "Elimina"
      },
      {
        "language": "CS",
        "text": "Smazat"
      },
      {
        "language": "EN",
        "text": "Delete"
      }
    ]
  },
  {
    "key": "btn_relaunch",
    "text": "Relaunch",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة إطلاق"
      },
      {
        "language": "DE",
        "text": "Relaunch"
      },
      {
        "language": "PT",
        "text": "Reiniciar"
      },
      {
        "language": "IT",
        "text": "Riavvia"
      },
      {
        "language": "CS",
        "text": "Znovuzahájení"
      },
      {
        "language": "EN",
        "text": "Relaunch"
      }
    ]
  },
  {
    "key": "txtRename",
    "text": "Rename",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تسمية"
      },
      {
        "language": "DE",
        "text": "Umbenennen"
      },
      {
        "language": "PT",
        "text": "Renomear"
      },
      {
        "language": "IT",
        "text": "Rinomina"
      },
      {
        "language": "CS",
        "text": "Přejmenovat"
      },
      {
        "language": "EN",
        "text": "Rename"
      }
    ]
  },
  {
    "key": "txtSurvey",
    "text": "Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم"
      },
      {
        "language": "DE",
        "text": "Assessment"
      },
      {
        "language": "PT",
        "text": "Avaliação"
      },
      {
        "language": "IT",
        "text": "Assessment"
      },
      {
        "language": "CS",
        "text": "Hodnocení"
      },
      {
        "language": "EN",
        "text": "Assessment"
      }
    ]
  },
  {
    "key": "txt_remove_candidates_confirmation_message",
    "text": "Are you sure you want to delete this candidate? Respondents for this candidate will be removed as well",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هؤلاء المرشحين؟ سيتم حذف المستجيون لهؤلاء المرشحين أيضاً!"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diesen Kandidaten wirklich löschen? Die Antwortenden für diesen Kandidaten werden ebenfalls gelöscht."
      },
      {
        "language": "PT",
        "text": "Tem certeza de que deseja excluir este candidato? Os entrevistados deste candidato também serão removidos"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questo candidato? Anche i rispondenti associati verranno rimossi"
      },
      {
        "language": "CS",
        "text": "Opravdu chcete tohoto uchazeče smazat? Budou odstraněny také odpovědi tohoto uchazeče."
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this candidate? Respondents for this candidate will be removed as well"
      }
    ]
  },
  {
    "key": "txt_every_candidate_rules",
    "text": "should have 1 manager and total of 2 Peer/Team",
    "translations": [
      {
        "language": "AR",
        "text": "أن يحظى بمدير واحد بالإضافة إلى اثنان من الزملاء/ أعضاء الفريق"
      },
      {
        "language": "DE",
        "text": "sollte 1 Manager und insgesamt 2 Peers/Teams haben"
      },
      {
        "language": "PT",
        "text": "deve ter 1 gerente e um total de 2 pares/equipe"
      },
      {
        "language": "IT",
        "text": "deve avere 1 manager e un totale di 2 tra i colleghi e il team"
      },
      {
        "language": "CS",
        "text": "měl by být 1-2 vedoucí a minimálně 2 kolegové/členi týmu"
      },
      {
        "language": "EN",
        "text": "should have 1 manager and total of 2 Peer/Team"
      }
    ]
  },
  {
    "key": "CRC_T_1_TITLE",
    "text": "New Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم جديد"
      },
      {
        "language": "EN",
        "text": "New Assessment"
      },
      {
        "language": "CS",
        "text": "Nové hodnocení"
      }
    ]
  },
  {
    "key": "CRC_T_1_DESCRIPTION",
    "text": "To create a new 360/180 assessment, click on “New Assessment”.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"تقييم جديد\" لإنشاء تقييم 360/180 جديد."
      },
      {
        "language": "EN",
        "text": "To create a new 360/180 assessment, click on “New Assessment”."
      },
      {
        "language": "CS",
        "text": "Chcete-li vytvořit nové 360/180 hodnocení, klikněte na „Nové hodnocení“."
      }
    ]
  },
  {
    "key": "CRC_T_2_TITLE",
    "text": "Continue Setup",
    "translations": [
      {
        "language": "AR",
        "text": "متابعة الاعداد"
      },
      {
        "language": "EN",
        "text": "Continue Setup"
      },
      {
        "language": "CS",
        "text": "Pokračovat v nastavení"
      }
    ]
  },
  {
    "key": "CRC_T_2_DESCRIPTION",
    "text": "To resume the configuration process, hover over any draft assessment, then select “Continue Setup”.",
    "translations": [
      {
        "language": "AR",
        "text": "لاستئناف عملية الإعداد، ضع مؤشر الماوس فوق أي تقييم بحالة المسودة، ثم اختر \"متابعة الإعداد\"."
      },
      {
        "language": "EN",
        "text": "To resume the configuration process, hover over any draft assessment, then select “Continue Setup”."
      },
      {
        "language": "CS",
        "text": "Chcete-li pokračovat v procesu konfigurace, najeďte kurzorem myši na libovolný návrh hodnocení a vyberte „Pokračovat v nastavení“."
      }
    ]
  },
  {
    "key": "CRC_T_3_TITLE",
    "text": "Open Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "فتح التقييم"
      },
      {
        "language": "EN",
        "text": "Open Assessment"
      },
      {
        "language": "CS",
        "text": "Otevřít hodnocení"
      }
    ]
  },
  {
    "key": "CRC_T_3_DESCRIPTION",
    "text": "Point the mouse over the assessment list to open live and closed assessments.",
    "translations": [
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق قائمة التقييمات لفتح التقييمات بحالة المباشرة والمغلقة."
      },
      {
        "language": "EN",
        "text": "Point the mouse over the assessment list to open live and closed assessments."
      },
      {
        "language": "CS",
        "text": "Přejděte myší nad seznam hodnocení a otevřete probíhající i uzavřená hodnocení."
      }
    ]
  },
  {
    "key": "CRC_T_4_TITLE",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      },
      {
        "language": "EN",
        "text": "More Actions"
      },
      {
        "language": "CS",
        "text": "Další akce"
      }
    ]
  },
  {
    "key": "CRC_T_4_DESCRIPTION",
    "text": "Click the ⋮ menu on any assessment to access additional options. Rename it, Clone it as a starting point for a new assessment, or Delete it if it's no longer needed.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بالنقر على قائمة ⋮ للوصول إلى خيارات إضافية. قم بإعادة تسميته، أو استنساخه كنقطة انطلاق لتقييم جديد، أو حذفه إذا لم تعد بحاجة إليه."
      },
      {
        "language": "EN",
        "text": "Click the ⋮ menu on any assessment to access additional options. Rename it, Clone it as a starting point for a new assessment, or Delete it if it's no longer needed."
      },
      {
        "language": "CS",
        "text": "Kliknutím na menu ⋮ u libovolného hodnocení získáte přístup k dalším možnostem. Můžete jej přejmenovat, zkopírovat jako výchozí bod pro nové hodnocení nebo smazat, pokud již není potřeba."
      }
    ]
  },
  {
    "key": "CRC_T_5_TITLE",
    "text": "Select Template",
    "translations": [
      {
        "language": "AR",
        "text": "اختر النموذج"
      },
      {
        "language": "EN",
        "text": "Select Template"
      },
      {
        "language": "CS",
        "text": "Vybrat šablonu"
      }
    ]
  },
  {
    "key": "CRC_T_5_DESCRIPTION",
    "text": "You have the option to select from Zenithr’s predefined templates or custom templates!",
    "translations": [
      {
        "language": "AR",
        "text": "لديك الخيار للاختيار من نماذج زينيثر المخصصة أو المُعرفة مسبقاً!"
      },
      {
        "language": "EN",
        "text": "You have the option to select from Zenithr’s predefined templates or custom templates!"
      },
      {
        "language": "CS",
        "text": "Máte možnost vybrat si z předdefinovaných šablon Zenithr nebo z vlastních šablon!"
      }
    ]
  },
  {
    "key": "CRC_T_6_TITLE",
    "text": "Manage Templates",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة النماذج"
      },
      {
        "language": "EN",
        "text": "Manage Templates"
      },
      {
        "language": "CS",
        "text": "Správa šablon"
      }
    ]
  },
  {
    "key": "CRC_T_6_DESCRIPTION",
    "text": "Unlock the power of customization with your very own template, where you can tailor competencies and statements to match your unique needs!",
    "translations": [
      {
        "language": "AR",
        "text": "استفد من خاصية التخصيص من خلال إنشاء نموذج خاص بك حيث يمكنك إضافة الجدارات والمهارات والعبارات لتتناسب مع أهدافك الفريدة!"
      },
      {
        "language": "EN",
        "text": "Unlock the power of customization with your very own template, where you can tailor competencies and statements to match your unique needs!"
      },
      {
        "language": "CS",
        "text": "Využijte plný potenciál přizpůsobení pomocí své vlastní šablony, ve které můžete kompetence a tvrzení přizpůsobit tak, aby odpovídaly vašim jedinečným potřebám!"
      }
    ]
  },
  {
    "key": "CRC_T_7_TITLE",
    "text": "Template Preview",
    "translations": [
      {
        "language": "AR",
        "text": "معاينة النموذج"
      },
      {
        "language": "EN",
        "text": "Template Preview"
      },
      {
        "language": "CS",
        "text": "Náhled šablony"
      }
    ]
  },
  {
    "key": "CRC_T_7_DESCRIPTION",
    "text": "To preview the competencies, statements under each competency, and weights distributed for a specific template, click on the competency within the “Template Preview”.\nNote: The template can be downloaded by clicking on Export Template.",
    "translations": [
      {
        "language": "AR",
        "text": "للاطلاع على الجدارات والعبارات لكل جدارة ومهارة والأوزان الموزعة لنموذج معين، انقر على الجدارة والمهارة ضمن \"معاينة النماذج\".\nملاحظة: يمكن تحميل النموذج بالنقر على تحميل النموذج."
      },
      {
        "language": "EN",
        "text": "To preview the competencies, statements under each competency, and weights distributed for a specific template, click on the competency within the “Template Preview”.\nNote: The template can be downloaded by clicking on Export Template."
      },
      {
        "language": "CS",
        "text": "Chcete-li si prohlédnout náhled kompetencí, tvrzení pod každou kompetencí a váhy rozdělené pro konkrétní šablonu, klikněte na kompetenci v části „Náhled šablony“. Poznámka: Šablonu lze stáhnout kliknutím na „Exportovat šablonu“."
      }
    ]
  },
  {
    "key": "CRC_T_8_TITLE",
    "text": "Next step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      },
      {
        "language": "EN",
        "text": "Next step!"
      },
      {
        "language": "CS",
        "text": "Další krok!"
      }
    ]
  },
  {
    "key": "CRC_T_8_DESCRIPTION",
    "text": "The first step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من الخطوة الأولى. انقر هنا للانتقال إلى الخطوة التالية."
      },
      {
        "language": "EN",
        "text": "The first step is done; click here for the next step."
      },
      {
        "language": "CS",
        "text": "První krok je hotový; klikněte zde pro další krok."
      }
    ]
  },
  {
    "key": "CRC_T_9_TITLE",
    "text": "New Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج جديد"
      },
      {
        "language": "EN",
        "text": "New Template"
      },
      {
        "language": "CS",
        "text": "Nová šablona"
      }
    ]
  },
  {
    "key": "CRC_T_9_DESCRIPTION",
    "text": "To create a new 360/180 assessment template, click on “New Template”.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"نموذج جديد\" لإنشاء نموذج جديد لتقييم 360/180 درجة."
      },
      {
        "language": "EN",
        "text": "To create a new 360/180 assessment template, click on “New Template”."
      },
      {
        "language": "CS",
        "text": "Chcete-li vytvořit novou šablonu pro 360/180° hodnocení, klikněte na „Nová šablona“."
      }
    ]
  },
  {
    "key": "CRC_T_10_TITLE",
    "text": "Continue Setup",
    "translations": [
      {
        "language": "AR",
        "text": "متابعة الاعداد"
      },
      {
        "language": "EN",
        "text": "Continue Setup"
      },
      {
        "language": "CS",
        "text": "Pokračovat v nastavení"
      }
    ]
  },
  {
    "key": "CRC_T_10_DESCRIPTION",
    "text": "To resume the configuration process, hover over any draft template, then select “Continue Setup”.",
    "translations": [
      {
        "language": "AR",
        "text": "لاستئناف عملية الإعداد، ضع مؤشر الماوس فوق أي نموذج بحالة المسودة، ثم اختر \"متابعة الإعداد\"."
      },
      {
        "language": "EN",
        "text": "To resume the configuration process, hover over any draft template, then select “Continue Setup”."
      },
      {
        "language": "CS",
        "text": "Chcete-li pokračovat v procesu konfigurace, najeďte kurzorem na libovolný návrh šablony a poté vyberte „Pokračovat v nastavení“."
      }
    ]
  },
  {
    "key": "CRC_T_11_TITLE",
    "text": "Preview",
    "translations": [
      {
        "language": "AR",
        "text": "معاينة"
      },
      {
        "language": "EN",
        "text": "Preview"
      },
      {
        "language": "CS",
        "text": "Náhled"
      }
    ]
  },
  {
    "key": "CRC_T_11_DESCRIPTION",
    "text": "To preview the contents of a saved template, click on “Preview.”",
    "translations": [
      {
        "language": "AR",
        "text": "للاطلاع على محتويات نموذج محفوظ، انقر على \"معاينة\"."
      },
      {
        "language": "EN",
        "text": "To preview the contents of a saved template, click on “Preview.”"
      },
      {
        "language": "CS",
        "text": "Chcete-li zobrazit náhled obsahu uložené šablony, klikněte na „Náhled“."
      }
    ]
  },
  {
    "key": "CRC_T_12_TITLE",
    "text": "Clone",
    "translations": [
      {
        "language": "AR",
        "text": "استنساخ"
      },
      {
        "language": "EN",
        "text": "Clone"
      },
      {
        "language": "CS",
        "text": "Zkopírovat"
      }
    ]
  },
  {
    "key": "CRC_T_12_DESCRIPTION",
    "text": "To clone a template, click on the three vertical dots and select “Clone”.\nNote: Cloning is only possible when the template is saved.",
    "translations": [
      {
        "language": "AR",
        "text": "لاستنساخ النموذج، انقر على النقاط الثلاث العمودية واختر “استنساخ\".\nملاحظة: لا يمكن الاستنساخ إلا عندما يكون النموذج محفوظاً."
      },
      {
        "language": "EN",
        "text": "To clone a template, click on the three vertical dots and select “Clone”.\nNote: Cloning is only possible when the template is saved."
      },
      {
        "language": "CS",
        "text": "Chcete-li šablonu zkopírovat, klikněte na tři svislé tečky a vyberte možnost „Kopírovat“. Poznámka: Kopírování je možné pouze v případě, že je šablona uložena."
      }
    ]
  },
  {
    "key": "CRC_T_13_TITLE",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "EN",
        "text": "Delete"
      },
      {
        "language": "CS",
        "text": "Odstranit"
      }
    ]
  },
  {
    "key": "CRC_T_13_DESCRIPTION",
    "text": "To delete a template, click on the three vertical dots and select \"Delete\".\nNote: Deletion is only possible when the assessment is in Draft status and cannot be undone.",
    "translations": [
      {
        "language": "AR",
        "text": "لحذف التقييم، انقر على النقاط الثلاث العمودية واختر \"حذف\".\nملاحظة: لا يمكن الحذف إلا عندما يكون النموذج بحالة المسودة، ولا يمكن التراجع."
      },
      {
        "language": "EN",
        "text": "To delete a template, click on the three vertical dots and select \"Delete\".\nNote: Deletion is only possible when the assessment is in Draft status and cannot be undone."
      },
      {
        "language": "CS",
        "text": "Chcete-li šablonu odstranit, klikněte na tři svislé tečky a vyberte možnost „Odstranit“. Poznámka: Odstranění je možné pouze v případě, že je hodnocení ve stavu „Návrh“, a nelze jej vrátit zpět."
      }
    ]
  },
  {
    "key": "CRC_T_14_TITLE",
    "text": "Categories",
    "translations": [
      {
        "language": "AR",
        "text": "التصنيفات"
      },
      {
        "language": "EN",
        "text": "Categories"
      },
      {
        "language": "CS",
        "text": "Kategorie"
      }
    ]
  },
  {
    "key": "CRC_T_14_DESCRIPTION",
    "text": "Here you can view the categories and explore competencies.",
    "translations": [
      {
        "language": "AR",
        "text": "من هنا يمكنك عرض التصنيفات والاطلاع على الجدارات والمهارات."
      },
      {
        "language": "EN",
        "text": "Here you can view the categories and explore competencies."
      },
      {
        "language": "CS",
        "text": "Zde si můžete prohlédnout kategorie a prozkoumat kompetence."
      }
    ]
  },
  {
    "key": "CRC_T_15_TITLE",
    "text": "Select Competency",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الجدارة والمهارة"
      },
      {
        "language": "EN",
        "text": "Select Competency"
      },
      {
        "language": "CS",
        "text": "Vybrat kompetenci"
      }
    ]
  },
  {
    "key": "CRC_T_15_DESCRIPTION",
    "text": "Click here to select the competencies you want to include in your template.\nNote: At least 3 competencies must be selected, and it is recommended to select 5 to 15 competencies.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لاختيار الجدارات والمهارات التي تريد تضمينها في النموذج الخاص بك.\nملاحظة: يجب اختيار ما لا يقل عن 3 جدارات ومهارات، ويُوصى باختيار ما بين 5 و15 جدارة ومهارة."
      },
      {
        "language": "EN",
        "text": "Click here to select the competencies you want to include in your template.\nNote: At least 3 competencies must be selected, and it is recommended to select 5 to 15 competencies."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a vyberte kompetence, které chcete zahrnout do své šablony. Poznámka: Je nutné vybrat alespoň 3 kompetence; doporučuje se vybrat 5 až 15 kompetencí."
      }
    ]
  },
  {
    "key": "CRC_T_16_TITLE",
    "text": "New Competency",
    "translations": [
      {
        "language": "AR",
        "text": "جدارة و مهارة جديدة"
      },
      {
        "language": "EN",
        "text": "New Competency"
      },
      {
        "language": "CS",
        "text": "Nová kompetence"
      }
    ]
  },
  {
    "key": "CRC_T_16_DESCRIPTION",
    "text": "Click “New Competency” to add custom competencies.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على “جدارة ومهارة جديدة \" لإضافة جدارات ومهارات مخصصة."
      },
      {
        "language": "EN",
        "text": "Click “New Competency” to add custom competencies."
      },
      {
        "language": "CS",
        "text": "Klikněte na „Nová kompetence“ a přidejte vlastní kompetenci."
      }
    ]
  },
  {
    "key": "CRC_T_17_TITLE",
    "text": "Competency Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الجدارة والمهارة"
      },
      {
        "language": "EN",
        "text": "Competency Name"
      },
      {
        "language": "CS",
        "text": "Název kompetence"
      }
    ]
  },
  {
    "key": "CRC_T_17_DESCRIPTION",
    "text": "Enter a name for the competency.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتسمية الجدارة والمهارة."
      },
      {
        "language": "EN",
        "text": "Enter a name for the competency."
      },
      {
        "language": "CS",
        "text": "Zadejte název kompetence."
      }
    ]
  },
  {
    "key": "CRC_T_18_TITLE",
    "text": "Competency Category",
    "translations": [
      {
        "language": "AR",
        "text": "فئة الجدارة والمهارة"
      },
      {
        "language": "EN",
        "text": "Competency Category"
      },
      {
        "language": "CS",
        "text": "Kategorie kompetence"
      }
    ]
  },
  {
    "key": "CRC_T_18_DESCRIPTION",
    "text": "Select a category from the dropdown menu; choose the one that best fits this competency.",
    "translations": [
      {
        "language": "AR",
        "text": "قم باختيار الفئة من القائمة المنسدلة، وحدد الفئة الأنسب لهذه الجدارة والمهارة."
      },
      {
        "language": "EN",
        "text": "Select a category from the dropdown menu; choose the one that best fits this competency."
      },
      {
        "language": "CS",
        "text": "Z rozevíracího menu vyberte kategorii, která nejlépe odpovídá této kompetenci."
      }
    ]
  },
  {
    "key": "CRC_T_19_TITLE",
    "text": "Competency Definition",
    "translations": [
      {
        "language": "AR",
        "text": "تعريف الجدارة والمهارة"
      },
      {
        "language": "EN",
        "text": "Competency Definition"
      },
      {
        "language": "CS",
        "text": "Definice kompetence"
      }
    ]
  },
  {
    "key": "CRC_T_19_DESCRIPTION",
    "text": "Add a definition to your competency.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإضافة التعريف للجدارة والمهارة."
      },
      {
        "language": "EN",
        "text": "Add a definition to your competency."
      },
      {
        "language": "CS",
        "text": "Přidejte definici své kompetence."
      }
    ]
  },
  {
    "key": "CRC_T_20_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      },
      {
        "language": "EN",
        "text": "Translation"
      },
      {
        "language": "CS",
        "text": "Překlad"
      }
    ]
  },
  {
    "key": "CRC_T_20_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      },
      {
        "language": "EN",
        "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!"
      },
      {
        "language": "CS",
        "text": "Přeložte text ručně kliknutím na „“ nebo „✨“ a nechte naši kouzelnou AI, aby to za vás udělala!"
      }
    ]
  },
  {
    "key": "CRC_T_21_TITLE",
    "text": "Create Competency",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء جدارة ومهارة"
      },
      {
        "language": "EN",
        "text": "Create Competency"
      },
      {
        "language": "CS",
        "text": "Vytvořit kompetenci"
      }
    ]
  },
  {
    "key": "CRC_T_21_DESCRIPTION",
    "text": "Once all the details are filled in, click \"Create Competency\" to save and add it to your template.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تعبئة جميع التفاصيل، انقر على \" إنشاء جدارة و مهارة \" لحفظها وإضافتها إلى النموذج."
      },
      {
        "language": "EN",
        "text": "Once all the details are filled in, click \"Create Competency\" to save and add it to your template."
      },
      {
        "language": "CS",
        "text": "Jakmile vyplníte všechny údaje, klikněte na „Vytvořit kompetenci“, abyste ji uložili a přidali do své šablony."
      }
    ]
  },
  {
    "key": "CRC_T_22_TITLE",
    "text": "Competency Definition View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض تعريف الجدارة والمهارة"
      },
      {
        "language": "EN",
        "text": "Competency Definition View"
      },
      {
        "language": "CS",
        "text": "Zobrazení definice kompetence"
      }
    ]
  },
  {
    "key": "CRC_T_22_DESCRIPTION",
    "text": "To view the definition of a competency, point the mouse over the (i) icon.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تعريف الجدارة والمهارة، من خلال تمرير مؤشر الفأرة فوق أيقونة (i)."
      },
      {
        "language": "EN",
        "text": "To view the definition of a competency, point the mouse over the (i) icon."
      },
      {
        "language": "CS",
        "text": "Chcete-li zobrazit definici kompetence, najeďte myší na ikonu (i)."
      }
    ]
  },
  {
    "key": "CRC_T_23_TITLE",
    "text": "Assign Weight",
    "translations": [
      {
        "language": "AR",
        "text": "تعيين الوزن"
      },
      {
        "language": "EN",
        "text": "Assign Weight"
      },
      {
        "language": "CS",
        "text": "Přiřazení váhy"
      }
    ]
  },
  {
    "key": "CRC_T_23_DESCRIPTION",
    "text": "You have the flexibility to assign weights to competencies according to their importance to your organization!\nNote: Weights are automatically distributed equally to a total of 100%.",
    "translations": [
      {
        "language": "AR",
        "text": "لديك المرونة في تعيين أوزان للجدارات والمهارات وفقاُ لأهميتها لمؤسستك!\nملحوظة: يتم توزيع الأوزان بشكل متساوي تلقائياً إلى إجمالي 100%."
      },
      {
        "language": "EN",
        "text": "You have the flexibility to assign weights to competencies according to their importance to your organization!\nNote: Weights are automatically distributed equally to a total of 100%."
      },
      {
        "language": "CS",
        "text": "Máte možnost flexibilně přiřazovat kompetencím váhy podle jejich důležitosti pro vaši organizaci! Poznámka: Váhy se automaticky rovnoměrně rozdělí na celkových 100 %."
      }
    ]
  },
  {
    "key": "CRC_T_24_TITLE",
    "text": "Next step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      },
      {
        "language": "EN",
        "text": "Next step!"
      },
      {
        "language": "CS",
        "text": "Další krok!"
      }
    ]
  },
  {
    "key": "CRC_T_24_DESCRIPTION",
    "text": "The first step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من الخطوة الأولى. انقر هنا للانتقال إلى الخطوة التالية."
      },
      {
        "language": "EN",
        "text": "The first step is done; click here for the next step."
      },
      {
        "language": "CS",
        "text": "První krok je hotový; klikněte sem pro další krok."
      }
    ]
  },
  {
    "key": "CRC_T_25_TITLE",
    "text": "Select Statements",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار العبارات"
      },
      {
        "language": "EN",
        "text": "Select Statements"
      },
      {
        "language": "CS",
        "text": "Výběr tvrzení"
      }
    ]
  },
  {
    "key": "CRC_T_25_DESCRIPTION",
    "text": "Click here to select the statements under each competency and add custom statements by clicking “Add Statement”!\nNote: It is recommended to add 5 statements under each competency.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لاختيار العبارات تحت كل جدارة ومهارة وقم بإضافة عبارات مخصصة من خلال النقر على \"إضافة عبارة\".\nملاحظة: يُوصى بإضافة 5 عبارات لكل جدارة و مهارة."
      },
      {
        "language": "EN",
        "text": "Click here to select the statements under each competency and add custom statements by clicking “Add Statement”!\nNote: It is recommended to add 5 statements under each competency."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a vyberte tvrzení pod každou kompetencí a přidejte vlastní tvrzení kliknutím na „Přidat tvrzení“! Poznámka: Doporučujeme přidat pod každou kompetenci 5 tvrzení."
      }
    ]
  },
  {
    "key": "CRC_T_26_TITLE",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      },
      {
        "language": "EN",
        "text": "New Statement"
      },
      {
        "language": "CS",
        "text": "Nové tvrzení"
      }
    ]
  },
  {
    "key": "CRC_T_26_DESCRIPTION",
    "text": "To add a new statement under a competency, click on \"New Statement\".",
    "translations": [
      {
        "language": "AR",
        "text": "لإضافة عبارة جديدة تحت الجدارة و المهارة، انقر على \"عبارة جديدة\"."
      },
      {
        "language": "EN",
        "text": "To add a new statement under a competency, click on \"New Statement\"."
      },
      {
        "language": "CS",
        "text": "Chcete-li pod kompetencí přidat nové tvrzení, klikněte na „Nové tvrzení“."
      }
    ]
  },
  {
    "key": "CRC_T_27_TITLE",
    "text": "Change Competency",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير الجدارة والمهارة"
      },
      {
        "language": "EN",
        "text": "Change Competency"
      },
      {
        "language": "CS",
        "text": "Změnit kompetenci"
      }
    ]
  },
  {
    "key": "CRC_T_27_DESCRIPTION",
    "text": "If you want to assign this statement to a different competency, select the desired competency from the dropdown.",
    "translations": [
      {
        "language": "AR",
        "text": "قم تعيين العبارة لجدارة و مهارة مختلفة، وحدد الجدارة والمهارة المطلوبة من القائمة المنسدلة."
      },
      {
        "language": "EN",
        "text": "If you want to assign this statement to a different competency, select the desired competency from the dropdown."
      },
      {
        "language": "CS",
        "text": "Chcete-li toto tvrzení přiřadit k jiné kompetenci, vyberte požadovanou kompetenci z rozevíracího seznamu."
      }
    ]
  },
  {
    "key": "CRC_T_28_TITLE",
    "text": "Create Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارة"
      },
      {
        "language": "EN",
        "text": "Create Statement"
      },
      {
        "language": "CS",
        "text": "Vytvořit výrok"
      }
    ]
  },
  {
    "key": "CRC_T_28_DESCRIPTION",
    "text": "Once all the details are filled in, click \"Create Statement\" to save and add it to your template.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تعبئة جميع التفاصيل، انقر على \"إنشاء عبارة\" لحفظها وإضافتها إلى النموذج."
      },
      {
        "language": "EN",
        "text": "Once all the details are filled in, click \"Create Statement\" to save and add it to your template."
      },
      {
        "language": "CS",
        "text": "Jakmile vyplníte všechny údaje, klikněte na „Vytvořit výrok“, abyste jej uložili a přidali do své šablony."
      }
    ]
  },
  {
    "key": "CRC_T_29_TITLE",
    "text": "Generate Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء العبارة"
      },
      {
        "language": "EN",
        "text": "Generate Statement"
      },
      {
        "language": "CS",
        "text": "Generovat výrok"
      }
    ]
  },
  {
    "key": "CRC_T_29_DESCRIPTION",
    "text": "Leverage AI to generate tailored statements for your competency in one click.",
    "translations": [
      {
        "language": "AR",
        "text": "قم باستخدام الذكاء الاصطناعي لإنشاء عبارات مخصصة للجدارات والمهارات."
      },
      {
        "language": "EN",
        "text": "Leverage AI to generate tailored statements for your competency in one click."
      },
      {
        "language": "CS",
        "text": "Využijte umělou inteligenci k vygenerování tvrzení na míru pro vaši kompetenci jediným kliknutím."
      }
    ]
  },
  {
    "key": "CRC_T_30_TITLE",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "معاينة السؤال"
      },
      {
        "language": "EN",
        "text": "Question Preview"
      },
      {
        "language": "CS",
        "text": "Náhled na otázku"
      }
    ]
  },
  {
    "key": "CRC_T_30_DESCRIPTION",
    "text": "To see how the statement will appear to respondents, click on \"Question Preview\".",
    "translations": [
      {
        "language": "AR",
        "text": "لمعاينة كيفية ظهور العبارة للمستجيبين، انقر على \"معاينة السؤال\"."
      },
      {
        "language": "EN",
        "text": "To see how the statement will appear to respondents, click on \"Question Preview\"."
      },
      {
        "language": "CS",
        "text": "Chcete-li vidět, jak se výrok zobrazí respondentům, klikněte na „Náhled na otázku“."
      }
    ]
  },
  {
    "key": "CRC_T_31_TITLE",
    "text": "Next Step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      },
      {
        "language": "EN",
        "text": "Next Step!"
      },
      {
        "language": "CS",
        "text": "Další krok!"
      }
    ]
  },
  {
    "key": "CRC_T_31_DESCRIPTION",
    "text": "Another step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من خطوة أخرى؛ انقر هنا للانتقال إلى الخطوة التالية."
      },
      {
        "language": "EN",
        "text": "Another step is done; click here for the next step."
      },
      {
        "language": "CS",
        "text": "Další krok je hotov; klikněte zde pro přechod k dalšímu kroku."
      }
    ]
  },
  {
    "key": "CRC_T_32_TITLE",
    "text": "Publish Template",
    "translations": [
      {
        "language": "AR",
        "text": "نشر النموذج"
      },
      {
        "language": "EN",
        "text": "Publish Template"
      },
      {
        "language": "CS",
        "text": "Zveřejnit šablonu"
      }
    ]
  },
  {
    "key": "CRC_T_32_DESCRIPTION",
    "text": "Click “Publish” to save and start using your template!",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"نشر\" للحفظ والبدء في استخدام النموذج الخاص بك."
      },
      {
        "language": "EN",
        "text": "Click “Publish” to save and start using your template!"
      },
      {
        "language": "CS",
        "text": "Klikněte na „Zveřejnit“, abyste šablonu uložili a mohli ji začít používat!"
      }
    ]
  },
  {
    "key": "CRC_T_33_TITLE",
    "text": "Analytical Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير التحليلية"
      },
      {
        "language": "EN",
        "text": "Analytical Criteria"
      },
      {
        "language": "CS",
        "text": "Analytická kritéria"
      }
    ]
  },
  {
    "key": "CRC_T_33_DESCRIPTION",
    "text": "In “Analytical Criteria”, you select the criteria based on your preference as a filter for the analysis.\nHint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive detailed analysis and comparison!",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المعايير التحليلية\"، يمكنك اختيار المعايير استنادًا إلى تفضيلاتك لعرض التحليلات المفصلة.\nتلميح: كلما قمت باختيار معايير أكثر كلما زادت تفاصيل تقاريرنا، مما يوفر لك تحليلًا مفصلًا شاملاً ومقارنًا!"
      },
      {
        "language": "EN",
        "text": "In “Analytical Criteria”, you select the criteria based on your preference as a filter for the analysis.\nHint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive detailed analysis and comparison!"
      },
      {
        "language": "CS",
        "text": "V části „Analytická kritéria“ vyberete kritéria podle svých preferencí jako filtr pro analýzu. Tip: Čím více kritérií vyberete, tím podrobnější budou naše zprávy, které vám poskytnou komplexní a detailní analýzu a srovnání!"
      }
    ]
  },
  {
    "key": "CRC_T_34_TITLE",
    "text": "Custom Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير مخصصة"
      },
      {
        "language": "EN",
        "text": "Custom Criteria"
      },
      {
        "language": "CS",
        "text": "Vlastní kritéria"
      }
    ]
  },
  {
    "key": "CRC_T_34_DESCRIPTION",
    "text": "You can create additional criteria.\nFill in the criterion name and its options.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إنشاء معايير إضافية.\nقم بتعبئة اسم المعيار وخياراته التابعة."
      },
      {
        "language": "EN",
        "text": "You can create additional criteria.\nFill in the criterion name and its options."
      },
      {
        "language": "CS",
        "text": "Můžete vytvořit další kritéria. Zadejte název kritéria a jeho možnosti."
      }
    ]
  },
  {
    "key": "CRC_T_35_TITLE",
    "text": "Respondent Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات المستجيب"
      },
      {
        "language": "EN",
        "text": "Respondent Information"
      },
      {
        "language": "CS",
        "text": "Informace o respondentech"
      }
    ]
  },
  {
    "key": "CRC_T_35_DESCRIPTION",
    "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتفعيل هذا الخيار في حال كنت تريد من المستجيبين أن يقوموا بتعبئة المعلومات من المعايير المختارة أعلاه أثناء التقييم."
      },
      {
        "language": "EN",
        "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the assessment."
      },
      {
        "language": "CS",
        "text": "Tuto možnost zapněte, pokud chcete, aby respondenti při vyplňování hodnocení zadávali informace podle výše vybraných kritérií."
      }
    ]
  },
  {
    "key": "CRC_T_36_TITLE",
    "text": "Next Step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      },
      {
        "language": "EN",
        "text": "Next Step!"
      },
      {
        "language": "CS",
        "text": "Další krok!"
      }
    ]
  },
  {
    "key": "CRC_T_36_DESCRIPTION",
    "text": "Another step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من خطوة أخرى؛ انقر هنا للانتقال إلى الخطوة التالية."
      },
      {
        "language": "EN",
        "text": "Another step is done; click here for the next step."
      },
      {
        "language": "CS",
        "text": "Další krok je hotový; klikněte zde pro přechod k dalšímu kroku."
      }
    ]
  },
  {
    "key": "CRC_T_37_TITLE",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبين"
      },
      {
        "language": "EN",
        "text": "Respondents"
      },
      {
        "language": "CS",
        "text": "Respondenti"
      }
    ]
  },
  {
    "key": "CRC_T_37_DESCRIPTION",
    "text": "In the “Respondents” page, you add the Respondents (Candidates & Evaluators) you want to invite to the assessment manually, by Excel file, or from your respondent pool.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"المستجيبين\"، يمكنك إضافة المستجيبين (المرشحون والمقيّمون) الذين ترغب في دعوتهم للتقييم يدوياً أو عبر ملف Excel أو من خلال مجموعة المستجيبين الخاصة بك."
      },
      {
        "language": "EN",
        "text": "In the “Respondents” page, you add the Respondents (Candidates & Evaluators) you want to invite to the assessment manually, by Excel file, or from your respondent pool."
      },
      {
        "language": "CS",
        "text": "Na stránce „Respondenti“ přidáte respondenty (kandidáty a hodnotitele), které chcete pozvat k hodnocení, a to ručně, pomocí souboru Excel nebo z vašeho seznamu respondentů."
      }
    ]
  },
  {
    "key": "CRC_T_38_TITLE",
    "text": "Add Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيبين"
      },
      {
        "language": "EN",
        "text": "Add Respondents"
      },
      {
        "language": "CS",
        "text": "Přidat respondenty"
      }
    ]
  },
  {
    "key": "CRC_T_38_DESCRIPTION",
    "text": "To start adding respondents, click on “Add Respondents”.",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة المستجيبين، انقر على \"إضافة مستجيبين\"."
      },
      {
        "language": "EN",
        "text": "To start adding respondents, click on “Add Respondents”."
      },
      {
        "language": "CS",
        "text": "Chcete-li začít přidávat respondenty, klikněte na „Přidat respondenty“."
      }
    ]
  },
  {
    "key": "CRC_T_39_TITLE",
    "text": "Bulk Upload",
    "translations": [
      {
        "language": "AR",
        "text": "رفع جدول البيانات"
      },
      {
        "language": "EN",
        "text": "Bulk Upload"
      },
      {
        "language": "CS",
        "text": "Hromadné nahrání"
      }
    ]
  },
  {
    "key": "CRC_T_39_DESCRIPTION",
    "text": "Download the pre-made spreadsheet template, populate it with your candidates and evaluators, and upload it to add respondents in bulk.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتنزيل نموذج جدول البيانات الجاهز، وأدخل بيانات المرشحين والمقيّمين، ثم ارفعه لإضافة المستجيبين دفعةً واحدة."
      },
      {
        "language": "EN",
        "text": "Download the pre-made spreadsheet template, populate it with your candidates and evaluators, and upload it to add respondents in bulk."
      },
      {
        "language": "CS",
        "text": "Stáhněte si předem připravenou šablonu tabulky, vyplňte ji svými kandidáty a hodnotiteli a nahrajte ji, abyste mohli přidat respondenty hromadně."
      }
    ]
  },
  {
    "key": "CRC_T_40_TITLE",
    "text": "Respondent Pool – Candidates",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة المستجيبين -المرشحين"
      },
      {
        "language": "EN",
        "text": "Respondent Pool – Candidates"
      },
      {
        "language": "CS",
        "text": "Seznam respondentů – Kandidáti"
      }
    ]
  },
  {
    "key": "CRC_T_40_DESCRIPTION",
    "text": "Select your candidates from the Respondent Pool and click \"Add Candidate(s)\".",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المرشحين من مجموعة المستجيبين وانقر على\" إضافة مرشح/مرشحين\"."
      },
      {
        "language": "EN",
        "text": "Select your candidates from the Respondent Pool and click \"Add Candidate(s)\"."
      },
      {
        "language": "CS",
        "text": "Vyberte kandidáty ze seznamu respondentů a klikněte na „Přidat kandidáta(y)“."
      }
    ]
  },
  {
    "key": "CRC_T_41_TITLE",
    "text": "Add Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المقيّمين"
      },
      {
        "language": "EN",
        "text": "Add Evaluators"
      },
      {
        "language": "CS",
        "text": "Přidání hodnotitelů"
      }
    ]
  },
  {
    "key": "CRC_T_41_DESCRIPTION",
    "text": "To start adding evaluators, click on \"Add Evaluator\" and select the relationship type.\n**360 Note: Each candidate must at least have 1 manager and 2 peers/team\n**180 Note: Each candidate must have at least 3 team members; adding peers is optional, and if added, it must be at least 2",
    "translations": [
      {
        "language": "AR",
        "text": "لبدء إضافة المقيّمين، انقر على \"إضافة مقيّم\" وحدد نوع العلاقة.\n**360 ملاحظة: يجب أن يكون لدى كل مرشح مدير واحد و2 من الزملاء أو أعضاء الفريق كحد أدنى.\n**180 ملاحظة: يجب أن يكون لدى كل مرشح 3 أعضاء فريق كحد أدنى؛ إضافة الزملاء اختياري وعند الإضافة يجب أن يكون عددهم 2 كحد أدنى."
      },
      {
        "language": "EN",
        "text": "To start adding evaluators, click on \"Add Evaluator\" and select the relationship type.\n**360 Note: Each candidate must at least have 1 manager and 2 peers/team\n**180 Note: Each candidate must have at least 3 team members; adding peers is optional, and if added, it must be at least 2"
      },
      {
        "language": "CS",
        "text": "Chcete-li začít přidávat hodnotitele, klikněte na „Přidat hodnotitele“ a vyberte typ vztahu. **Poznámka k hodnocení 360: Každý kandidát musí mít alespoň 1 nadřízeného a 2 kolegy/členy týmu **Poznámka k hodnocení 180: Každý kandidát musí mít alespoň 3 členy týmu; přidání kolegů je volitelné a pokud jsou přidáni, musí být alespoň 2"
      }
    ]
  },
  {
    "key": "CRC_T_42_TITLE",
    "text": "Respondent Pool – Evaluators",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة المستجيبين - المقيّمين"
      },
      {
        "language": "EN",
        "text": "Respondent Pool – Evaluators"
      },
      {
        "language": "CS",
        "text": "Skupina respondentů – Hodnotitelé"
      }
    ]
  },
  {
    "key": "CRC_T_42_DESCRIPTION",
    "text": "Select your evaluators from the Respondent Pool and click Add Evaluator(s).\nHint: You can select the relationship type from the dropdown.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المقيّمين من مجموعة المستجيبين وانقر على إضافة مقيّم/مقيّمين.\nتلميح: يمكنك تحديد صلة المقيم للمرشح من القائمة المنسدلة."
      },
      {
        "language": "EN",
        "text": "Select your evaluators from the Respondent Pool and click Add Evaluator(s).\nHint: You can select the relationship type from the dropdown."
      },
      {
        "language": "CS",
        "text": "Vyberte si hodnotitele ze skupiny respondentů a klikněte na „Přidat hodnotitele“. Tip: Typ vztahu můžete vybrat z rozevíracího seznamu."
      }
    ]
  },
  {
    "key": "CRC_T_43_TITLE",
    "text": "Single Select",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار فردي"
      },
      {
        "language": "EN",
        "text": "Single Select"
      },
      {
        "language": "CS",
        "text": "Jednotlivý výběr"
      }
    ]
  },
  {
    "key": "CRC_T_43_DESCRIPTION",
    "text": "To select a candidate or evaluator, click on the box next to their name.",
    "translations": [
      {
        "language": "AR",
        "text": "لتحديد مرشح أو مقيّم، انقر على المربع بجانب اسمه."
      },
      {
        "language": "EN",
        "text": "To select a candidate or evaluator, click on the box next to their name."
      },
      {
        "language": "CS",
        "text": "Chcete-li vybrat kandidáta nebo hodnotitele, klikněte na políčko vedle jeho jména."
      }
    ]
  },
  {
    "key": "CRC_T_44_TITLE",
    "text": "Select All",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الكل"
      },
      {
        "language": "EN",
        "text": "Select All"
      },
      {
        "language": "CS",
        "text": "Vybrat vše"
      }
    ]
  },
  {
    "key": "CRC_T_44_DESCRIPTION",
    "text": "To select all candidates or evaluators at once, click on Select All.",
    "translations": [
      {
        "language": "AR",
        "text": "لتحديد جميع المرشحين أو المقيِّمين دفعةً واحدة، قم بالنقر على \"تحديد الكل\"."
      },
      {
        "language": "EN",
        "text": "To select all candidates or evaluators at once, click on Select All."
      },
      {
        "language": "CS",
        "text": "Chcete-li vybrat všechny kandidáty nebo hodnotitele najednou, klikněte na „Vybrat vše“."
      }
    ]
  },
  {
    "key": "CRC_T_45_TITLE",
    "text": "Remove",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "EN",
        "text": "Remove"
      },
      {
        "language": "CS",
        "text": "Odstranit"
      }
    ]
  },
  {
    "key": "CRC_T_45_DESCRIPTION",
    "text": "To remove a candidate or evaluator, click on the Remove icon.",
    "translations": [
      {
        "language": "AR",
        "text": "لحذف مرشح أو مقيّم، انقر على أيقونة الحذف."
      },
      {
        "language": "EN",
        "text": "To remove a candidate or evaluator, click on the Remove icon."
      },
      {
        "language": "CS",
        "text": "Chcete-li odstranit kandidáta nebo hodnotitele, klikněte na ikonu „Odstranit“."
      }
    ]
  },
  {
    "key": "CRC_T_46_TITLE",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحت"
      },
      {
        "language": "EN",
        "text": "Search"
      },
      {
        "language": "CS",
        "text": "Hledat"
      }
    ]
  },
  {
    "key": "CRC_T_46_DESCRIPTION",
    "text": "Use the search bar to find a candidate or evaluator.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم شريط البحث للعثور على مرشح أو مقيّم."
      },
      {
        "language": "EN",
        "text": "Use the search bar to find a candidate or evaluator."
      },
      {
        "language": "CS",
        "text": "K vyhledání kandidáta nebo hodnotitele použijte vyhledávací lištu."
      }
    ]
  },
  {
    "key": "CRC_T_47_TITLE",
    "text": "Next Step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      },
      {
        "language": "EN",
        "text": "Next Step!"
      },
      {
        "language": "CS",
        "text": "Další krok!"
      }
    ]
  },
  {
    "key": "CRC_T_47_DESCRIPTION",
    "text": "You are ready to go to the next step!",
    "translations": [
      {
        "language": "AR",
        "text": "أنت جاهز للانتقال إلى الخطوة التالية!"
      },
      {
        "language": "EN",
        "text": "You are ready to go to the next step!"
      },
      {
        "language": "CS",
        "text": "Jste připraveni přejít k dalšímu kroku!"
      }
    ]
  },
  {
    "key": "CRC_T_48_TITLE",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "EN",
        "text": "Timeframe"
      },
      {
        "language": "CS",
        "text": "Časový rámec"
      }
    ]
  },
  {
    "key": "CRC_T_48_DESCRIPTION",
    "text": "In “Timeframe”, you set the assessment deadline in addition to automated reminders.",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني للتقييم بالإضافة إلى تذكيرات تلقائية لاستكمال التقييم."
      },
      {
        "language": "EN",
        "text": "In “Timeframe”, you set the assessment deadline in addition to automated reminders."
      },
      {
        "language": "CS",
        "text": "V části „Časový rámec“ nastavíte termín dokončení hodnocení a také automatická připomenutí."
      }
    ]
  },
  {
    "key": "CRC_T_49_TITLE",
    "text": "Assessment Deadline",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ إكمال التقييم"
      },
      {
        "language": "EN",
        "text": "Assessment Deadline"
      },
      {
        "language": "CS",
        "text": "Termín dokončení hodnocení"
      }
    ]
  },
  {
    "key": "CRC_T_49_DESCRIPTION",
    "text": "Set the completion date of your assessment!\nHint: You can extend the completion date after you send the invitations!",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ إكمال التقييم!\nتلميح: يمكنك تمديد تاريخ الإكمال بعد إرسال الدعوات!"
      },
      {
        "language": "EN",
        "text": "Set the completion date of your assessment!\nHint: You can extend the completion date after you send the invitations!"
      },
      {
        "language": "CS",
        "text": "Nastavte datum dokončení vašeho hodnocení! Tip: Termín dokončení můžete prodloužit i po odeslání pozvánek!"
      }
    ]
  },
  {
    "key": "CRC_T_50_TITLE",
    "text": "Automated Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "التذكيرات التلقائية"
      },
      {
        "language": "EN",
        "text": "Automated Reminders"
      },
      {
        "language": "CS",
        "text": "Automatická upomínka"
      }
    ]
  },
  {
    "key": "CRC_T_50_DESCRIPTION",
    "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف 3 تذكيرات تلقائية كحد أقصى في تواريخ محددة لإرسال تذكيرات تلقائية للمستجيبين الذين لم يستكملوا التقييم."
      },
      {
        "language": "EN",
        "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the assessment."
      },
      {
        "language": "CS",
        "text": "Přidejte až 3 automatické upomínky v konkrétních termínech, které se automaticky odešlou respondentům, kteří hodnocení nedokončili."
      }
    ]
  },
  {
    "key": "CRC_T_51_TITLE",
    "text": "Next Step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      },
      {
        "language": "EN",
        "text": "Next Step!"
      },
      {
        "language": "CS",
        "text": "Další krok!"
      }
    ]
  },
  {
    "key": "CRC_T_51_DESCRIPTION",
    "text": "One more step, and you’re ready to go!",
    "translations": [
      {
        "language": "AR",
        "text": "تبقى خطوة أخرى وتنتهي من إعداد التقييم!"
      },
      {
        "language": "EN",
        "text": "One more step, and you’re ready to go!"
      },
      {
        "language": "CS",
        "text": "Ještě jeden krok a máte hotovo!"
      }
    ]
  },
  {
    "key": "CRC_T_52_TITLE",
    "text": "Assessment Setup",
    "translations": [
      {
        "language": "AR",
        "text": "خيارات التقييم"
      },
      {
        "language": "EN",
        "text": "Assessment Setup"
      },
      {
        "language": "CS",
        "text": "Nastavení hodnocení"
      }
    ]
  },
  {
    "key": "CRC_T_52_DESCRIPTION",
    "text": "In the Assessment Options, you can edit the welcome message, select your preferred scale type, and customize the invitation and reminder emails sent to both candidates and evaluators.",
    "translations": [
      {
        "language": "AR",
        "text": "في خيارات التقييم، يمكنك تعديل رسالة الترحيب، وإعداد المقياس، وتخصيص نماذج الدعوة والتذكير المرسلة إلى المرشحين والمقيّمين."
      },
      {
        "language": "EN",
        "text": "In the Assessment Options, you can edit the welcome message, select your preferred scale type, and customize the invitation and reminder emails sent to both candidates and evaluators."
      },
      {
        "language": "CS",
        "text": "V části Možnosti hodnocení můžete upravit úvodní zprávu, vybrat preferovaný typ stupnice a přizpůsobit pozvánky a upomínkové e-maily zasílané jak kandidátům, tak hodnotitelům."
      }
    ]
  },
  {
    "key": "CRC_T_53_TITLE",
    "text": "Welcome Message",
    "translations": [
      {
        "language": "AR",
        "text": "رسالة الترحيب"
      },
      {
        "language": "EN",
        "text": "Welcome Message"
      },
      {
        "language": "CS",
        "text": "Úvodní zpráva"
      }
    ]
  },
  {
    "key": "CRC_T_53_DESCRIPTION",
    "text": "Customize the welcome message and title that respondents will see before starting the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص رسالة الترحيب والعنوان الذي سيراه المستجيبون قبل البدء في التقييم."
      },
      {
        "language": "EN",
        "text": "Customize the welcome message and title that respondents will see before starting the assessment."
      },
      {
        "language": "CS",
        "text": "Přizpůsobte úvodní zprávu a nadpis, které se respondentům zobrazí před zahájením hodnocení."
      }
    ]
  },
  {
    "key": "CRC_T_54_TITLE",
    "text": "Scale Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد المقياس"
      },
      {
        "language": "EN",
        "text": "Scale Setup"
      },
      {
        "language": "CS",
        "text": "Nastavení stupnice"
      }
    ]
  },
  {
    "key": "CRC_T_54_DESCRIPTION",
    "text": "Select your preferred scale type from Emoji, Check, or Stars to be displayed to respondents when taking the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر نوع المقياس من الرموز التعبيرية أو زر الاختيار أو النجوم لعرضه للمستجيبين عند إجراء التقييم."
      },
      {
        "language": "EN",
        "text": "Select your preferred scale type from Emoji, Check, or Stars to be displayed to respondents when taking the assessment."
      },
      {
        "language": "CS",
        "text": "Vyberte si preferovaný typ stupnice z možností Emoji, Zaškrtávací políčko nebo Hvězdičky, která se respondentům zobrazí při vyplňování hodnocení."
      }
    ]
  },
  {
    "key": "CRC_T_55_TITLE",
    "text": "Email Templates",
    "translations": [
      {
        "language": "AR",
        "text": "نماذج البريد الإلكتروني"
      },
      {
        "language": "EN",
        "text": "Email Templates"
      },
      {
        "language": "CS",
        "text": "Šablony e-mailů"
      }
    ]
  },
  {
    "key": "CRC_T_55_DESCRIPTION",
    "text": "Personalize the invitation and reminder emails for both candidates and evaluators, including the subject line and email body.\nHint: Do not erase the assessment link. If erased, click on the reset template button.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نماذج الدعوة والتذكير للمرشحين والمقيّمين، بما في ذلك خانة العنوان ومحتوى البريد الإلكتروني.\nملحوظة: لا تقم بمسح رابط التقييم. إذا تم مسحه، انقر على \"النموذج الأساسي\"."
      },
      {
        "language": "EN",
        "text": "Personalize the invitation and reminder emails for both candidates and evaluators, including the subject line and email body.\nHint: Do not erase the assessment link. If erased, click on the reset template button."
      },
      {
        "language": "CS",
        "text": "Přizpůsobte si pozvánky a upomínky pro kandidáty i hodnotitele, včetně předmětu a textu e-mailu. Tip: Nevymazávejte odkaz na hodnocení. Pokud dojde k jeho vymazání, klikněte na tlačítko pro obnovení šablony."
      }
    ]
  },
  {
    "key": "CRC_T_56_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      },
      {
        "language": "EN",
        "text": "Translation"
      },
      {
        "language": "CS",
        "text": "Překlad"
      }
    ]
  },
  {
    "key": "CRC_T_56_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      },
      {
        "language": "EN",
        "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!"
      },
      {
        "language": "CS",
        "text": "Přeložte text ručně kliknutím na „“ nebo „✨“ a nechte naši kouzelnou AI, aby to za vás udělala!"
      }
    ]
  },
  {
    "key": "CRC_T_57_TITLE",
    "text": "Publish",
    "translations": [
      {
        "language": "AR",
        "text": "نشر التقييم"
      },
      {
        "language": "EN",
        "text": "Publish"
      },
      {
        "language": "CS",
        "text": "Zveřejnit"
      }
    ]
  },
  {
    "key": "CRC_T_57_DESCRIPTION",
    "text": "Once you set up the invitation & reminder emails, click here to send the assessment invitations and go live!",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد أن تقوم بإعداد الدعوات لاستكمال التقييم، انقر هنا لإرسال دعوات التقييم وإطلاق التقييم مباشرةً!"
      },
      {
        "language": "EN",
        "text": "Once you set up the invitation & reminder emails, click here to send the assessment invitations and go live!"
      },
      {
        "language": "CS",
        "text": "Jakmile nastavíte e-maily s pozvánkami a upomínkami, klikněte sem, abyste odeslali pozvánky k hodnocení a spustili ho!"
      }
    ]
  },
  {
    "key": "CRC_T_58_TITLE",
    "text": "Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      },
      {
        "language": "EN",
        "text": "Response Rate"
      },
      {
        "language": "CS",
        "text": "Míra odezvy"
      }
    ]
  },
  {
    "key": "CRC_T_58_DESCRIPTION",
    "text": "Track your respondents' progress!\nNote: We recommend a 65% - 75% response rate for a better analysis.",
    "translations": [
      {
        "language": "AR",
        "text": "تتبع معدل الاستجابة للمستجيبين.\nملحوظة: نوصي بمعدل استجابة يتراوح بين 65% - 75% لتحليلات أفضل."
      },
      {
        "language": "EN",
        "text": "Track your respondents' progress!\nNote: We recommend a 65% - 75% response rate for a better analysis."
      },
      {
        "language": "CS",
        "text": "Sledujte pokrok svých respondentů! Poznámka: Pro lepší analýzu doporučujeme míru odezvy 65 % – 75 %."
      }
    ]
  },
  {
    "key": "CRC_T_59_TITLE",
    "text": "Select Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد المستجيبين"
      },
      {
        "language": "EN",
        "text": "Select Respondents"
      },
      {
        "language": "CS",
        "text": "Vybrat respondenty"
      }
    ]
  },
  {
    "key": "CRC_T_59_DESCRIPTION",
    "text": "Click here to select respondents and send reminders to respondents who did not complete the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتحديد المستجيبين لكي تقوم بإرسال تذكيرات للمستجيبين الذين لم يستكملوا التقييم."
      },
      {
        "language": "EN",
        "text": "Click here to select respondents and send reminders to respondents who did not complete the assessment."
      },
      {
        "language": "CS",
        "text": "Klikněte sem, abyste vybrali respondenty a odeslali upomínky těm, kteří hodnocení nedokončili."
      }
    ]
  },
  {
    "key": "CRC_T_60_TITLE",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      },
      {
        "language": "EN",
        "text": "More Actions"
      },
      {
        "language": "CS",
        "text": "Další akce"
      }
    ]
  },
  {
    "key": "CRC_T_60_DESCRIPTION",
    "text": "Send manual reminders or delete the respondent.",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات يدوية أو قم بحذف المستجيب."
      },
      {
        "language": "EN",
        "text": "Send manual reminders or delete the respondent."
      },
      {
        "language": "CS",
        "text": "Odesílejte ruční upomínky nebo odstraňte respondenta."
      }
    ]
  },
  {
    "key": "CRC_T_61_TITLE",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "EN",
        "text": "Add Respondent"
      },
      {
        "language": "CS",
        "text": "Přidat respondenta"
      }
    ]
  },
  {
    "key": "CRC_T_61_DESCRIPTION",
    "text": "Forgot to add a respondent? No worries. Click here to start adding.",
    "translations": [
      {
        "language": "AR",
        "text": "هل نسيت إضافة مستجيب؟ لا تقلق انقر هنا وابدأ بالإضافة."
      },
      {
        "language": "EN",
        "text": "Forgot to add a respondent? No worries. Click here to start adding."
      },
      {
        "language": "CS",
        "text": "Zapomněli jste přidat respondenta? Žádný problém. Klikněte sem a začněte přidávat."
      }
    ]
  },
  {
    "key": "CRC_T_62_TITLE",
    "text": "Add Evaluator",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مقيّم"
      },
      {
        "language": "EN",
        "text": "Add Evaluator"
      },
      {
        "language": "CS",
        "text": "Přidat hodnotitele"
      }
    ]
  },
  {
    "key": "CRC_T_62_DESCRIPTION",
    "text": "Forgot to add an evaluator? No worries, click here and start adding.",
    "translations": [
      {
        "language": "AR",
        "text": "هل نسيت إضافة مقيّم؟ لا تقلق انقر هنا وابدأ بالإضافة."
      },
      {
        "language": "EN",
        "text": "Forgot to add an evaluator? No worries, click here and start adding."
      },
      {
        "language": "CS",
        "text": "Zapomněli jste přidat hodnotitele? Žádný problém, klikněte sem a začněte přidávat."
      }
    ]
  },
  {
    "key": "CRC_T_63_TITLE",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      },
      {
        "language": "EN",
        "text": "More Actions"
      },
      {
        "language": "CS",
        "text": "Další akce"
      }
    ]
  },
  {
    "key": "CRC_T_63_DESCRIPTION",
    "text": "Click here to export respondents in an Excel sheet, view the assessment questions in PDF format, or update the deadline and automated reminder dates.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتحميل المستجيبين بصيغة Excel، أو عرض أسئلة التقييم بصيغة PDF، أو لتحديث تاريخ الإكمال وتواريخ التذكير التلقائي."
      },
      {
        "language": "EN",
        "text": "Click here to export respondents in an Excel sheet, view the assessment questions in PDF format, or update the deadline and automated reminder dates."
      },
      {
        "language": "CS",
        "text": "Klikněte sem a exportujte respondenty do souboru Excel, zobrazte otázky hodnocení ve formátu PDF nebo aktualizujte termín a data automatických upomínek."
      }
    ]
  },
  {
    "key": "CRC_T_64_TITLE",
    "text": "Open Candidate Report",
    "translations": [
      {
        "language": "AR",
        "text": "فتح تقرير المرشح"
      },
      {
        "language": "EN",
        "text": "Open Candidate Report"
      },
      {
        "language": "CS",
        "text": "Otevřít zprávu o kandidátovi"
      }
    ]
  },
  {
    "key": "CRC_T_64_DESCRIPTION",
    "text": "Have some of your candidates and evaluators completed their assessments while others are still in progress? No worries! You can view their reports by clicking “Close” for the chosen candidate.\nTo view the closed candidate’s report, click on “Open”.\n***For 360\nNote: To close a candidate's report, it is required a minimum of self-assessment, one manager assessment, and two peer or team assessments to be completed.\n*** For 180\nNote: To close a candidate's report, it is required a minimum of self-assessment and at least three team assessments to be completed.\n***360\n*** 180",
    "translations": [
      {
        "language": "AR",
        "text": "هل استكمل بعض المرشحين والمقيمين لديك تقييماتهم بينما لا يزال البعض الآخر قيد الإنجاز؟ لا تقلق! يمكنك عرض هذه التقارير بالنقر على \"أغلق الآن\" للمرشح المختار.\nوللاطلاع على تقرير المرشح المغلق انقر على “فتح”.\nملحوظة: لإغلاق تقرير المرشح، يلزم استكمال التقييم الذاتي، وتقييم مدير واحد، وتقييمين من الزملاء أو أعضاء الفريق كحد أدنى.\nملحوظة: لإغلاق تقرير المرشح، يُشترط إكمال تقييم ذاتي واحد على الأقل وثلاثة تقييمات من أعضاء الفريق كحد أدنى."
      },
      {
        "language": "EN",
        "text": "Have some of your candidates and evaluators completed their assessments while others are still in progress? No worries! You can view their reports by clicking “Close” for the chosen candidate.\nTo view the closed candidate’s report, click on “Open”.\n***For 360\nNote: To close a candidate's report, it is required a minimum of self-assessment, one manager assessment, and two peer or team assessments to be completed.\n*** For 180\nNote: To close a candidate's report, it is required a minimum of self-assessment and at least three team assessments to be completed.\n***360\n*** 180"
      },
      {
        "language": "CS",
        "text": "Dokončili někteří z vašich kandidátů a hodnotitelů svá hodnocení, zatímco ostatní ještě pracují? Žádný problém! Zprávy si můžete zobrazit kliknutím na „Uzavřít“ u vybraného kandidáta. Chcete-li zobrazit zprávu o uzavřeném kandidátovi, klikněte na „Otevřít“. ***Pro 360 Poznámka: K uzavření zprávy kandidáta je nutné, aby bylo vyplněno minimálně sebehodnocení, jedno hodnocení manažerem a dvě hodnocení kolegy nebo týmem.  *** Pro 180 Poznámka: K uzavření zprávy kandidáta je nutné, aby bylo vyplněno minimálně sebehodnocení a alespoň tři hodnocení týmem. ***360 *** 180"
      }
    ]
  },
  {
    "key": "CRC_T_65_TITLE",
    "text": "Close Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق التقييم"
      },
      {
        "language": "EN",
        "text": "Close Assessment"
      },
      {
        "language": "CS",
        "text": "Uzavřít hodnocení"
      }
    ]
  },
  {
    "key": "CRC_T_65_DESCRIPTION",
    "text": "Click on “Close Assessment” to close the assessment.\nNote: You cannot add or delete respondents once you close the assessment.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"أغلق التقييم\" لإغلاق التقييم.\nملحوظة: لن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      },
      {
        "language": "EN",
        "text": "Click on “Close Assessment” to close the assessment.\nNote: You cannot add or delete respondents once you close the assessment."
      },
      {
        "language": "CS",
        "text": "Kliknutím na „Uzavřít hodnocení“ hodnocení uzavřete. Poznámka: Po uzavření hodnocení již nelze přidávat ani odstraňovat respondenty."
      }
    ]
  },
  {
    "key": "CRC_T_66_TITLE",
    "text": "Assessment Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل التقييم"
      },
      {
        "language": "EN",
        "text": "Assessment Details"
      },
      {
        "language": "CS",
        "text": "Podrobnosti hodnocení"
      }
    ]
  },
  {
    "key": "CRC_T_66_DESCRIPTION",
    "text": "View a full summary of the assessment, including the final response rate, total number of candidates, evaluators, competencies, and statements.",
    "translations": [
      {
        "language": "AR",
        "text": "اطّلع على ملخص كامل للتقييم، يشمل معدل الاستجابة النهائي، والعدد الإجمالي للمرشحين والمقيّمين، والجدارات والمهارات والعبارات."
      },
      {
        "language": "EN",
        "text": "View a full summary of the assessment, including the final response rate, total number of candidates, evaluators, competencies, and statements."
      },
      {
        "language": "CS",
        "text": "Zobrazte si úplný souhrn hodnocení, včetně konečné míry odezvy, celkového počtu kandidátů, hodnotitelů, kompetencí a tvrzení."
      }
    ]
  },
  {
    "key": "CRC_T_67_TITLE",
    "text": "Competency Drop Down",
    "translations": [
      {
        "language": "AR",
        "text": "القائمة المنسدلة للجدارة والمهارة"
      },
      {
        "language": "EN",
        "text": "Competency Drop Down"
      },
      {
        "language": "CS",
        "text": "Rozbalovací nabídka kompetencí"
      }
    ]
  },
  {
    "key": "CRC_T_67_DESCRIPTION",
    "text": "Select a competency from the list to view its detailed results or select All Competencies for a complete overview.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد جدارة ومهارة من القائمة لعرض نتائجها التفصيلية، أو اختر كل الجدارات والمهارات للاطلاع على الصورة الكاملة."
      },
      {
        "language": "EN",
        "text": "Select a competency from the list to view its detailed results or select All Competencies for a complete overview."
      },
      {
        "language": "CS",
        "text": "Vyberte kompetenci ze seznamu a zobrazte si její podrobné výsledky, nebo vyberte možnost „Všechny kompetence“ pro kompletní přehled."
      }
    ]
  },
  {
    "key": "CRC_T_68_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "التصفيات"
      },
      {
        "language": "EN",
        "text": "Filters"
      },
      {
        "language": "CS",
        "text": "Filtry"
      }
    ]
  },
  {
    "key": "CRC_T_68_DESCRIPTION",
    "text": "Select your preferred display option from Previous/Change, Avg. Score, Relations, or Gap Analysis, and click Apply to update the results.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر خيار العرض المفضل من السابق/التغيير، أو متوسط الدرجات، أو العلاقات، أو تحليل الفجوات، ثم انقر على تطبيق لتحديث النتائج."
      },
      {
        "language": "EN",
        "text": "Select your preferred display option from Previous/Change, Avg. Score, Relations, or Gap Analysis, and click Apply to update the results."
      },
      {
        "language": "CS",
        "text": "Vyberte si preferovanou možnost zobrazení z možností „Předchozí/Změnit“, „Průměrné skóre“, „Vztahy“ nebo „Analýza mezer“ a kliknutím na „Použít“ aktualizujte výsledky."
      }
    ]
  },
  {
    "key": "CRC_T_69_TITLE",
    "text": "Change View",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير طريقة العرض"
      },
      {
        "language": "EN",
        "text": "Change View"
      },
      {
        "language": "CS",
        "text": "Změnit zobrazení"
      }
    ]
  },
  {
    "key": "CRC_T_69_DESCRIPTION",
    "text": "Switch between the performance cards view and the list view to display the results in your preferred format.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تغيير العرض بين البطاقات والقائمة لعرض النتائج بالشكل الذي يناسبك."
      },
      {
        "language": "EN",
        "text": "Switch between the performance cards view and the list view to display the results in your preferred format."
      },
      {
        "language": "CS",
        "text": "Přepínejte mezi zobrazením výkonnostních karet a zobrazením seznamu, abyste si výsledky zobrazili ve formátu, který vám vyhovuje."
      }
    ]
  },
  {
    "key": "CRC_T_70_TITLE",
    "text": "Comparison Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة"
      },
      {
        "language": "EN",
        "text": "Comparison Report"
      },
      {
        "language": "CS",
        "text": "Srovnávací zpráva"
      }
    ]
  },
  {
    "key": "CRC_T_70_DESCRIPTION",
    "text": "You can download the candidates’ list and overall performance score across all competencies for a detailed comparison.\nNote: Available in Excel format.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المرشحين ومعدل تقييم الأداء العام لجميع الجدارات والمهارات لإجراء مقارنة تفصيلية.\nملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "EN",
        "text": "You can download the candidates’ list and overall performance score across all competencies for a detailed comparison.\nNote: Available in Excel format."
      },
      {
        "language": "CS",
        "text": "Pro podrobné srovnání si můžete stáhnout seznam kandidátů a celkové skóre výkonu ve všech kompetencích. Poznámka: K dispozici ve formátu Excel."
      }
    ]
  },
  {
    "key": "CRC_T_71_TITLE",
    "text": "Sorting",
    "translations": [
      {
        "language": "AR",
        "text": "الترتيب"
      },
      {
        "language": "EN",
        "text": "Sorting"
      },
      {
        "language": "CS",
        "text": "Třídění"
      }
    ]
  },
  {
    "key": "CRC_T_71_DESCRIPTION",
    "text": "Arrange the results by selecting between ascending or descending order.",
    "translations": [
      {
        "language": "AR",
        "text": "رتّب النتائج باختيار الترتيب التصاعدي أو التنازلي."
      },
      {
        "language": "EN",
        "text": "Arrange the results by selecting between ascending or descending order."
      },
      {
        "language": "CS",
        "text": "Seřaďte výsledky výběrem vzestupného nebo sestupného pořadí."
      }
    ]
  },
  {
    "key": "CRC_T_72_TITLE",
    "text": "Performance Card",
    "translations": [
      {
        "language": "AR",
        "text": "بطاقة الأداء"
      },
      {
        "language": "EN",
        "text": "Performance Card"
      },
      {
        "language": "CS",
        "text": "Karta výkonu"
      }
    ]
  },
  {
    "key": "CRC_T_72_DESCRIPTION",
    "text": "The Performance Card displays the candidate's self-score, evaluators score, previous score, difference, and percentage change. Click on it to view the detailed report of the candidate.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض بطاقة الأداء نتيجة المرشح الذاتية، نتيجة المقيّمين، والدرجة السابقة، والفرق، ونسبة التغيير. يمكنك الضغط على البطاقة لعرض التقرير المُفصل للمرشح."
      },
      {
        "language": "EN",
        "text": "The Performance Card displays the candidate's self-score, evaluators score, previous score, difference, and percentage change. Click on it to view the detailed report of the candidate."
      },
      {
        "language": "CS",
        "text": "Karta výkonu zobrazuje vlastní hodnocení kandidáta, hodnocení hodnotitelů, předchozí skóre, rozdíl a procentuální změnu. Kliknutím na ni zobrazíte podrobnou zprávu o kandidátovi."
      }
    ]
  },
  {
    "key": "CRC_T_73_TITLE",
    "text": "Score Card",
    "translations": [
      {
        "language": "AR",
        "text": "بطاقة التقييم"
      },
      {
        "language": "EN",
        "text": "Score Card"
      },
      {
        "language": "CS",
        "text": "Karta skóre"
      }
    ]
  },
  {
    "key": "CRC_T_73_DESCRIPTION",
    "text": "The Score Card displays the candidate's self-score, evaluators score, and a competency-level breakdown, including average scores and gap analysis.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض بطاقة النتائج درجة المرشح الذاتية، ودرجة المقيّمين، وتفصيلاً على مستوى الجدارات والمهارات يشمل متوسط الدرجات وتحليل الفجوات."
      },
      {
        "language": "EN",
        "text": "The Score Card displays the candidate's self-score, evaluators score, and a competency-level breakdown, including average scores and gap analysis."
      },
      {
        "language": "CS",
        "text": "Karta skóre zobrazuje vlastní hodnocení kandidáta, hodnocení hodnotitelů a rozpis podle úrovní kompetencí, včetně průměrných skóre a analýzy mezer."
      }
    ]
  },
  {
    "key": "CRC_T_74_TITLE",
    "text": "Self-Score & Evaluator Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة التقييم الذاتي ونتيجة المقيّمين"
      },
      {
        "language": "EN",
        "text": "Self-Score & Evaluator Score"
      },
      {
        "language": "CS",
        "text": "Vlastní hodnocení a hodnocení hodnotitelů"
      }
    ]
  },
  {
    "key": "CRC_T_74_DESCRIPTION",
    "text": "View the candidate's self-score and evaluators score, along with the previous score, difference, and percentage change for each.",
    "translations": [
      {
        "language": "AR",
        "text": "اطّلع على نتيجة التقييم الذاتي للمرشح ونتيجة المقيّمين، إلى جانب الدرجة السابقة والفرق ونسبة التغيير لكل منهما."
      },
      {
        "language": "EN",
        "text": "View the candidate's self-score and evaluators score, along with the previous score, difference, and percentage change for each."
      },
      {
        "language": "CS",
        "text": "Zobrazte vlastní hodnocení kandidáta a hodnocení hodnotitelů spolu s předchozím hodnocením, rozdílem a procentuální změnou u každého z nich."
      }
    ]
  },
  {
    "key": "CRC_T_75_TITLE",
    "text": "Competency Breakdown View",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل الجدارات والمهارات"
      },
      {
        "language": "EN",
        "text": "Competency Breakdown View"
      },
      {
        "language": "CS",
        "text": "Zobrazení rozdělení podle kompetencí"
      }
    ]
  },
  {
    "key": "CRC_T_75_DESCRIPTION",
    "text": "The competency breakdown displays the score, average score, and gap for each competency. Toggle between Avg. Score and Previous Score to compare results.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض تفصيل الجدارات والمهارات الدرجة ومتوسط الدرجة والفجوة لكل جدارة ومهارة. ويمكنك التنقل بين متوسط الدرجة والدرجة السابقة لمقارنة النتائج."
      },
      {
        "language": "EN",
        "text": "The competency breakdown displays the score, average score, and gap for each competency. Toggle between Avg. Score and Previous Score to compare results."
      },
      {
        "language": "CS",
        "text": "Rozdělení podle kompetencí zobrazuje skóre, průměrné skóre a mezeru u každé kompetence. Přepínejte mezi „Průměrným skóre“ a „Předchozím skóre“, abyste mohli porovnat výsledky."
      }
    ]
  },
  {
    "key": "CRC_T_76_TITLE",
    "text": "Competency Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الجدارات والمهارات"
      },
      {
        "language": "EN",
        "text": "Competency Analysis"
      },
      {
        "language": "CS",
        "text": "Analýza kompetencí"
      }
    ]
  },
  {
    "key": "CRC_T_76_DESCRIPTION",
    "text": "Switch between “Competencies” and “Statements” to view the detailed score for each competency and its corresponding statements for each candidate.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بالاطلاع على \"الجدارات والمهارات\" أو \"العبارات\" لعرض معدل التقييم المٌفصل لكل جدارة ومهارة والعبارات التابعة لها لكل مرشح."
      },
      {
        "language": "EN",
        "text": "Switch between “Competencies” and “Statements” to view the detailed score for each competency and its corresponding statements for each candidate."
      },
      {
        "language": "CS",
        "text": "Přepínejte mezi položkami „Kompetence“ a „Tvrzení“, abyste si u každého uchazeče prohlédli podrobné skóre pro každou kompetenci a odpovídající tvrzení."
      }
    ]
  },
  {
    "key": "CRC_T_77_TITLE",
    "text": "Select Competency",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الجدارة والمهارة"
      },
      {
        "language": "EN",
        "text": "Select Competency"
      },
      {
        "language": "CS",
        "text": "Výběr kompetence"
      }
    ]
  },
  {
    "key": "CRC_T_77_DESCRIPTION",
    "text": "Select a competency to unveil the candidate's score breakdown for each statement within that competency.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد الجدارة والمهارة لكي تكشف عن تفصيل معدل أداء المرشح في كل عبارة تحت الجدارة والمهارة المحددة."
      },
      {
        "language": "EN",
        "text": "Select a competency to unveil the candidate's score breakdown for each statement within that competency."
      },
      {
        "language": "CS",
        "text": "Vyberte kompetenci a zobrazte si rozpis skóre uchazeče pro každé tvrzení v rámci dané kompetence."
      }
    ]
  },
  {
    "key": "CRC_T_78_TITLE",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "EN",
        "text": "Comments"
      },
      {
        "language": "CS",
        "text": "Komentáře"
      }
    ]
  },
  {
    "key": "CRC_T_78_DESCRIPTION",
    "text": "The Comments section displays evaluators' feedback on the candidate's strength areas and areas of improvement, grouped by relationship type.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض قسم التعليقات ملاحظات المقيّمين حول نقاط القوة ومجالات التحسين لدى المرشح، مجمّعةً حسب نوع العلاقة."
      },
      {
        "language": "EN",
        "text": "The Comments section displays evaluators' feedback on the candidate's strength areas and areas of improvement, grouped by relationship type."
      },
      {
        "language": "CS",
        "text": "Sekce Komentáře zobrazuje zpětnou vazbu hodnotitelů ohledně silných stránek uchazeče a oblastí, ve kterých se může zlepšit, seskupenou podle typu vztahu."
      }
    ]
  },
  {
    "key": "CRC_T_79_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "EN",
        "text": "Export"
      },
      {
        "language": "CS",
        "text": "Export"
      }
    ]
  },
  {
    "key": "CRC_T_79_DESCRIPTION",
    "text": "Export the comments by clicking on export\nNote: Available in Excel format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل التعليقات بالنقر على تحميل.\nملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "EN",
        "text": "Export the comments by clicking on export\nNote: Available in Excel format."
      },
      {
        "language": "CS",
        "text": "Komentáře exportujte kliknutím na tlačítko „Exportovat“. Poznámka: K dispozici ve formátu Excel."
      }
    ]
  },
  {
    "key": "CRC_T_80_TITLE",
    "text": "AI Translation",
    "translations": [
      {
        "language": "AR",
        "text": "ترجمة الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Translation"
      },
      {
        "language": "CS",
        "text": "Překlad pomocí AI"
      }
    ]
  },
  {
    "key": "CRC_T_80_DESCRIPTION",
    "text": "Click on Translation to translate all comments using AI into the language of your choice.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بالنقر على \"الترجمة\" لترجمة جميع التعليقات باستخدام الذكاء الاصطناعي إلى اللغة التي تختارها."
      },
      {
        "language": "EN",
        "text": "Click on Translation to translate all comments using AI into the language of your choice."
      },
      {
        "language": "CS",
        "text": "Kliknutím na „Překlad“ přeložíte všechny komentáře pomocí umělé inteligence do jazyka podle vašeho výběru."
      }
    ]
  },
  {
    "key": "CRC_T_81_TITLE",
    "text": "Show/Hide Translation",
    "translations": [
      {
        "language": "AR",
        "text": "إظهار/إخفاء الترجمة"
      },
      {
        "language": "EN",
        "text": "Show/Hide Translation"
      },
      {
        "language": "CS",
        "text": "Zobrazit/skrýt překlad"
      }
    ]
  },
  {
    "key": "CRC_T_81_DESCRIPTION",
    "text": "Click on the eye icon to show/hide the translated comments.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بالنقر على أيقونة العين لإظهار/إخفاء التعليقات المترجمة."
      },
      {
        "language": "EN",
        "text": "Click on the eye icon to show/hide the translated comments."
      },
      {
        "language": "CS",
        "text": "Kliknutím na ikonu oka zobrazíte nebo skryjete přeložené komentáře."
      }
    ]
  },
  {
    "key": "CRC_T_82_TITLE",
    "text": "Respondent Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المستجيبون"
      },
      {
        "language": "EN",
        "text": "Respondent Analysis"
      },
      {
        "language": "CS",
        "text": "Analýza respondentů"
      }
    ]
  },
  {
    "key": "CRC_T_82_DESCRIPTION",
    "text": "On the “Respondent Analysis” page, the assessment status for the list of candidates and evaluators who participated is displayed. You can download the list of respondents with their assessment status!\nNote: Available in Excel format.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"تحليل المستجيبون\"، يتم عرض حالة التقييم لقائمة المرشحين والمقيمين المشاركين.\nيمكنك تحميل قائمة المستجيبين مع حالة التقييم الخاص بهم!\nملحوظة: متوفر في صيغة Excel."
      },
      {
        "language": "EN",
        "text": "On the “Respondent Analysis” page, the assessment status for the list of candidates and evaluators who participated is displayed. You can download the list of respondents with their assessment status!\nNote: Available in Excel format."
      },
      {
        "language": "CS",
        "text": "Na stránce „Analýza respondentů“ se zobrazuje stav hodnocení pro seznam uchazečů a hodnotitelů, kteří se zúčastnili. Seznam respondentů s jejich stavem hodnocení si můžete stáhnout! Poznámka: K dispozici ve formátu Excel."
      }
    ]
  },
  {
    "key": "CRC_T_83_TITLE",
    "text": "Peer to Peer Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة زميل لزميل"
      },
      {
        "language": "EN",
        "text": "Peer to Peer Comparison"
      },
      {
        "language": "CS",
        "text": "Srovnání mezi kandidáty"
      }
    ]
  },
  {
    "key": "CRC_T_83_DESCRIPTION",
    "text": "Select two candidates to enable the Peer-to-Peer Comparison which displays a side-by-side view of each candidate's overall scores and competency-level results, with a spider chart for a visual comparison.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد مرشحان لعرض تحليل مقارنة زميل لزميل والذي يُظهر إجمالي الدرجات لكل مرشح ونتائجه على مستوى الجدارات والمهارات، مع مخطط عنكبوتي للمقارنة البصرية"
      },
      {
        "language": "EN",
        "text": "Select two candidates to enable the Peer-to-Peer Comparison which displays a side-by-side view of each candidate's overall scores and competency-level results, with a spider chart for a visual comparison."
      },
      {
        "language": "CS",
        "text": "Vyberte dva kandidáty a aktivujte tak „Srovnání mezi kandidáty“, které zobrazuje vedle sebe celkové skóre a výsledky na úrovni kompetencí každého kandidáta, včetně pavoučího grafu pro vizuální srovnání."
      }
    ]
  },
  {
    "key": "CRC_T_84_TITLE",
    "text": "Peer to Peer Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير مقارنة زميل لزميل"
      },
      {
        "language": "EN",
        "text": "Peer to Peer Report"
      },
      {
        "language": "CS",
        "text": "Zpráva o srovnání mezi kandidáty"
      }
    ]
  },
  {
    "key": "CRC_T_84_DESCRIPTION",
    "text": "Click on Export to download the peer-to-peer comparison report.\nNote: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير مقارنة زميل لـ زميل بالنقر على تحميل.\nملحوظة: متوفر بصيغة PDF."
      },
      {
        "language": "EN",
        "text": "Click on Export to download the peer-to-peer comparison report.\nNote: Available in PDF format."
      },
      {
        "language": "CS",
        "text": "Klikněte na „Exportovat“ a stáhněte si zprávu o srovnání mezi kandidáty. Poznámka: K dispozici ve formátu PDF."
      }
    ]
  },
  {
    "key": "CRC_T_85_TITLE",
    "text": "Multi-Compare",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة المتعددة"
      },
      {
        "language": "EN",
        "text": "Multi-Compare"
      },
      {
        "language": "CS",
        "text": "Víceúčelové srovnání"
      }
    ]
  },
  {
    "key": "CRC_T_85_DESCRIPTION",
    "text": "Select at least 3 candidates to enable the Multi Comparison which displays each candidate's evaluators score and gap against the organization average, with the ability to filter by competency.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد ثلاثة مرشحين على الأقل لعرض تقرير المقارنة المتعددة والذي يُظهرنتيجة المقيّمين والفجوة لكل مرشح مقارنةً بمتوسط المؤسسة، مع إمكانية التصفية حسب الجدارة والمهارة."
      },
      {
        "language": "EN",
        "text": "Select at least 3 candidates to enable the Multi Comparison which displays each candidate's evaluators score and gap against the organization average, with the ability to filter by competency."
      },
      {
        "language": "CS",
        "text": "Vyberte alespoň 3 kandidáty a aktivujte tak funkci „Víceporovnání“, která zobrazuje skóre každého kandidáta od hodnotitelů a jeho odchylku od průměru organizace, s možností filtrování podle kompetence."
      }
    ]
  },
  {
    "key": "CRC_T_86_TITLE",
    "text": "Multi-Comparison Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة المتعددة"
      },
      {
        "language": "EN",
        "text": "Multi-Comparison Report"
      },
      {
        "language": "CS",
        "text": "Zpráva o víceporovnání"
      }
    ]
  },
  {
    "key": "CRC_T_86_DESCRIPTION",
    "text": "Click on Export to download the multi-comparison report.\nNote: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة المتعددة بالنقر على تحميل.\nملحوظة: متوفر بصيغة PDF."
      },
      {
        "language": "EN",
        "text": "Click on Export to download the multi-comparison report.\nNote: Available in PDF format."
      },
      {
        "language": "CS",
        "text": "Kliknutím na tlačítko „Exportovat“ si můžete stáhnout zprávu o víceporovnání. Poznámka: K dispozici ve formátu PDF."
      }
    ]
  },
  {
    "key": "CRC_T_87_TITLE",
    "text": "Share Results",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة النتائج"
      },
      {
        "language": "EN",
        "text": "Share Results"
      },
      {
        "language": "CS",
        "text": "Sdílení výsledků"
      }
    ]
  },
  {
    "key": "CRC_T_87_DESCRIPTION",
    "text": "Select your recipients, report type, and the sections to include. You can select all candidates at once or individually, then share the assessment results.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد المرسل إليهم ونوع التقرير والأقسام المراد تضمينها. يمكنك تحديد جميع المرشحين دفعةً واحدة أو بشكل فردي، ثم مشاركة نتائج التقييم."
      },
      {
        "language": "EN",
        "text": "Select your recipients, report type, and the sections to include. You can select all candidates at once or individually, then share the assessment results."
      },
      {
        "language": "CS",
        "text": "Vyberte příjemce, typ zprávy a sekce, které chcete zahrnout. Můžete vybrat všechny kandidáty najednou nebo jednotlivě a poté sdílet výsledky hodnocení."
      }
    ]
  },
  {
    "key": "CRC_T_88_TITLE",
    "text": "Sharing Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل المشاركة"
      },
      {
        "language": "EN",
        "text": "Sharing Details"
      },
      {
        "language": "CS",
        "text": "Podrobnosti sdílení"
      }
    ]
  },
  {
    "key": "CRC_T_88_DESCRIPTION",
    "text": "Select who to share the results with, choose the report type, and toggle the sections to include. You can also opt to display the original language or an AI-translated version.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المرسل إليهم لمشاركة النتائج، واختر نوع التقرير، وحدد الأقسام المراد تضمينها. يمكنك أيضاً اختيار عرض اللغة الأصلية أو نسخة مترجمة بالذكاء الاصطناعي."
      },
      {
        "language": "EN",
        "text": "Select who to share the results with, choose the report type, and toggle the sections to include. You can also opt to display the original language or an AI-translated version."
      },
      {
        "language": "CS",
        "text": "Vyberte, s kým chcete výsledky sdílet, zvolte typ zprávy a zaškrtněte sekce, které chcete zahrnout. Můžete se také rozhodnout, zda se má zobrazit původní jazyk nebo verze přeložená umělou inteligencí."
      }
    ]
  },
  {
    "key": "CRC_T_89_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الالكتروني"
      },
      {
        "language": "EN",
        "text": "Email Template"
      },
      {
        "language": "CS",
        "text": "Šablona e-mailu"
      }
    ]
  },
  {
    "key": "CRC_T_89_DESCRIPTION",
    "text": "Customize the subject line and email body that will be sent to the selected recipients along with their assessment results report.\nHint: Do not erase the feedback link. If erased, click on the reset template button.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص خانة العنوان ومحتوى البريد الإلكتروني الذي سيُرسل إلى المرسل إليهم المحددين مع تقرير نتائج تقييمهم.\nملحوظة: لا تقم بمسح رابط التغذية الراجعة. إذا تم مسحه، انقر على زر \"النموذج الأساسي\"."
      },
      {
        "language": "EN",
        "text": "Customize the subject line and email body that will be sent to the selected recipients along with their assessment results report.\nHint: Do not erase the feedback link. If erased, click on the reset template button."
      },
      {
        "language": "CS",
        "text": "Přizpůsobte předmět a text e-mailu, který bude odeslán vybraným příjemcům spolu se zprávou o výsledcích hodnocení. Tip: Nevymazávejte odkaz na zpětnou vazbu. Pokud dojde k jeho vymazání, klikněte na tlačítko „Obnovit šablonu“."
      }
    ]
  },
  {
    "key": "CRC_T_90_TITLE",
    "text": "Share Now",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة الان"
      },
      {
        "language": "EN",
        "text": "Share Now"
      },
      {
        "language": "CS",
        "text": "Sdílet nyní"
      }
    ]
  },
  {
    "key": "CRC_T_90_DESCRIPTION",
    "text": "Once all sharing details are confirmed, click Share Now to send the assessment results to the selected recipients.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تأكيد جميع تفاصيل المشاركة، انقر على شارك الآن لإرسال نتائج التقييم إلى المرسل إليهم المحددين."
      },
      {
        "language": "EN",
        "text": "Once all sharing details are confirmed, click Share Now to send the assessment results to the selected recipients."
      },
      {
        "language": "CS",
        "text": "Jakmile potvrdíte všechny podrobnosti sdílení, klikněte na tlačítko Sdílet nyní a odešlete výsledky hodnocení vybraným příjemcům."
      }
    ]
  },
  {
    "key": "CRC_T_91_TITLE",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "EN",
        "text": "Download"
      },
      {
        "language": "CS",
        "text": "Stáhnout"
      }
    ]
  },
  {
    "key": "CRC_T_91_DESCRIPTION",
    "text": "Download the assessment report by selecting either the Management or Candidate report format.\nNote: Available as PDF",
    "translations": [
      {
        "language": "AR",
        "text": "حمّل تقرير التقييم باختيار صيغة التقرير الإداري أو تقرير المرشح.\nملحوظة: متوفر بصيغة PDF."
      },
      {
        "language": "EN",
        "text": "Download the assessment report by selecting either the Management or Candidate report format.\nNote: Available as PDF"
      },
      {
        "language": "CS",
        "text": "Stáhněte si zprávu o hodnocení výběrem formátu zprávy pro vedení nebo pro kandidáty. Poznámka: K dispozici ve formátu PDF"
      }
    ]
  },
  {
    "key": "txt_EvaluatorsAvgScore",
    "text": "Evaluators Avg. Score",
    "translations": [
      {
        "language": "EN",
        "text": "Evaluators Avg. Score"
      },
      {
        "language": "AR",
        "text": "متوسط درجة المقيمين"
      },
      {
        "language": "CS",
        "text": "Průměrné skóre hodnotitelů"
      }
    ]
  },
  {
    "key": "txt_AcrossAllCompetencies",
    "text": "Across all competencies",
    "translations": [
      {
        "language": "EN",
        "text": "Across all competencies"
      },
      {
        "language": "AR",
        "text": "على مستوى جميع الجدارات"
      },
      {
        "language": "CS",
        "text": "Ve všech kompetencích"
      }
    ]
  },
  {
    "key": "txt_SelfAvgScore",
    "text": "Self Avg. Score",
    "translations": [
      {
        "language": "EN",
        "text": "Self Avg. Score"
      },
      {
        "language": "AR",
        "text": "متوسط درجة التقييم الذاتي"
      },
      {
        "language": "CS",
        "text": "Průměrné skóre kandidáta"
      }
    ]
  },
  {
    "key": "txt_SelfVsEvaluators",
    "text": "Self vs Evaluators",
    "translations": [
      {
        "language": "EN",
        "text": "Self vs Evaluators"
      },
      {
        "language": "AR",
        "text": "التقييم الذاتي مقابل المقيّمين"
      },
      {
        "language": "CS",
        "text": "Kandidát vs. hodnotitelé"
      }
    ]
  },
  {
    "key": "txt_RiskCandidates",
    "text": "Low-Performing Candidates",
    "translations": [
      {
        "language": "EN",
        "text": "Low-Performing Candidates"
      },
      {
        "language": "AR",
        "text": "المرشحون منخفضو الأداء"
      },
      {
        "language": "CS",
        "text": "Kandidáti s nízkým výkonem"
      }
    ]
  },
  {
    "key": "txt_PerformanceOverview",
    "text": "Performance Overview",
    "translations": [
      {
        "language": "EN",
        "text": "Performance Overview"
      },
      {
        "language": "AR",
        "text": "نظرة عامة على الأداء"
      },
      {
        "language": "CS",
        "text": "Přehled výkonu"
      }
    ]
  },
  {
    "key": "txt_ShowSelfScore",
    "text": "Show Self Score",
    "translations": [
      {
        "language": "EN",
        "text": "Show Self Score"
      },
      {
        "language": "AR",
        "text": "عرض تقييم الذات"
      },
      {
        "language": "CS",
        "text": "Zobrazit vlastní skóre"
      }
    ]
  },
  {
    "key": "txt_Top5PerformersScore",
    "text": "Top 5 Performers Score",
    "translations": [
      {
        "language": "EN",
        "text": "Top 5 Performers Score"
      },
      {
        "language": "AR",
        "text": "درجات أفضل 5 أداءً"
      },
      {
        "language": "CS",
        "text": "Skóre 5 nejlepších uchazečů"
      }
    ]
  },
  {
    "key": "txt_StrongestPerformer",
    "text": "Strongest Performer",
    "translations": [
      {
        "language": "EN",
        "text": "Strongest Performers"
      },
      {
        "language": "AR",
        "text": "الأعلى أداءً"
      },
      {
        "language": "CS",
        "text": "Nejlepší uchazeči"
      }
    ]
  },
  {
    "key": "txt_Bottom5PerformersScore",
    "text": "Bottom 5 Performers Score",
    "translations": [
      {
        "language": "EN",
        "text": "Bottom 5 Performers Score"
      },
      {
        "language": "AR",
        "text": "درجات أقل 5 أداءً"
      },
      {
        "language": "CS",
        "text": "Skóre 5 nejhorších uchazečů"
      }
    ]
  },
  {
    "key": "txt_NeedsAttention",
    "text": "Needs Attention",
    "translations": [
      {
        "language": "EN",
        "text": "Needs Attention"
      },
      {
        "language": "AR",
        "text": "بحاجة إلى متابعة"
      },
      {
        "language": "CS",
        "text": "Vyžaduje pozornost"
      }
    ]
  },
  {
    "key": "txt_AICommentAnalysis",
    "text": "AI Comment Analysis",
    "translations": [
      {
        "language": "EN",
        "text": "AI Comment Analysis"
      },
      {
        "language": "AR",
        "text": "تحليل التعليقات بالذكاء الاصطناعي"
      },
      {
        "language": "CS",
        "text": "Analýza komentářů AI"
      }
    ]
  },
  {
    "key": "txt_AllTheme",
    "text": "All Theme",
    "translations": [
      {
        "language": "EN",
        "text": "All Theme"
      },
      {
        "language": "AR",
        "text": "جميع المواضيع"
      },
      {
        "language": "CS",
        "text": "Všechna témata"
      }
    ]
  },
  {
    "key": "txt_Themes",
    "text": "Themes",
    "translations": [
      {
        "language": "EN",
        "text": "Themes"
      },
      {
        "language": "AR",
        "text": "المواضيع"
      },
      {
        "language": "CS",
        "text": "Témata"
      }
    ]
  },
  {
    "key": "txt_TotalComments",
    "text": "Total Comments",
    "translations": [
      {
        "language": "EN",
        "text": "Total Comments"
      },
      {
        "language": "AR",
        "text": "إجمالي التعليقات"
      },
      {
        "language": "CS",
        "text": "Celkový počet komentářů"
      }
    ]
  },
  {
    "key": "txt_Strengths",
    "text": "Strengths",
    "translations": [
      {
        "language": "EN",
        "text": "Strengths"
      },
      {
        "language": "AR",
        "text": "نقاط القوة"
      },
      {
        "language": "CS",
        "text": "Silné stránky"
      }
    ]
  },
  {
    "key": "txt_Improvements",
    "text": "Improvements",
    "translations": [
      {
        "language": "EN",
        "text": "Improvements"
      },
      {
        "language": "AR",
        "text": "نقاط الضعف"
      },
      {
        "language": "CS",
        "text": "Oblasti ke zlepšení"
      }
    ]
  },
  {
    "key": "txt_Mentions",
    "text": "Mentions",
    "translations": [
      {
        "language": "EN",
        "text": "Mentions"
      },
      {
        "language": "AR",
        "text": "المشار إليهم"
      },
      {
        "language": "CS",
        "text": "Odkaz"
      }
    ]
  },
  {
    "key": "txt_ShowCandidates",
    "text": "Show Candidates",
    "translations": [
      {
        "language": "EN",
        "text": "Show Candidates"
      },
      {
        "language": "AR",
        "text": "عرض المرشحين"
      },
      {
        "language": "CS",
        "text": "Zobrazit uchazeče"
      }
    ]
  },
  {
    "key": "txt_RiskCandidatesDescStart",
    "text": "Candidates whose evaluator score is below",
    "translations": [
      {
        "language": "EN",
        "text": "Candidates whose evaluator score is below"
      },
      {
        "language": "AR",
        "text": "المرشحون الذين تقل درجة تقييم المقيّمين لديهم عن"
      },
      {
        "language": "CS",
        "text": "Uchazeči, jejichž skóre od hodnotitelů je nižší než"
      }
    ]
  },
  {
    "key": "txt_RiskCandidatesDescEnd",
    "text": "(the average evaluator score)",
    "translations": [
      {
        "language": "EN",
        "text": "(the average evaluator score)"
      },
      {
        "language": "AR",
        "text": "(متوسط درجة المقيّمين)"
      },
      {
        "language": "CS",
        "text": "(průměrné skóre od hodnotitelů)"
      }
    ]
  },
  {
    "key": "txt_RespondentName",
    "text": "Respondent Name",
    "translations": [
      {
        "language": "EN",
        "text": "Respondent Name"
      },
      {
        "language": "AR",
        "text": "اسم المستجيب"
      },
      {
        "language": "CS",
        "text": "Jméno respondenta"
      }
    ]
  },
  {
    "key": "txt_Entity",
    "text": "Entity",
    "translations": [
      {
        "language": "EN",
        "text": "Entity"
      },
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "CS",
        "text": "Organizace"
      }
    ]
  },
  {
    "key": "txt_AIInsightSummary",
    "text": "AI Insight Summary",
    "translations": [
      {
        "language": "EN",
        "text": "AI Insight Summary"
      },
      {
        "language": "AR",
        "text": "ملخص التحليلات بالذكاء الاصطناعي"
      },
      {
        "language": "CS",
        "text": "Souhrn poznatků AI"
      }
    ]
  },
  {
    "key": "txt_FlaggedCandidates",
    "text": "Flagged Candidates",
    "translations": [
      {
        "language": "EN",
        "text": "Flagged Candidates"
      },
      {
        "language": "AR",
        "text": "المرشحون الذين تستدعي نتائجهم الانتباه"
      },
      {
        "language": "CS",
        "text": "Označení uchazeči"
      }
    ]
  },
  {
    "key": "txt_crcNavigationTour",
    "text": "Navigation",
    "translations": [
      {
        "language": "EN",
        "text": "Navigation"
      },
      {
        "language": "AR",
        "text": "التنقل"
      }
    ]
  },
  {
    "key": "txt_crcNavigationTour_desc",
    "text": "Hover over the “navigation” and click it to select 360°/180° Assessments.",
    "translations": [
      {
        "language": "EN",
        "text": "Hover over the “navigation” and click it to select 360°/180° Assessments."
      },
      {
        "language": "AR",
        "text": "مرّر الماوس فوق \"التنقل\"، اختر تقييمات °360/°180"
      }
    ]
  },
  {
    "key": "txt_crcNewAssessmentTour",
    "text": "New Assessment",
    "translations": [
      {
        "language": "EN",
        "text": "New Assessment"
      },
      {
        "language": "AR",
        "text": "تقييم جديد"
      }
    ]
  },
  {
    "key": "txt_crcNewAssessmentTour_desc",
    "text": "To create a new 360/180 assessment, click on “New Assessment”.",
    "translations": [
      {
        "language": "EN",
        "text": "To create a new 360/180 assessment, click on “New Assessment”."
      },
      {
        "language": "AR",
        "text": "انقر على \"تقييم جديد\" لإنشاء تقييم 360/180 جديد."
      }
    ]
  },
  {
    "key": "txt_crcContinueSetupTour",
    "text": "Continue Setup",
    "translations": [
      {
        "language": "EN",
        "text": "Continue Setup"
      },
      {
        "language": "AR",
        "text": "متابعة الاعداد"
      }
    ]
  },
  {
    "key": "txt_crcContinueSetupTour_desc",
    "text": "To resume the configuration process, hover over any draft assessment, then select “Continue Setup”.",
    "translations": [
      {
        "language": "EN",
        "text": "To resume the configuration process, hover over any draft assessment, then select “Continue Setup”."
      },
      {
        "language": "AR",
        "text": "لاستئناف عملية الإعداد، ضع مؤشر الماوس فوق أي تقييم بحالة المسودة، ثم اختر \"متابعة الإعداد\"."
      }
    ]
  },
  {
    "key": "txt_crcOpenAssessmentTour",
    "text": "Open Assessment",
    "translations": [
      {
        "language": "EN",
        "text": "Open Assessment"
      },
      {
        "language": "AR",
        "text": "فتح التقييم"
      }
    ]
  },
  {
    "key": "txt_crcOpenAssessmentTour_desc",
    "text": "Point the mouse over the assessment list to open live and closed assessments.",
    "translations": [
      {
        "language": "EN",
        "text": "Point the mouse over the assessment list to open live and closed assessments."
      },
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق قائمة التقييمات لفتح التقييمات بحالة المباشرة والمغلقة."
      }
    ]
  },
  {
    "key": "txt_crcMoreActionsTour",
    "text": "More Actions",
    "translations": [
      {
        "language": "EN",
        "text": "More Actions"
      },
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      }
    ]
  },
  {
    "key": "txt_crcMoreActionsTour_desc",
    "text": "Click the ⋮ menu on any assessment to access additional options. Rename it, Clone it as a starting point for a new assessment, or Delete it if it's no longer needed.",
    "translations": [
      {
        "language": "EN",
        "text": "Click the ⋮ menu on any assessment to access additional options. Rename it, Clone it as a starting point for a new assessment, or Delete it if it's no longer needed."
      },
      {
        "language": "AR",
        "text": "قم بالنقر على قائمة ⋮ للوصول إلى خيارات إضافية. قم بإعادة تسميته، أو استنساخه كنقطة انطلاق لتقييم جديد، أو حذفه إذا لم تعد بحاجة إليه."
      }
    ]
  },
  {
    "key": "txt_crcTemplatePreviewTour",
    "text": "Template Preview",
    "translations": [
      {
        "language": "EN",
        "text": "Template Preview"
      },
      {
        "language": "AR",
        "text": "معاينة النموذج"
      }
    ]
  },
  {
    "key": "txt_crcTemplatePreviewTour_desc",
    "text": "To preview the competencies, statements under each competency, and weights distributed for a specific template, click on the competency within the “Template Preview”.<br>Note: The template can be downloaded by clicking on Export Template.",
    "translations": [
      {
        "language": "EN",
        "text": "To preview the competencies, statements under each competency, and weights distributed for a specific template, click on the competency within the “Template Preview”.<br>Note: The template can be downloaded by clicking on Export Template."
      },
      {
        "language": "AR",
        "text": "للاطلاع على الجدارات والعبارات لكل جدارة ومهارة والأوزان الموزعة لنموذج معين، انقر على الجدارة والمهارة ضمن \"معاينة النماذج\".<br>ملاحظة: يمكن تحميل النموذج بالنقر على تحميل النموذج."
      }
    ]
  },
  {
    "key": "txt_tplNewTemplateTour_desc",
    "text": "To create a new 360/180 assessment template, click on “<b>New Template</b>”.",
    "translations": [
      {
        "language": "EN",
        "text": "To create a new 360/180 assessment template, click on “<b>New Template</b>”."
      },
      {
        "language": "AR",
        "text": "انقر على \"<b>نموذج جديد</b>\" لإنشاء نموذج جديد لتقييم 360/180 درجة."
      }
    ]
  },
  {
    "key": "txt_tplContinueSetupTour",
    "text": "Continue Setup",
    "translations": [
      {
        "language": "EN",
        "text": "Continue Setup"
      },
      {
        "language": "AR",
        "text": "متابعة الاعداد"
      }
    ]
  },
  {
    "key": "txt_tplContinueSetupTour_desc",
    "text": "To resume the configuration process, hover over any draft template, then select “<b>Continue Setup</b>”.",
    "translations": [
      {
        "language": "EN",
        "text": "To resume the configuration process, hover over any draft template, then select “<b>Continue Setup</b>”."
      },
      {
        "language": "AR",
        "text": "لاستئناف عملية الإعداد، ضع مؤشر الماوس فوق أي نموذج بحالة المسودة، ثم اختر \"<b>متابعة الإعداد</b>\"."
      }
    ]
  },
  {
    "key": "txt_tplPreviewTour",
    "text": "Preview",
    "translations": [
      {
        "language": "EN",
        "text": "Preview"
      },
      {
        "language": "AR",
        "text": "معاينة"
      }
    ]
  },
  {
    "key": "txt_tplPreviewTour_desc",
    "text": "To preview the contents of a saved template, click on “<b>Preview</b>”.",
    "translations": [
      {
        "language": "EN",
        "text": "To preview the contents of a saved template, click on “<b>Preview</b>”."
      },
      {
        "language": "AR",
        "text": "للاطلاع على محتويات نموذج محفوظ، انقر على \"<b>معاينة</b>\"."
      }
    ]
  },
  {
    "key": "txt_tplCloneTour",
    "text": "Clone",
    "translations": [
      {
        "language": "EN",
        "text": "Clone"
      },
      {
        "language": "AR",
        "text": "استنساخ"
      }
    ]
  },
  {
    "key": "txt_tplCloneTour_desc",
    "text": "To clone a template, click on the three vertical dots and select “<b>Clone</b>”.<br>Note: Cloning is only possible when the template is saved.",
    "translations": [
      {
        "language": "EN",
        "text": "To clone a template, click on the three vertical dots and select “<b>Clone</b>”.<br>Note: Cloning is only possible when the template is saved."
      },
      {
        "language": "AR",
        "text": "لاستنساخ النموذج، انقر على النقاط الثلاث العمودية واختر \"<b>استنساخ</b>\".<br>ملاحظة: لا يمكن الاستنساخ إلا عندما يكون النموذج محفوظاً."
      }
    ]
  },
  {
    "key": "txt_tplDeleteTour",
    "text": "Delete",
    "translations": [
      {
        "language": "EN",
        "text": "Delete"
      },
      {
        "language": "AR",
        "text": "حذف"
      }
    ]
  },
  {
    "key": "txt_tplDeleteTour_desc",
    "text": "To delete a template, click on the three vertical dots and select \"<b>Delete</b>\".<br>Note: Deletion is only possible when the assessment is in Draft status and cannot be undone.",
    "translations": [
      {
        "language": "EN",
        "text": "To delete a template, click on the three vertical dots and select \"<b>Delete</b>\".<br>Note: Deletion is only possible when the assessment is in Draft status and cannot be undone."
      },
      {
        "language": "AR",
        "text": "لحذف التقييم، انقر على النقاط الثلاث العمودية واختر \"<b>حذف</b>\".<br>ملاحظة: لا يمكن الحذف إلا عندما يكون النموذج بحالة المسودة، ولا يمكن التراجع."
      }
    ]
  },
  {
    "key": "txt_tplSelectCompetencyTour_desc",
    "text": "Click here to select the competencies you want to include in your template.<br>Note: At least 3 competencies must be selected, and it is recommended to select 5 to 15 competencies.",
    "translations": [
      {
        "language": "EN",
        "text": "Click here to select the competencies you want to include in your template.<br>Note: At least 3 competencies must be selected, and it is recommended to select 5 to 15 competencies."
      },
      {
        "language": "AR",
        "text": "انقر هنا لاختيار الجدارات والمهارات التي تريد تضمينها في النموذج الخاص بك.<br>ملاحظة: يجب اختيار ما لا يقل عن 3 جدارات ومهارات، ويُوصى باختيار ما بين 5 و15 جدارة ومهارة."
      }
    ]
  },
  {
    "key": "txt_tplNewCompetencyTour",
    "text": "New Competency",
    "translations": [
      {
        "language": "EN",
        "text": "New Competency"
      },
      {
        "language": "AR",
        "text": "جدارة و مهارة جديدة"
      }
    ]
  },
  {
    "key": "txt_tplNewCompetencyTour_desc",
    "text": "Click “<b>New Competency</b>” to add custom competencies.",
    "translations": [
      {
        "language": "EN",
        "text": "Click “<b>New Competency</b>” to add custom competencies."
      },
      {
        "language": "AR",
        "text": "انقر على \"<b>جدارة ومهارة جديدة</b>\" لإضافة جدارات ومهارات مخصصة."
      }
    ]
  },
  {
    "key": "txt_tplCompetencyNameTour",
    "text": "Competency Name",
    "translations": [
      {
        "language": "EN",
        "text": "Competency Name"
      },
      {
        "language": "AR",
        "text": "اسم الجدارة والمهارة"
      }
    ]
  },
  {
    "key": "txt_tplCompetencyNameTour_desc",
    "text": "Enter a name for the competency.",
    "translations": [
      {
        "language": "EN",
        "text": "Enter a name for the competency."
      },
      {
        "language": "AR",
        "text": "قم بتسمية الجدارة والمهارة."
      }
    ]
  },
  {
    "key": "txt_tplCompetencyCategoryTour",
    "text": "Competency Category",
    "translations": [
      {
        "language": "EN",
        "text": "Competency Category"
      },
      {
        "language": "AR",
        "text": "فئة الجدارة والمهارة"
      }
    ]
  },
  {
    "key": "txt_tplCompetencyCategoryTour_desc",
    "text": "Select a category from the dropdown menu; choose the one that best fits this competency.",
    "translations": [
      {
        "language": "EN",
        "text": "Select a category from the dropdown menu; choose the one that best fits this competency."
      },
      {
        "language": "AR",
        "text": "قم باختيار الفئة من القائمة المنسدلة، وحدد الفئة الأنسب لهذه الجدارة والمهارة."
      }
    ]
  },
  {
    "key": "txt_tplCompetencyDefinitionTour",
    "text": "Competency Definition",
    "translations": [
      {
        "language": "EN",
        "text": "Competency Definition"
      },
      {
        "language": "AR",
        "text": "تعريف الجدارة والمهارة"
      }
    ]
  },
  {
    "key": "txt_tplCompetencyDefinitionTour_desc",
    "text": "Add a definition to your competency.",
    "translations": [
      {
        "language": "EN",
        "text": "Add a definition to your competency."
      },
      {
        "language": "AR",
        "text": "قم بإضافة التعريف للجدارة والمهارة."
      }
    ]
  },
  {
    "key": "txt_tplTranslationTour",
    "text": "Translation",
    "translations": [
      {
        "language": "EN",
        "text": "Translation"
      },
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "txt_tplTranslationTour_desc",
    "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "EN",
        "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you!"
      },
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على \"🌐\" أو انقر على \"✨\" واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابة عنك!"
      }
    ]
  },
  {
    "key": "txt_tplCreateCompetencyTour",
    "text": "Create Competency",
    "translations": [
      {
        "language": "EN",
        "text": "Create Competency"
      },
      {
        "language": "AR",
        "text": "إنشاء جدارة ومهارة"
      }
    ]
  },
  {
    "key": "txt_tplCreateCompetencyTour_desc",
    "text": "Once all the details are filled in, click \"<b>Create Competency</b>\" to save and add it to your template.",
    "translations": [
      {
        "language": "EN",
        "text": "Once all the details are filled in, click \"<b>Create Competency</b>\" to save and add it to your template."
      },
      {
        "language": "AR",
        "text": "بعد تعبئة جميع التفاصيل، انقر على \"<b>إنشاء جدارة و مهارة</b>\" لحفظها وإضافتها إلى النموذج."
      }
    ]
  },
  {
    "key": "txt_tplDefinitionViewTour",
    "text": "Competency Definition View",
    "translations": [
      {
        "language": "EN",
        "text": "Competency Definition View"
      },
      {
        "language": "AR",
        "text": "عرض تعريف الجدارة والمهارة"
      }
    ]
  },
  {
    "key": "txt_tplDefinitionViewTour_desc",
    "text": "To view the definition of a competency, point the mouse over the (i) icon.",
    "translations": [
      {
        "language": "EN",
        "text": "To view the definition of a competency, point the mouse over the (i) icon."
      },
      {
        "language": "AR",
        "text": "قم بعرض تعريف الجدارة والمهارة، من خلال تمرير مؤشر الفأرة فوق أيقونة (i)."
      }
    ]
  },
  {
    "key": "txt_tplSelectStatementsTour_desc",
    "text": "Click here to select the statements under each competency and add custom statements by clicking “<b>Add Statement</b>”!<br>Note: It is recommended to add 5 statements under each competency.",
    "translations": [
      {
        "language": "EN",
        "text": "Click here to select the statements under each competency and add custom statements by clicking “<b>Add Statement</b>”!<br>Note: It is recommended to add 5 statements under each competency."
      },
      {
        "language": "AR",
        "text": "انقر هنا لاختيار العبارات تحت كل جدارة ومهارة وقم بإضافة عبارات مخصصة من خلال النقر على \"<b>إضافة عبارة</b>\".<br>ملاحظة: يُوصى بإضافة 5 عبارات لكل جدارة و مهارة."
      }
    ]
  },
  {
    "key": "txt_tplNewStatementTour",
    "text": "New Statement",
    "translations": [
      {
        "language": "EN",
        "text": "New Statement"
      },
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "txt_tplNewStatementTour_desc",
    "text": "To add a new statement under a competency, click on \"<b>New Statement</b>\".",
    "translations": [
      {
        "language": "EN",
        "text": "To add a new statement under a competency, click on \"<b>New Statement</b>\"."
      },
      {
        "language": "AR",
        "text": "لإضافة عبارة جديدة تحت الجدارة و المهارة، انقر على \"<b>عبارة جديدة</b>\"."
      }
    ]
  },
  {
    "key": "txt_tplChangeCompetencyTour",
    "text": "Change Competency",
    "translations": [
      {
        "language": "EN",
        "text": "Change Competency"
      },
      {
        "language": "AR",
        "text": "تغيير الجدارة والمهارة"
      }
    ]
  },
  {
    "key": "txt_tplChangeCompetencyTour_desc",
    "text": "If you want to assign this statement to a different competency, select the desired competency from the dropdown.",
    "translations": [
      {
        "language": "EN",
        "text": "If you want to assign this statement to a different competency, select the desired competency from the dropdown."
      },
      {
        "language": "AR",
        "text": "قم تعيين العبارة لجدارة و مهارة مختلفة، وحدد الجدارة والمهارة المطلوبة من القائمة المنسدلة."
      }
    ]
  },
  {
    "key": "txt_tplCreateStatementTour",
    "text": "Create Statement",
    "translations": [
      {
        "language": "EN",
        "text": "Create Statement"
      },
      {
        "language": "AR",
        "text": "إنشاء عبارة"
      }
    ]
  },
  {
    "key": "txt_tplCreateStatementTour_desc",
    "text": "Once all the details are filled in, click \"<b>Create Statement</b>\" to save and add it to your template.",
    "translations": [
      {
        "language": "EN",
        "text": "Once all the details are filled in, click \"<b>Create Statement</b>\" to save and add it to your template."
      },
      {
        "language": "AR",
        "text": "بعد تعبئة جميع التفاصيل، انقر على \"<b>إنشاء عبارة</b>\" لحفظها وإضافتها إلى النموذج."
      }
    ]
  },
  {
    "key": "txt_tplGenerateStatementTour",
    "text": "Generate Statement",
    "translations": [
      {
        "language": "EN",
        "text": "Generate Statement"
      },
      {
        "language": "AR",
        "text": "إنشاء العبارة"
      }
    ]
  },
  {
    "key": "txt_tplGenerateStatementTour_desc",
    "text": "Leverage AI to generate tailored statements for your competency in one click.",
    "translations": [
      {
        "language": "EN",
        "text": "Leverage AI to generate tailored statements for your competency in one click."
      },
      {
        "language": "AR",
        "text": "قم باستخدام الذكاء الاصطناعي لإنشاء عبارات مخصصة للجدارات والمهارات."
      }
    ]
  },
  {
    "key": "txt_tplQuestionPreviewTour",
    "text": "Question Preview",
    "translations": [
      {
        "language": "EN",
        "text": "Question Preview"
      },
      {
        "language": "AR",
        "text": "معاينة السؤال"
      }
    ]
  },
  {
    "key": "txt_tplQuestionPreviewTour_desc",
    "text": "To see how the statement will appear to respondents, click on \"<b>Question Preview</b>\".",
    "translations": [
      {
        "language": "EN",
        "text": "To see how the statement will appear to respondents, click on \"<b>Question Preview</b>\"."
      },
      {
        "language": "AR",
        "text": "لمعاينة كيفية ظهور العبارة للمستجيبين، انقر على \"<b>معاينة السؤال</b>\"."
      }
    ]
  }
]